// @generated
import { PapiDeviation } from '@wix/da-papi-types';

// source profiles > yumeruby/favourites (newest)
// additonal source > muteor/favourites
// jq '[.results | .[] | .deviation]' ;)
export const imageDeviations: PapiDeviation[] = [
  {
    deviationId: 560424901,
    typeId: 1,
    url: 'https://www.deviantart.com/sverkhpena/art/Kung-Fu-Fish-560424901',
    title: 'Kung Fu Fish',
    isJournal: false,
    isPurchasable: false,
    publishedTime: '2015-09-15T02:40:25-0700',
    isTextEditable: false,
    legacyTextEditUrl: null,
    isShareable: true,
    isCommentable: true,
    isFavourited: true,
    isDeleted: false,
    isMature: false,
    isDownloadable: true,
    isAntisocial: false,
    isBlocked: false,
    isPublished: true,
    blockReasons: [],
    author: {
      userId: 18958435,
      useridUuid: 'f3c61edf-b5cc-4961-83b9-64b190982026',
      username: 'sverkhpena',
      usericon: 'https://a.deviantart.net/avatars-big/s/v/sverkhpena.jpg?8',
      type: 'premium',
      isNewDeviant: false,
    },
    stats: {
      comments: 100,
      favourites: 598,
    },
    media: {
      baseUri:
        'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/f3c61edf-b5cc-4961-83b9-64b190982026/d99numd-0acb0646-e45d-46b8-bc0a-79378c4fb997.jpg',
      prettyName: 'kung_fu_fish_by_sverkhpena_d99numd',
      token: [
        'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7ImhlaWdodCI6Ijw9MTE1OSIsInBhdGgiOiJcL2ZcL2YzYzYxZWRmLWI1Y2MtNDk2MS04M2I5LTY0YjE5MDk4MjAyNlwvZDk5bnVtZC0wYWNiMDY0Ni1lNDVkLTQ2YjgtYmMwYS03OTM3OGM0ZmI5OTcuanBnIiwid2lkdGgiOiI8PTE2MDAifV1dLCJhdWQiOlsidXJuOnNlcnZpY2U6aW1hZ2Uub3BlcmF0aW9ucyJdfQ.VVckByeaJ4jdlBl7THOmNTx2Mvxq6fdMZIHFnjxNtbA',
      ],
      types: [
        {
          t: '150',
          r: 0,
          c: 'v1/fit/w_150,h_150,q_70,strp/<prettyName>-150.jpg',
          h: 109,
          w: 150,
        },
        {
          t: '200H',
          r: 0,
          c: 'v1/fill/w_276,h_200,q_70,strp/<prettyName>-200h.jpg',
          h: 200,
          w: 276,
        },
        {
          t: '300W',
          r: 0,
          c: 'v1/fit/w_300,h_900,q_70,strp/<prettyName>-300w.jpg',
          h: 217,
          w: 300,
        },
        {
          t: '250T',
          r: 0,
          c: 'v1/fill/w_345,h_250,q_70,strp/<prettyName>-250t.jpg',
          h: 250,
          w: 345,
        },
        {
          t: '350T',
          r: 0,
          c: 'v1/fill/w_483,h_350,q_70,strp/<prettyName>-350t.jpg',
          h: 350,
          w: 483,
        },
        {
          t: '400T',
          r: 0,
          c: 'v1/fill/w_552,h_400,q_70,strp/<prettyName>-400t.jpg',
          h: 400,
          w: 552,
        },
        {
          t: 'preview',
          r: 0,
          c: 'v1/fill/w_1050,h_761,q_70,strp/<prettyName>-pre.jpg',
          h: 761,
          w: 1050,
          f: 3710409,
        },
        {
          t: 'social_preview',
          r: 0,
          c: 'v1/fill/w_1050,h_761,q_70,strp/<prettyName>-pre.jpg',
          h: 761,
          w: 1050,
        },
        {
          t: 'fullview',
          r: 0,
          c: 'v1/fill/w_1600,h_1159,q_75,strp/<prettyName>-fullview.jpg',
          h: 1159,
          w: 1600,
          f: 3710409,
        },
      ],
    },
  },
  {
    deviationId: 816125159,
    typeId: 1,
    url: 'https://www.deviantart.com/danielbogni/art/Video-Leaving-816125159',
    title: 'Video - Leaving',
    isJournal: false,
    isPurchasable: false,
    publishedTime: '2019-10-08T19:46:39-0700',
    isTextEditable: false,
    legacyTextEditUrl: null,
    isShareable: true,
    isCommentable: true,
    isFavourited: true,
    isDeleted: false,
    isMature: false,
    isDownloadable: true,
    isAntisocial: false,
    isBlocked: false,
    isPublished: true,
    blockReasons: [],
    author: {
      userId: 10810086,
      useridUuid: 'cf2ee033-82b6-4233-9fad-5170ceec3779',
      username: 'danielbogni',
      usericon: 'https://a.deviantart.net/avatars-big/d/a/danielbogni.jpg?8',
      type: 'regular',
      isNewDeviant: false,
    },
    stats: {
      comments: 4,
      favourites: 215,
    },
    media: {
      baseUri:
        'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/cf2ee033-82b6-4233-9fad-5170ceec3779/ddhwe7b-e37d48d6-1d7d-4f68-b07e-cfd722a2f3cb.png',
      prettyName: 'video___leaving_by_danielbogni_ddhwe7b',
      token: [
        'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7ImhlaWdodCI6Ijw9MTA4MCIsInBhdGgiOiJcL2ZcL2NmMmVlMDMzLTgyYjYtNDIzMy05ZmFkLTUxNzBjZWVjMzc3OVwvZGRod2U3Yi1lMzdkNDhkNi0xZDdkLTRmNjgtYjA3ZS1jZmQ3MjJhMmYzY2IucG5nIiwid2lkdGgiOiI8PTE5MjAifV1dLCJhdWQiOlsidXJuOnNlcnZpY2U6aW1hZ2Uub3BlcmF0aW9ucyJdfQ.IogP1zLfWpd1lqUUt4JapxlMKVcUBeO2wuNOe_eOWIk',
        'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7InBhdGgiOiJcL2ZcL2NmMmVlMDMzLTgyYjYtNDIzMy05ZmFkLTUxNzBjZWVjMzc3OVwvZGRod2U3Yi1lMzdkNDhkNi0xZDdkLTRmNjgtYjA3ZS1jZmQ3MjJhMmYzY2IucG5nIn1dXSwiYXVkIjpbInVybjpzZXJ2aWNlOmZpbGUuZG93bmxvYWQiXX0.uO_-Aghtg0KEbvJsuc1AdPs3LNOTqW7ngj9DO7bamyk',
      ],
      types: [
        {
          t: '150',
          r: 0,
          c: 'v1/fit/w_150,h_150,q_70,strp/<prettyName>-150.jpg',
          h: 84,
          w: 150,
        },
        {
          t: '200H',
          r: 0,
          c: 'v1/fill/w_300,h_169,q_70,strp/<prettyName>-200h.jpg',
          h: 169,
          w: 300,
        },
        {
          t: '300W',
          r: 0,
          c: 'v1/fit/w_300,h_900,q_70,strp/<prettyName>-300w.jpg',
          h: 169,
          w: 300,
        },
        {
          t: '250T',
          r: 0,
          c: 'v1/fill/w_444,h_250,q_70,strp/<prettyName>-250t.jpg',
          h: 250,
          w: 444,
        },
        {
          t: '350T',
          r: 0,
          c: 'v1/fill/w_622,h_350,q_70,strp/<prettyName>-350t.jpg',
          h: 350,
          w: 622,
        },
        {
          t: '400T',
          r: 0,
          c: 'v1/fill/w_711,h_400,q_70,strp/<prettyName>-400t.jpg',
          h: 400,
          w: 711,
        },
        {
          t: 'preview',
          r: 0,
          c: 'v1/fill/w_1192,h_670,q_70,strp/<prettyName>-pre.jpg',
          h: 670,
          w: 1192,
          f: 2019725,
        },
        {
          t: 'social_preview',
          r: 0,
          c: 'v1/fill/w_1192,h_670,q_70,strp/<prettyName>-pre.jpg',
          h: 670,
          w: 1192,
        },
        {
          t: 'fullview',
          r: 1,
          h: 1080,
          w: 1920,
          f: 2019725,
        },
      ],
    },
  },
  {
    deviationId: 815538975,
    typeId: 1,
    url: 'https://www.deviantart.com/sabay-d-der/art/CM-Novel-cov-Seeking-the-flying-sword-path-815538975',
    title: '[ CM ] Novel cov : Seeking the flying sword path',
    isJournal: false,
    isPurchasable: false,
    publishedTime: '2019-10-04T01:49:27-0700',
    isTextEditable: false,
    legacyTextEditUrl: null,
    isShareable: true,
    isCommentable: true,
    isFavourited: true,
    isDeleted: false,
    isMature: false,
    isDownloadable: false,
    isAntisocial: false,
    isBlocked: false,
    isPublished: true,
    blockReasons: [],
    author: {
      userId: 42412262,
      useridUuid: '29b37fd5-86ea-43b0-9d31-8ddcebc57510',
      username: 'sabay-d-der',
      usericon: 'https://a.deviantart.net/avatars-big/s/a/sabay-d-der.jpg?5',
      type: 'regular',
      isNewDeviant: false,
    },
    stats: {
      comments: 13,
      favourites: 159,
    },
    media: {
      baseUri:
        'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/29b37fd5-86ea-43b0-9d31-8ddcebc57510/ddhjtwf-27bd85f2-2ea3-4eed-a59f-a131bceb4ffc.jpg',
      prettyName: '__cm___novel_cov___seeking_the_flying_sword_path_by_sabay_d_der_ddhjtwf',
      token: [
        'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7ImhlaWdodCI6Ijw9MTgxNyIsInBhdGgiOiJcL2ZcLzI5YjM3ZmQ1LTg2ZWEtNDNiMC05ZDMxLThkZGNlYmM1NzUxMFwvZGRoanR3Zi0yN2JkODVmMi0yZWEzLTRlZWQtYTU5Zi1hMTMxYmNlYjRmZmMuanBnIiwid2lkdGgiOiI8PTEyODAifV1dLCJhdWQiOlsidXJuOnNlcnZpY2U6aW1hZ2Uub3BlcmF0aW9ucyJdfQ.eeo-R7g-2xa0P1n8QlfUkdZph-5qxaqPXWg7D7meRZY',
      ],
      types: [
        {
          t: '150',
          r: 0,
          c: 'v1/fit/w_150,h_150,q_70,strp/<prettyName>-150.jpg',
          h: 150,
          w: 106,
        },
        {
          t: '200H',
          r: 0,
          c: 'v1/fill/w_141,h_200,q_70,strp/<prettyName>-200h.jpg',
          h: 200,
          w: 141,
        },
        {
          t: '300W',
          r: 0,
          c: 'v1/fit/w_300,h_900,q_70,strp/<prettyName>-300w.jpg',
          h: 426,
          w: 300,
        },
        {
          t: '250T',
          r: 0,
          c: 'v1/fill/w_176,h_250,q_70,strp/<prettyName>-250t.jpg',
          h: 250,
          w: 176,
        },
        {
          t: '350T',
          r: 0,
          c: 'v1/fill/w_247,h_350,q_70,strp/<prettyName>-350t.jpg',
          h: 350,
          w: 247,
        },
        {
          t: '400T',
          r: 0,
          c: 'v1/fill/w_282,h_400,q_70,strp/<prettyName>-400t.jpg',
          h: 400,
          w: 282,
        },
        {
          t: 'preview',
          r: 0,
          c: 'v1/fill/w_750,h_1065,q_70,strp/<prettyName>-pre.jpg',
          h: 1065,
          w: 750,
          f: 1213920,
        },
        {
          t: 'social_preview',
          r: 0,
          c: 'v1/fill/w_750,h_1065,q_70,strp/<prettyName>-pre.jpg',
          h: 1065,
          w: 750,
        },
        {
          t: 'fullview',
          r: 0,
          c: 'v1/fill/w_1280,h_1817,q_75,strp/<prettyName>-fullview.jpg',
          h: 1817,
          w: 1280,
          f: 1213920,
        },
      ],
    },
  },
  {
    deviationId: 815551889,
    typeId: 1,
    url: 'https://www.deviantart.com/realmantis/art/0989-Cormorant-815551889',
    title: '0989 Cormorant',
    isJournal: false,
    isPurchasable: false,
    publishedTime: '2019-10-04T06:07:31-0700',
    isTextEditable: false,
    legacyTextEditUrl: null,
    isShareable: true,
    isCommentable: true,
    isFavourited: true,
    isDeleted: false,
    isMature: false,
    isDownloadable: true,
    isAntisocial: false,
    isBlocked: false,
    isPublished: true,
    blockReasons: [],
    author: {
      userId: 43324666,
      useridUuid: '168753f2-a2fc-4edd-b524-57cafa935c69',
      username: 'RealMantis',
      usericon: 'https://a.deviantart.net/avatars-big/r/e/realmantis.png?7',
      type: 'premium',
      isNewDeviant: false,
    },
    stats: {
      comments: 16,
      favourites: 146,
    },
    media: {
      baseUri:
        'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/168753f2-a2fc-4edd-b524-57cafa935c69/ddhk3v5-275476cb-5fea-437d-b789-099cc79510b1.jpg',
      prettyName: '0989_cormorant_by_realmantis_ddhk3v5',
      token: [
        'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7ImhlaWdodCI6Ijw9ODU0IiwicGF0aCI6IlwvZlwvMTY4NzUzZjItYTJmYy00ZWRkLWI1MjQtNTdjYWZhOTM1YzY5XC9kZGhrM3Y1LTI3NTQ3NmNiLTVmZWEtNDM3ZC1iNzg5LTA5OWNjNzk1MTBiMS5qcGciLCJ3aWR0aCI6Ijw9MTI4MCJ9XV0sImF1ZCI6WyJ1cm46c2VydmljZTppbWFnZS5vcGVyYXRpb25zIl19.mjOUjD_xIYs3XksIciKjQmJpWeq4Uey_VZsNYjam0e4',
      ],
      types: [
        {
          t: '150',
          r: 0,
          c: 'v1/fit/w_150,h_150,q_70,strp/<prettyName>-150.jpg',
          h: 100,
          w: 150,
        },
        {
          t: '200H',
          r: 0,
          c: 'v1/fill/w_300,h_200,q_70,strp/<prettyName>-200h.jpg',
          h: 200,
          w: 300,
        },
        {
          t: '300W',
          r: 0,
          c: 'v1/fit/w_300,h_854,q_70,strp/<prettyName>-300w.jpg',
          h: 200,
          w: 300,
        },
        {
          t: '250T',
          r: 0,
          c: 'v1/fill/w_375,h_250,q_70,strp/<prettyName>-250t.jpg',
          h: 250,
          w: 375,
        },
        {
          t: '350T',
          r: 0,
          c: 'v1/fill/w_525,h_350,q_70,strp/<prettyName>-350t.jpg',
          h: 350,
          w: 525,
        },
        {
          t: '400T',
          r: 0,
          c: 'v1/fill/w_600,h_400,q_70,strp/<prettyName>-400t.jpg',
          h: 400,
          w: 600,
        },
        {
          t: 'preview',
          r: 0,
          c: 'v1/fill/w_1095,h_730,q_70,strp/<prettyName>-pre.jpg',
          h: 730,
          w: 1095,
          f: 1084244,
        },
        {
          t: 'social_preview',
          r: 0,
          c: 'v1/fill/w_1095,h_730,q_70,strp/<prettyName>-pre.jpg',
          h: 730,
          w: 1095,
        },
        {
          t: 'fullview',
          r: 0,
          c: 'v1/fill/w_1280,h_854,q_75,strp/<prettyName>-fullview.jpg',
          h: 854,
          w: 1280,
          f: 1084244,
        },
      ],
    },
  },
  {
    deviationId: 815551557,
    typeId: 1,
    url: 'https://www.deviantart.com/sayuuhiro/art/Emet-Selch-815551557',
    title: 'Emet-Selch',
    isJournal: false,
    isPurchasable: false,
    publishedTime: '2019-10-04T05:52:03-0700',
    isTextEditable: false,
    legacyTextEditUrl: null,
    isShareable: true,
    isCommentable: true,
    isFavourited: true,
    isDeleted: false,
    isMature: false,
    isDownloadable: true,
    isAntisocial: false,
    isBlocked: false,
    isPublished: true,
    blockReasons: [],
    author: {
      userId: 20558774,
      useridUuid: '13eba3ec-a69b-445a-92b8-8aa8e6d1e802',
      username: 'sayuuhiro',
      usericon: 'https://a.deviantart.net/avatars-big/s/a/sayuuhiro.png?13',
      type: 'premium',
      isNewDeviant: false,
    },
    stats: {
      comments: 4,
      favourites: 256,
    },
    media: {
      baseUri:
        'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/13eba3ec-a69b-445a-92b8-8aa8e6d1e802/ddhk3lx-c684d25c-fb63-4b8e-b9f1-75564512a271.jpg',
      prettyName: 'emet_selch_by_sayuuhiro_ddhk3lx',
      token: [
        'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7ImhlaWdodCI6Ijw9MTAwMCIsInBhdGgiOiJcL2ZcLzEzZWJhM2VjLWE2OWItNDQ1YS05MmI4LThhYThlNmQxZTgwMlwvZGRoazNseC1jNjg0ZDI1Yy1mYjYzLTRiOGUtYjlmMS03NTU2NDUxMmEyNzEuanBnIiwid2lkdGgiOiI8PTcwNyJ9XV0sImF1ZCI6WyJ1cm46c2VydmljZTppbWFnZS5vcGVyYXRpb25zIl19.vPmKkCk7CzifctrGPxOU4TiZ_b1pp7-HV_ng6uiWHXA',
        'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7InBhdGgiOiJcL2ZcLzEzZWJhM2VjLWE2OWItNDQ1YS05MmI4LThhYThlNmQxZTgwMlwvZGRoazNseC1jNjg0ZDI1Yy1mYjYzLTRiOGUtYjlmMS03NTU2NDUxMmEyNzEuanBnIn1dXSwiYXVkIjpbInVybjpzZXJ2aWNlOmZpbGUuZG93bmxvYWQiXX0.jrv6rCpUZ2Sank1AIlxK6DvA1Y3uQ2gzzF4bYW9XLY0',
      ],
      types: [
        {
          t: '150',
          r: 0,
          c: 'v1/fit/w_150,h_150,q_70,strp/<prettyName>-150.jpg',
          h: 150,
          w: 106,
        },
        {
          t: '200H',
          r: 0,
          c: 'v1/crop/w_141,h_200,x_0,y_0,scl_0.2008486562942,q_70,strp/<prettyName>-200h.jpg',
          h: 200,
          w: 141,
        },
        {
          t: '300W',
          r: 0,
          c: 'v1/fit/w_300,h_900,q_70,strp/<prettyName>-300w.jpg',
          h: 424,
          w: 300,
        },
        {
          t: '250T',
          r: 0,
          c: 'v1/fill/w_177,h_250,q_70,strp/<prettyName>-250t.jpg',
          h: 250,
          w: 177,
        },
        {
          t: '350T',
          r: 0,
          c: 'v1/crop/w_247,h_350,x_0,y_0,scl_0.35077793493635,q_70,strp/<prettyName>-350t.jpg',
          h: 350,
          w: 247,
        },
        {
          t: '400T',
          r: 0,
          c: 'v1/fill/w_283,h_400,q_70,strp/<prettyName>-400t.jpg',
          h: 400,
          w: 283,
        },
        {
          t: 'preview',
          r: 0,
          c: 'v1/fill/w_707,h_1000,q_75,strp/<prettyName>-fullview.jpg',
          h: 1000,
          w: 707,
          f: 88963,
        },
        {
          t: 'social_preview',
          r: 0,
          c: 'v1/fill/w_707,h_1000,q_75,strp/<prettyName>-fullview.jpg',
          h: 1000,
          w: 707,
        },
        {
          t: 'fullview',
          r: 1,
          h: 1000,
          w: 707,
          f: 88963,
        },
      ],
    },
  },
  {
    deviationId: 638057939,
    typeId: 1,
    url: 'https://www.deviantart.com/lhuin/art/Pixie-and-Petro-638057939',
    title: 'Pixie and Petro',
    isJournal: false,
    isPurchasable: false,
    publishedTime: '2016-10-03T12:02:14-0700',
    isTextEditable: false,
    legacyTextEditUrl: null,
    isShareable: true,
    isCommentable: true,
    isFavourited: true,
    isDeleted: false,
    isMature: false,
    isDownloadable: false,
    isAntisocial: false,
    isBlocked: false,
    isPublished: true,
    blockReasons: [],
    author: {
      userId: 15320509,
      useridUuid: '6fa77992-b1c0-4a15-b95c-d069a3dbd156',
      username: 'Lhuin',
      usericon: 'https://a.deviantart.net/avatars-big/l/h/lhuin.jpg?3',
      type: 'premium',
      isNewDeviant: false,
    },
    stats: {
      comments: 33,
      favourites: 1238,
    },
    media: {
      baseUri:
        'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/6fa77992-b1c0-4a15-b95c-d069a3dbd156/dajvsnn-ada96086-5eda-4874-b90e-b8c0eb3c0b6a.jpg',
      prettyName: 'pixie_and_petro_by_lhuin_dajvsnn',
      token: [
        'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7ImhlaWdodCI6Ijw9NzA3IiwicGF0aCI6IlwvZlwvNmZhNzc5OTItYjFjMC00YTE1LWI5NWMtZDA2OWEzZGJkMTU2XC9kYWp2c25uLWFkYTk2MDg2LTVlZGEtNDg3NC1iOTBlLWI4YzBlYjNjMGI2YS5qcGciLCJ3aWR0aCI6Ijw9MTAwMCJ9XV0sImF1ZCI6WyJ1cm46c2VydmljZTppbWFnZS5vcGVyYXRpb25zIl19.o4ncuIQ4rQA9hZeeIbF2Wg494DQ97aX9tKnTZWzsMJ4',
        'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7InBhdGgiOiJcL2ZcLzZmYTc3OTkyLWIxYzAtNGExNS1iOTVjLWQwNjlhM2RiZDE1NlwvZGFqdnNubi1hZGE5NjA4Ni01ZWRhLTQ4NzQtYjkwZS1iOGMwZWIzYzBiNmEuanBnIn1dXSwiYXVkIjpbInVybjpzZXJ2aWNlOmZpbGUuZG93bmxvYWQiXX0.WtH4nX68o5x-91m4mWNbHY0zSaIFvwZweE5Hb42uL98',
      ],
      types: [
        {
          t: '150',
          r: 0,
          c: 'v1/fit/w_150,h_150,q_70,strp/<prettyName>-150.jpg',
          h: 106,
          w: 150,
        },
        {
          t: '200H',
          r: 0,
          c: 'v1/fill/w_283,h_200,q_70,strp/<prettyName>-200h.jpg',
          h: 200,
          w: 283,
        },
        {
          t: '300W',
          r: 0,
          c: 'v1/fit/w_300,h_707,q_70,strp/<prettyName>-300w.jpg',
          h: 212,
          w: 300,
        },
        {
          t: '250T',
          r: 0,
          c: 'v1/fill/w_354,h_250,q_70,strp/<prettyName>-250t.jpg',
          h: 250,
          w: 354,
        },
        {
          t: '350T',
          r: 0,
          c: 'v1/fill/w_495,h_350,q_70,strp/<prettyName>-350t.jpg',
          h: 350,
          w: 495,
        },
        {
          t: '400T',
          r: 0,
          c: 'v1/fill/w_566,h_400,q_70,strp/<prettyName>-400t.jpg',
          h: 400,
          w: 566,
        },
        {
          t: 'preview',
          r: 0,
          c: 'v1/fill/w_1000,h_707,q_75,strp/<prettyName>-fullview.jpg',
          h: 707,
          w: 1000,
          f: 615028,
        },
        {
          t: 'social_preview',
          r: 0,
          c: 'v1/fill/w_1000,h_707,q_75,strp/<prettyName>-fullview.jpg',
          h: 707,
          w: 1000,
        },
        {
          t: 'fullview',
          r: 1,
          h: 707,
          w: 1000,
          f: 615028,
        },
      ],
    },
  },
  {
    deviationId: 638535342,
    typeId: 1,
    url: 'https://www.deviantart.com/lhuin/art/Kitten-Galore-638535342',
    title: 'Kitten Galore',
    isJournal: false,
    isPurchasable: false,
    publishedTime: '2016-10-06T02:54:09-0700',
    isTextEditable: false,
    legacyTextEditUrl: null,
    isShareable: true,
    isCommentable: true,
    isFavourited: true,
    isDeleted: false,
    isMature: false,
    isDownloadable: false,
    isAntisocial: false,
    isBlocked: false,
    isPublished: true,
    blockReasons: [],
    author: {
      userId: 15320509,
      useridUuid: '6fa77992-b1c0-4a15-b95c-d069a3dbd156',
      username: 'Lhuin',
      usericon: 'https://a.deviantart.net/avatars-big/l/h/lhuin.jpg?3',
      type: 'premium',
      isNewDeviant: false,
    },
    stats: {
      comments: 52,
      favourites: 1671,
    },
    media: {
      baseUri:
        'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/6fa77992-b1c0-4a15-b95c-d069a3dbd156/dak610u-565e450d-7b44-4463-b6d9-702fdd1a3d4b.jpg',
      prettyName: 'kitten_galore_by_lhuin_dak610u',
      token: [
        'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7ImhlaWdodCI6Ijw9MTE4OSIsInBhdGgiOiJcL2ZcLzZmYTc3OTkyLWIxYzAtNGExNS1iOTVjLWQwNjlhM2RiZDE1NlwvZGFrNjEwdS01NjVlNDUwZC03YjQ0LTQ0NjMtYjZkOS03MDJmZGQxYTNkNGIuanBnIiwid2lkdGgiOiI8PTE2ODEifV1dLCJhdWQiOlsidXJuOnNlcnZpY2U6aW1hZ2Uub3BlcmF0aW9ucyJdfQ.2PcBxUPjNpv0_dh88oZO9w56vlN7vTpFYUhkiOfxDOQ',
        'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7InBhdGgiOiJcL2ZcLzZmYTc3OTkyLWIxYzAtNGExNS1iOTVjLWQwNjlhM2RiZDE1NlwvZGFrNjEwdS01NjVlNDUwZC03YjQ0LTQ0NjMtYjZkOS03MDJmZGQxYTNkNGIuanBnIn1dXSwiYXVkIjpbInVybjpzZXJ2aWNlOmZpbGUuZG93bmxvYWQiXX0.fE5v9G8FhZwGm_8V1nsnmTZ8NL2EWjLXJly-BMkrzc0',
      ],
      types: [
        {
          t: '150',
          r: 0,
          c: 'v1/fit/w_150,h_150,q_70,strp/<prettyName>-150.jpg',
          h: 106,
          w: 150,
        },
        {
          t: '200H',
          r: 0,
          c: 'v1/fill/w_283,h_200,q_70,strp/<prettyName>-200h.jpg',
          h: 200,
          w: 283,
        },
        {
          t: '300W',
          r: 0,
          c: 'v1/fit/w_300,h_900,q_70,strp/<prettyName>-300w.jpg',
          h: 212,
          w: 300,
        },
        {
          t: '250T',
          r: 0,
          c: 'v1/fill/w_353,h_250,q_70,strp/<prettyName>-250t.jpg',
          h: 250,
          w: 353,
        },
        {
          t: '350T',
          r: 0,
          c: 'v1/fill/w_495,h_350,q_70,strp/<prettyName>-350t.jpg',
          h: 350,
          w: 495,
        },
        {
          t: '400T',
          r: 0,
          c: 'v1/fill/w_566,h_400,q_70,strp/<prettyName>-400t.jpg',
          h: 400,
          w: 566,
        },
        {
          t: 'preview',
          r: 0,
          c: 'v1/fill/w_1063,h_752,q_70,strp/<prettyName>-pre.jpg',
          h: 752,
          w: 1063,
          f: 1572051,
        },
        {
          t: 'social_preview',
          r: 0,
          c: 'v1/fill/w_1063,h_752,q_70,strp/<prettyName>-pre.jpg',
          h: 752,
          w: 1063,
        },
        {
          t: 'fullview',
          r: 1,
          h: 1189,
          w: 1681,
          f: 1572051,
        },
      ],
    },
  },
  {
    deviationId: 814120978,
    typeId: 1,
    url: 'https://www.deviantart.com/era7/art/Strange-Dragon-814120978',
    title: 'Strange Dragon...',
    isJournal: false,
    isPurchasable: false,
    publishedTime: '2019-09-22T01:29:45-0700',
    isTextEditable: false,
    legacyTextEditUrl: null,
    isShareable: true,
    isCommentable: true,
    isFavourited: true,
    isDeleted: false,
    isMature: false,
    isDownloadable: true,
    isAntisocial: false,
    isBlocked: false,
    isPublished: true,
    blockReasons: [],
    author: {
      userId: 45338500,
      useridUuid: 'fd3a8fb7-5eef-4ae8-857d-977ef347f1e3',
      username: 'ERA7',
      usericon: 'https://a.deviantart.net/avatars-big/e/r/era7.gif?10',
      type: 'premium',
      isNewDeviant: false,
    },
    stats: {
      comments: 78,
      favourites: 965,
    },
    media: {
      baseUri:
        'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/fd3a8fb7-5eef-4ae8-857d-977ef347f1e3/ddgpfrm-547a6f6e-8747-4f4d-bea7-733af6554050.jpg',
      prettyName: 'strange_dragon____by_era7_ddgpfrm',
      token: [
        'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7ImhlaWdodCI6Ijw9MTQ0MCIsInBhdGgiOiJcL2ZcL2ZkM2E4ZmI3LTVlZWYtNGFlOC04NTdkLTk3N2VmMzQ3ZjFlM1wvZGRncGZybS01NDdhNmY2ZS04NzQ3LTRmNGQtYmVhNy03MzNhZjY1NTQwNTAuanBnIiwid2lkdGgiOiI8PTI1NjAifV1dLCJhdWQiOlsidXJuOnNlcnZpY2U6aW1hZ2Uub3BlcmF0aW9ucyJdfQ.wH-uARemcBPnnSS3kll69Z7V4qVF6xb6CGN2p6C9qLQ',
        'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7InBhdGgiOiJcL2ZcL2ZkM2E4ZmI3LTVlZWYtNGFlOC04NTdkLTk3N2VmMzQ3ZjFlM1wvZGRncGZybS01NDdhNmY2ZS04NzQ3LTRmNGQtYmVhNy03MzNhZjY1NTQwNTAuanBnIn1dXSwiYXVkIjpbInVybjpzZXJ2aWNlOmZpbGUuZG93bmxvYWQiXX0.XePopUqnhDK9mpJBJF0EhVprB06uHXmzrRMTZSBBXdI',
      ],
      types: [
        {
          t: '150',
          r: 0,
          c: 'v1/fit/w_150,h_150,q_70,strp/<prettyName>-150.jpg',
          h: 84,
          w: 150,
        },
        {
          t: '200H',
          r: 0,
          c: 'v1/fill/w_300,h_169,q_70,strp/<prettyName>-200h.jpg',
          h: 169,
          w: 300,
        },
        {
          t: '300W',
          r: 0,
          c: 'v1/fit/w_300,h_900,q_70,strp/<prettyName>-300w.jpg',
          h: 169,
          w: 300,
        },
        {
          t: '250T',
          r: 0,
          c: 'v1/fill/w_444,h_250,q_70,strp/<prettyName>-250t.jpg',
          h: 250,
          w: 444,
        },
        {
          t: '350T',
          r: 0,
          c: 'v1/fill/w_622,h_350,q_70,strp/<prettyName>-350t.jpg',
          h: 350,
          w: 622,
        },
        {
          t: '400T',
          r: 0,
          c: 'v1/fill/w_711,h_400,q_70,strp/<prettyName>-400t.jpg',
          h: 400,
          w: 711,
        },
        {
          t: 'preview',
          r: 0,
          c: 'v1/fill/w_1192,h_670,q_70,strp/<prettyName>-pre.jpg',
          h: 670,
          w: 1192,
          f: 2105123,
        },
        {
          t: 'social_preview',
          r: 0,
          c: 'v1/fill/w_1192,h_670,q_70,strp/<prettyName>-pre.jpg',
          h: 670,
          w: 1192,
        },
        {
          t: 'fullview',
          r: 1,
          h: 1440,
          w: 2560,
          f: 2105123,
        },
      ],
    },
  },
  {
    deviationId: 772559692,
    typeId: 1,
    url: 'https://www.deviantart.com/neytirix/art/Bunny-Butts-772559692',
    title: 'Bunny Butts',
    isJournal: false,
    isPurchasable: false,
    publishedTime: '2018-11-14T04:56:54-0800',
    isTextEditable: false,
    legacyTextEditUrl: null,
    isShareable: true,
    isCommentable: true,
    isFavourited: true,
    isDeleted: false,
    isMature: false,
    isDownloadable: true,
    isAntisocial: false,
    isBlocked: false,
    isPublished: true,
    blockReasons: [],
    author: {
      userId: 18500451,
      useridUuid: 'bcdbac5b-cdc4-410e-8020-c863a7210f66',
      username: 'Neytirix',
      usericon: 'https://a.deviantart.net/avatars-big/n/e/neytirix.gif?4',
      type: 'hell-beta',
      isNewDeviant: false,
    },
    stats: {
      comments: 48,
      favourites: 1920,
    },
    media: {
      baseUri:
        'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/bcdbac5b-cdc4-410e-8020-c863a7210f66/dcrymvg-51374f3b-08d2-4f0a-9ec1-05ce1da8b8c3.jpg',
      prettyName: 'bunny_butts_by_neytirix_dcrymvg',
      token: [
        'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7ImhlaWdodCI6Ijw9OTAwIiwicGF0aCI6IlwvZlwvYmNkYmFjNWItY2RjNC00MTBlLTgwMjAtYzg2M2E3MjEwZjY2XC9kY3J5bXZnLTUxMzc0ZjNiLTA4ZDItNGYwYS05ZWMxLTA1Y2UxZGE4YjhjMy5qcGciLCJ3aWR0aCI6Ijw9MTYwMCJ9XV0sImF1ZCI6WyJ1cm46c2VydmljZTppbWFnZS5vcGVyYXRpb25zIl19.fWgoBuzLWBZeCDWZztr1TpM5grOuSxpJJxPn642EZzo',
      ],
      types: [
        {
          t: '150',
          r: 0,
          c: 'v1/fit/w_150,h_150,q_70,strp/<prettyName>-150.jpg',
          h: 84,
          w: 150,
        },
        {
          t: '200H',
          r: 0,
          c: 'v1/fill/w_300,h_169,q_70,strp/<prettyName>-200h.jpg',
          h: 169,
          w: 300,
        },
        {
          t: '300W',
          r: 0,
          c: 'v1/fit/w_300,h_900,q_70,strp/<prettyName>-300w.jpg',
          h: 169,
          w: 300,
        },
        {
          t: '250T',
          r: 0,
          c: 'v1/fill/w_444,h_250,q_70,strp/<prettyName>-250t.jpg',
          h: 250,
          w: 444,
        },
        {
          t: '350T',
          r: 0,
          c: 'v1/fill/w_622,h_350,q_70,strp/<prettyName>-350t.jpg',
          h: 350,
          w: 622,
        },
        {
          t: '400T',
          r: 0,
          c: 'v1/fill/w_711,h_400,q_70,strp/<prettyName>-400t.jpg',
          h: 400,
          w: 711,
        },
        {
          t: 'preview',
          r: 0,
          c: 'v1/fill/w_1192,h_670,q_70,strp/<prettyName>-pre.jpg',
          h: 670,
          w: 1192,
          f: 740292,
        },
        {
          t: 'social_preview',
          r: 0,
          c: 'v1/fill/w_1192,h_670,q_70,strp/<prettyName>-pre.jpg',
          h: 670,
          w: 1192,
        },
        {
          t: 'fullview',
          r: 0,
          c: 'v1/fill/w_1600,h_900,q_75,strp/<prettyName>-fullview.jpg',
          h: 900,
          w: 1600,
          f: 740292,
        },
      ],
    },
  },
  {
    deviationId: 814471452,
    typeId: 1,
    url: 'https://www.deviantart.com/lonary/art/YCH-Commision-120-814471452',
    title: 'YCH Commision: 120',
    isJournal: false,
    isPurchasable: false,
    publishedTime: '2019-09-25T03:05:06-0700',
    isTextEditable: false,
    legacyTextEditUrl: null,
    isShareable: true,
    isCommentable: true,
    isFavourited: true,
    isDeleted: false,
    isMature: false,
    isDownloadable: false,
    isAntisocial: false,
    isBlocked: false,
    isPublished: true,
    blockReasons: [],
    author: {
      userId: 37272267,
      useridUuid: '3809ab01-0b28-4146-a862-b57b51ca7b44',
      username: 'Lonary',
      usericon: 'https://a.deviantart.net/avatars-big/l/o/lonary.jpg?7',
      type: 'premium',
      isNewDeviant: false,
    },
    stats: {
      comments: 8,
      favourites: 227,
    },
    media: {
      baseUri:
        'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/3809ab01-0b28-4146-a862-b57b51ca7b44/ddgwy70-1fffd5c4-2c9c-452d-a730-a94c561f3d69.jpg',
      prettyName: 'ych_commision__120_by_lonary_ddgwy70',
      token: [
        'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7ImhlaWdodCI6Ijw9MTgyOCIsInBhdGgiOiJcL2ZcLzM4MDlhYjAxLTBiMjgtNDE0Ni1hODYyLWI1N2I1MWNhN2I0NFwvZGRnd3k3MC0xZmZmZDVjNC0yYzljLTQ1MmQtYTczMC1hOTRjNTYxZjNkNjkuanBnIiwid2lkdGgiOiI8PTgwMCJ9XV0sImF1ZCI6WyJ1cm46c2VydmljZTppbWFnZS5vcGVyYXRpb25zIl19.iLpRyMVtEzNJbdM0SqOkGiQbfpslBgvQjs09CJacbP4',
      ],
      types: [
        {
          t: '150',
          r: 0,
          c: 'v1/fit/w_150,h_150,q_70,strp/<prettyName>-150.jpg',
          h: 150,
          w: 66,
        },
        {
          t: '200H',
          r: 0,
          c: 'v1/crop/w_100,h_201,x_0,y_0,scl_0.099800399201597,q_70,strp/<prettyName>-200h.jpg',
          h: 201,
          w: 100,
        },
        {
          t: '300W',
          r: 0,
          c: 'v1/fit/w_300,h_900,q_70,strp/<prettyName>-300w.jpg',
          h: 686,
          w: 300,
        },
        {
          t: '250T',
          r: 0,
          c: 'v1/crop/w_109,h_250,x_0,y_0,scl_0.10978043912176,q_70,strp/<prettyName>-250t.jpg',
          h: 250,
          w: 109,
        },
        {
          t: '350T',
          r: 0,
          c: 'v1/fill/w_153,h_350,q_70,strp/<prettyName>-350t.jpg',
          h: 350,
          w: 153,
        },
        {
          t: '400T',
          r: 0,
          c: 'v1/fill/w_175,h_400,q_70,strp/<prettyName>-400t.jpg',
          h: 400,
          w: 175,
        },
        {
          t: 'preview',
          r: 0,
          c: 'v1/fill/w_591,h_1352,q_70,strp/<prettyName>-pre.jpg',
          h: 1352,
          w: 591,
          f: 1241472,
        },
        {
          t: 'social_preview',
          r: 0,
          c: 'v1/fill/w_591,h_1352,q_70,strp/<prettyName>-pre.jpg',
          h: 1352,
          w: 591,
        },
        {
          t: 'fullview',
          r: 0,
          c: 'v1/fill/w_800,h_1828,q_75,strp/<prettyName>-fullview.jpg',
          h: 1828,
          w: 800,
          f: 1241472,
        },
      ],
    },
  },
  {
    deviationId: 941140145,
    type: 'image',
    typeId: 1,
    url: 'https://www.deviantart.com/simply-er1c/art/Reflect-941140145',
    title: 'Reflect',
    isJournal: false,
    isVideo: false,
    isPurchasable: false,
    isFavouritable: true,
    publishedTime: '2022-12-15T05:45:42-0800',
    isTextEditable: false,
    isBackgroundEditable: false,
    legacyTextEditUrl: null,
    isShareable: true,
    isCommentable: true,
    isFavourited: true,
    isDeleted: false,
    isMature: false,
    isNsfg: false,
    isDownloadable: true,
    isAntisocial: false,
    isBlocked: false,
    isPublished: true,
    isDailyDeviation: false,
    hasPrivateComments: false,
    isDreamsofart: false,
    isAiUseDisallowed: true,
    blockReasons: [],
    author: {
      userId: 62623104,
      useridUuid: '2911cdbe-274f-4162-8691-a1a6dc8fbe35',
      username: 'Simply-Er1c',
      usericon: 'https://a.deviantart.net/avatars-big/s/i/simply-er1c.jpg?10',
      type: 'regular',
      isWatching: false,
      isSubscribed: false,
      isNewDeviant: false,
    },
    stats: {
      comments: 1,
      favourites: 90,
      views: 4077,
      downloads: 19,
    },
    media: {
      baseUri:
        'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/2911cdbe-274f-4162-8691-a1a6dc8fbe35/dfkbwdt-49be7094-2103-4e14-a443-447ac4de844b.png',
      prettyName: 'reflect_by_simply_er1c_dfkbwdt',
      token: [
        'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7ImhlaWdodCI6Ijw9NzIwIiwicGF0aCI6IlwvZlwvMjkxMWNkYmUtMjc0Zi00MTYyLTg2OTEtYTFhNmRjOGZiZTM1XC9kZmtid2R0LTQ5YmU3MDk0LTIxMDMtNGUxNC1hNDQzLTQ0N2FjNGRlODQ0Yi5wbmciLCJ3aWR0aCI6Ijw9MTI4MCJ9XV0sImF1ZCI6WyJ1cm46c2VydmljZTppbWFnZS5vcGVyYXRpb25zIl19.X4e3HKG7GnYNQ_GORUvuTqmGiWa9tr5Cmnypkxr2K9U',
      ],
      types: [
        {
          t: '150',
          r: 0,
          c: '/v1/fit/w_150,h_150,q_70,strp/<prettyName>-150.jpg',
          h: 84,
          w: 150,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_300,h_300,q_70,strp/<prettyName>-150-2x.jpg',
            },
          ],
        },
        {
          t: '200H',
          r: 0,
          c: '/v1/fill/w_300,h_169,q_70,strp/<prettyName>-200h.jpg',
          h: 169,
          w: 300,
          ss: [
            {
              x: 2,
              c: '/v1/fill/w_600,h_338,q_70,strp/<prettyName>-200h-2x.jpg',
            },
          ],
        },
        {
          t: '300W',
          r: 0,
          c: '/v1/fit/w_300,h_720,q_70,strp/<prettyName>-300w.jpg',
          h: 169,
          w: 300,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_600,h_720,q_70,strp/<prettyName>-300w-2x.jpg',
            },
          ],
        },
        {
          t: '375W',
          r: 0,
          c: '/v1/fit/w_375,h_211,q_70,strp/<prettyName>-375w.jpg',
          h: 211,
          w: 375,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_750,h_422,q_70,strp/<prettyName>-375w-2x.jpg',
            },
          ],
        },
        {
          t: '414W',
          r: 0,
          c: '/v1/fit/w_414,h_233,q_70,strp/<prettyName>-414w.jpg',
          h: 233,
          w: 414,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_828,h_466,q_70,strp/<prettyName>-414w-2x.jpg',
            },
          ],
        },
        {
          t: '250T',
          r: 0,
          c: '/v1/fill/w_444,h_250,q_70,strp/<prettyName>-250t.jpg',
          h: 250,
          w: 444,
          ss: [
            {
              x: 2,
              c: '/v1/fill/w_889,h_500,q_70,strp/<prettyName>-250t-2x.jpg',
            },
          ],
        },
        {
          t: '350T',
          r: 0,
          c: '/v1/fill/w_622,h_350,q_70,strp/<prettyName>-350t.jpg',
          h: 350,
          w: 622,
          ss: [
            {
              x: 2,
              c: '/v1/fill/w_1244,h_700,q_70,strp/<prettyName>-350t-2x.jpg',
            },
          ],
        },
        {
          t: '400T',
          r: 0,
          c: '/v1/fill/w_711,h_400,q_70,strp/<prettyName>-400t.jpg',
          h: 400,
          w: 711,
        },
        {
          t: 'preview',
          r: 0,
          c: '/v1/fill/w_1192,h_670,q_70,strp/<prettyName>-pre.jpg',
          h: 670,
          w: 1192,
          f: 4949527,
        },
        {
          t: 'social_preview',
          r: 0,
          c: '/v1/fill/w_1192,h_670,q_70,strp/<prettyName>-pre.jpg',
          h: 670,
          w: 1192,
        },
        {
          t: 'fullview',
          r: 0,
          c: '/v1/fill/w_1280,h_720,q_80,strp/<prettyName>-fullview.jpg',
          h: 720,
          w: 1280,
          f: 4949527,
        },
        {
          t: '92S',
          r: 0,
          c: '/v1/crop/w_92,h_92,x_18,y_0,scl_0.034074074074074,q_70,strp/<prettyName>-92s.jpg',
          h: 92,
          w: 92,
          ss: [
            {
              x: 2,
              c: '/v1/crop/w_184,h_184,x_36,y_0,scl_0.068148148148148,q_70,strp/<prettyName>-92s-2x.jpg',
            },
          ],
        },
      ],
    },
  },
  {
    deviationId: 940992122,
    type: 'image',
    typeId: 1,
    url: 'https://www.deviantart.com/f4rt1st/art/From-the-book-of-Lee-Jeffries-2-940992122',
    title: 'From the book of Lee Jeffries 2',
    isJournal: false,
    isVideo: false,
    isPurchasable: false,
    isFavouritable: true,
    publishedTime: '2022-12-14T00:09:26-0800',
    isTextEditable: false,
    isBackgroundEditable: false,
    legacyTextEditUrl: null,
    isShareable: true,
    isCommentable: true,
    isFavourited: true,
    isDeleted: false,
    isMature: false,
    isNsfg: false,
    isDownloadable: true,
    isAntisocial: false,
    isBlocked: false,
    isPublished: true,
    isDailyDeviation: false,
    hasPrivateComments: false,
    isDreamsofart: false,
    isAiUseDisallowed: true,
    blockReasons: [],
    author: {
      userId: 83026715,
      useridUuid: '0570ebf6-325d-4a72-845b-3e6e374e1273',
      username: 'F4RT1ST',
      usericon: 'https://a.deviantart.net/avatars-big/f/4/f4rt1st.jpg?4',
      type: 'core_access',
      isWatching: true,
      isSubscribed: false,
      isNewDeviant: true,
    },
    stats: {
      comments: 6,
      favourites: 105,
      views: 10816,
      downloads: 1,
    },
    media: {
      baseUri:
        'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/0570ebf6-325d-4a72-845b-3e6e374e1273/dfk8q62-4a934133-6fc9-46ef-8631-44154394b0c6.jpg',
      prettyName: 'from_the_book_of_lee_jeffries_2_by_f4rt1st_dfk8q62',
      token: [
        'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7ImhlaWdodCI6Ijw9NTM0NCIsInBhdGgiOiJcL2ZcLzA1NzBlYmY2LTMyNWQtNGE3Mi04NDViLTNlNmUzNzRlMTI3M1wvZGZrOHE2Mi00YTkzNDEzMy02ZmM5LTQ2ZWYtODYzMS00NDE1NDM5NGIwYzYuanBnIiwid2lkdGgiOiI8PTQwMDgifV1dLCJhdWQiOlsidXJuOnNlcnZpY2U6aW1hZ2Uub3BlcmF0aW9ucyJdfQ.nmuWDYKj48ujzvER4NVZLchDJfCAIDLfc02nEblbhxQ',
        'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7InBhdGgiOiJcL2ZcLzA1NzBlYmY2LTMyNWQtNGE3Mi04NDViLTNlNmUzNzRlMTI3M1wvZGZrOHE2Mi00YTkzNDEzMy02ZmM5LTQ2ZWYtODYzMS00NDE1NDM5NGIwYzYuanBnIn1dXSwiYXVkIjpbInVybjpzZXJ2aWNlOmZpbGUuZG93bmxvYWQiXX0.BSwC3JrwASo6y2vhV09gNIrpyyjw5DJ5H7XqncHLI_g',
      ],
      types: [
        {
          t: '150',
          r: 0,
          c: '/v1/fit/w_150,h_150,q_70,strp/<prettyName>-150.jpg',
          h: 150,
          w: 113,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_300,h_300,q_70,strp/<prettyName>-150-2x.jpg',
            },
          ],
        },
        {
          t: '200H',
          r: 0,
          c: '/v1/fill/w_150,h_200,q_70,strp/<prettyName>-200h.jpg',
          h: 200,
          w: 150,
          ss: [
            {
              x: 2,
              c: '/v1/fill/w_300,h_400,q_70,strp/<prettyName>-200h-2x.jpg',
            },
          ],
        },
        {
          t: '300W',
          r: 0,
          c: '/v1/fit/w_300,h_900,q_70,strp/<prettyName>-300w.jpg',
          h: 400,
          w: 300,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_600,h_1800,q_70,strp/<prettyName>-300w-2x.jpg',
            },
          ],
        },
        {
          t: '375W',
          r: 0,
          c: '/v1/fit/w_375,h_500,q_70,strp/<prettyName>-375w.jpg',
          h: 500,
          w: 375,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_750,h_1000,q_70,strp/<prettyName>-375w-2x.jpg',
            },
          ],
        },
        {
          t: '414W',
          r: 0,
          c: '/v1/fit/w_414,h_552,q_70,strp/<prettyName>-414w.jpg',
          h: 552,
          w: 414,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_828,h_1104,q_70,strp/<prettyName>-414w-2x.jpg',
            },
          ],
        },
        {
          t: '250T',
          r: 0,
          c: '/v1/crop/w_188,h_250,x_0,y_0,scl_0.04690618762475,q_70,strp/<prettyName>-250t.jpg',
          h: 250,
          w: 188,
          ss: [
            {
              x: 2,
              c: '/v1/fill/w_375,h_500,q_70,strp/<prettyName>-250t-2x.jpg',
            },
          ],
        },
        {
          t: '350T',
          r: 0,
          c: '/v1/crop/w_263,h_350,x_0,y_0,scl_0.06561876247505,q_70,strp/<prettyName>-350t.jpg',
          h: 350,
          w: 263,
          ss: [
            {
              x: 2,
              c: '/v1/fill/w_525,h_700,q_70,strp/<prettyName>-350t-2x.jpg',
            },
          ],
        },
        {
          t: '400T',
          r: 0,
          c: '/v1/fill/w_300,h_400,q_70,strp/<prettyName>-400t.jpg',
          h: 400,
          w: 300,
          ss: [
            {
              x: 2,
              c: '/v1/fill/w_600,h_800,q_70,strp/<prettyName>-400t-2x.jpg',
            },
          ],
        },
        {
          t: 'preview',
          r: 0,
          c: '/v1/fill/w_774,h_1032,q_70,strp/<prettyName>-pre.jpg',
          h: 1032,
          w: 774,
          f: 5563165,
        },
        {
          t: 'social_preview',
          r: 0,
          c: '/v1/fill/w_774,h_1032,q_70,strp/<prettyName>-pre.jpg',
          h: 1032,
          w: 774,
        },
        {
          t: 'fullview',
          r: 1,
          h: 5344,
          w: 4008,
          f: 5563165,
        },
        {
          t: '92S',
          r: 0,
          c: '/v1/crop/w_92,h_92,x_0,y_8,scl_0.022954091816367,q_70,strp/<prettyName>-92s.jpg',
          h: 92,
          w: 92,
          ss: [
            {
              x: 2,
              c: '/v1/crop/w_184,h_184,x_0,y_15,scl_0.045908183632735,q_70,strp/<prettyName>-92s-2x.jpg',
            },
          ],
        },
      ],
    },
  },
  {
    deviationId: 939442288,
    type: 'image',
    typeId: 1,
    url: 'https://www.deviantart.com/f4rt1st/art/Studying-Beksinski-s-photography-939442288',
    title: "Studying Beksinski's photography ",
    isJournal: false,
    isVideo: false,
    isPurchasable: false,
    isFavouritable: true,
    publishedTime: '2022-12-01T23:02:14-0800',
    isTextEditable: false,
    isBackgroundEditable: false,
    legacyTextEditUrl: null,
    isShareable: true,
    isCommentable: true,
    isFavourited: true,
    isDeleted: false,
    isMature: false,
    isNsfg: false,
    isDownloadable: true,
    isAntisocial: false,
    isBlocked: false,
    isPublished: true,
    isDailyDeviation: false,
    hasPrivateComments: false,
    isDreamsofart: false,
    isAiUseDisallowed: true,
    blockReasons: [],
    author: {
      userId: 83026715,
      useridUuid: '0570ebf6-325d-4a72-845b-3e6e374e1273',
      username: 'F4RT1ST',
      usericon: 'https://a.deviantart.net/avatars-big/f/4/f4rt1st.jpg?4',
      type: 'core_access',
      isWatching: true,
      isSubscribed: false,
      isNewDeviant: true,
    },
    stats: {
      comments: 8,
      favourites: 190,
      views: 7259,
      downloads: 5,
    },
    media: {
      baseUri:
        'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/0570ebf6-325d-4a72-845b-3e6e374e1273/dfjbib4-3348e314-7a47-4f03-a464-d8957b6dea4d.jpg',
      prettyName: 'studying_beksinski_s_photography__by_f4rt1st_dfjbib4',
      token: [
        'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7ImhlaWdodCI6Ijw9Mzk4MyIsInBhdGgiOiJcL2ZcLzA1NzBlYmY2LTMyNWQtNGE3Mi04NDViLTNlNmUzNzRlMTI3M1wvZGZqYmliNC0zMzQ4ZTMxNC03YTQ3LTRmMDMtYTQ2NC1kODk1N2I2ZGVhNGQuanBnIiwid2lkdGgiOiI8PTI4NTcifV1dLCJhdWQiOlsidXJuOnNlcnZpY2U6aW1hZ2Uub3BlcmF0aW9ucyJdfQ.gQ9EqACcx21y3e8Fh9RGSkmikjeyBTjhy4KfGGax-RI',
        'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7InBhdGgiOiJcL2ZcLzA1NzBlYmY2LTMyNWQtNGE3Mi04NDViLTNlNmUzNzRlMTI3M1wvZGZqYmliNC0zMzQ4ZTMxNC03YTQ3LTRmMDMtYTQ2NC1kODk1N2I2ZGVhNGQuanBnIn1dXSwiYXVkIjpbInVybjpzZXJ2aWNlOmZpbGUuZG93bmxvYWQiXX0.nGmsWOLuXObXvwIunCyH3Q9D9WaxiLGSiG_hGQGSlus',
      ],
      types: [
        {
          t: '150',
          r: 0,
          c: '/v1/fit/w_150,h_150,q_70,strp/<prettyName>-150.jpg',
          h: 150,
          w: 108,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_300,h_300,q_70,strp/<prettyName>-150-2x.jpg',
            },
          ],
        },
        {
          t: '200H',
          r: 0,
          c: '/v1/crop/w_143,h_200,x_0,y_0,scl_0.050402520126006,q_70,strp/<prettyName>-200h.jpg',
          h: 200,
          w: 143,
          ss: [
            {
              x: 2,
              c: '/v1/fill/w_287,h_400,q_70,strp/<prettyName>-200h-2x.jpg',
            },
          ],
        },
        {
          t: '300W',
          r: 0,
          c: '/v1/fit/w_300,h_900,q_70,strp/<prettyName>-300w.jpg',
          h: 418,
          w: 300,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_600,h_1800,q_70,strp/<prettyName>-300w-2x.jpg',
            },
          ],
        },
        {
          t: '375W',
          r: 0,
          c: '/v1/fit/w_375,h_523,q_70,strp/<prettyName>-375w.jpg',
          h: 523,
          w: 375,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_750,h_1046,q_70,strp/<prettyName>-375w-2x.jpg',
            },
          ],
        },
        {
          t: '414W',
          r: 0,
          c: '/v1/fit/w_414,h_577,q_70,strp/<prettyName>-414w.jpg',
          h: 577,
          w: 414,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_828,h_1154,q_70,strp/<prettyName>-414w-2x.jpg',
            },
          ],
        },
        {
          t: '250T',
          r: 0,
          c: '/v1/fill/w_179,h_250,q_70,strp/<prettyName>-250t.jpg',
          h: 250,
          w: 179,
          ss: [
            {
              x: 2,
              c: '/v1/fill/w_359,h_500,q_70,strp/<prettyName>-250t-2x.jpg',
            },
          ],
        },
        {
          t: '350T',
          r: 0,
          c: '/v1/fill/w_251,h_350,q_70,strp/<prettyName>-350t.jpg',
          h: 350,
          w: 251,
          ss: [
            {
              x: 2,
              c: '/v1/fill/w_502,h_700,q_70,strp/<prettyName>-350t-2x.jpg',
            },
          ],
        },
        {
          t: '400T',
          r: 0,
          c: '/v1/fill/w_287,h_400,q_70,strp/<prettyName>-400t.jpg',
          h: 400,
          w: 287,
          ss: [
            {
              x: 2,
              c: '/v1/fill/w_574,h_800,q_70,strp/<prettyName>-400t-2x.jpg',
            },
          ],
        },
        {
          t: 'preview',
          r: 0,
          c: '/v1/fill/w_757,h_1056,q_70,strp/<prettyName>-pre.jpg',
          h: 1056,
          w: 757,
          f: 3089920,
        },
        {
          t: 'social_preview',
          r: 0,
          c: '/v1/fill/w_757,h_1056,q_70,strp/<prettyName>-pre.jpg',
          h: 1056,
          w: 757,
        },
        {
          t: 'fullview',
          r: 1,
          h: 3983,
          w: 2857,
          f: 3089920,
        },
        {
          t: '92S',
          r: 0,
          c: '/v1/crop/w_92,h_92,x_0,y_9,scl_0.032201610080504,q_70,strp/<prettyName>-92s.jpg',
          h: 92,
          w: 92,
          ss: [
            {
              x: 2,
              c: '/v1/crop/w_184,h_184,x_0,y_18,scl_0.064403220161008,q_70,strp/<prettyName>-92s-2x.jpg',
            },
          ],
        },
      ],
    },
  },
  {
    deviationId: 932779355,
    type: 'image',
    typeId: 1,
    url: 'https://www.deviantart.com/igo4987/art/Music-Angel-932779355',
    title: 'Music. Angel',
    isJournal: false,
    isVideo: false,
    isPurchasable: false,
    isFavouritable: true,
    publishedTime: '2022-10-12T04:00:37-0700',
    isTextEditable: false,
    isBackgroundEditable: false,
    legacyTextEditUrl: null,
    isShareable: true,
    isCommentable: true,
    isFavourited: true,
    isDeleted: false,
    isMature: false,
    isNsfg: false,
    isDownloadable: true,
    isAntisocial: false,
    isBlocked: false,
    isPublished: true,
    isDailyDeviation: false,
    hasPrivateComments: false,
    isDreamsofart: false,
    isAiUseDisallowed: true,
    blockReasons: [],
    author: {
      userId: 52617575,
      useridUuid: '48160854-3189-45db-bc49-9eb6c9f5eedd',
      username: 'igo4987',
      usericon: 'https://a.deviantart.net/avatars-big/i/g/igo4987.jpg?2',
      type: 'regular',
      isWatching: true,
      isSubscribed: false,
      isNewDeviant: false,
    },
    stats: {
      comments: 9,
      favourites: 130,
      views: 5108,
      downloads: 4,
    },
    media: {
      baseUri:
        'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/48160854-3189-45db-bc49-9eb6c9f5eedd/dffcp5n-b2e9d0f1-bc8f-4d6e-b357-4905819c1f41.png',
      prettyName: 'music__angel_by_igo4987_dffcp5n',
      token: [
        'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7ImhlaWdodCI6Ijw9MTcwNyIsInBhdGgiOiJcL2ZcLzQ4MTYwODU0LTMxODktNDVkYi1iYzQ5LTllYjZjOWY1ZWVkZFwvZGZmY3A1bi1iMmU5ZDBmMS1iYzhmLTRkNmUtYjM1Ny00OTA1ODE5YzFmNDEucG5nIiwid2lkdGgiOiI8PTEyODAifV1dLCJhdWQiOlsidXJuOnNlcnZpY2U6aW1hZ2Uub3BlcmF0aW9ucyJdfQ.wlPRTWhQnFh0sYvMAa0XyF9ZuGcCmBUAXEQB92WbqpM',
      ],
      types: [
        {
          t: '150',
          r: 0,
          c: '/v1/fit/w_150,h_150,q_70,strp/<prettyName>-150.jpg',
          h: 150,
          w: 112,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_300,h_300,q_70,strp/<prettyName>-150-2x.jpg',
            },
          ],
        },
        {
          t: '200H',
          r: 0,
          c: '/v1/fill/w_150,h_200,q_70,strp/<prettyName>-200h.jpg',
          h: 200,
          w: 150,
          ss: [
            {
              x: 2,
              c: '/v1/fill/w_300,h_400,q_70,strp/<prettyName>-200h-2x.jpg',
            },
          ],
        },
        {
          t: '300W',
          r: 0,
          c: '/v1/fit/w_300,h_900,q_70,strp/<prettyName>-300w.jpg',
          h: 400,
          w: 300,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_600,h_1707,q_70,strp/<prettyName>-300w-2x.jpg',
            },
          ],
        },
        {
          t: '375W',
          r: 0,
          c: '/v1/fit/w_375,h_500,q_70,strp/<prettyName>-375w.jpg',
          h: 500,
          w: 375,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_750,h_1000,q_70,strp/<prettyName>-375w-2x.jpg',
            },
          ],
        },
        {
          t: '414W',
          r: 0,
          c: '/v1/fit/w_414,h_552,q_70,strp/<prettyName>-414w.jpg',
          h: 552,
          w: 414,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_828,h_1104,q_70,strp/<prettyName>-414w-2x.jpg',
            },
          ],
        },
        {
          t: '250T',
          r: 0,
          c: '/v1/crop/w_188,h_250,x_0,y_0,scl_0.083555555555556,q_70,strp/<prettyName>-250t.jpg',
          h: 250,
          w: 187,
          ss: [
            {
              x: 2,
              c: '/v1/fill/w_375,h_500,q_70,strp/<prettyName>-250t-2x.jpg',
            },
          ],
        },
        {
          t: '350T',
          r: 0,
          c: '/v1/crop/w_263,h_350,x_0,y_0,scl_0.11688888888889,q_70,strp/<prettyName>-350t.jpg',
          h: 350,
          w: 262,
          ss: [
            {
              x: 2,
              c: '/v1/fill/w_525,h_700,q_70,strp/<prettyName>-350t-2x.jpg',
            },
          ],
        },
        {
          t: '400T',
          r: 0,
          c: '/v1/fill/w_300,h_400,q_70,strp/<prettyName>-400t.jpg',
          h: 400,
          w: 300,
          ss: [
            {
              x: 2,
              c: '/v1/fill/w_600,h_800,q_70,strp/<prettyName>-400t-2x.jpg',
            },
          ],
        },
        {
          t: 'preview',
          r: 0,
          c: '/v1/fill/w_774,h_1032,q_70,strp/<prettyName>-pre.jpg',
          h: 1032,
          w: 774,
          f: 9867052,
        },
        {
          t: 'social_preview',
          r: 0,
          c: '/v1/fill/w_774,h_1032,q_70,strp/<prettyName>-pre.jpg',
          h: 1032,
          w: 774,
        },
        {
          t: 'fullview',
          r: 0,
          c: '/v1/fill/w_1280,h_1707,q_80,strp/<prettyName>-fullview.jpg',
          h: 1707,
          w: 1280,
          f: 9867052,
        },
        {
          t: '92S',
          r: 0,
          c: '/v1/crop/w_92,h_92,x_0,y_8,scl_0.040888888888889,q_70,strp/<prettyName>-92s.jpg',
          h: 92,
          w: 92,
          ss: [
            {
              x: 2,
              c: '/v1/crop/w_184,h_184,x_0,y_15,scl_0.081777777777778,q_70,strp/<prettyName>-92s-2x.jpg',
            },
          ],
        },
      ],
    },
  },
  {
    deviationId: 931830001,
    type: 'image',
    typeId: 1,
    url: 'https://www.deviantart.com/nelsondaniel/art/Inktober-02-931830001',
    title: 'Inktober 02',
    isJournal: false,
    isVideo: false,
    isPurchasable: false,
    isFavouritable: true,
    publishedTime: '2022-10-04T04:46:43-0700',
    isTextEditable: false,
    isBackgroundEditable: false,
    legacyTextEditUrl: null,
    isShareable: true,
    isCommentable: true,
    isFavourited: true,
    isDeleted: false,
    isMature: false,
    isNsfg: false,
    isDownloadable: true,
    isAntisocial: false,
    isBlocked: false,
    isPublished: true,
    isDailyDeviation: false,
    hasPrivateComments: false,
    isDreamsofart: false,
    isAiUseDisallowed: true,
    blockReasons: [],
    author: {
      userId: 9560873,
      useridUuid: '37b12d2b-ab48-4f2a-8a0c-9eac3eb8a6c5',
      username: 'nelsondaniel',
      usericon: 'https://a.deviantart.net/avatars-big/n/e/nelsondaniel.png?5',
      type: 'regular',
      isWatching: false,
      isSubscribed: false,
      isNewDeviant: false,
    },
    stats: {
      comments: 6,
      favourites: 168,
      views: 5479,
      downloads: 12,
    },
    media: {
      baseUri:
        'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/37b12d2b-ab48-4f2a-8a0c-9eac3eb8a6c5/dfescmp-c11a51ba-c339-42f5-90a4-23025227a03c.jpg',
      prettyName: 'inktober_02_by_nelsondaniel_dfescmp',
      token: [
        'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7ImhlaWdodCI6Ijw9OTkzIiwicGF0aCI6IlwvZlwvMzdiMTJkMmItYWI0OC00ZjJhLThhMGMtOWVhYzNlYjhhNmM1XC9kZmVzY21wLWMxMWE1MWJhLWMzMzktNDJmNS05MGE0LTIzMDI1MjI3YTAzYy5qcGciLCJ3aWR0aCI6Ijw9OTkzIn1dXSwiYXVkIjpbInVybjpzZXJ2aWNlOmltYWdlLm9wZXJhdGlvbnMiXX0.9CWYaWc5EvF-Tv0AfTPmHgj6q9ipOpXvAYuJWib5hUA',
        'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7InBhdGgiOiJcL2ZcLzM3YjEyZDJiLWFiNDgtNGYyYS04YTBjLTllYWMzZWI4YTZjNVwvZGZlc2NtcC1jMTFhNTFiYS1jMzM5LTQyZjUtOTBhNC0yMzAyNTIyN2EwM2MuanBnIn1dXSwiYXVkIjpbInVybjpzZXJ2aWNlOmZpbGUuZG93bmxvYWQiXX0.jYdZN3lOXj-cGyLpwFLeWAW8_AwTZlRMcqjDh9Fasvs',
      ],
      types: [
        {
          t: '150',
          r: 0,
          c: '/v1/fit/w_150,h_150,q_70,strp/<prettyName>-150.jpg',
          h: 150,
          w: 150,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_300,h_300,q_70,strp/<prettyName>-150-2x.jpg',
            },
          ],
        },
        {
          t: '200H',
          r: 0,
          c: '/v1/fill/w_200,h_200,q_70,strp/<prettyName>-200h.jpg',
          h: 200,
          w: 200,
          ss: [
            {
              x: 2,
              c: '/v1/fill/w_400,h_400,q_70,strp/<prettyName>-200h-2x.jpg',
            },
          ],
        },
        {
          t: '300W',
          r: 0,
          c: '/v1/fit/w_300,h_900,q_70,strp/<prettyName>-300w.jpg',
          h: 300,
          w: 300,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_600,h_993,q_70,strp/<prettyName>-300w-2x.jpg',
            },
          ],
        },
        {
          t: '375W',
          r: 0,
          c: '/v1/fit/w_375,h_375,q_70,strp/<prettyName>-375w.jpg',
          h: 375,
          w: 375,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_750,h_750,q_70,strp/<prettyName>-375w-2x.jpg',
            },
          ],
        },
        {
          t: '414W',
          r: 0,
          c: '/v1/fit/w_414,h_414,q_70,strp/<prettyName>-414w.jpg',
          h: 414,
          w: 414,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_828,h_828,q_70,strp/<prettyName>-414w-2x.jpg',
            },
          ],
        },
        {
          t: '250T',
          r: 0,
          c: '/v1/fill/w_250,h_250,q_70,strp/<prettyName>-250t.jpg',
          h: 250,
          w: 250,
          ss: [
            {
              x: 2,
              c: '/v1/fill/w_500,h_500,q_70,strp/<prettyName>-250t-2x.jpg',
            },
          ],
        },
        {
          t: '350T',
          r: 0,
          c: '/v1/fill/w_350,h_350,q_70,strp/<prettyName>-350t.jpg',
          h: 350,
          w: 350,
          ss: [
            {
              x: 2,
              c: '/v1/fill/w_700,h_700,q_70,strp/<prettyName>-350t-2x.jpg',
            },
          ],
        },
        {
          t: '400T',
          r: 0,
          c: '/v1/fill/w_400,h_400,q_70,strp/<prettyName>-400t.jpg',
          h: 400,
          w: 400,
          ss: [
            {
              x: 2,
              c: '/v1/fill/w_800,h_800,q_70,strp/<prettyName>-400t-2x.jpg',
            },
          ],
        },
        {
          t: 'preview',
          r: 0,
          c: '/v1/fill/w_894,h_894,q_70,strp/<prettyName>-pre.jpg',
          h: 894,
          w: 894,
          f: 432873,
        },
        {
          t: 'social_preview',
          r: 0,
          c: '/v1/fill/w_894,h_894,q_70,strp/<prettyName>-pre.jpg',
          h: 894,
          w: 894,
        },
        {
          t: 'fullview',
          r: 1,
          h: 993,
          w: 993,
          f: 432873,
        },
        {
          t: '92S',
          r: 0,
          c: '/v1/crop/w_92,h_92,x_0,y_0,scl_0.092648539778449,q_70,strp/<prettyName>-92s.jpg',
          h: 92,
          w: 92,
          ss: [
            {
              x: 2,
              c: '/v1/crop/w_184,h_184,x_0,y_0,scl_0.1852970795569,q_70,strp/<prettyName>-92s-2x.jpg',
            },
          ],
        },
      ],
    },
  },
  {
    deviationId: 928866394,
    type: 'image',
    typeId: 1,
    url: 'https://www.deviantart.com/coolzone17500/art/Cosmic-Elementary-928866394',
    title: 'Cosmic Elementary',
    isJournal: false,
    isVideo: false,
    isPurchasable: false,
    isFavouritable: true,
    publishedTime: '2022-09-09T01:34:03-0700',
    isTextEditable: false,
    isBackgroundEditable: false,
    legacyTextEditUrl: null,
    isShareable: true,
    isCommentable: true,
    isFavourited: true,
    isDeleted: false,
    isMature: false,
    isNsfg: false,
    isDownloadable: true,
    isAntisocial: false,
    isBlocked: false,
    isPublished: true,
    isDailyDeviation: false,
    hasPrivateComments: false,
    isDreamsofart: false,
    isAiUseDisallowed: true,
    blockReasons: [],
    author: {
      userId: 44345754,
      useridUuid: '5786bd06-7524-4b35-b31c-cc53ee2c9073',
      username: 'COOLZONE17500',
      usericon: 'https://a.deviantart.net/avatars-big/c/o/coolzone17500.gif?4',
      type: 'regular',
      isWatching: false,
      isSubscribed: false,
      isNewDeviant: false,
    },
    stats: {
      comments: 0,
      favourites: 92,
      views: 3764,
      downloads: 5,
    },
    media: {
      baseUri:
        'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/5786bd06-7524-4b35-b31c-cc53ee2c9073/dfd0twa-455db6a2-be7e-40f4-af6d-dc2bd6708612.jpg',
      prettyName: 'cosmic_elementary_by_coolzone17500_dfd0twa',
      token: [
        'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7ImhlaWdodCI6Ijw9Mjg4MCIsInBhdGgiOiJcL2ZcLzU3ODZiZDA2LTc1MjQtNGIzNS1iMzFjLWNjNTNlZTJjOTA3M1wvZGZkMHR3YS00NTVkYjZhMi1iZTdlLTQwZjQtYWY2ZC1kYzJiZDY3MDg2MTIuanBnIiwid2lkdGgiOiI8PTUxMjAifV1dLCJhdWQiOlsidXJuOnNlcnZpY2U6aW1hZ2Uub3BlcmF0aW9ucyJdfQ.FgUD0lGXf6tjAK2pXbfrXceAk1EpVA42za6TR3hZ3LU',
        'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7InBhdGgiOiJcL2ZcLzU3ODZiZDA2LTc1MjQtNGIzNS1iMzFjLWNjNTNlZTJjOTA3M1wvZGZkMHR3YS00NTVkYjZhMi1iZTdlLTQwZjQtYWY2ZC1kYzJiZDY3MDg2MTIuanBnIn1dXSwiYXVkIjpbInVybjpzZXJ2aWNlOmZpbGUuZG93bmxvYWQiXX0.40uUf72qV4oBWMZ3q1J12D9WRe65bszhaz3wcJKIkFo',
      ],
      types: [
        {
          t: '150',
          r: 0,
          c: '/v1/fit/w_150,h_150,q_70,strp/<prettyName>-150.jpg',
          h: 84,
          w: 150,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_300,h_300,q_70,strp/<prettyName>-150-2x.jpg',
            },
          ],
        },
        {
          t: '200H',
          r: 0,
          c: '/v1/fill/w_300,h_169,q_70,strp/<prettyName>-200h.jpg',
          h: 169,
          w: 300,
          ss: [
            {
              x: 2,
              c: '/v1/fill/w_600,h_338,q_70,strp/<prettyName>-200h-2x.jpg',
            },
          ],
        },
        {
          t: '300W',
          r: 0,
          c: '/v1/fit/w_300,h_900,q_70,strp/<prettyName>-300w.jpg',
          h: 169,
          w: 300,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_600,h_1800,q_70,strp/<prettyName>-300w-2x.jpg',
            },
          ],
        },
        {
          t: '375W',
          r: 0,
          c: '/v1/fit/w_375,h_211,q_70,strp/<prettyName>-375w.jpg',
          h: 211,
          w: 375,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_750,h_422,q_70,strp/<prettyName>-375w-2x.jpg',
            },
          ],
        },
        {
          t: '414W',
          r: 0,
          c: '/v1/fit/w_414,h_233,q_70,strp/<prettyName>-414w.jpg',
          h: 233,
          w: 414,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_828,h_466,q_70,strp/<prettyName>-414w-2x.jpg',
            },
          ],
        },
        {
          t: '250T',
          r: 0,
          c: '/v1/fill/w_444,h_250,q_70,strp/<prettyName>-250t.jpg',
          h: 250,
          w: 444,
          ss: [
            {
              x: 2,
              c: '/v1/fill/w_889,h_500,q_70,strp/<prettyName>-250t-2x.jpg',
            },
          ],
        },
        {
          t: '350T',
          r: 0,
          c: '/v1/fill/w_622,h_350,q_70,strp/<prettyName>-350t.jpg',
          h: 350,
          w: 622,
          ss: [
            {
              x: 2,
              c: '/v1/fill/w_1244,h_700,q_70,strp/<prettyName>-350t-2x.jpg',
            },
          ],
        },
        {
          t: '400T',
          r: 0,
          c: '/v1/fill/w_711,h_400,q_70,strp/<prettyName>-400t.jpg',
          h: 400,
          w: 711,
          ss: [
            {
              x: 2,
              c: '/v1/fill/w_1422,h_800,q_70,strp/<prettyName>-400t-2x.jpg',
            },
          ],
        },
        {
          t: 'preview',
          r: 0,
          c: '/v1/fill/w_1192,h_670,q_70,strp/<prettyName>-pre.jpg',
          h: 670,
          w: 1192,
          f: 33740271,
        },
        {
          t: 'social_preview',
          r: 0,
          c: '/v1/fill/w_1192,h_670,q_70,strp/<prettyName>-pre.jpg',
          h: 670,
          w: 1192,
        },
        {
          t: 'fullview',
          r: 1,
          h: 2880,
          w: 5120,
          f: 33740271,
        },
        {
          t: '92S',
          r: 0,
          c: '/v1/crop/w_92,h_92,x_18,y_0,scl_0.031944444444444,q_70,strp/<prettyName>-92s.jpg',
          h: 92,
          w: 92,
          ss: [
            {
              x: 2,
              c: '/v1/crop/w_184,h_184,x_36,y_0,scl_0.063888888888889,q_70,strp/<prettyName>-92s-2x.jpg',
            },
          ],
        },
      ],
    },
  },
  {
    deviationId: 920725067,
    type: 'image',
    typeId: 1,
    url: 'https://www.deviantart.com/rasrgallery/art/Ocean-floor-920725067',
    title: 'Ocean floor',
    isJournal: false,
    isVideo: false,
    isPurchasable: false,
    isFavouritable: true,
    publishedTime: '2022-06-27T23:53:43-0700',
    isTextEditable: false,
    isBackgroundEditable: false,
    legacyTextEditUrl: null,
    isShareable: true,
    isCommentable: true,
    isFavourited: true,
    isDeleted: false,
    isMature: false,
    isNsfg: false,
    isDownloadable: false,
    isAntisocial: false,
    isBlocked: false,
    isPublished: true,
    isDailyDeviation: false,
    hasPrivateComments: false,
    isDreamsofart: false,
    isAiUseDisallowed: true,
    blockReasons: [],
    author: {
      userId: 74831527,
      useridUuid: 'e52faaa1-fd93-428f-9534-6a43e1cc1de2',
      username: 'RasrGallery',
      usericon: 'https://a.deviantart.net/avatars-big/r/a/rasrgallery.jpg?6',
      type: 'regular',
      isWatching: false,
      isSubscribed: false,
      isNewDeviant: false,
    },
    stats: {
      comments: 4,
      favourites: 163,
      views: 6599,
      downloads: 0,
    },
    media: {
      baseUri:
        'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/e52faaa1-fd93-428f-9534-6a43e1cc1de2/df86c0b-0475df64-cc37-4e9c-8572-343e3e58adea.png',
      prettyName: 'ocean_floor_by_rasrgallery_df86c0b',
      token: [
        'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7ImhlaWdodCI6Ijw9NzY4IiwicGF0aCI6IlwvZlwvZTUyZmFhYTEtZmQ5My00MjhmLTk1MzQtNmE0M2UxY2MxZGUyXC9kZjg2YzBiLTA0NzVkZjY0LWNjMzctNGU5Yy04NTcyLTM0M2UzZTU4YWRlYS5wbmciLCJ3aWR0aCI6Ijw9MTI4MCJ9XV0sImF1ZCI6WyJ1cm46c2VydmljZTppbWFnZS5vcGVyYXRpb25zIl19.QmHUw4YhSOP0x2RR9Xpl9_3yue3qbscfYsnwsxyLaOU',
        'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7InBhdGgiOiJcL2ZcL2U1MmZhYWExLWZkOTMtNDI4Zi05NTM0LTZhNDNlMWNjMWRlMlwvZGY4NmMwYi0wNDc1ZGY2NC1jYzM3LTRlOWMtODU3Mi0zNDNlM2U1OGFkZWEucG5nIn1dXSwiYXVkIjpbInVybjpzZXJ2aWNlOmZpbGUuZG93bmxvYWQiXX0.1GEB-DlLOKtxwUZQ5jBHaunMOQbbefNwdNeb1a3S3Zk',
      ],
      types: [
        {
          t: '150',
          r: 0,
          c: '/v1/fit/w_150,h_150,q_70,strp/<prettyName>-150.jpg',
          h: 90,
          w: 150,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_300,h_300,q_70,strp/<prettyName>-150-2x.jpg',
            },
          ],
        },
        {
          t: '200H',
          r: 0,
          c: '/v1/fill/w_300,h_180,q_70,strp/<prettyName>-200h.jpg',
          h: 180,
          w: 300,
          ss: [
            {
              x: 2,
              c: '/v1/fill/w_600,h_360,q_70,strp/<prettyName>-200h-2x.jpg',
            },
          ],
        },
        {
          t: '300W',
          r: 0,
          c: '/v1/fit/w_300,h_768,q_70,strp/<prettyName>-300w.jpg',
          h: 180,
          w: 300,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_600,h_768,q_70,strp/<prettyName>-300w-2x.jpg',
            },
          ],
        },
        {
          t: '375W',
          r: 0,
          c: '/v1/fit/w_375,h_225,q_70,strp/<prettyName>-375w.jpg',
          h: 225,
          w: 375,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_750,h_450,q_70,strp/<prettyName>-375w-2x.jpg',
            },
          ],
        },
        {
          t: '414W',
          r: 0,
          c: '/v1/fit/w_414,h_248,q_70,strp/<prettyName>-414w.jpg',
          h: 248,
          w: 414,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_828,h_496,q_70,strp/<prettyName>-414w-2x.jpg',
            },
          ],
        },
        {
          t: '250T',
          r: 0,
          c: '/v1/fill/w_417,h_250,q_70,strp/<prettyName>-250t.jpg',
          h: 250,
          w: 417,
          ss: [
            {
              x: 2,
              c: '/v1/fill/w_833,h_500,q_70,strp/<prettyName>-250t-2x.jpg',
            },
          ],
        },
        {
          t: '350T',
          r: 0,
          c: '/v1/fill/w_583,h_350,q_70,strp/<prettyName>-350t.jpg',
          h: 350,
          w: 583,
          ss: [
            {
              x: 2,
              c: '/v1/fill/w_1167,h_700,q_70,strp/<prettyName>-350t-2x.jpg',
            },
          ],
        },
        {
          t: '400T',
          r: 0,
          c: '/v1/fill/w_667,h_400,q_70,strp/<prettyName>-400t.jpg',
          h: 400,
          w: 667,
          ss: [
            {
              x: 2,
              c: '/v1/fill/w_1280,h_768,q_70,strp/<prettyName>-400t-2x.jpg',
            },
          ],
        },
        {
          t: 'preview',
          r: 0,
          c: '/v1/fill/w_1154,h_692,q_70,strp/<prettyName>-pre.jpg',
          h: 692,
          w: 1154,
          f: 1889744,
        },
        {
          t: 'social_preview',
          r: 0,
          c: '/v1/fill/w_1154,h_692,q_70,strp/<prettyName>-pre.jpg',
          h: 692,
          w: 1154,
        },
        {
          t: 'fullview',
          r: 1,
          h: 768,
          w: 1280,
          f: 1889744,
        },
        {
          t: '92S',
          r: 0,
          c: '/v1/crop/w_92,h_92,x_15,y_0,scl_0.11979166666667,q_70,strp/<prettyName>-92s.jpg',
          h: 92,
          w: 92,
          ss: [
            {
              x: 2,
              c: '/v1/crop/w_184,h_184,x_31,y_0,scl_0.23958333333333,q_70,strp/<prettyName>-92s-2x.jpg',
            },
          ],
        },
      ],
    },
  },
  {
    deviationId: 921059193,
    type: 'image',
    typeId: 1,
    url: 'https://www.deviantart.com/iammarcin/art/Andromeda-Galaxy-921059193',
    title: 'Andromeda Galaxy',
    isJournal: false,
    isVideo: false,
    isPurchasable: false,
    isFavouritable: true,
    publishedTime: '2022-07-01T03:39:28-0700',
    isTextEditable: false,
    isBackgroundEditable: false,
    legacyTextEditUrl: null,
    isShareable: true,
    isCommentable: true,
    isFavourited: true,
    isDeleted: false,
    isMature: false,
    isNsfg: false,
    isDownloadable: false,
    isAntisocial: false,
    isBlocked: false,
    isPublished: true,
    isDailyDeviation: false,
    hasPrivateComments: false,
    isDreamsofart: false,
    isAiUseDisallowed: true,
    blockReasons: [],
    author: {
      userId: 13429488,
      useridUuid: '7ed68027-f093-4984-b8f9-584ff804ba67',
      username: 'iammarcin',
      usericon: 'https://a.deviantart.net/avatars-big/i/a/iammarcin.jpg?10',
      type: 'regular',
      isWatching: false,
      isSubscribed: false,
      isNewDeviant: false,
    },
    stats: {
      comments: 5,
      favourites: 158,
      views: 9623,
      downloads: 0,
    },
    media: {
      baseUri:
        'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/7ed68027-f093-4984-b8f9-584ff804ba67/df8dhtl-614696c0-87c0-4092-a6f9-7caed7700ba2.jpg',
      prettyName: 'andromeda_galaxy_by_iammarcin_df8dhtl',
      token: [
        'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7ImhlaWdodCI6Ijw9MTA3NSIsInBhdGgiOiJcL2ZcLzdlZDY4MDI3LWYwOTMtNDk4NC1iOGY5LTU4NGZmODA0YmE2N1wvZGY4ZGh0bC02MTQ2OTZjMC04N2MwLTQwOTItYTZmOS03Y2FlZDc3MDBiYTIuanBnIiwid2lkdGgiOiI8PTE2MDAifV1dLCJhdWQiOlsidXJuOnNlcnZpY2U6aW1hZ2Uub3BlcmF0aW9ucyJdfQ.RYCdepYMtQXGPEvYamHeyZ9wo5hHnGg8ZBrruF1cra0',
      ],
      types: [
        {
          t: '150',
          r: 0,
          c: '/v1/fit/w_150,h_150,q_70,strp/<prettyName>-150.jpg',
          h: 101,
          w: 150,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_300,h_300,q_70,strp/<prettyName>-150-2x.jpg',
            },
          ],
        },
        {
          t: '200H',
          r: 0,
          c: '/v1/fill/w_298,h_200,q_70,strp/<prettyName>-200h.jpg',
          h: 200,
          w: 298,
          ss: [
            {
              x: 2,
              c: '/v1/fill/w_596,h_400,q_70,strp/<prettyName>-200h-2x.jpg',
            },
          ],
        },
        {
          t: '300W',
          r: 0,
          c: '/v1/fit/w_300,h_900,q_70,strp/<prettyName>-300w.jpg',
          h: 202,
          w: 300,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_600,h_1075,q_70,strp/<prettyName>-300w-2x.jpg',
            },
          ],
        },
        {
          t: '375W',
          r: 0,
          c: '/v1/fit/w_375,h_252,q_70,strp/<prettyName>-375w.jpg',
          h: 252,
          w: 375,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_750,h_504,q_70,strp/<prettyName>-375w-2x.jpg',
            },
          ],
        },
        {
          t: '414W',
          r: 0,
          c: '/v1/fit/w_414,h_278,q_70,strp/<prettyName>-414w.jpg',
          h: 278,
          w: 414,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_828,h_556,q_70,strp/<prettyName>-414w-2x.jpg',
            },
          ],
        },
        {
          t: '250T',
          r: 0,
          c: '/v1/fill/w_372,h_250,q_70,strp/<prettyName>-250t.jpg',
          h: 250,
          w: 372,
          ss: [
            {
              x: 2,
              c: '/v1/fill/w_745,h_500,q_70,strp/<prettyName>-250t-2x.jpg',
            },
          ],
        },
        {
          t: '350T',
          r: 0,
          c: '/v1/fill/w_521,h_350,q_70,strp/<prettyName>-350t.jpg',
          h: 350,
          w: 521,
          ss: [
            {
              x: 2,
              c: '/v1/fill/w_1043,h_700,q_70,strp/<prettyName>-350t-2x.jpg',
            },
          ],
        },
        {
          t: '400T',
          r: 0,
          c: '/v1/fill/w_596,h_400,q_70,strp/<prettyName>-400t.jpg',
          h: 400,
          w: 595,
          ss: [
            {
              x: 2,
              c: '/v1/fill/w_1191,h_800,q_70,strp/<prettyName>-400t-2x.jpg',
            },
          ],
        },
        {
          t: 'preview',
          r: 0,
          c: '/v1/fill/w_1091,h_733,q_70,strp/<prettyName>-pre.jpg',
          h: 733,
          w: 1091,
          f: 4668749,
        },
        {
          t: 'social_preview',
          r: 0,
          c: '/v1/fill/w_1091,h_733,q_70,strp/<prettyName>-pre.jpg',
          h: 733,
          w: 1091,
        },
        {
          t: 'fullview',
          r: 0,
          c: '/v1/fill/w_1600,h_1075,q_75,strp/<prettyName>-fullview.jpg',
          h: 1075,
          w: 1600,
          f: 4668749,
        },
        {
          t: '92S',
          r: 0,
          c: '/v1/crop/w_92,h_92,x_11,y_0,scl_0.035811599844297,q_70,strp/<prettyName>-92s.jpg',
          h: 92,
          w: 92,
          ss: [
            {
              x: 2,
              c: '/v1/crop/w_184,h_184,x_23,y_0,scl_0.071623199688595,q_70,strp/<prettyName>-92s-2x.jpg',
            },
          ],
        },
      ],
    },
  },
  {
    deviationId: 928341088,
    type: 'image',
    typeId: 1,
    url: 'https://www.deviantart.com/rndmodels/art/Life-Drawing-Class-Pocket-Etch-a-Sketch-Edition-928341088',
    title: 'Life Drawing Class (Pocket Etch-a-Sketch Edition)',
    isJournal: false,
    isVideo: false,
    isPurchasable: false,
    isFavouritable: true,
    publishedTime: '2022-09-04T13:32:51-0700',
    isTextEditable: false,
    isBackgroundEditable: false,
    legacyTextEditUrl: null,
    isShareable: true,
    isCommentable: true,
    isFavourited: true,
    isDeleted: false,
    isMature: false,
    isNsfg: false,
    isDownloadable: true,
    isAntisocial: false,
    isBlocked: false,
    isPublished: true,
    isDailyDeviation: false,
    hasPrivateComments: false,
    isDreamsofart: false,
    isAiUseDisallowed: true,
    blockReasons: [],
    author: {
      userId: 13723444,
      useridUuid: 'ca54b2e2-e97d-4872-8a28-5586818eb42f',
      username: 'RNDmodels',
      usericon: 'https://a.deviantart.net/avatars-big/r/n/rndmodels.jpg?14',
      type: 'core_access',
      isWatching: false,
      isSubscribed: false,
      isNewDeviant: false,
    },
    stats: {
      comments: 47,
      favourites: 125,
      views: 7159,
      downloads: 0,
    },
    media: {
      baseUri:
        'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/ca54b2e2-e97d-4872-8a28-5586818eb42f/dfcpkkg-a95738e2-05bc-4d23-a85a-c36bbd1cbcc8.jpg',
      prettyName: 'life_drawing_class__pocket_etch_a_sketch_edition__by_rndmodels_dfcpkkg',
      token: [
        'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7ImhlaWdodCI6Ijw9OTYwIiwicGF0aCI6IlwvZlwvY2E1NGIyZTItZTk3ZC00ODcyLThhMjgtNTU4NjgxOGViNDJmXC9kZmNwa2tnLWE5NTczOGUyLTA1YmMtNGQyMy1hODVhLWMzNmJiZDFjYmNjOC5qcGciLCJ3aWR0aCI6Ijw9MTI4MCJ9XV0sImF1ZCI6WyJ1cm46c2VydmljZTppbWFnZS5vcGVyYXRpb25zIl19.EBp26dtUDSxylS93Y8zESp58ivRqxcRwWCKOFrClewI',
      ],
      types: [
        {
          t: '150',
          r: 0,
          c: '/v1/fit/w_150,h_150,q_70,strp/<prettyName>-150.jpg',
          h: 113,
          w: 150,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_300,h_300,q_70,strp/<prettyName>-150-2x.jpg',
            },
          ],
        },
        {
          t: '200H',
          r: 0,
          c: '/v1/fill/w_267,h_200,q_70,strp/<prettyName>-200h.jpg',
          h: 200,
          w: 267,
          ss: [
            {
              x: 2,
              c: '/v1/fill/w_533,h_400,q_70,strp/<prettyName>-200h-2x.jpg',
            },
          ],
        },
        {
          t: '300W',
          r: 0,
          c: '/v1/fit/w_300,h_900,q_70,strp/<prettyName>-300w.jpg',
          h: 225,
          w: 300,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_600,h_960,q_70,strp/<prettyName>-300w-2x.jpg',
            },
          ],
        },
        {
          t: '375W',
          r: 0,
          c: '/v1/fit/w_375,h_281,q_70,strp/<prettyName>-375w.jpg',
          h: 281,
          w: 375,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_750,h_562,q_70,strp/<prettyName>-375w-2x.jpg',
            },
          ],
        },
        {
          t: '414W',
          r: 0,
          c: '/v1/fit/w_414,h_311,q_70,strp/<prettyName>-414w.jpg',
          h: 311,
          w: 414,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_828,h_622,q_70,strp/<prettyName>-414w-2x.jpg',
            },
          ],
        },
        {
          t: '250T',
          r: 0,
          c: '/v1/fill/w_333,h_250,q_70,strp/<prettyName>-250t.jpg',
          h: 250,
          w: 333,
          ss: [
            {
              x: 2,
              c: '/v1/fill/w_667,h_500,q_70,strp/<prettyName>-250t-2x.jpg',
            },
          ],
        },
        {
          t: '350T',
          r: 0,
          c: '/v1/fill/w_467,h_350,q_70,strp/<prettyName>-350t.jpg',
          h: 350,
          w: 467,
          ss: [
            {
              x: 2,
              c: '/v1/fill/w_934,h_700,q_70,strp/<prettyName>-350t-2x.jpg',
            },
          ],
        },
        {
          t: '400T',
          r: 0,
          c: '/v1/fill/w_533,h_400,q_70,strp/<prettyName>-400t.jpg',
          h: 400,
          w: 533,
          ss: [
            {
              x: 2,
              c: '/v1/fill/w_1067,h_800,q_70,strp/<prettyName>-400t-2x.jpg',
            },
          ],
        },
        {
          t: 'preview',
          r: 0,
          c: '/v1/fill/w_1032,h_774,q_70,strp/<prettyName>-pre.jpg',
          h: 774,
          w: 1032,
          f: 492139,
        },
        {
          t: 'social_preview',
          r: 0,
          c: '/v1/fill/w_1032,h_774,q_70,strp/<prettyName>-pre.jpg',
          h: 774,
          w: 1032,
        },
        {
          t: 'fullview',
          r: 0,
          c: '/v1/fill/w_1280,h_960,q_75,strp/<prettyName>-fullview.jpg',
          h: 960,
          w: 1280,
          f: 492139,
        },
        {
          t: '92S',
          r: 0,
          c: '/v1/crop/w_92,h_92,x_8,y_0,scl_0.067597354886113,q_70,strp/<prettyName>-92s.jpg',
          h: 92,
          w: 92,
          ss: [
            {
              x: 2,
              c: '/v1/crop/w_184,h_184,x_15,y_0,scl_0.13519470977223,q_70,strp/<prettyName>-92s-2x.jpg',
            },
          ],
        },
      ],
    },
  },
  {
    deviationId: 918549922,
    type: 'image',
    typeId: 1,
    url: 'https://www.deviantart.com/eastblueace/art/sun-of-tomorrow-918549922',
    title: 'sun of tomorrow.',
    isJournal: false,
    isVideo: false,
    isPurchasable: false,
    isFavouritable: true,
    publishedTime: '2022-06-07T08:37:24-0700',
    isTextEditable: false,
    isBackgroundEditable: false,
    legacyTextEditUrl: null,
    isShareable: true,
    isCommentable: true,
    isFavourited: true,
    isDeleted: false,
    isMature: false,
    isNsfg: false,
    isDownloadable: true,
    isAntisocial: false,
    isBlocked: false,
    isPublished: true,
    isDailyDeviation: true,
    hasPrivateComments: false,
    isDreamsofart: false,
    isAiUseDisallowed: true,
    blockReasons: [],
    author: {
      userId: 76041301,
      useridUuid: '9e4aa83f-917b-49b3-a7c4-29db063b53c3',
      username: 'eastblueace',
      usericon: 'https://a.deviantart.net/avatars-big/e/a/eastblueace.jpg',
      type: 'regular',
      isWatching: false,
      isSubscribed: false,
      isNewDeviant: false,
    },
    stats: {
      comments: 33,
      favourites: 550,
      views: 449453,
      downloads: 46,
    },
    media: {
      baseUri:
        'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/9e4aa83f-917b-49b3-a7c4-29db063b53c3/df6vpnm-7b6a1e27-f879-4865-89a1-1707dbc3f9fd.png',
      prettyName: 'sun_of_tomorrow__by_eastblueace_df6vpnm',
      token: [
        'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7ImhlaWdodCI6Ijw9MjA3MSIsInBhdGgiOiJcL2ZcLzllNGFhODNmLTkxN2ItNDliMy1hN2M0LTI5ZGIwNjNiNTNjM1wvZGY2dnBubS03YjZhMWUyNy1mODc5LTQ4NjUtODlhMS0xNzA3ZGJjM2Y5ZmQucG5nIiwid2lkdGgiOiI8PTEyODAifV1dLCJhdWQiOlsidXJuOnNlcnZpY2U6aW1hZ2Uub3BlcmF0aW9ucyJdfQ.7lfqNFfmV3yyy1TzUitrdOgpzaKNjILPEuTW3FyiFVY',
      ],
      types: [
        {
          t: '150',
          r: 0,
          c: '/v1/fit/w_150,h_150,q_70,strp/<prettyName>-150.jpg',
          h: 150,
          w: 93,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_300,h_300,q_70,strp/<prettyName>-150-2x.jpg',
            },
          ],
        },
        {
          t: '200H',
          r: 0,
          c: '/v1/crop/w_124,h_200,x_0,y_0,scl_0.072941176470588,q_70,strp/<prettyName>-200h.jpg',
          h: 200,
          w: 124,
          ss: [
            {
              x: 2,
              c: '/v1/fill/w_247,h_400,q_70,strp/<prettyName>-200h-2x.jpg',
            },
          ],
        },
        {
          t: '300W',
          r: 0,
          c: '/v1/fit/w_300,h_900,q_70,strp/<prettyName>-300w.jpg',
          h: 485,
          w: 300,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_600,h_1800,q_70,strp/<prettyName>-300w-2x.jpg',
            },
          ],
        },
        {
          t: '375W',
          r: 0,
          c: '/v1/fit/w_375,h_607,q_70,strp/<prettyName>-375w.jpg',
          h: 607,
          w: 375,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_750,h_1214,q_70,strp/<prettyName>-375w-2x.jpg',
            },
          ],
        },
        {
          t: '414W',
          r: 0,
          c: '/v1/fit/w_414,h_670,q_70,strp/<prettyName>-414w.jpg',
          h: 670,
          w: 414,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_828,h_1340,q_70,strp/<prettyName>-414w-2x.jpg',
            },
          ],
        },
        {
          t: '250T',
          r: 0,
          c: '/v1/crop/w_155,h_250,x_0,y_0,scl_0.091176470588235,q_70,strp/<prettyName>-250t.jpg',
          h: 250,
          w: 155,
          ss: [
            {
              x: 2,
              c: '/v1/fill/w_309,h_500,q_70,strp/<prettyName>-250t-2x.jpg',
            },
          ],
        },
        {
          t: '350T',
          r: 0,
          c: '/v1/crop/w_216,h_350,x_0,y_0,scl_0.12764705882353,q_70,strp/<prettyName>-350t.jpg',
          h: 350,
          w: 216,
          ss: [
            {
              x: 2,
              c: '/v1/fill/w_433,h_700,q_70,strp/<prettyName>-350t-2x.jpg',
            },
          ],
        },
        {
          t: '400T',
          r: 0,
          c: '/v1/fill/w_247,h_400,q_70,strp/<prettyName>-400t.jpg',
          h: 400,
          w: 247,
          ss: [
            {
              x: 2,
              c: '/v1/crop/w_495,h_800,x_0,y_0,scl_0.29117647058824,q_70,strp/<prettyName>-400t-2x.jpg',
            },
          ],
        },
        {
          t: 'preview',
          r: 0,
          c: '/v1/fill/w_703,h_1137,q_70,strp/<prettyName>-pre.jpg',
          h: 1137,
          w: 703,
          f: 73607,
        },
        {
          t: 'social_preview',
          r: 0,
          c: '/v1/fill/w_703,h_1137,q_70,strp/<prettyName>-pre.jpg',
          h: 1137,
          w: 703,
        },
        {
          t: 'fullview',
          r: 0,
          c: '/v1/fill/w_1280,h_2071,q_80,strp/<prettyName>-fullview.jpg',
          h: 2071,
          w: 1280,
          f: 73607,
        },
        {
          t: '92S',
          r: 0,
          c: '/v1/crop/w_92,h_92,x_0,y_14,scl_0.054117647058824,q_70,strp/<prettyName>-92s.jpg',
          h: 92,
          w: 92,
          ss: [
            {
              x: 2,
              c: '/v1/crop/w_184,h_184,x_0,y_28,scl_0.10823529411765,q_70,strp/<prettyName>-92s-2x.jpg',
            },
          ],
        },
      ],
    },
  },
  {
    deviationId: 918730431,
    type: 'image',
    typeId: 1,
    url: 'https://www.deviantart.com/gudzart/art/Through-the-smoke-918730431',
    title: 'Through the smoke',
    isJournal: false,
    isVideo: false,
    isPurchasable: false,
    isFavouritable: true,
    publishedTime: '2022-06-09T02:06:17-0700',
    isTextEditable: false,
    isBackgroundEditable: false,
    legacyTextEditUrl: null,
    isShareable: true,
    isCommentable: true,
    isFavourited: true,
    isDeleted: false,
    isMature: false,
    isNsfg: false,
    isDownloadable: true,
    isAntisocial: false,
    isBlocked: false,
    isPublished: true,
    isDailyDeviation: false,
    hasPrivateComments: false,
    isDreamsofart: false,
    isAiUseDisallowed: true,
    blockReasons: [],
    author: {
      userId: 45047560,
      useridUuid: '57b38de6-1b18-4abf-804e-3bab24014e65',
      username: 'Gudzart',
      usericon: 'https://a.deviantart.net/avatars-big/g/u/gudzart.jpg?6',
      type: 'core_access',
      isWatching: false,
      isSubscribed: false,
      isNewDeviant: false,
    },
    stats: {
      comments: 4,
      favourites: 191,
      views: 5434,
      downloads: 6,
    },
    media: {
      baseUri:
        'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/57b38de6-1b18-4abf-804e-3bab24014e65/df6zkxr-960acb9e-fa73-413d-aa62-fc0929abf556.jpg',
      prettyName: 'through_the_smoke_by_gudzart_df6zkxr',
      token: [
        'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7ImhlaWdodCI6Ijw9OTYwIiwicGF0aCI6IlwvZlwvNTdiMzhkZTYtMWIxOC00YWJmLTgwNGUtM2JhYjI0MDE0ZTY1XC9kZjZ6a3hyLTk2MGFjYjllLWZhNzMtNDEzZC1hYTYyLWZjMDkyOWFiZjU1Ni5qcGciLCJ3aWR0aCI6Ijw9MTI4MCJ9XV0sImF1ZCI6WyJ1cm46c2VydmljZTppbWFnZS5vcGVyYXRpb25zIl19.ipiswb9CEmWjqdbHdUesgO6reNflrnSQ9bAm10yeum8',
      ],
      types: [
        {
          t: '150',
          r: 0,
          c: '/v1/fit/w_150,h_150,q_70,strp/<prettyName>-150.jpg',
          h: 113,
          w: 150,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_300,h_300,q_70,strp/<prettyName>-150-2x.jpg',
            },
          ],
        },
        {
          t: '200H',
          r: 0,
          c: '/v1/fill/w_267,h_200,q_70,strp/<prettyName>-200h.jpg',
          h: 200,
          w: 267,
          ss: [
            {
              x: 2,
              c: '/v1/fill/w_533,h_400,q_70,strp/<prettyName>-200h-2x.jpg',
            },
          ],
        },
        {
          t: '300W',
          r: 0,
          c: '/v1/fit/w_300,h_900,q_70,strp/<prettyName>-300w.jpg',
          h: 225,
          w: 300,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_600,h_960,q_70,strp/<prettyName>-300w-2x.jpg',
            },
          ],
        },
        {
          t: '375W',
          r: 0,
          c: '/v1/fit/w_375,h_281,q_70,strp/<prettyName>-375w.jpg',
          h: 281,
          w: 375,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_750,h_562,q_70,strp/<prettyName>-375w-2x.jpg',
            },
          ],
        },
        {
          t: '414W',
          r: 0,
          c: '/v1/fit/w_414,h_311,q_70,strp/<prettyName>-414w.jpg',
          h: 311,
          w: 414,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_828,h_622,q_70,strp/<prettyName>-414w-2x.jpg',
            },
          ],
        },
        {
          t: '250T',
          r: 0,
          c: '/v1/fill/w_333,h_250,q_70,strp/<prettyName>-250t.jpg',
          h: 250,
          w: 333,
          ss: [
            {
              x: 2,
              c: '/v1/fill/w_667,h_500,q_70,strp/<prettyName>-250t-2x.jpg',
            },
          ],
        },
        {
          t: '350T',
          r: 0,
          c: '/v1/fill/w_467,h_350,q_70,strp/<prettyName>-350t.jpg',
          h: 350,
          w: 467,
          ss: [
            {
              x: 2,
              c: '/v1/fill/w_933,h_700,q_70,strp/<prettyName>-350t-2x.jpg',
            },
          ],
        },
        {
          t: '400T',
          r: 0,
          c: '/v1/fill/w_533,h_400,q_70,strp/<prettyName>-400t.jpg',
          h: 400,
          w: 533,
          ss: [
            {
              x: 2,
              c: '/v1/fill/w_1067,h_800,q_70,strp/<prettyName>-400t-2x.jpg',
            },
          ],
        },
        {
          t: 'preview',
          r: 0,
          c: '/v1/fill/w_1032,h_774,q_70,strp/<prettyName>-pre.jpg',
          h: 774,
          w: 1032,
          f: 4115633,
        },
        {
          t: 'social_preview',
          r: 0,
          c: '/v1/fill/w_1032,h_774,q_70,strp/<prettyName>-pre.jpg',
          h: 774,
          w: 1032,
        },
        {
          t: 'fullview',
          r: 0,
          c: '/v1/fill/w_1280,h_960,q_75,strp/<prettyName>-fullview.jpg',
          h: 960,
          w: 1280,
          f: 4115633,
        },
        {
          t: '92S',
          r: 0,
          c: '/v1/crop/w_92,h_92,x_8,y_0,scl_0.029715762273902,q_70,strp/<prettyName>-92s.jpg',
          h: 92,
          w: 92,
          ss: [
            {
              x: 2,
              c: '/v1/crop/w_184,h_184,x_15,y_0,scl_0.059431524547804,q_70,strp/<prettyName>-92s-2x.jpg',
            },
          ],
        },
      ],
    },
  },
  {
    deviationId: 918529207,
    type: 'image',
    typeId: 1,
    url: 'https://www.deviantart.com/organicvision/art/Seaside-Guardians-918529207',
    title: 'Seaside Guardians',
    isJournal: false,
    isVideo: false,
    isPurchasable: false,
    isFavouritable: true,
    publishedTime: '2022-06-07T03:04:36-0700',
    isTextEditable: false,
    isBackgroundEditable: false,
    legacyTextEditUrl: null,
    isShareable: true,
    isCommentable: true,
    isFavourited: true,
    isDeleted: false,
    isMature: false,
    isNsfg: false,
    isDownloadable: false,
    isAntisocial: false,
    isBlocked: false,
    isPublished: true,
    isDailyDeviation: true,
    hasPrivateComments: false,
    isDreamsofart: false,
    isAiUseDisallowed: true,
    blockReasons: [],
    author: {
      userId: 21703705,
      useridUuid: 'd596863a-3f04-416d-91fb-7fb7c3c5fb83',
      username: 'organicvision',
      usericon: 'https://a.deviantart.net/avatars-big/o/r/organicvision.jpg?10',
      type: 'regular',
      isWatching: false,
      isSubscribed: false,
      isNewDeviant: false,
    },
    stats: {
      comments: 66,
      favourites: 335,
      views: 454337,
      downloads: 0,
    },
    media: {
      baseUri:
        'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/d596863a-3f04-416d-91fb-7fb7c3c5fb83/df6v9o7-a1875b7c-25ba-40db-b51e-bd1228061027.jpg',
      prettyName: 'seaside_guardians_by_organicvision_df6v9o7',
      token: [
        'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7ImhlaWdodCI6Ijw9ODU0IiwicGF0aCI6IlwvZlwvZDU5Njg2M2EtM2YwNC00MTZkLTkxZmItN2ZiN2MzYzVmYjgzXC9kZjZ2OW83LWExODc1YjdjLTI1YmEtNDBkYi1iNTFlLWJkMTIyODA2MTAyNy5qcGciLCJ3aWR0aCI6Ijw9MTI4MCJ9XV0sImF1ZCI6WyJ1cm46c2VydmljZTppbWFnZS5vcGVyYXRpb25zIl19.mnQ0doM7IGnfpSG4C2cVTUkj8dKzwoqyn6Us_8yhRt8',
      ],
      types: [
        {
          t: '150',
          r: 0,
          c: '/v1/fit/w_150,h_150,q_70,strp/<prettyName>-150.jpg',
          h: 100,
          w: 150,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_300,h_300,q_70,strp/<prettyName>-150-2x.jpg',
            },
          ],
        },
        {
          t: '200H',
          r: 0,
          c: '/v1/fill/w_300,h_200,q_70,strp/<prettyName>-200h.jpg',
          h: 200,
          w: 300,
          ss: [
            {
              x: 2,
              c: '/v1/fill/w_600,h_400,q_70,strp/<prettyName>-200h-2x.jpg',
            },
          ],
        },
        {
          t: '300W',
          r: 0,
          c: '/v1/fit/w_300,h_854,q_70,strp/<prettyName>-300w.jpg',
          h: 200,
          w: 300,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_600,h_854,q_70,strp/<prettyName>-300w-2x.jpg',
            },
          ],
        },
        {
          t: '375W',
          r: 0,
          c: '/v1/fit/w_375,h_250,q_70,strp/<prettyName>-375w.jpg',
          h: 250,
          w: 375,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_750,h_500,q_70,strp/<prettyName>-375w-2x.jpg',
            },
          ],
        },
        {
          t: '414W',
          r: 0,
          c: '/v1/fit/w_414,h_276,q_70,strp/<prettyName>-414w.jpg',
          h: 276,
          w: 414,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_828,h_552,q_70,strp/<prettyName>-414w-2x.jpg',
            },
          ],
        },
        {
          t: '250T',
          r: 0,
          c: '/v1/fill/w_375,h_250,q_70,strp/<prettyName>-250t.jpg',
          h: 250,
          w: 375,
          ss: [
            {
              x: 2,
              c: '/v1/fill/w_750,h_500,q_70,strp/<prettyName>-250t-2x.jpg',
            },
          ],
        },
        {
          t: '350T',
          r: 0,
          c: '/v1/fill/w_525,h_350,q_70,strp/<prettyName>-350t.jpg',
          h: 350,
          w: 525,
          ss: [
            {
              x: 2,
              c: '/v1/fill/w_1050,h_700,q_70,strp/<prettyName>-350t-2x.jpg',
            },
          ],
        },
        {
          t: '400T',
          r: 0,
          c: '/v1/fill/w_600,h_400,q_70,strp/<prettyName>-400t.jpg',
          h: 400,
          w: 600,
          ss: [
            {
              x: 2,
              c: '/v1/fill/w_1200,h_800,q_70,strp/<prettyName>-400t-2x.jpg',
            },
          ],
        },
        {
          t: 'preview',
          r: 0,
          c: '/v1/fill/w_1095,h_730,q_70,strp/<prettyName>-pre.jpg',
          h: 730,
          w: 1095,
          f: 13113944,
        },
        {
          t: 'social_preview',
          r: 0,
          c: '/v1/fill/w_1095,h_730,q_70,strp/<prettyName>-pre.jpg',
          h: 730,
          w: 1095,
        },
        {
          t: 'fullview',
          r: 0,
          c: '/v1/fill/w_1280,h_854,q_75,strp/<prettyName>-fullview.jpg',
          h: 854,
          w: 1280,
          f: 13113944,
        },
        {
          t: '92S',
          r: 0,
          c: '/v1/crop/w_92,h_92,x_12,y_0,scl_0.022727272727273,q_70,strp/<prettyName>-92s.jpg',
          h: 92,
          w: 92,
          ss: [
            {
              x: 2,
              c: '/v1/crop/w_184,h_184,x_23,y_0,scl_0.045454545454545,q_70,strp/<prettyName>-92s-2x.jpg',
            },
          ],
        },
      ],
    },
  },
  {
    deviationId: 918530302,
    type: 'image',
    typeId: 1,
    url: 'https://www.deviantart.com/aatheone/art/restrain-918530302',
    title: 'restrain',
    isJournal: false,
    isVideo: false,
    isPurchasable: false,
    isFavouritable: true,
    publishedTime: '2022-06-07T03:13:27-0700',
    isTextEditable: false,
    isBackgroundEditable: false,
    legacyTextEditUrl: null,
    isShareable: true,
    isCommentable: true,
    isFavourited: true,
    isDeleted: false,
    isMature: false,
    isNsfg: false,
    isDownloadable: true,
    isAntisocial: false,
    isBlocked: false,
    isPublished: true,
    isDailyDeviation: false,
    hasPrivateComments: false,
    isDreamsofart: false,
    isAiUseDisallowed: true,
    blockReasons: [],
    author: {
      userId: 17316954,
      useridUuid: '6acccae0-4e4b-4b59-bd80-6e04e7156862',
      username: 'aatheone',
      usericon: 'https://a.deviantart.net/avatars-big/a/a/aatheone.jpg?6',
      type: 'core_access',
      isWatching: false,
      isSubscribed: false,
      isNewDeviant: false,
    },
    stats: {
      comments: 6,
      favourites: 133,
      views: 7443,
      downloads: 11,
    },
    media: {
      baseUri:
        'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/6acccae0-4e4b-4b59-bd80-6e04e7156862/df6vaim-c63861af-a3dc-4894-8af4-6a4a8ab62a03.jpg',
      prettyName: 'restrain_by_aatheone_df6vaim',
      token: [
        'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7ImhlaWdodCI6Ijw9MTQzNSIsInBhdGgiOiJcL2ZcLzZhY2NjYWUwLTRlNGItNGI1OS1iZDgwLTZlMDRlNzE1Njg2MlwvZGY2dmFpbS1jNjM4NjFhZi1hM2RjLTQ4OTQtOGFmNC02YTRhOGFiNjJhMDMuanBnIiwid2lkdGgiOiI8PTk5MCJ9XV0sImF1ZCI6WyJ1cm46c2VydmljZTppbWFnZS5vcGVyYXRpb25zIl19.j0NwCqB1gWuvGt3rPEitKMpMNsgMJsUfm1xxMr3DFHQ',
        'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7InBhdGgiOiJcL2ZcLzZhY2NjYWUwLTRlNGItNGI1OS1iZDgwLTZlMDRlNzE1Njg2MlwvZGY2dmFpbS1jNjM4NjFhZi1hM2RjLTQ4OTQtOGFmNC02YTRhOGFiNjJhMDMuanBnIn1dXSwiYXVkIjpbInVybjpzZXJ2aWNlOmZpbGUuZG93bmxvYWQiXX0.Z_98AnaYWeSOR37vqvTphOwm7f0irPglHfd1cz9LUpc',
      ],
      types: [
        {
          t: '150',
          r: 0,
          c: '/v1/fit/w_150,h_150,q_70,strp/<prettyName>-150.jpg',
          h: 150,
          w: 103,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_300,h_300,q_70,strp/<prettyName>-150-2x.jpg',
            },
          ],
        },
        {
          t: '200H',
          r: 0,
          c: '/v1/fill/w_138,h_200,q_70,strp/<prettyName>-200h.jpg',
          h: 200,
          w: 138,
          ss: [
            {
              x: 2,
              c: '/v1/fill/w_276,h_400,q_70,strp/<prettyName>-200h-2x.jpg',
            },
          ],
        },
        {
          t: '300W',
          r: 0,
          c: '/v1/fit/w_300,h_900,q_70,strp/<prettyName>-300w.jpg',
          h: 435,
          w: 300,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_600,h_1435,q_70,strp/<prettyName>-300w-2x.jpg',
            },
          ],
        },
        {
          t: '375W',
          r: 0,
          c: '/v1/fit/w_375,h_544,q_70,strp/<prettyName>-375w.jpg',
          h: 544,
          w: 375,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_750,h_1088,q_70,strp/<prettyName>-375w-2x.jpg',
            },
          ],
        },
        {
          t: '414W',
          r: 0,
          c: '/v1/fit/w_414,h_600,q_70,strp/<prettyName>-414w.jpg',
          h: 600,
          w: 414,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_828,h_1200,q_70,strp/<prettyName>-414w-2x.jpg',
            },
          ],
        },
        {
          t: '250T',
          r: 0,
          c: '/v1/crop/w_172,h_250,x_0,y_0,scl_0.17474747474747,q_70,strp/<prettyName>-250t.jpg',
          h: 250,
          w: 172,
          ss: [
            {
              x: 2,
              c: '/v1/fill/w_345,h_500,q_70,strp/<prettyName>-250t-2x.jpg',
            },
          ],
        },
        {
          t: '350T',
          r: 0,
          c: '/v1/crop/w_241,h_350,x_0,y_0,scl_0.24444444444444,q_70,strp/<prettyName>-350t.jpg',
          h: 350,
          w: 241,
          ss: [
            {
              x: 2,
              c: '/v1/fill/w_483,h_700,q_70,strp/<prettyName>-350t-2x.jpg',
            },
          ],
        },
        {
          t: '400T',
          r: 0,
          c: '/v1/fill/w_276,h_400,q_70,strp/<prettyName>-400t.jpg',
          h: 400,
          w: 276,
          ss: [
            {
              x: 2,
              c: '/v1/fill/w_552,h_800,q_70,strp/<prettyName>-400t-2x.jpg',
            },
          ],
        },
        {
          t: 'preview',
          r: 0,
          c: '/v1/fill/w_742,h_1076,q_70,strp/<prettyName>-pre.jpg',
          h: 1076,
          w: 742,
          f: 954152,
        },
        {
          t: 'social_preview',
          r: 0,
          c: '/v1/fill/w_742,h_1076,q_70,strp/<prettyName>-pre.jpg',
          h: 1076,
          w: 742,
        },
        {
          t: 'fullview',
          r: 1,
          h: 1435,
          w: 990,
          f: 954152,
        },
        {
          t: '92S',
          r: 0,
          c: '/v1/crop/w_92,h_92,x_0,y_10,scl_0.092929292929293,q_70,strp/<prettyName>-92s.jpg',
          h: 92,
          w: 92,
          ss: [
            {
              x: 2,
              c: '/v1/crop/w_184,h_184,x_0,y_21,scl_0.18585858585859,q_70,strp/<prettyName>-92s-2x.jpg',
            },
          ],
        },
      ],
    },
  },
  {
    deviationId: 917191725,
    type: 'image',
    typeId: 1,
    url: 'https://www.deviantart.com/martinstranka/art/Remember-Me-917191725',
    title: 'Remember Me',
    isJournal: false,
    isVideo: false,
    isPurchasable: false,
    isFavouritable: true,
    publishedTime: '2022-05-25T03:23:21-0700',
    isTextEditable: false,
    isBackgroundEditable: false,
    legacyTextEditUrl: null,
    isShareable: true,
    isCommentable: true,
    isFavourited: true,
    isDeleted: false,
    isMature: false,
    isNsfg: false,
    isDownloadable: true,
    isAntisocial: false,
    isBlocked: false,
    isPublished: true,
    isDailyDeviation: true,
    hasPrivateComments: false,
    isDreamsofart: false,
    isAiUseDisallowed: true,
    blockReasons: [],
    author: {
      userId: 3938047,
      useridUuid: '760879ef-81bd-4f43-aa73-1346c0a51d89',
      username: 'MartinStranka',
      usericon: 'https://a.deviantart.net/avatars-big/m/a/martinstranka.jpg?5',
      type: 'regular',
      isWatching: false,
      isSubscribed: false,
      isNewDeviant: false,
    },
    stats: {
      comments: 13,
      favourites: 210,
      views: 362926,
      downloads: 22,
    },
    media: {
      baseUri:
        'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/760879ef-81bd-4f43-aa73-1346c0a51d89/df62lnx-7b1b524b-0a75-40ce-a1c9-d284733f9950.jpg',
      prettyName: 'remember_me_by_martinstranka_df62lnx',
      token: [
        'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7ImhlaWdodCI6Ijw9ODQ1IiwicGF0aCI6IlwvZlwvNzYwODc5ZWYtODFiZC00ZjQzLWFhNzMtMTM0NmMwYTUxZDg5XC9kZjYybG54LTdiMWI1MjRiLTBhNzUtNDBjZS1hMWM5LWQyODQ3MzNmOTk1MC5qcGciLCJ3aWR0aCI6Ijw9MTI4MCJ9XV0sImF1ZCI6WyJ1cm46c2VydmljZTppbWFnZS5vcGVyYXRpb25zIl19.pn51qkAlu6TvGTlLDFvmWU9JnCdX95g0v9g_9KIHMYQ',
      ],
      types: [
        {
          t: '150',
          r: 0,
          c: '/v1/fit/w_150,h_150,q_70,strp/<prettyName>-150.jpg',
          h: 99,
          w: 150,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_300,h_300,q_70,strp/<prettyName>-150-2x.jpg',
            },
          ],
        },
        {
          t: '200H',
          r: 0,
          c: '/v1/fill/w_300,h_198,q_70,strp/<prettyName>-200h.jpg',
          h: 198,
          w: 300,
          ss: [
            {
              x: 2,
              c: '/v1/fill/w_600,h_396,q_70,strp/<prettyName>-200h-2x.jpg',
            },
          ],
        },
        {
          t: '300W',
          r: 0,
          c: '/v1/fit/w_300,h_845,q_70,strp/<prettyName>-300w.jpg',
          h: 198,
          w: 300,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_600,h_845,q_70,strp/<prettyName>-300w-2x.jpg',
            },
          ],
        },
        {
          t: '375W',
          r: 0,
          c: '/v1/fit/w_375,h_248,q_70,strp/<prettyName>-375w.jpg',
          h: 248,
          w: 375,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_750,h_496,q_70,strp/<prettyName>-375w-2x.jpg',
            },
          ],
        },
        {
          t: '414W',
          r: 0,
          c: '/v1/fit/w_414,h_273,q_70,strp/<prettyName>-414w.jpg',
          h: 273,
          w: 414,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_828,h_546,q_70,strp/<prettyName>-414w-2x.jpg',
            },
          ],
        },
        {
          t: '250T',
          r: 0,
          c: '/v1/fill/w_379,h_250,q_70,strp/<prettyName>-250t.jpg',
          h: 250,
          w: 379,
          ss: [
            {
              x: 2,
              c: '/v1/fill/w_758,h_500,q_70,strp/<prettyName>-250t-2x.jpg',
            },
          ],
        },
        {
          t: '350T',
          r: 0,
          c: '/v1/fill/w_531,h_350,q_70,strp/<prettyName>-350t.jpg',
          h: 350,
          w: 530,
          ss: [
            {
              x: 2,
              c: '/v1/fill/w_1061,h_700,q_70,strp/<prettyName>-350t-2x.jpg',
            },
          ],
        },
        {
          t: '400T',
          r: 0,
          c: '/v1/fill/w_606,h_400,q_70,strp/<prettyName>-400t.jpg',
          h: 400,
          w: 606,
          ss: [
            {
              x: 2,
              c: '/v1/fill/w_1213,h_800,q_70,strp/<prettyName>-400t-2x.jpg',
            },
          ],
        },
        {
          t: 'preview',
          r: 0,
          c: '/v1/fill/w_1100,h_726,q_70,strp/<prettyName>-pre.jpg',
          h: 726,
          w: 1100,
          f: 2722230,
        },
        {
          t: 'social_preview',
          r: 0,
          c: '/v1/fill/w_1100,h_726,q_70,strp/<prettyName>-pre.jpg',
          h: 726,
          w: 1100,
        },
        {
          t: 'fullview',
          r: 0,
          c: '/v1/fill/w_1280,h_845,q_75,strp/<prettyName>-fullview.jpg',
          h: 845,
          w: 1280,
          f: 2722230,
        },
        {
          t: '92S',
          r: 0,
          c: '/v1/crop/w_92,h_92,x_12,y_0,scl_0.055791388720437,q_70,strp/<prettyName>-92s.jpg',
          h: 92,
          w: 92,
          ss: [
            {
              x: 2,
              c: '/v1/crop/w_184,h_184,x_24,y_0,scl_0.11158277744087,q_70,strp/<prettyName>-92s-2x.jpg',
            },
          ],
        },
      ],
    },
  },
  {
    deviationId: 917678173,
    type: 'image',
    typeId: 1,
    url: 'https://www.deviantart.com/rikitza/art/In-and-Out-night-on-a-Paris-street-917678173',
    title: 'In and Out - night on a Paris street',
    isJournal: false,
    isVideo: false,
    isPurchasable: false,
    isFavouritable: true,
    publishedTime: '2022-05-29T21:49:22-0700',
    isTextEditable: false,
    isBackgroundEditable: false,
    legacyTextEditUrl: null,
    isShareable: true,
    isCommentable: true,
    isFavourited: true,
    isDeleted: false,
    isMature: false,
    isNsfg: false,
    isDownloadable: true,
    isAntisocial: false,
    isBlocked: false,
    isPublished: true,
    isDailyDeviation: false,
    hasPrivateComments: false,
    isDreamsofart: false,
    isAiUseDisallowed: true,
    blockReasons: [],
    author: {
      userId: 18546283,
      useridUuid: '9968a872-fd9f-494c-8015-0b6525e73f18',
      username: 'Rikitza',
      usericon: 'https://a.deviantart.net/avatars-big/r/i/rikitza.png?5',
      type: 'senior',
      isWatching: false,
      isSubscribed: false,
      isNewDeviant: false,
    },
    stats: {
      comments: 33,
      favourites: 182,
      views: 5281,
      downloads: 5,
    },
    media: {
      baseUri:
        'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/9968a872-fd9f-494c-8015-0b6525e73f18/df6d10d-e091c149-32e1-49ed-91b2-d7555fb593c2.jpg',
      prettyName: 'in_and_out___night_on_a_paris_street_by_rikitza_df6d10d',
      token: [
        'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7ImhlaWdodCI6Ijw9NTQwMCIsInBhdGgiOiJcL2ZcLzk5NjhhODcyLWZkOWYtNDk0Yy04MDE1LTBiNjUyNWU3M2YxOFwvZGY2ZDEwZC1lMDkxYzE0OS0zMmUxLTQ5ZWQtOTFiMi1kNzU1NWZiNTkzYzIuanBnIiwid2lkdGgiOiI8PTk2MDAifV1dLCJhdWQiOlsidXJuOnNlcnZpY2U6aW1hZ2Uub3BlcmF0aW9ucyJdfQ.88kKEWQocxxP3qsBX3boYasX0l7hE_IWdowzmenMgwU',
        'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7InBhdGgiOiJcL2ZcLzk5NjhhODcyLWZkOWYtNDk0Yy04MDE1LTBiNjUyNWU3M2YxOFwvZGY2ZDEwZC1lMDkxYzE0OS0zMmUxLTQ5ZWQtOTFiMi1kNzU1NWZiNTkzYzIuanBnIn1dXSwiYXVkIjpbInVybjpzZXJ2aWNlOmZpbGUuZG93bmxvYWQiXX0._UxnKICgNXzjmOH63WsunG0n76eNps_3Cobc3dtp-Y0',
      ],
      types: [
        {
          t: '150',
          r: 0,
          c: '/v1/fit/w_150,h_150,q_70,strp/<prettyName>-150.jpg',
          h: 84,
          w: 150,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_300,h_300,q_70,strp/<prettyName>-150-2x.jpg',
            },
          ],
        },
        {
          t: '200H',
          r: 0,
          c: '/v1/fill/w_300,h_169,q_70,strp/<prettyName>-200h.jpg',
          h: 169,
          w: 300,
          ss: [
            {
              x: 2,
              c: '/v1/fill/w_600,h_338,q_70,strp/<prettyName>-200h-2x.jpg',
            },
          ],
        },
        {
          t: '300W',
          r: 0,
          c: '/v1/fit/w_300,h_900,q_70,strp/<prettyName>-300w.jpg',
          h: 169,
          w: 300,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_600,h_1800,q_70,strp/<prettyName>-300w-2x.jpg',
            },
          ],
        },
        {
          t: '375W',
          r: 0,
          c: '/v1/fit/w_375,h_211,q_70,strp/<prettyName>-375w.jpg',
          h: 211,
          w: 375,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_750,h_422,q_70,strp/<prettyName>-375w-2x.jpg',
            },
          ],
        },
        {
          t: '414W',
          r: 0,
          c: '/v1/fit/w_414,h_233,q_70,strp/<prettyName>-414w.jpg',
          h: 233,
          w: 414,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_828,h_466,q_70,strp/<prettyName>-414w-2x.jpg',
            },
          ],
        },
        {
          t: '250T',
          r: 0,
          c: '/v1/fill/w_444,h_250,q_70,strp/<prettyName>-250t.jpg',
          h: 250,
          w: 444,
          ss: [
            {
              x: 2,
              c: '/v1/fill/w_889,h_500,q_70,strp/<prettyName>-250t-2x.jpg',
            },
          ],
        },
        {
          t: '350T',
          r: 0,
          c: '/v1/fill/w_622,h_350,q_70,strp/<prettyName>-350t.jpg',
          h: 350,
          w: 622,
          ss: [
            {
              x: 2,
              c: '/v1/fill/w_1244,h_700,q_70,strp/<prettyName>-350t-2x.jpg',
            },
          ],
        },
        {
          t: '400T',
          r: 0,
          c: '/v1/fill/w_711,h_400,q_70,strp/<prettyName>-400t.jpg',
          h: 400,
          w: 711,
          ss: [
            {
              x: 2,
              c: '/v1/fill/w_1422,h_800,q_70,strp/<prettyName>-400t-2x.jpg',
            },
          ],
        },
        {
          t: 'preview',
          r: 0,
          c: '/v1/fill/w_1192,h_670,q_70,strp/<prettyName>-pre.jpg',
          h: 670,
          w: 1192,
          f: 37003743,
        },
        {
          t: 'social_preview',
          r: 0,
          c: '/v1/fill/w_1192,h_670,q_70,strp/<prettyName>-pre.jpg',
          h: 670,
          w: 1192,
        },
        {
          t: 'fullview',
          r: 1,
          h: 5400,
          w: 9600,
          f: 37003743,
        },
        {
          t: '92S',
          r: 0,
          c: '/v1/crop/w_92,h_92,x_18,y_0,scl_0.017037037037037,q_70,strp/<prettyName>-92s.jpg',
          h: 92,
          w: 92,
          ss: [
            {
              x: 2,
              c: '/v1/crop/w_184,h_184,x_36,y_0,scl_0.034074074074074,q_70,strp/<prettyName>-92s-2x.jpg',
            },
          ],
        },
      ],
    },
  },
  {
    deviationId: 917700285,
    type: 'image',
    typeId: 1,
    url: 'https://www.deviantart.com/trentanthonyfrancis/art/VP-Sessions-Cyberpunk-2077-917700285',
    title: 'VP Sessions: Cyberpunk 2077',
    isJournal: false,
    isVideo: false,
    isPurchasable: false,
    isFavouritable: true,
    publishedTime: '2022-05-30T04:11:27-0700',
    isTextEditable: false,
    isBackgroundEditable: false,
    legacyTextEditUrl: null,
    isShareable: true,
    isCommentable: true,
    isFavourited: true,
    isDeleted: false,
    isMature: false,
    isNsfg: false,
    isDownloadable: true,
    isAntisocial: false,
    isBlocked: false,
    isPublished: true,
    isDailyDeviation: false,
    hasPrivateComments: false,
    isDreamsofart: false,
    isAiUseDisallowed: true,
    blockReasons: [],
    author: {
      userId: 63797691,
      useridUuid: 'a2e1068d-f3fd-4c0e-9f90-483fc4fc1e64',
      username: 'TrentAnthonyFrancis',
      usericon: 'https://a.deviantart.net/avatars-big/t/r/trentanthonyfrancis.jpg?12',
      type: 'core_plus',
      isWatching: false,
      isSubscribed: false,
      isNewDeviant: false,
    },
    stats: {
      comments: 3,
      favourites: 90,
      views: 2695,
      downloads: 17,
    },
    media: {
      baseUri:
        'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/a2e1068d-f3fd-4c0e-9f90-483fc4fc1e64/df6di2l-8436039e-efc1-42e9-9272-29dc48eb61ab.jpg',
      prettyName: 'vp_sessions__cyberpunk_2077_by_trentanthonyfrancis_df6di2l',
      token: [
        'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7ImhlaWdodCI6Ijw9MjE2MCIsInBhdGgiOiJcL2ZcL2EyZTEwNjhkLWYzZmQtNGMwZS05ZjkwLTQ4M2ZjNGZjMWU2NFwvZGY2ZGkybC04NDM2MDM5ZS1lZmMxLTQyZTktOTI3Mi0yOWRjNDhlYjYxYWIuanBnIiwid2lkdGgiOiI8PTM4NDAifV1dLCJhdWQiOlsidXJuOnNlcnZpY2U6aW1hZ2Uub3BlcmF0aW9ucyJdfQ.NnRuPhtaCJvetWaHRrw920TCRsijCvPvFvW6lH9dvlY',
        'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7InBhdGgiOiJcL2ZcL2EyZTEwNjhkLWYzZmQtNGMwZS05ZjkwLTQ4M2ZjNGZjMWU2NFwvZGY2ZGkybC04NDM2MDM5ZS1lZmMxLTQyZTktOTI3Mi0yOWRjNDhlYjYxYWIuanBnIn1dXSwiYXVkIjpbInVybjpzZXJ2aWNlOmZpbGUuZG93bmxvYWQiXX0.HczXbAZM0OrihCMyfHefLlpLux2r215SybIAvA6kqu0',
      ],
      types: [
        {
          t: '150',
          r: 0,
          c: '/v1/fit/w_150,h_150,q_70,strp/<prettyName>-150.jpg',
          h: 84,
          w: 150,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_300,h_300,q_70,strp/<prettyName>-150-2x.jpg',
            },
          ],
        },
        {
          t: '200H',
          r: 0,
          c: '/v1/fill/w_300,h_169,q_70,strp/<prettyName>-200h.jpg',
          h: 169,
          w: 300,
          ss: [
            {
              x: 2,
              c: '/v1/fill/w_600,h_338,q_70,strp/<prettyName>-200h-2x.jpg',
            },
          ],
        },
        {
          t: '300W',
          r: 0,
          c: '/v1/fit/w_300,h_900,q_70,strp/<prettyName>-300w.jpg',
          h: 169,
          w: 300,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_600,h_1800,q_70,strp/<prettyName>-300w-2x.jpg',
            },
          ],
        },
        {
          t: '375W',
          r: 0,
          c: '/v1/fit/w_375,h_211,q_70,strp/<prettyName>-375w.jpg',
          h: 211,
          w: 375,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_750,h_422,q_70,strp/<prettyName>-375w-2x.jpg',
            },
          ],
        },
        {
          t: '414W',
          r: 0,
          c: '/v1/fit/w_414,h_233,q_70,strp/<prettyName>-414w.jpg',
          h: 233,
          w: 414,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_828,h_466,q_70,strp/<prettyName>-414w-2x.jpg',
            },
          ],
        },
        {
          t: '250T',
          r: 0,
          c: '/v1/fill/w_444,h_250,q_70,strp/<prettyName>-250t.jpg',
          h: 250,
          w: 444,
          ss: [
            {
              x: 2,
              c: '/v1/fill/w_889,h_500,q_70,strp/<prettyName>-250t-2x.jpg',
            },
          ],
        },
        {
          t: '350T',
          r: 0,
          c: '/v1/fill/w_622,h_350,q_70,strp/<prettyName>-350t.jpg',
          h: 350,
          w: 622,
          ss: [
            {
              x: 2,
              c: '/v1/fill/w_1244,h_700,q_70,strp/<prettyName>-350t-2x.jpg',
            },
          ],
        },
        {
          t: '400T',
          r: 0,
          c: '/v1/fill/w_711,h_400,q_70,strp/<prettyName>-400t.jpg',
          h: 400,
          w: 711,
          ss: [
            {
              x: 2,
              c: '/v1/fill/w_1422,h_800,q_70,strp/<prettyName>-400t-2x.jpg',
            },
          ],
        },
        {
          t: 'preview',
          r: 0,
          c: '/v1/fill/w_1192,h_670,q_70,strp/<prettyName>-pre.jpg',
          h: 670,
          w: 1192,
          f: 10675622,
        },
        {
          t: 'social_preview',
          r: 0,
          c: '/v1/fill/w_1192,h_670,q_70,strp/<prettyName>-pre.jpg',
          h: 670,
          w: 1192,
        },
        {
          t: 'fullview',
          r: 1,
          h: 2160,
          w: 3840,
          f: 10675622,
        },
        {
          t: '92S',
          r: 0,
          c: '/v1/crop/w_92,h_92,x_18,y_0,scl_0.042592592592593,q_70,strp/<prettyName>-92s.jpg',
          h: 92,
          w: 92,
          ss: [
            {
              x: 2,
              c: '/v1/crop/w_184,h_184,x_36,y_0,scl_0.085185185185185,q_70,strp/<prettyName>-92s-2x.jpg',
            },
          ],
        },
      ],
    },
  },
  {
    deviationId: 916067583,
    type: 'image',
    typeId: 1,
    url: 'https://www.deviantart.com/milicraft/art/Chief-Ice-Breaker-Bolf-916067583',
    title: 'Chief Ice Breaker Bolf',
    isJournal: false,
    isVideo: false,
    isPurchasable: false,
    isFavouritable: true,
    publishedTime: '2022-05-14T06:10:51-0700',
    isTextEditable: false,
    isBackgroundEditable: false,
    legacyTextEditUrl: null,
    isShareable: true,
    isCommentable: true,
    isFavourited: true,
    isDeleted: false,
    isMature: false,
    isNsfg: false,
    isDownloadable: false,
    isAntisocial: false,
    isBlocked: false,
    isPublished: true,
    isDailyDeviation: false,
    hasPrivateComments: false,
    isDreamsofart: false,
    isAiUseDisallowed: true,
    blockReasons: [],
    author: {
      userId: 26326249,
      useridUuid: '9d64afdc-0eb8-48e4-bdc0-bc83cb6b8a43',
      username: 'MILICRAFT',
      usericon: 'https://a.deviantart.net/avatars-big/m/i/milicraft.jpg?10',
      type: 'regular',
      isWatching: false,
      isSubscribed: false,
      isNewDeviant: false,
    },
    stats: {
      comments: 0,
      favourites: 165,
      views: 4198,
      downloads: 0,
    },
    media: {
      baseUri:
        'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/9d64afdc-0eb8-48e4-bdc0-bc83cb6b8a43/df5ei9r-a8801abd-0e89-4f96-91c9-dd434882da58.png',
      prettyName: 'chief_ice_breaker_bolf_by_milicraft_df5ei9r',
      token: [
        'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7ImhlaWdodCI6Ijw9MTMwMCIsInBhdGgiOiJcL2ZcLzlkNjRhZmRjLTBlYjgtNDhlNC1iZGMwLWJjODNjYjZiOGE0M1wvZGY1ZWk5ci1hODgwMWFiZC0wZTg5LTRmOTYtOTFjOS1kZDQzNDg4MmRhNTgucG5nIiwid2lkdGgiOiI8PTEwOTUifV1dLCJhdWQiOlsidXJuOnNlcnZpY2U6aW1hZ2Uub3BlcmF0aW9ucyJdfQ.XocAq3OtHyrNWg6hAWSif_Mvf2-3CZqFhcjyCgn1i60',
        'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7InBhdGgiOiJcL2ZcLzlkNjRhZmRjLTBlYjgtNDhlNC1iZGMwLWJjODNjYjZiOGE0M1wvZGY1ZWk5ci1hODgwMWFiZC0wZTg5LTRmOTYtOTFjOS1kZDQzNDg4MmRhNTgucG5nIn1dXSwiYXVkIjpbInVybjpzZXJ2aWNlOmZpbGUuZG93bmxvYWQiXX0.tYxWY_Kv6icUdysl6Qgakh4Is3iLFC353rADZHLDFnQ',
      ],
      types: [
        {
          t: '150',
          r: 0,
          c: '/v1/fit/w_150,h_150,q_70,strp/<prettyName>-150.jpg',
          h: 150,
          w: 126,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_300,h_300,q_70,strp/<prettyName>-150-2x.jpg',
            },
          ],
        },
        {
          t: '200H',
          r: 0,
          c: '/v1/crop/w_168,h_200,x_0,y_0,scl_0.15433789954338,q_70,strp/<prettyName>-200h.jpg',
          h: 200,
          w: 168,
          ss: [
            {
              x: 2,
              c: '/v1/fill/w_337,h_400,q_70,strp/<prettyName>-200h-2x.jpg',
            },
          ],
        },
        {
          t: '300W',
          r: 0,
          c: '/v1/fit/w_300,h_900,q_70,strp/<prettyName>-300w.jpg',
          h: 356,
          w: 300,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_600,h_1300,q_70,strp/<prettyName>-300w-2x.jpg',
            },
          ],
        },
        {
          t: '375W',
          r: 0,
          c: '/v1/fit/w_375,h_445,q_70,strp/<prettyName>-375w.jpg',
          h: 445,
          w: 375,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_750,h_890,q_70,strp/<prettyName>-375w-2x.jpg',
            },
          ],
        },
        {
          t: '414W',
          r: 0,
          c: '/v1/fit/w_414,h_492,q_70,strp/<prettyName>-414w.jpg',
          h: 492,
          w: 414,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_828,h_984,q_70,strp/<prettyName>-414w-2x.jpg',
            },
          ],
        },
        {
          t: '250T',
          r: 0,
          c: '/v1/crop/w_211,h_250,x_0,y_0,scl_0.19269406392694,q_70,strp/<prettyName>-250t.jpg',
          h: 250,
          w: 211,
          ss: [
            {
              x: 2,
              c: '/v1/fill/w_421,h_500,q_70,strp/<prettyName>-250t-2x.jpg',
            },
          ],
        },
        {
          t: '350T',
          r: 0,
          c: '/v1/fill/w_295,h_350,q_70,strp/<prettyName>-350t.jpg',
          h: 350,
          w: 295,
          ss: [
            {
              x: 2,
              c: '/v1/fill/w_590,h_700,q_70,strp/<prettyName>-350t-2x.jpg',
            },
          ],
        },
        {
          t: '400T',
          r: 0,
          c: '/v1/fill/w_337,h_400,q_70,strp/<prettyName>-400t.jpg',
          h: 400,
          w: 337,
          ss: [
            {
              x: 2,
              c: '/v1/fill/w_674,h_800,q_70,strp/<prettyName>-400t-2x.jpg',
            },
          ],
        },
        {
          t: 'preview',
          r: 0,
          c: '/v1/fill/w_820,h_974,q_70,strp/<prettyName>-pre.jpg',
          h: 974,
          w: 820,
          f: 1635522,
        },
        {
          t: 'social_preview',
          r: 0,
          c: '/v1/fill/w_820,h_974,q_70,strp/<prettyName>-pre.jpg',
          h: 974,
          w: 820,
        },
        {
          t: 'fullview',
          r: 1,
          h: 1300,
          w: 1095,
          f: 1635522,
        },
        {
          t: '92S',
          r: 0,
          c: '/v1/crop/w_92,h_92,x_0,y_4,scl_0.084018264840183,q_70,strp/<prettyName>-92s.jpg',
          h: 92,
          w: 92,
          ss: [
            {
              x: 2,
              c: '/v1/crop/w_184,h_184,x_0,y_9,scl_0.16803652968037,q_70,strp/<prettyName>-92s-2x.jpg',
            },
          ],
        },
      ],
    },
  },
  {
    deviationId: 907835060,
    type: 'image',
    typeId: 1,
    url: 'https://www.deviantart.com/sinakasra/art/THE-RED-ONNA-MUSHA-XII-907835060',
    title: 'THE RED ONNA-MUSHA - XII',
    isJournal: false,
    isVideo: false,
    isPurchasable: false,
    isFavouritable: true,
    publishedTime: '2022-02-22T09:40:12-0800',
    isTextEditable: false,
    isBackgroundEditable: false,
    legacyTextEditUrl: null,
    isShareable: true,
    isCommentable: true,
    isFavourited: true,
    isDeleted: false,
    isMature: false,
    isNsfg: false,
    isDownloadable: true,
    isAntisocial: false,
    isBlocked: false,
    isPublished: true,
    isDailyDeviation: false,
    hasPrivateComments: false,
    isDreamsofart: false,
    isAiUseDisallowed: true,
    blockReasons: [],
    author: {
      userId: 11282060,
      useridUuid: '982be8e6-d0f6-4214-845a-be09c09bc40d',
      username: 'sinakasra',
      usericon: 'https://a.deviantart.net/avatars-big/s/i/sinakasra.jpg?3',
      type: 'regular',
      isWatching: true,
      isSubscribed: false,
      isNewDeviant: false,
    },
    stats: {
      comments: 12,
      favourites: 722,
      views: 26735,
      downloads: 104,
    },
    media: {
      baseUri:
        'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/982be8e6-d0f6-4214-845a-be09c09bc40d/df0i20k-3b2e0b1b-1f63-4de9-8a36-77099c3aa66d.jpg',
      prettyName: 'the_red_onna_musha___xii_by_sinakasra_df0i20k',
      token: [
        'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7ImhlaWdodCI6Ijw9MTAxOCIsInBhdGgiOiJcL2ZcLzk4MmJlOGU2LWQwZjYtNDIxNC04NDVhLWJlMDljMDliYzQwZFwvZGYwaTIway0zYjJlMGIxYi0xZjYzLTRkZTktOGEzNi03NzA5OWMzYWE2NmQuanBnIiwid2lkdGgiOiI8PTE4MTAifV1dLCJhdWQiOlsidXJuOnNlcnZpY2U6aW1hZ2Uub3BlcmF0aW9ucyJdfQ.niMuAp30ui_cdqZzDHdsL1j6AqSHPHKSs7-cpGphV4E',
        'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7InBhdGgiOiJcL2ZcLzk4MmJlOGU2LWQwZjYtNDIxNC04NDVhLWJlMDljMDliYzQwZFwvZGYwaTIway0zYjJlMGIxYi0xZjYzLTRkZTktOGEzNi03NzA5OWMzYWE2NmQuanBnIn1dXSwiYXVkIjpbInVybjpzZXJ2aWNlOmZpbGUuZG93bmxvYWQiXX0.h27-k9TDuocpbvl9JX1WevwWPz6_GWxRrFY2qahElqI',
      ],
      types: [
        {
          t: '150',
          r: 0,
          c: '/v1/fit/w_150,h_150,q_70,strp/<prettyName>-150.jpg',
          h: 84,
          w: 150,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_300,h_300,q_70,strp/<prettyName>-150-2x.jpg',
            },
          ],
        },
        {
          t: '200H',
          r: 0,
          c: '/v1/fill/w_300,h_169,q_70,strp/<prettyName>-200h.jpg',
          h: 169,
          w: 300,
          ss: [
            {
              x: 2,
              c: '/v1/fill/w_600,h_337,q_70,strp/<prettyName>-200h-2x.jpg',
            },
          ],
        },
        {
          t: '300W',
          r: 0,
          c: '/v1/fit/w_300,h_900,q_70,strp/<prettyName>-300w.jpg',
          h: 169,
          w: 300,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_600,h_1018,q_70,strp/<prettyName>-300w-2x.jpg',
            },
          ],
        },
        {
          t: '375W',
          r: 0,
          c: '/v1/fit/w_375,h_211,q_70,strp/<prettyName>-375w.jpg',
          h: 211,
          w: 375,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_750,h_422,q_70,strp/<prettyName>-375w-2x.jpg',
            },
          ],
        },
        {
          t: '414W',
          r: 0,
          c: '/v1/fit/w_414,h_233,q_70,strp/<prettyName>-414w.jpg',
          h: 233,
          w: 414,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_828,h_466,q_70,strp/<prettyName>-414w-2x.jpg',
            },
          ],
        },
        {
          t: '250T',
          r: 0,
          c: '/v1/fill/w_444,h_250,q_70,strp/<prettyName>-250t.jpg',
          h: 250,
          w: 444,
          ss: [
            {
              x: 2,
              c: '/v1/fill/w_889,h_500,q_70,strp/<prettyName>-250t-2x.jpg',
            },
          ],
        },
        {
          t: '350T',
          r: 0,
          c: '/v1/fill/w_622,h_350,q_70,strp/<prettyName>-350t.jpg',
          h: 350,
          w: 622,
          ss: [
            {
              x: 2,
              c: '/v1/fill/w_1245,h_700,q_70,strp/<prettyName>-350t-2x.jpg',
            },
          ],
        },
        {
          t: '400T',
          r: 0,
          c: '/v1/fill/w_711,h_400,q_70,strp/<prettyName>-400t.jpg',
          h: 400,
          w: 711,
          ss: [
            {
              x: 2,
              c: '/v1/fill/w_1422,h_800,q_70,strp/<prettyName>-400t-2x.jpg',
            },
          ],
        },
        {
          t: 'preview',
          r: 0,
          c: '/v1/fill/w_1192,h_670,q_70,strp/<prettyName>-pre.jpg',
          h: 670,
          w: 1192,
          f: 995864,
        },
        {
          t: 'social_preview',
          r: 0,
          c: '/v1/fill/w_1192,h_670,q_70,strp/<prettyName>-pre.jpg',
          h: 670,
          w: 1192,
        },
        {
          t: 'fullview',
          r: 1,
          h: 1018,
          w: 1810,
          f: 995864,
        },
        {
          t: '92S',
          r: 0,
          c: '/v1/crop/w_92,h_92,x_18,y_0,scl_0.090373280943026,q_70,strp/<prettyName>-92s.jpg',
          h: 92,
          w: 92,
          ss: [
            {
              x: 2,
              c: '/v1/crop/w_184,h_184,x_36,y_0,scl_0.18074656188605,q_70,strp/<prettyName>-92s-2x.jpg',
            },
          ],
        },
      ],
    },
  },
  {
    deviationId: 909191361,
    type: 'image',
    typeId: 1,
    url: 'https://www.deviantart.com/panaderalken/art/The-little-skull-king-909191361',
    title: 'The little skull king',
    isJournal: false,
    isVideo: false,
    isPurchasable: false,
    isFavouritable: true,
    publishedTime: '2022-03-07T19:45:23-0800',
    isTextEditable: false,
    isBackgroundEditable: false,
    legacyTextEditUrl: null,
    isShareable: true,
    isCommentable: true,
    isFavourited: true,
    isDeleted: false,
    isMature: false,
    isNsfg: false,
    isDownloadable: false,
    isAntisocial: false,
    isBlocked: false,
    isPublished: true,
    isDailyDeviation: false,
    hasPrivateComments: false,
    isDreamsofart: false,
    isAiUseDisallowed: true,
    blockReasons: [],
    author: {
      userId: 44440211,
      useridUuid: '502165f7-c1b6-4d8a-8dd6-c968d75250fd',
      username: 'Panaderalken',
      usericon: 'https://a.deviantart.net/avatars-big/p/a/panaderalken.jpg?7',
      type: 'regular',
      isWatching: true,
      isSubscribed: false,
      isNewDeviant: false,
    },
    stats: {
      comments: 5,
      favourites: 279,
      views: 6453,
      downloads: 0,
    },
    media: {
      baseUri:
        'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/502165f7-c1b6-4d8a-8dd6-c968d75250fd/df1b4jl-47caeafa-5df2-4835-9a2a-7f4e2b8c75df.jpg',
      prettyName: 'the_little_skull_king_by_panaderalken_df1b4jl',
      token: [
        'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7ImhlaWdodCI6Ijw9MTAyNCIsInBhdGgiOiJcL2ZcLzUwMjE2NWY3LWMxYjYtNGQ4YS04ZGQ2LWM5NjhkNzUyNTBmZFwvZGYxYjRqbC00N2NhZWFmYS01ZGYyLTQ4MzUtOWEyYS03ZjRlMmI4Yzc1ZGYuanBnIiwid2lkdGgiOiI8PTEwMjQifV1dLCJhdWQiOlsidXJuOnNlcnZpY2U6aW1hZ2Uub3BlcmF0aW9ucyJdfQ.C3g-P7VI7wkzUmkkYOVASqQgozVHsz0fuwqEBfeoLVA',
      ],
      types: [
        {
          t: '150',
          r: 0,
          c: '/v1/fit/w_150,h_150,q_70,strp/<prettyName>-150.jpg',
          h: 150,
          w: 150,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_300,h_300,q_70,strp/<prettyName>-150-2x.jpg',
            },
          ],
        },
        {
          t: '200H',
          r: 0,
          c: '/v1/fill/w_200,h_200,q_70,strp/<prettyName>-200h.jpg',
          h: 200,
          w: 200,
          ss: [
            {
              x: 2,
              c: '/v1/fill/w_400,h_400,q_70,strp/<prettyName>-200h-2x.jpg',
            },
          ],
        },
        {
          t: '300W',
          r: 0,
          c: '/v1/fit/w_300,h_900,q_70,strp/<prettyName>-300w.jpg',
          h: 300,
          w: 300,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_600,h_1024,q_70,strp/<prettyName>-300w-2x.jpg',
            },
          ],
        },
        {
          t: '375W',
          r: 0,
          c: '/v1/fit/w_375,h_375,q_70,strp/<prettyName>-375w.jpg',
          h: 375,
          w: 375,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_750,h_750,q_70,strp/<prettyName>-375w-2x.jpg',
            },
          ],
        },
        {
          t: '414W',
          r: 0,
          c: '/v1/fit/w_414,h_414,q_70,strp/<prettyName>-414w.jpg',
          h: 414,
          w: 414,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_828,h_828,q_70,strp/<prettyName>-414w-2x.jpg',
            },
          ],
        },
        {
          t: '250T',
          r: 0,
          c: '/v1/fill/w_250,h_250,q_70,strp/<prettyName>-250t.jpg',
          h: 250,
          w: 250,
          ss: [
            {
              x: 2,
              c: '/v1/fill/w_500,h_500,q_70,strp/<prettyName>-250t-2x.jpg',
            },
          ],
        },
        {
          t: '350T',
          r: 0,
          c: '/v1/fill/w_350,h_350,q_70,strp/<prettyName>-350t.jpg',
          h: 350,
          w: 350,
          ss: [
            {
              x: 2,
              c: '/v1/fill/w_700,h_700,q_70,strp/<prettyName>-350t-2x.jpg',
            },
          ],
        },
        {
          t: '400T',
          r: 0,
          c: '/v1/fill/w_400,h_400,q_70,strp/<prettyName>-400t.jpg',
          h: 400,
          w: 400,
          ss: [
            {
              x: 2,
              c: '/v1/fill/w_800,h_800,q_70,strp/<prettyName>-400t-2x.jpg',
            },
          ],
        },
        {
          t: 'preview',
          r: 0,
          c: '/v1/fill/w_894,h_894,q_70,strp/<prettyName>-pre.jpg',
          h: 894,
          w: 894,
          f: 13042343,
        },
        {
          t: 'social_preview',
          r: 0,
          c: '/v1/fill/w_894,h_894,q_70,strp/<prettyName>-pre.jpg',
          h: 894,
          w: 894,
        },
        {
          t: 'fullview',
          r: 0,
          c: '/v1/fill/w_1024,h_1024,q_75,strp/<prettyName>-fullview.jpg',
          h: 1024,
          w: 1024,
          f: 13042343,
        },
        {
          t: '92S',
          r: 0,
          c: '/v1/crop/w_92,h_92,x_0,y_0,scl_0.026285714285714,q_70,strp/<prettyName>-92s.jpg',
          h: 92,
          w: 92,
          ss: [
            {
              x: 2,
              c: '/v1/crop/w_184,h_184,x_0,y_0,scl_0.052571428571429,q_70,strp/<prettyName>-92s-2x.jpg',
            },
          ],
        },
      ],
    },
  },
  {
    deviationId: 905950004,
    type: 'image',
    typeId: 1,
    url: 'https://www.deviantart.com/mizuriau/art/Luke-and-The-Mandalorian-905950004',
    title: 'Luke and The Mandalorian',
    isJournal: false,
    isVideo: false,
    isPurchasable: false,
    isFavouritable: true,
    publishedTime: '2022-02-03T23:48:49-0800',
    isTextEditable: false,
    isBackgroundEditable: false,
    legacyTextEditUrl: null,
    isShareable: true,
    isCommentable: true,
    isFavourited: true,
    isDeleted: false,
    isMature: false,
    isNsfg: false,
    isDownloadable: false,
    isAntisocial: false,
    isBlocked: false,
    isPublished: true,
    isDailyDeviation: false,
    hasPrivateComments: false,
    isDreamsofart: false,
    isAiUseDisallowed: true,
    blockReasons: [],
    author: {
      userId: 44419253,
      useridUuid: '5aa16421-e20b-4a8d-9428-fe192c4f41d2',
      username: 'MizuriAU',
      usericon: 'https://a.deviantart.net/avatars-big/m/i/mizuriau.png?8',
      type: 'regular',
      isWatching: false,
      isSubscribed: false,
      isNewDeviant: false,
    },
    stats: {
      comments: 5,
      favourites: 193,
      views: 9273,
      downloads: 0,
    },
    media: {
      baseUri:
        'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/5aa16421-e20b-4a8d-9428-fe192c4f41d2/dezdnhw-0db8482f-5663-4d85-893c-b0ebb996539b.png',
      prettyName: 'luke_and_the_mandalorian_by_mizuriau_dezdnhw',
      token: [
        'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7ImhlaWdodCI6Ijw9MTA2OCIsInBhdGgiOiJcL2ZcLzVhYTE2NDIxLWUyMGItNGE4ZC05NDI4LWZlMTkyYzRmNDFkMlwvZGV6ZG5ody0wZGI4NDgyZi01NjYzLTRkODUtODkzYy1iMGViYjk5NjUzOWIucG5nIiwid2lkdGgiOiI8PTE2MDAifV1dLCJhdWQiOlsidXJuOnNlcnZpY2U6aW1hZ2Uub3BlcmF0aW9ucyJdfQ.u6oQPPQl-M7cz1DYltRj80O88w2HE8GLPW31p70AgTs',
      ],
      types: [
        {
          t: '150',
          r: 0,
          c: '/v1/fit/w_150,h_150,q_70,strp/<prettyName>-150.jpg',
          h: 100,
          w: 150,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_300,h_300,q_70,strp/<prettyName>-150-2x.jpg',
            },
          ],
        },
        {
          t: '200H',
          r: 0,
          c: '/v1/fill/w_300,h_200,q_70,strp/<prettyName>-200h.jpg',
          h: 200,
          w: 300,
          ss: [
            {
              x: 2,
              c: '/v1/fill/w_600,h_400,q_70,strp/<prettyName>-200h-2x.jpg',
            },
          ],
        },
        {
          t: '300W',
          r: 0,
          c: '/v1/fit/w_300,h_900,q_70,strp/<prettyName>-300w.jpg',
          h: 200,
          w: 300,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_600,h_1068,q_70,strp/<prettyName>-300w-2x.jpg',
            },
          ],
        },
        {
          t: '375W',
          r: 0,
          c: '/v1/fit/w_375,h_250,q_70,strp/<prettyName>-375w.jpg',
          h: 250,
          w: 375,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_750,h_500,q_70,strp/<prettyName>-375w-2x.jpg',
            },
          ],
        },
        {
          t: '414W',
          r: 0,
          c: '/v1/fit/w_414,h_276,q_70,strp/<prettyName>-414w.jpg',
          h: 276,
          w: 414,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_828,h_552,q_70,strp/<prettyName>-414w-2x.jpg',
            },
          ],
        },
        {
          t: '250T',
          r: 0,
          c: '/v1/fill/w_375,h_250,q_70,strp/<prettyName>-250t.jpg',
          h: 250,
          w: 375,
          ss: [
            {
              x: 2,
              c: '/v1/fill/w_750,h_500,q_70,strp/<prettyName>-250t-2x.jpg',
            },
          ],
        },
        {
          t: '350T',
          r: 0,
          c: '/v1/fill/w_525,h_350,q_70,strp/<prettyName>-350t.jpg',
          h: 350,
          w: 524,
          ss: [
            {
              x: 2,
              c: '/v1/fill/w_1049,h_700,q_70,strp/<prettyName>-350t-2x.jpg',
            },
          ],
        },
        {
          t: '400T',
          r: 0,
          c: '/v1/fill/w_600,h_400,q_70,strp/<prettyName>-400t.jpg',
          h: 400,
          w: 599,
          ss: [
            {
              x: 2,
              c: '/v1/fill/w_1199,h_800,q_70,strp/<prettyName>-400t-2x.jpg',
            },
          ],
        },
        {
          t: 'preview',
          r: 0,
          c: '/v1/fill/w_1094,h_730,q_70,strp/<prettyName>-pre.jpg',
          h: 730,
          w: 1094,
          f: 10794534,
        },
        {
          t: 'social_preview',
          r: 0,
          c: '/v1/fill/w_1094,h_730,q_70,strp/<prettyName>-pre.jpg',
          h: 730,
          w: 1094,
        },
        {
          t: 'fullview',
          r: 0,
          c: '/v1/fill/w_1600,h_1068,q_80,strp/<prettyName>-fullview.jpg',
          h: 1068,
          w: 1600,
          f: 10794534,
        },
        {
          t: '92S',
          r: 0,
          c: '/v1/crop/w_92,h_92,x_11,y_0,scl_0.03448275862069,q_70,strp/<prettyName>-92s.jpg',
          h: 92,
          w: 92,
          ss: [
            {
              x: 2,
              c: '/v1/crop/w_184,h_184,x_23,y_0,scl_0.068965517241379,q_70,strp/<prettyName>-92s-2x.jpg',
            },
          ],
        },
      ],
    },
  },
  {
    deviationId: 905340315,
    type: 'image',
    typeId: 1,
    url: 'https://www.deviantart.com/jnwhite801/art/Wind-Cut-Canyon-905340315',
    title: 'Wind Cut Canyon',
    isJournal: false,
    isVideo: false,
    isPurchasable: false,
    isFavouritable: true,
    publishedTime: '2022-01-29T05:40:18-0800',
    isTextEditable: false,
    isBackgroundEditable: false,
    legacyTextEditUrl: null,
    isShareable: true,
    isCommentable: true,
    isFavourited: true,
    isDeleted: false,
    isMature: false,
    isNsfg: false,
    isDownloadable: false,
    isAntisocial: false,
    isBlocked: false,
    isPublished: true,
    isDailyDeviation: false,
    hasPrivateComments: false,
    isDreamsofart: false,
    isAiUseDisallowed: true,
    blockReasons: [],
    author: {
      userId: 74941722,
      useridUuid: 'f5b309f3-fb41-49b1-af23-dd79d06d10cc',
      username: 'jnwhite801',
      usericon: 'https://a.deviantart.net/avatars-big/j/n/jnwhite801.png?12',
      type: 'core_access',
      isWatching: true,
      isSubscribed: false,
      isNewDeviant: false,
    },
    stats: {
      comments: 1,
      favourites: 105,
      views: 1465,
      downloads: 0,
    },
    media: {
      baseUri:
        'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/f5b309f3-fb41-49b1-af23-dd79d06d10cc/dez0l23-aa18d104-8751-4363-823e-7e0e494401d6.jpg',
      prettyName: 'wind_cut_canyon_by_jnwhite801_dez0l23',
      token: [
        'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7ImhlaWdodCI6Ijw9MTY1NyIsInBhdGgiOiJcL2ZcL2Y1YjMwOWYzLWZiNDEtNDliMS1hZjIzLWRkNzlkMDZkMTBjY1wvZGV6MGwyMy1hYTE4ZDEwNC04NzUxLTQzNjMtODIzZS03ZTBlNDk0NDAxZDYuanBnIiwid2lkdGgiOiI8PTEyODAifV1dLCJhdWQiOlsidXJuOnNlcnZpY2U6aW1hZ2Uub3BlcmF0aW9ucyJdfQ.r8rNGczFsNOuuGasqkDtxFFGg6B8Cq7RvuG7Bfh6B4U',
      ],
      types: [
        {
          t: '150',
          r: 0,
          c: '/v1/fit/w_150,h_150,q_70,strp/<prettyName>-150.jpg',
          h: 150,
          w: 116,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_300,h_300,q_70,strp/<prettyName>-150-2x.jpg',
            },
          ],
        },
        {
          t: '200H',
          r: 0,
          c: '/v1/crop/w_155,h_200,x_0,y_0,scl_0.06078431372549,q_70,strp/<prettyName>-200h.jpg',
          h: 200,
          w: 154,
          ss: [
            {
              x: 2,
              c: '/v1/fill/w_309,h_400,q_70,strp/<prettyName>-200h-2x.jpg',
            },
          ],
        },
        {
          t: '300W',
          r: 0,
          c: '/v1/fit/w_300,h_900,q_70,strp/<prettyName>-300w.jpg',
          h: 388,
          w: 300,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_600,h_1657,q_70,strp/<prettyName>-300w-2x.jpg',
            },
          ],
        },
        {
          t: '375W',
          r: 0,
          c: '/v1/fit/w_375,h_485,q_70,strp/<prettyName>-375w.jpg',
          h: 485,
          w: 375,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_750,h_970,q_70,strp/<prettyName>-375w-2x.jpg',
            },
          ],
        },
        {
          t: '414W',
          r: 0,
          c: '/v1/fit/w_414,h_536,q_70,strp/<prettyName>-414w.jpg',
          h: 536,
          w: 414,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_828,h_1072,q_70,strp/<prettyName>-414w-2x.jpg',
            },
          ],
        },
        {
          t: '250T',
          r: 0,
          c: '/v1/fill/w_193,h_250,q_70,strp/<prettyName>-250t.jpg',
          h: 250,
          w: 193,
          ss: [
            {
              x: 2,
              c: '/v1/fill/w_386,h_500,q_70,strp/<prettyName>-250t-2x.jpg',
            },
          ],
        },
        {
          t: '350T',
          r: 0,
          c: '/v1/crop/w_270,h_350,x_0,y_0,scl_0.10627450980392,q_70,strp/<prettyName>-350t.jpg',
          h: 350,
          w: 270,
          ss: [
            {
              x: 2,
              c: '/v1/fill/w_541,h_700,q_70,strp/<prettyName>-350t-2x.jpg',
            },
          ],
        },
        {
          t: '400T',
          r: 0,
          c: '/v1/fill/w_309,h_400,q_70,strp/<prettyName>-400t.jpg',
          h: 400,
          w: 309,
          ss: [
            {
              x: 2,
              c: '/v1/fill/w_618,h_800,q_70,strp/<prettyName>-400t-2x.jpg',
            },
          ],
        },
        {
          t: 'preview',
          r: 0,
          c: '/v1/fill/w_786,h_1017,q_70,strp/<prettyName>-pre.jpg',
          h: 1017,
          w: 786,
          f: 1687889,
        },
        {
          t: 'social_preview',
          r: 0,
          c: '/v1/fill/w_786,h_1017,q_70,strp/<prettyName>-pre.jpg',
          h: 1017,
          w: 786,
        },
        {
          t: 'fullview',
          r: 0,
          c: '/v1/fill/w_1280,h_1657,q_75,strp/<prettyName>-fullview.jpg',
          h: 1657,
          w: 1280,
          f: 1687889,
        },
        {
          t: '92S',
          r: 0,
          c: '/v1/crop/w_92,h_92,x_0,y_7,scl_0.036078431372549,q_70,strp/<prettyName>-92s.jpg',
          h: 92,
          w: 92,
          ss: [
            {
              x: 2,
              c: '/v1/crop/w_184,h_184,x_0,y_14,scl_0.072156862745098,q_70,strp/<prettyName>-92s-2x.jpg',
            },
          ],
        },
      ],
    },
  },
  {
    deviationId: 905336732,
    type: 'image',
    typeId: 1,
    url: 'https://www.deviantart.com/nuhanotion/art/Sky-Mobs-905336732',
    title: 'Sky Mobs',
    isJournal: false,
    isVideo: false,
    isPurchasable: false,
    isFavouritable: true,
    publishedTime: '2022-01-29T04:46:43-0800',
    isTextEditable: false,
    isBackgroundEditable: false,
    legacyTextEditUrl: null,
    isShareable: true,
    isCommentable: true,
    isFavourited: true,
    isDeleted: false,
    isMature: false,
    isNsfg: false,
    isDownloadable: false,
    isAntisocial: false,
    isBlocked: false,
    isPublished: true,
    isDailyDeviation: true,
    hasPrivateComments: false,
    isDreamsofart: false,
    isAiUseDisallowed: true,
    blockReasons: [],
    author: {
      userId: 56442148,
      useridUuid: '0372a9b8-a2fb-43eb-bd96-8bd4454f4e15',
      username: 'Nuhanotion',
      usericon: 'https://a.deviantart.net/avatars-big/n/u/nuhanotion.jpg?14',
      type: 'core_access',
      isWatching: true,
      isSubscribed: false,
      isNewDeviant: false,
    },
    stats: {
      comments: 36,
      favourites: 1479,
      views: 570752,
      downloads: 0,
    },
    media: {
      baseUri:
        'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/0372a9b8-a2fb-43eb-bd96-8bd4454f4e15/dez0iak-8dc65046-4bdb-4da6-87d7-b477d88d225f.jpg',
      prettyName: 'sky_mobs_by_nuhanotion_dez0iak',
      token: [
        'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7ImhlaWdodCI6Ijw9NzIwIiwicGF0aCI6IlwvZlwvMDM3MmE5YjgtYTJmYi00M2ViLWJkOTYtOGJkNDQ1NGY0ZTE1XC9kZXowaWFrLThkYzY1MDQ2LTRiZGItNGRhNi04N2Q3LWI0NzdkODhkMjI1Zi5qcGciLCJ3aWR0aCI6Ijw9MTI4MCJ9XV0sImF1ZCI6WyJ1cm46c2VydmljZTppbWFnZS5vcGVyYXRpb25zIl19.Q0fFP_0bHoTSMd3mq2Hw4ZfCcTv4pQva9QdaevIx0IY',
      ],
      types: [
        {
          t: '150',
          r: 0,
          c: '/v1/fit/w_150,h_150,q_70,strp/<prettyName>-150.jpg',
          h: 84,
          w: 150,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_300,h_300,q_70,strp/<prettyName>-150-2x.jpg',
            },
          ],
        },
        {
          t: '200H',
          r: 0,
          c: '/v1/fill/w_300,h_169,q_70,strp/<prettyName>-200h.jpg',
          h: 169,
          w: 300,
          ss: [
            {
              x: 2,
              c: '/v1/fill/w_600,h_338,q_70,strp/<prettyName>-200h-2x.jpg',
            },
          ],
        },
        {
          t: '300W',
          r: 0,
          c: '/v1/fit/w_300,h_720,q_70,strp/<prettyName>-300w.jpg',
          h: 169,
          w: 300,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_600,h_720,q_70,strp/<prettyName>-300w-2x.jpg',
            },
          ],
        },
        {
          t: '375W',
          r: 0,
          c: '/v1/fit/w_375,h_211,q_70,strp/<prettyName>-375w.jpg',
          h: 211,
          w: 375,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_750,h_422,q_70,strp/<prettyName>-375w-2x.jpg',
            },
          ],
        },
        {
          t: '414W',
          r: 0,
          c: '/v1/fit/w_414,h_233,q_70,strp/<prettyName>-414w.jpg',
          h: 233,
          w: 414,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_828,h_466,q_70,strp/<prettyName>-414w-2x.jpg',
            },
          ],
        },
        {
          t: '250T',
          r: 0,
          c: '/v1/fill/w_444,h_250,q_70,strp/<prettyName>-250t.jpg',
          h: 250,
          w: 444,
          ss: [
            {
              x: 2,
              c: '/v1/fill/w_889,h_500,q_70,strp/<prettyName>-250t-2x.jpg',
            },
          ],
        },
        {
          t: '350T',
          r: 0,
          c: '/v1/fill/w_622,h_350,q_70,strp/<prettyName>-350t.jpg',
          h: 350,
          w: 622,
          ss: [
            {
              x: 2,
              c: '/v1/fill/w_1244,h_700,q_70,strp/<prettyName>-350t-2x.jpg',
            },
          ],
        },
        {
          t: '400T',
          r: 0,
          c: '/v1/fill/w_711,h_400,q_70,strp/<prettyName>-400t.jpg',
          h: 400,
          w: 711,
        },
        {
          t: 'preview',
          r: 0,
          c: '/v1/fill/w_1192,h_670,q_70,strp/<prettyName>-pre.jpg',
          h: 670,
          w: 1192,
          f: 1592681,
        },
        {
          t: 'social_preview',
          r: 0,
          c: '/v1/fill/w_1192,h_670,q_70,strp/<prettyName>-pre.jpg',
          h: 670,
          w: 1192,
        },
        {
          t: 'fullview',
          r: 0,
          c: '/v1/fill/w_1280,h_720,q_75,strp/<prettyName>-fullview.jpg',
          h: 720,
          w: 1280,
          f: 1592681,
        },
        {
          t: '92S',
          r: 0,
          c: '/v1/crop/w_92,h_92,x_18,y_0,scl_0.085185185185185,q_70,strp/<prettyName>-92s.jpg',
          h: 92,
          w: 92,
          ss: [
            {
              x: 2,
              c: '/v1/crop/w_184,h_184,x_36,y_0,scl_0.17037037037037,q_70,strp/<prettyName>-92s-2x.jpg',
            },
          ],
        },
      ],
    },
  },
  {
    deviationId: 905339153,
    type: 'image',
    typeId: 1,
    url: 'https://www.deviantart.com/k-a-t-art/art/Last-Summer-905339153',
    title: 'Last Summer',
    isJournal: false,
    isVideo: false,
    isPurchasable: false,
    isFavouritable: true,
    publishedTime: '2022-01-29T05:22:00-0800',
    isTextEditable: false,
    isBackgroundEditable: false,
    legacyTextEditUrl: null,
    isShareable: true,
    isCommentable: true,
    isFavourited: true,
    isDeleted: false,
    isMature: false,
    isNsfg: false,
    isDownloadable: false,
    isAntisocial: false,
    isBlocked: false,
    isPublished: true,
    isDailyDeviation: false,
    hasPrivateComments: false,
    isDreamsofart: false,
    isAiUseDisallowed: true,
    blockReasons: [],
    author: {
      userId: 57667923,
      useridUuid: '780717ad-f6ad-4c9e-8575-622c2865591f',
      username: 'K-A-T-art',
      usericon: 'https://a.deviantart.net/avatars-big/k/_/k-a-t-art.jpg?6',
      type: 'regular',
      isWatching: true,
      isSubscribed: false,
      isNewDeviant: false,
    },
    stats: {
      comments: 7,
      favourites: 121,
      views: 2674,
      downloads: 0,
    },
    media: {
      baseUri:
        'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/780717ad-f6ad-4c9e-8575-622c2865591f/dez0k5t-a90a416b-657f-41ed-875c-22c158da538b.jpg',
      prettyName: 'last_summer_by_k_a_t_art_dez0k5t',
      token: [
        'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7ImhlaWdodCI6Ijw9MTkyMCIsInBhdGgiOiJcL2ZcLzc4MDcxN2FkLWY2YWQtNGM5ZS04NTc1LTYyMmMyODY1NTkxZlwvZGV6MGs1dC1hOTBhNDE2Yi02NTdmLTQxZWQtODc1Yy0yMmMxNThkYTUzOGIuanBnIiwid2lkdGgiOiI8PTE5MjAifV1dLCJhdWQiOlsidXJuOnNlcnZpY2U6aW1hZ2Uub3BlcmF0aW9ucyJdfQ.7irEMen1DiJvhw5uwwsR2EIO-f0AuRa21ga3XKcRgAc',
      ],
      types: [
        {
          t: '150',
          r: 0,
          c: '/v1/fit/w_150,h_150,q_70,strp/<prettyName>-150.jpg',
          h: 150,
          w: 150,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_300,h_300,q_70,strp/<prettyName>-150-2x.jpg',
            },
          ],
        },
        {
          t: '200H',
          r: 0,
          c: '/v1/fill/w_200,h_200,q_70,strp/<prettyName>-200h.jpg',
          h: 200,
          w: 200,
          ss: [
            {
              x: 2,
              c: '/v1/fill/w_400,h_400,q_70,strp/<prettyName>-200h-2x.jpg',
            },
          ],
        },
        {
          t: '300W',
          r: 0,
          c: '/v1/fit/w_300,h_900,q_70,strp/<prettyName>-300w.jpg',
          h: 300,
          w: 300,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_600,h_1800,q_70,strp/<prettyName>-300w-2x.jpg',
            },
          ],
        },
        {
          t: '375W',
          r: 0,
          c: '/v1/fit/w_375,h_375,q_70,strp/<prettyName>-375w.jpg',
          h: 375,
          w: 375,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_750,h_750,q_70,strp/<prettyName>-375w-2x.jpg',
            },
          ],
        },
        {
          t: '414W',
          r: 0,
          c: '/v1/fit/w_414,h_414,q_70,strp/<prettyName>-414w.jpg',
          h: 414,
          w: 414,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_828,h_828,q_70,strp/<prettyName>-414w-2x.jpg',
            },
          ],
        },
        {
          t: '250T',
          r: 0,
          c: '/v1/fill/w_250,h_250,q_70,strp/<prettyName>-250t.jpg',
          h: 250,
          w: 250,
          ss: [
            {
              x: 2,
              c: '/v1/fill/w_500,h_500,q_70,strp/<prettyName>-250t-2x.jpg',
            },
          ],
        },
        {
          t: '350T',
          r: 0,
          c: '/v1/fill/w_350,h_350,q_70,strp/<prettyName>-350t.jpg',
          h: 350,
          w: 350,
          ss: [
            {
              x: 2,
              c: '/v1/fill/w_700,h_700,q_70,strp/<prettyName>-350t-2x.jpg',
            },
          ],
        },
        {
          t: '400T',
          r: 0,
          c: '/v1/fill/w_400,h_400,q_70,strp/<prettyName>-400t.jpg',
          h: 400,
          w: 400,
          ss: [
            {
              x: 2,
              c: '/v1/fill/w_800,h_800,q_70,strp/<prettyName>-400t-2x.jpg',
            },
          ],
        },
        {
          t: 'preview',
          r: 0,
          c: '/v1/fill/w_894,h_894,q_70,strp/<prettyName>-pre.jpg',
          h: 894,
          w: 894,
          f: 6185498,
        },
        {
          t: 'social_preview',
          r: 0,
          c: '/v1/fill/w_894,h_894,q_70,strp/<prettyName>-pre.jpg',
          h: 894,
          w: 894,
        },
        {
          t: 'fullview',
          r: 0,
          c: '/v1/fill/w_1920,h_1920,q_75,strp/<prettyName>-fullview.jpg',
          h: 1920,
          w: 1920,
          f: 6185498,
        },
        {
          t: '92S',
          r: 0,
          c: '/v1/crop/w_92,h_92,x_0,y_0,scl_0.026225769669327,q_70,strp/<prettyName>-92s.jpg',
          h: 92,
          w: 92,
          ss: [
            {
              x: 2,
              c: '/v1/crop/w_184,h_184,x_0,y_0,scl_0.052451539338655,q_70,strp/<prettyName>-92s-2x.jpg',
            },
          ],
        },
      ],
    },
  },
  {
    deviationId: 905326901,
    type: 'image',
    typeId: 1,
    url: 'https://www.deviantart.com/ewanpestrenin/art/Spaceships-and-clouds-pixelart-905326901',
    title: 'Spaceships and clouds pixelart',
    isJournal: false,
    isVideo: false,
    isPurchasable: false,
    isFavouritable: true,
    publishedTime: '2022-01-29T01:02:41-0800',
    isTextEditable: false,
    isBackgroundEditable: false,
    legacyTextEditUrl: null,
    isShareable: true,
    isCommentable: true,
    isFavourited: true,
    isDeleted: false,
    isMature: false,
    isNsfg: false,
    isDownloadable: true,
    isAntisocial: false,
    isBlocked: false,
    isPublished: true,
    isDailyDeviation: false,
    hasPrivateComments: false,
    isDreamsofart: false,
    isAiUseDisallowed: true,
    blockReasons: [],
    author: {
      userId: 61288216,
      useridUuid: '3ceeeac8-c493-4375-b3f5-bde9e37e929b',
      username: 'ewanpestrenin',
      usericon: 'https://a.deviantart.net/avatars-big/e/w/ewanpestrenin.jpg?4',
      type: 'regular',
      isWatching: false,
      isSubscribed: false,
      isNewDeviant: false,
    },
    stats: {
      comments: 2,
      favourites: 111,
      views: 9926,
      downloads: 15,
    },
    media: {
      baseUri:
        'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/3ceeeac8-c493-4375-b3f5-bde9e37e929b/dez0aph-c0e05ec0-013f-4709-889d-50d52fdb5fb1.jpg',
      prettyName: 'spaceships_and_clouds_pixelart_by_ewanpestrenin_dez0aph',
      token: [
        'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7ImhlaWdodCI6Ijw9OTUwIiwicGF0aCI6IlwvZlwvM2NlZWVhYzgtYzQ5My00Mzc1LWIzZjUtYmRlOWUzN2U5MjliXC9kZXowYXBoLWMwZTA1ZWMwLTAxM2YtNDcwOS04ODlkLTUwZDUyZmRiNWZiMS5qcGciLCJ3aWR0aCI6Ijw9MTI4MCJ9XV0sImF1ZCI6WyJ1cm46c2VydmljZTppbWFnZS5vcGVyYXRpb25zIl19.lFihWwJ6SKiyBO3eS0E00omLMm90BNGM_BT1KA0BprU',
      ],
      types: [
        {
          t: '150',
          r: 0,
          c: '/v1/fit/w_150,h_150,q_70,strp/<prettyName>-150.jpg',
          h: 111,
          w: 150,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_300,h_300,q_70,strp/<prettyName>-150-2x.jpg',
            },
          ],
        },
        {
          t: '200H',
          r: 0,
          c: '/v1/fill/w_269,h_200,q_70,strp/<prettyName>-200h.jpg',
          h: 200,
          w: 269,
          ss: [
            {
              x: 2,
              c: '/v1/fill/w_539,h_400,q_70,strp/<prettyName>-200h-2x.jpg',
            },
          ],
        },
        {
          t: '300W',
          r: 0,
          c: '/v1/fit/w_300,h_900,q_70,strp/<prettyName>-300w.jpg',
          h: 223,
          w: 300,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_600,h_950,q_70,strp/<prettyName>-300w-2x.jpg',
            },
          ],
        },
        {
          t: '375W',
          r: 0,
          c: '/v1/fit/w_375,h_278,q_70,strp/<prettyName>-375w.jpg',
          h: 278,
          w: 375,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_750,h_556,q_70,strp/<prettyName>-375w-2x.jpg',
            },
          ],
        },
        {
          t: '414W',
          r: 0,
          c: '/v1/fit/w_414,h_307,q_70,strp/<prettyName>-414w.jpg',
          h: 307,
          w: 414,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_828,h_614,q_70,strp/<prettyName>-414w-2x.jpg',
            },
          ],
        },
        {
          t: '250T',
          r: 0,
          c: '/v1/fill/w_337,h_250,q_70,strp/<prettyName>-250t.jpg',
          h: 250,
          w: 337,
          ss: [
            {
              x: 2,
              c: '/v1/fill/w_674,h_500,q_70,strp/<prettyName>-250t-2x.jpg',
            },
          ],
        },
        {
          t: '350T',
          r: 0,
          c: '/v1/fill/w_472,h_350,q_70,strp/<prettyName>-350t.jpg',
          h: 350,
          w: 472,
          ss: [
            {
              x: 2,
              c: '/v1/fill/w_943,h_700,q_70,strp/<prettyName>-350t-2x.jpg',
            },
          ],
        },
        {
          t: '400T',
          r: 0,
          c: '/v1/fill/w_539,h_400,q_70,strp/<prettyName>-400t.jpg',
          h: 400,
          w: 539,
          ss: [
            {
              x: 2,
              c: '/v1/fill/w_1078,h_800,q_70,strp/<prettyName>-400t-2x.jpg',
            },
          ],
        },
        {
          t: 'preview',
          r: 0,
          c: '/v1/fill/w_1038,h_770,q_70,strp/<prettyName>-pre.jpg',
          h: 770,
          w: 1038,
          f: 2031892,
        },
        {
          t: 'social_preview',
          r: 0,
          c: '/v1/fill/w_1038,h_770,q_70,strp/<prettyName>-pre.jpg',
          h: 770,
          w: 1038,
        },
        {
          t: 'fullview',
          r: 0,
          c: '/v1/fill/w_1280,h_950,q_75,strp/<prettyName>-fullview.jpg',
          h: 950,
          w: 1280,
          f: 2031892,
        },
        {
          t: '92S',
          r: 0,
          c: '/v1/crop/w_92,h_92,x_8,y_0,scl_0.024210526315789,q_70,strp/<prettyName>-92s.jpg',
          h: 92,
          w: 92,
          ss: [
            {
              x: 2,
              c: '/v1/crop/w_184,h_184,x_16,y_0,scl_0.048421052631579,q_70,strp/<prettyName>-92s-2x.jpg',
            },
          ],
        },
      ],
    },
  },
  {
    deviationId: 899561299,
    type: 'image',
    typeId: 1,
    url: 'https://www.deviantart.com/bloominstella/art/Winter-Spirit-study-899561299',
    title: 'Winter Spirit (study)',
    isJournal: false,
    isVideo: false,
    isPurchasable: false,
    isFavouritable: true,
    publishedTime: '2021-12-01T20:26:09-0800',
    isTextEditable: false,
    isBackgroundEditable: false,
    legacyTextEditUrl: null,
    isShareable: true,
    isCommentable: true,
    isFavourited: true,
    isDeleted: false,
    isMature: false,
    isNsfg: false,
    isDownloadable: false,
    isAntisocial: false,
    isBlocked: false,
    isPublished: true,
    isDailyDeviation: false,
    hasPrivateComments: false,
    isDreamsofart: false,
    isAiUseDisallowed: true,
    blockReasons: [],
    author: {
      userId: 37099592,
      useridUuid: 'cdf86537-9ee9-4ec0-a6aa-9c6d295ca9c3',
      username: 'BloominStella',
      usericon: 'https://a.deviantart.net/avatars-big/b/l/bloominstella.jpg?7',
      type: 'regular',
      isWatching: false,
      isSubscribed: false,
      isNewDeviant: false,
    },
    stats: {
      comments: 5,
      favourites: 185,
      views: 5318,
      downloads: 0,
    },
    media: {
      baseUri:
        'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/cdf86537-9ee9-4ec0-a6aa-9c6d295ca9c3/devkpxv-5eccf86f-9552-4511-8bdf-318bb7fa3fb2.png',
      prettyName: 'winter_spirit__study__by_bloominstella_devkpxv',
      token: [
        'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7ImhlaWdodCI6Ijw9OTA2IiwicGF0aCI6IlwvZlwvY2RmODY1MzctOWVlOS00ZWMwLWE2YWEtOWM2ZDI5NWNhOWMzXC9kZXZrcHh2LTVlY2NmODZmLTk1NTItNDUxMS04YmRmLTMxOGJiN2ZhM2ZiMi5wbmciLCJ3aWR0aCI6Ijw9MTI4MCJ9XV0sImF1ZCI6WyJ1cm46c2VydmljZTppbWFnZS5vcGVyYXRpb25zIl19.Wogllg53zZeJctOQhlFe6LbquzHpEcFVeQtxarapH_Q',
      ],
      types: [
        {
          t: '150',
          r: 0,
          c: '/v1/fit/w_150,h_150,q_70,strp/<prettyName>-150.jpg',
          h: 106,
          w: 150,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_300,h_300,q_70,strp/<prettyName>-150-2x.jpg',
            },
          ],
        },
        {
          t: '200H',
          r: 0,
          c: '/v1/fill/w_283,h_200,q_70,strp/<prettyName>-200h.jpg',
          h: 200,
          w: 283,
          ss: [
            {
              x: 2,
              c: '/v1/fill/w_566,h_400,q_70,strp/<prettyName>-200h-2x.jpg',
            },
          ],
        },
        {
          t: '300W',
          r: 0,
          c: '/v1/fit/w_300,h_900,q_70,strp/<prettyName>-300w.jpg',
          h: 212,
          w: 300,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_600,h_906,q_70,strp/<prettyName>-300w-2x.jpg',
            },
          ],
        },
        {
          t: '375W',
          r: 0,
          c: '/v1/fit/w_375,h_265,q_70,strp/<prettyName>-375w.jpg',
          h: 265,
          w: 375,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_750,h_530,q_70,strp/<prettyName>-375w-2x.jpg',
            },
          ],
        },
        {
          t: '414W',
          r: 0,
          c: '/v1/fit/w_414,h_293,q_70,strp/<prettyName>-414w.jpg',
          h: 293,
          w: 414,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_828,h_586,q_70,strp/<prettyName>-414w-2x.jpg',
            },
          ],
        },
        {
          t: '250T',
          r: 0,
          c: '/v1/fill/w_353,h_250,q_70,strp/<prettyName>-250t.jpg',
          h: 250,
          w: 353,
          ss: [
            {
              x: 2,
              c: '/v1/fill/w_707,h_500,q_70,strp/<prettyName>-250t-2x.jpg',
            },
          ],
        },
        {
          t: '350T',
          r: 0,
          c: '/v1/fill/w_495,h_350,q_70,strp/<prettyName>-350t.jpg',
          h: 350,
          w: 494,
          ss: [
            {
              x: 2,
              c: '/v1/fill/w_990,h_700,q_70,strp/<prettyName>-350t-2x.jpg',
            },
          ],
        },
        {
          t: '400T',
          r: 0,
          c: '/v1/fill/w_566,h_400,q_70,strp/<prettyName>-400t.jpg',
          h: 400,
          w: 565,
          ss: [
            {
              x: 2,
              c: '/v1/fill/w_1131,h_800,q_70,strp/<prettyName>-400t-2x.jpg',
            },
          ],
        },
        {
          t: 'preview',
          r: 0,
          c: '/v1/fill/w_1063,h_752,q_70,strp/<prettyName>-pre.jpg',
          h: 752,
          w: 1063,
          f: 3268857,
        },
        {
          t: 'social_preview',
          r: 0,
          c: '/v1/fill/w_1063,h_752,q_70,strp/<prettyName>-pre.jpg',
          h: 752,
          w: 1063,
        },
        {
          t: 'fullview',
          r: 0,
          c: '/v1/fill/w_1280,h_906,q_80,strp/<prettyName>-fullview.jpg',
          h: 906,
          w: 1280,
          f: 3268857,
        },
        {
          t: '92S',
          r: 0,
          c: '/v1/crop/w_92,h_92,x_10,y_0,scl_0.086710650329877,q_70,strp/<prettyName>-92s.jpg',
          h: 92,
          w: 92,
          ss: [
            {
              x: 2,
              c: '/v1/crop/w_184,h_184,x_19,y_0,scl_0.17342130065975,q_70,strp/<prettyName>-92s-2x.jpg',
            },
          ],
        },
      ],
    },
  },
  {
    deviationId: 899559987,
    type: 'image',
    typeId: 1,
    url: 'https://www.deviantart.com/cypressdahlia/art/Splash-Screen-Pixel-Art-899559987',
    title: 'Splash Screen Pixel Art',
    isJournal: false,
    isVideo: false,
    isPurchasable: false,
    isFavouritable: true,
    publishedTime: '2021-12-01T20:08:37-0800',
    isTextEditable: false,
    isBackgroundEditable: false,
    legacyTextEditUrl: null,
    isShareable: true,
    isCommentable: true,
    isFavourited: true,
    isDeleted: false,
    isMature: false,
    isNsfg: false,
    isDownloadable: false,
    isAntisocial: false,
    isBlocked: false,
    isPublished: true,
    isDailyDeviation: false,
    hasPrivateComments: false,
    isDreamsofart: false,
    isAiUseDisallowed: true,
    blockReasons: [],
    author: {
      userId: 4973830,
      useridUuid: '4ae8b3c2-0621-4e22-8729-1de81f4235a6',
      username: 'CypressDahlia',
      usericon: 'https://a.deviantart.net/avatars-big/c/y/cypressdahlia.png?5',
      type: 'regular',
      isWatching: true,
      isSubscribed: false,
      isNewDeviant: false,
    },
    stats: {
      comments: 2,
      favourites: 61,
      views: 1970,
      downloads: 0,
    },
    media: {
      baseUri:
        'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/4ae8b3c2-0621-4e22-8729-1de81f4235a6/devkoxf-051dd152-a229-4636-95ec-e6d61f8348b3.png',
      prettyName: 'splash_screen_pixel_art_by_cypressdahlia_devkoxf',
      token: [
        'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7ImhlaWdodCI6Ijw9MzQ2IiwicGF0aCI6IlwvZlwvNGFlOGIzYzItMDYyMS00ZTIyLTg3MjktMWRlODFmNDIzNWE2XC9kZXZrb3hmLTA1MWRkMTUyLWEyMjktNDYzNi05NWVjLWU2ZDYxZjgzNDhiMy5wbmciLCJ3aWR0aCI6Ijw9NDk2In1dXSwiYXVkIjpbInVybjpzZXJ2aWNlOmltYWdlLm9wZXJhdGlvbnMiXX0.RrNcHGlyZTtVgJB0UIxOLjqtXoD-OXPC2vqnU2-iZJE',
        'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7InBhdGgiOiJcL2ZcLzRhZThiM2MyLTA2MjEtNGUyMi04NzI5LTFkZTgxZjQyMzVhNlwvZGV2a294Zi0wNTFkZDE1Mi1hMjI5LTQ2MzYtOTVlYy1lNmQ2MWY4MzQ4YjMucG5nIn1dXSwiYXVkIjpbInVybjpzZXJ2aWNlOmZpbGUuZG93bmxvYWQiXX0.H59GNhbD9Fp7J-0E4LKlTbcMv8bEVkS6OIpDGPn82tI',
      ],
      types: [
        {
          t: '150',
          r: 0,
          c: '/v1/fit/w_150,h_150,q_70,strp/<prettyName>-150.jpg',
          h: 105,
          w: 150,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_300,h_300,q_70,strp/<prettyName>-150-2x.jpg',
            },
          ],
        },
        {
          t: '200H',
          r: 0,
          c: '/v1/fill/w_287,h_200,q_70,strp/<prettyName>-200h.jpg',
          h: 200,
          w: 287,
          ss: [
            {
              x: 2,
              c: '/v1/fill/w_496,h_346,q_70,strp/<prettyName>-200h-2x.jpg',
            },
          ],
        },
        {
          t: '300W',
          r: 0,
          c: '/v1/fit/w_300,h_346,q_70,strp/<prettyName>-300w.jpg',
          h: 209,
          w: 300,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_496,h_346,q_70,strp/<prettyName>-300w-2x.jpg',
            },
          ],
        },
        {
          t: '375W',
          r: 0,
          c: '/v1/fit/w_375,h_262,q_70,strp/<prettyName>-375w.jpg',
          h: 262,
          w: 375,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_496,h_346,q_70,strp/<prettyName>-375w-2x.jpg',
            },
          ],
        },
        {
          t: '414W',
          r: 0,
          c: '/v1/fit/w_414,h_289,q_70,strp/<prettyName>-414w.jpg',
          h: 289,
          w: 414,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_496,h_346,q_70,strp/<prettyName>-414w-2x.jpg',
            },
          ],
        },
        {
          t: '250T',
          r: 0,
          c: '/v1/fill/w_358,h_250,q_70,strp/<prettyName>-250t.jpg',
          h: 250,
          w: 358,
          ss: [
            {
              x: 2,
              c: '/v1/fill/w_496,h_346,q_70,strp/<prettyName>-250t-2x.jpg',
            },
          ],
        },
        {
          t: '350T',
          r: 0,
          c: '/v1/fill/w_496,h_346,q_80,strp/<prettyName>-fullview.jpg',
          h: 346,
          w: 496,
        },
        {
          t: '400T',
          r: 0,
          c: '/v1/fill/w_496,h_346,q_80,strp/<prettyName>-fullview.jpg',
          h: 346,
          w: 496,
        },
        {
          t: 'preview',
          r: 0,
          c: '/v1/fill/w_496,h_346,q_80,strp/<prettyName>-fullview.jpg',
          h: 346,
          w: 496,
          f: 65313,
        },
        {
          t: 'social_preview',
          r: 0,
          c: '/v1/fill/w_496,h_346,q_80,strp/<prettyName>-fullview.jpg',
          h: 346,
          w: 496,
        },
        {
          t: 'fullview',
          r: 1,
          h: 346,
          w: 496,
          f: 65313,
        },
        {
          t: '92S',
          r: 0,
          c: '/v1/crop/w_92,h_92,x_10,y_0,scl_0.26589595375723,q_70,strp/<prettyName>-92s.jpg',
          h: 92,
          w: 92,
          ss: [
            {
              x: 2,
              c: '/v1/crop/w_184,h_184,x_20,y_0,scl_0.53179190751445,q_70,strp/<prettyName>-92s-2x.jpg',
            },
          ],
        },
      ],
    },
  },
  {
    deviationId: 898277350,
    type: 'image',
    typeId: 1,
    url: 'https://www.deviantart.com/queen-of-phoenix/art/Virtual-pleinair-898277350',
    title: 'Virtual pleinair',
    isJournal: false,
    isVideo: false,
    isPurchasable: false,
    isFavouritable: true,
    publishedTime: '2021-11-18T08:22:44-0800',
    isTextEditable: false,
    isBackgroundEditable: false,
    legacyTextEditUrl: null,
    isShareable: true,
    isCommentable: true,
    isFavourited: true,
    isDeleted: false,
    isMature: false,
    isNsfg: false,
    isDownloadable: false,
    isAntisocial: false,
    isBlocked: false,
    isPublished: true,
    isDailyDeviation: false,
    hasPrivateComments: false,
    isDreamsofart: false,
    isAiUseDisallowed: true,
    blockReasons: [],
    author: {
      userId: 17948122,
      useridUuid: 'd574abcb-fd8d-4708-804f-99f1ede78f60',
      username: 'Queen-of-Phoenix',
      usericon: 'https://a.deviantart.net/avatars-big/q/u/queen-of-phoenix.jpg?3',
      type: 'regular',
      isWatching: false,
      isSubscribed: false,
      isNewDeviant: false,
    },
    stats: {
      comments: 4,
      favourites: 152,
      views: 5803,
      downloads: 0,
    },
    media: {
      baseUri:
        'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/d574abcb-fd8d-4708-804f-99f1ede78f60/deut78m-55c527fe-eb30-4848-b381-38e04fed21e7.png',
      prettyName: 'virtual_pleinair_by_queen_of_phoenix_deut78m',
      token: [
        'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7ImhlaWdodCI6Ijw9NTU2IiwicGF0aCI6IlwvZlwvZDU3NGFiY2ItZmQ4ZC00NzA4LTgwNGYtOTlmMWVkZTc4ZjYwXC9kZXV0NzhtLTU1YzUyN2ZlLWViMzAtNDg0OC1iMzgxLTM4ZTA0ZmVkMjFlNy5wbmciLCJ3aWR0aCI6Ijw9MTI4MCJ9XV0sImF1ZCI6WyJ1cm46c2VydmljZTppbWFnZS5vcGVyYXRpb25zIl19.RFLpQ8a4R8rXXkiyxtoWewwX55bPYaAkeCNCs8XlUag',
      ],
      types: [
        {
          t: '150',
          r: 0,
          c: '/v1/fit/w_150,h_150,q_70,strp/<prettyName>-150.jpg',
          h: 65,
          w: 150,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_300,h_300,q_70,strp/<prettyName>-150-2x.jpg',
            },
          ],
        },
        {
          t: '200H',
          r: 0,
          c: '/v1/fill/w_300,h_130,q_70,strp/<prettyName>-200h.jpg',
          h: 130,
          w: 300,
          ss: [
            {
              x: 2,
              c: '/v1/fill/w_600,h_260,q_70,strp/<prettyName>-200h-2x.jpg',
            },
          ],
        },
        {
          t: '300W',
          r: 0,
          c: '/v1/fit/w_300,h_556,q_70,strp/<prettyName>-300w.jpg',
          h: 130,
          w: 300,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_600,h_556,q_70,strp/<prettyName>-300w-2x.jpg',
            },
          ],
        },
        {
          t: '375W',
          r: 0,
          c: '/v1/fit/w_375,h_163,q_70,strp/<prettyName>-375w.jpg',
          h: 163,
          w: 375,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_750,h_326,q_70,strp/<prettyName>-375w-2x.jpg',
            },
          ],
        },
        {
          t: '414W',
          r: 0,
          c: '/v1/fit/w_414,h_180,q_70,strp/<prettyName>-414w.jpg',
          h: 180,
          w: 414,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_828,h_360,q_70,strp/<prettyName>-414w-2x.jpg',
            },
          ],
        },
        {
          t: '250T',
          r: 0,
          c: '/v1/fill/w_500,h_217,q_70,strp/<prettyName>-250t.jpg',
          h: 217,
          w: 500,
          ss: [
            {
              x: 2,
              c: '/v1/fill/w_1000,h_434,q_70,strp/<prettyName>-250t-2x.jpg',
            },
          ],
        },
        {
          t: '350T',
          r: 0,
          c: '/v1/fill/w_700,h_304,q_70,strp/<prettyName>-350t.jpg',
          h: 304,
          w: 700,
        },
        {
          t: '400T',
          r: 0,
          c: '/v1/fill/w_800,h_347,q_70,strp/<prettyName>-400t.jpg',
          h: 348,
          w: 800,
        },
        {
          t: 'preview',
          r: 0,
          c: '/v1/fill/w_1280,h_556,q_80,strp/<prettyName>-fullview.jpg',
          h: 556,
          w: 1280,
          f: 1530025,
        },
        {
          t: 'social_preview',
          r: 0,
          c: '/v1/fill/w_1280,h_556,q_80,strp/<prettyName>-fullview.jpg',
          h: 556,
          w: 1280,
        },
        {
          t: 'fullview',
          r: 0,
          c: '/v1/fill/w_1280,h_556,q_80,strp/<prettyName>-fullview.jpg',
          h: 556,
          w: 1280,
          f: 1530025,
        },
        {
          t: '92S',
          r: 0,
          c: '/v1/crop/w_92,h_92,x_30,y_0,scl_0.11779769526248,q_70,strp/<prettyName>-92s.jpg',
          h: 92,
          w: 92,
          ss: [
            {
              x: 2,
              c: '/v1/crop/w_184,h_184,x_60,y_0,scl_0.23559539052497,q_70,strp/<prettyName>-92s-2x.jpg',
            },
          ],
        },
      ],
    },
  },
  {
    deviationId: 898347064,
    type: 'image',
    typeId: 1,
    url: 'https://www.deviantart.com/realitydream/art/Autumn-Walk-CCXXXIII-898347064',
    title: 'Autumn Walk CCXXXIII.',
    isJournal: false,
    isVideo: false,
    isPurchasable: false,
    isFavouritable: true,
    publishedTime: '2021-11-19T01:16:19-0800',
    isTextEditable: false,
    isBackgroundEditable: false,
    legacyTextEditUrl: null,
    isShareable: true,
    isCommentable: true,
    isFavourited: true,
    isDeleted: false,
    isMature: false,
    isNsfg: false,
    isDownloadable: false,
    isAntisocial: false,
    isBlocked: false,
    isPublished: true,
    isDailyDeviation: false,
    hasPrivateComments: false,
    isDreamsofart: false,
    isAiUseDisallowed: true,
    blockReasons: [],
    author: {
      userId: 2689472,
      useridUuid: 'c8fefb08-2166-4271-9b38-f009522cd601',
      username: 'realityDream',
      usericon: 'https://a.deviantart.net/avatars-big/r/e/realitydream.jpg?11',
      type: 'regular',
      isWatching: false,
      isSubscribed: false,
      isNewDeviant: false,
    },
    stats: {
      comments: 6,
      favourites: 296,
      views: 23836,
      downloads: 0,
    },
    media: {
      baseUri:
        'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/c8fefb08-2166-4271-9b38-f009522cd601/deuup14-8f92fff0-f62f-40ac-9632-c30c919e7c2e.jpg',
      prettyName: 'autumn_walk_ccxxxiii__by_realitydream_deuup14',
      token: [
        'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7ImhlaWdodCI6Ijw9ODQ5IiwicGF0aCI6IlwvZlwvYzhmZWZiMDgtMjE2Ni00MjcxLTliMzgtZjAwOTUyMmNkNjAxXC9kZXV1cDE0LThmOTJmZmYwLWY2MmYtNDBhYy05NjMyLWMzMGM5MTllN2MyZS5qcGciLCJ3aWR0aCI6Ijw9MTI4MCJ9XV0sImF1ZCI6WyJ1cm46c2VydmljZTppbWFnZS5vcGVyYXRpb25zIl19.DRvzCpQ21BRRTAS9MBMfmAmlKw_ANv2XCNHSEuyqVV0',
      ],
      types: [
        {
          t: '150',
          r: 0,
          c: '/v1/fit/w_150,h_150,q_70,strp/<prettyName>-150.jpg',
          h: 99,
          w: 150,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_300,h_300,q_70,strp/<prettyName>-150-2x.jpg',
            },
          ],
        },
        {
          t: '200H',
          r: 0,
          c: '/v1/fill/w_300,h_199,q_70,strp/<prettyName>-200h.jpg',
          h: 199,
          w: 300,
          ss: [
            {
              x: 2,
              c: '/v1/fill/w_600,h_398,q_70,strp/<prettyName>-200h-2x.jpg',
            },
          ],
        },
        {
          t: '300W',
          r: 0,
          c: '/v1/fit/w_300,h_849,q_70,strp/<prettyName>-300w.jpg',
          h: 199,
          w: 300,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_600,h_849,q_70,strp/<prettyName>-300w-2x.jpg',
            },
          ],
        },
        {
          t: '375W',
          r: 0,
          c: '/v1/fit/w_375,h_249,q_70,strp/<prettyName>-375w.jpg',
          h: 249,
          w: 375,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_750,h_498,q_70,strp/<prettyName>-375w-2x.jpg',
            },
          ],
        },
        {
          t: '414W',
          r: 0,
          c: '/v1/fit/w_414,h_275,q_70,strp/<prettyName>-414w.jpg',
          h: 275,
          w: 414,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_828,h_550,q_70,strp/<prettyName>-414w-2x.jpg',
            },
          ],
        },
        {
          t: '250T',
          r: 0,
          c: '/v1/fill/w_377,h_250,q_70,strp/<prettyName>-250t.jpg',
          h: 250,
          w: 377,
          ss: [
            {
              x: 2,
              c: '/v1/fill/w_755,h_500,q_70,strp/<prettyName>-250t-2x.jpg',
            },
          ],
        },
        {
          t: '350T',
          r: 0,
          c: '/v1/fill/w_528,h_350,q_70,strp/<prettyName>-350t.jpg',
          h: 350,
          w: 528,
          ss: [
            {
              x: 2,
              c: '/v1/fill/w_1056,h_700,q_70,strp/<prettyName>-350t-2x.jpg',
            },
          ],
        },
        {
          t: '400T',
          r: 0,
          c: '/v1/fill/w_604,h_400,q_70,strp/<prettyName>-400t.jpg',
          h: 400,
          w: 603,
          ss: [
            {
              x: 2,
              c: '/v1/fill/w_1207,h_800,q_70,strp/<prettyName>-400t-2x.jpg',
            },
          ],
        },
        {
          t: 'preview',
          r: 0,
          c: '/v1/fill/w_1098,h_728,q_70,strp/<prettyName>-pre.jpg',
          h: 728,
          w: 1098,
          f: 2403274,
        },
        {
          t: 'social_preview',
          r: 0,
          c: '/v1/fill/w_1098,h_728,q_70,strp/<prettyName>-pre.jpg',
          h: 728,
          w: 1098,
        },
        {
          t: 'fullview',
          r: 0,
          c: '/v1/fill/w_1280,h_849,q_75,strp/<prettyName>-fullview.jpg',
          h: 849,
          w: 1280,
          f: 2403274,
        },
        {
          t: '92S',
          r: 0,
          c: '/v1/crop/w_92,h_92,x_12,y_0,scl_0.092555331991952,q_70,strp/<prettyName>-92s.jpg',
          h: 92,
          w: 92,
          ss: [
            {
              x: 2,
              c: '/v1/crop/w_184,h_184,x_23,y_0,scl_0.1851106639839,q_70,strp/<prettyName>-92s-2x.jpg',
            },
          ],
        },
      ],
    },
  },
  {
    deviationId: 898339935,
    type: 'image',
    typeId: 1,
    url: 'https://www.deviantart.com/vilone/art/At-the-sunset-of-magic-898339935',
    title: 'At the sunset of magic',
    isJournal: false,
    isVideo: false,
    isPurchasable: false,
    isFavouritable: true,
    publishedTime: '2021-11-18T22:54:14-0800',
    isTextEditable: false,
    isBackgroundEditable: false,
    legacyTextEditUrl: null,
    isShareable: true,
    isCommentable: true,
    isFavourited: true,
    isDeleted: false,
    isMature: false,
    isNsfg: false,
    isDownloadable: false,
    isAntisocial: false,
    isBlocked: false,
    isPublished: true,
    isDailyDeviation: false,
    hasPrivateComments: false,
    isDreamsofart: false,
    isAiUseDisallowed: true,
    blockReasons: [],
    author: {
      userId: 5704498,
      useridUuid: 'b2e97104-f04d-4b7f-bcc2-1c6550a78363',
      username: 'Vilone',
      usericon: 'https://a.deviantart.net/avatars-big/v/i/vilone.jpg?4',
      type: 'regular',
      isWatching: false,
      isSubscribed: false,
      isNewDeviant: false,
    },
    stats: {
      comments: 4,
      favourites: 192,
      views: 4968,
      downloads: 0,
    },
    media: {
      baseUri:
        'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/b2e97104-f04d-4b7f-bcc2-1c6550a78363/deuujj3-c35c3e97-dac6-4db8-b9f0-2f240c385d78.jpg',
      prettyName: 'at_the_sunset_of_magic_by_vilone_deuujj3',
      token: [
        'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7ImhlaWdodCI6Ijw9ODAwIiwicGF0aCI6IlwvZlwvYjJlOTcxMDQtZjA0ZC00YjdmLWJjYzItMWM2NTUwYTc4MzYzXC9kZXV1amozLWMzNWMzZTk3LWRhYzYtNGRiOC1iOWYwLTJmMjQwYzM4NWQ3OC5qcGciLCJ3aWR0aCI6Ijw9MTI4MCJ9XV0sImF1ZCI6WyJ1cm46c2VydmljZTppbWFnZS5vcGVyYXRpb25zIl19.sS6cUBydLuACQms7utAePulzZ3kM1WClB26ncIszMpU',
      ],
      types: [
        {
          t: '150',
          r: 0,
          c: '/v1/fit/w_150,h_150,q_70,strp/<prettyName>-150.jpg',
          h: 94,
          w: 150,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_300,h_300,q_70,strp/<prettyName>-150-2x.jpg',
            },
          ],
        },
        {
          t: '200H',
          r: 0,
          c: '/v1/fill/w_300,h_188,q_70,strp/<prettyName>-200h.jpg',
          h: 188,
          w: 300,
          ss: [
            {
              x: 2,
              c: '/v1/fill/w_600,h_375,q_70,strp/<prettyName>-200h-2x.jpg',
            },
          ],
        },
        {
          t: '300W',
          r: 0,
          c: '/v1/fit/w_300,h_800,q_70,strp/<prettyName>-300w.jpg',
          h: 188,
          w: 300,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_600,h_800,q_70,strp/<prettyName>-300w-2x.jpg',
            },
          ],
        },
        {
          t: '375W',
          r: 0,
          c: '/v1/fit/w_375,h_234,q_70,strp/<prettyName>-375w.jpg',
          h: 234,
          w: 375,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_750,h_468,q_70,strp/<prettyName>-375w-2x.jpg',
            },
          ],
        },
        {
          t: '414W',
          r: 0,
          c: '/v1/fit/w_414,h_259,q_70,strp/<prettyName>-414w.jpg',
          h: 259,
          w: 414,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_828,h_518,q_70,strp/<prettyName>-414w-2x.jpg',
            },
          ],
        },
        {
          t: '250T',
          r: 0,
          c: '/v1/fill/w_400,h_250,q_70,strp/<prettyName>-250t.jpg',
          h: 250,
          w: 400,
          ss: [
            {
              x: 2,
              c: '/v1/fill/w_800,h_500,q_70,strp/<prettyName>-250t-2x.jpg',
            },
          ],
        },
        {
          t: '350T',
          r: 0,
          c: '/v1/fill/w_560,h_350,q_70,strp/<prettyName>-350t.jpg',
          h: 350,
          w: 560,
          ss: [
            {
              x: 2,
              c: '/v1/fill/w_1120,h_700,q_70,strp/<prettyName>-350t-2x.jpg',
            },
          ],
        },
        {
          t: '400T',
          r: 0,
          c: '/v1/fill/w_640,h_400,q_70,strp/<prettyName>-400t.jpg',
          h: 400,
          w: 640,
          ss: [
            {
              x: 2,
              c: '/v1/fill/w_1280,h_800,q_70,strp/<prettyName>-400t-2x.jpg',
            },
          ],
        },
        {
          t: 'preview',
          r: 0,
          c: '/v1/fill/w_1131,h_707,q_70,strp/<prettyName>-pre.jpg',
          h: 707,
          w: 1131,
          f: 380450,
        },
        {
          t: 'social_preview',
          r: 0,
          c: '/v1/fill/w_1131,h_707,q_70,strp/<prettyName>-pre.jpg',
          h: 707,
          w: 1131,
        },
        {
          t: 'fullview',
          r: 0,
          c: '/v1/fill/w_1280,h_800,q_75,strp/<prettyName>-fullview.jpg',
          h: 800,
          w: 1280,
          f: 380450,
        },
        {
          t: '92S',
          r: 0,
          c: '/v1/crop/w_92,h_92,x_14,y_0,scl_0.076666666666667,q_70,strp/<prettyName>-92s.jpg',
          h: 92,
          w: 92,
          ss: [
            {
              x: 2,
              c: '/v1/crop/w_184,h_184,x_28,y_0,scl_0.15333333333333,q_70,strp/<prettyName>-92s-2x.jpg',
            },
          ],
        },
      ],
    },
  },
  {
    deviationId: 897155197,
    type: 'film',
    typeId: 1,
    url: 'https://www.deviantart.com/eikoweb/art/Broken-897155197',
    title: 'Broken',
    isJournal: false,
    isVideo: true,
    isPurchasable: false,
    isFavouritable: true,
    publishedTime: '2021-11-06T12:02:32-0700',
    isTextEditable: false,
    isBackgroundEditable: false,
    legacyTextEditUrl: null,
    isShareable: true,
    isCommentable: true,
    isFavourited: true,
    isDeleted: false,
    isMature: false,
    isNsfg: false,
    isDownloadable: false,
    isAntisocial: false,
    isBlocked: false,
    isPublished: true,
    isDailyDeviation: false,
    hasPrivateComments: false,
    blockReasons: [],
    author: {
      userId: 808930,
      useridUuid: '9c6ef7b6-a310-472a-bd1a-f39b6f630229',
      username: 'eikoweb',
      usericon: 'https://a.deviantart.net/avatars-big/e/i/eikoweb.jpg?13',
      type: 'beta',
      isWatching: false,
      isSubscribed: false,
      isNewDeviant: false,
    },
    stats: {
      comments: 11,
      favourites: 22,
      views: 2459,
      downloads: 0,
    },
    media: {
      baseUri:
        'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/i/9c6ef7b6-a310-472a-bd1a-f39b6f630229/deu55dp-27f8a1c7-b9ef-4f9e-bd4a-79b200eae023.jpg',
      prettyName: 'broken_by_eikoweb_deu55dp',
      types: [
        {
          t: '150',
          r: -1,
          c: '/v1/fit/w_150,h_150,q_70,strp/<prettyName>-150.jpg',
          h: 84,
          w: 150,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_300,h_300,q_70,strp/<prettyName>-150-2x.jpg',
            },
          ],
        },
        {
          t: '200H',
          r: -1,
          c: '/v1/fill/w_300,h_169,q_70,strp/<prettyName>-200h.jpg',
          h: 169,
          w: 300,
          ss: [
            {
              x: 2,
              c: '/v1/fill/w_600,h_338,q_70,strp/<prettyName>-200h-2x.jpg',
            },
          ],
        },
        {
          t: '300W',
          r: -1,
          c: '/v1/fit/w_300,h_900,q_70,strp/<prettyName>-300w.jpg',
          h: 169,
          w: 300,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_600,h_1296,q_70,strp/<prettyName>-300w-2x.jpg',
            },
          ],
        },
        {
          t: '375W',
          r: -1,
          c: '/v1/fit/w_375,h_211,q_70,strp/<prettyName>-375w.jpg',
          h: 211,
          w: 375,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_750,h_422,q_70,strp/<prettyName>-375w-2x.jpg',
            },
          ],
        },
        {
          t: '414W',
          r: -1,
          c: '/v1/fit/w_414,h_233,q_70,strp/<prettyName>-414w.jpg',
          h: 233,
          w: 414,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_828,h_466,q_70,strp/<prettyName>-414w-2x.jpg',
            },
          ],
        },
        {
          t: '250T',
          r: -1,
          c: '/v1/fill/w_444,h_250,q_70,strp/<prettyName>-250t.jpg',
          h: 250,
          w: 444,
          ss: [
            {
              x: 2,
              c: '/v1/fill/w_889,h_500,q_70,strp/<prettyName>-250t-2x.jpg',
            },
          ],
        },
        {
          t: '350T',
          r: -1,
          c: '/v1/fill/w_622,h_350,q_70,strp/<prettyName>-350t.jpg',
          h: 350,
          w: 622,
          ss: [
            {
              x: 2,
              c: '/v1/fill/w_1244,h_700,q_70,strp/<prettyName>-350t-2x.jpg',
            },
          ],
        },
        {
          t: '400T',
          r: -1,
          c: '/v1/fill/w_711,h_400,q_70,strp/<prettyName>-400t.jpg',
          h: 400,
          w: 711,
          ss: [
            {
              x: 2,
              c: '/v1/fill/w_1422,h_800,q_70,strp/<prettyName>-400t-2x.jpg',
            },
          ],
        },
        {
          t: 'preview',
          r: -1,
          c: '/v1/fill/w_1192,h_670,q_70,strp/<prettyName>-pre.jpg',
          h: 670,
          w: 1192,
          f: 17717,
        },
        {
          t: 'social_preview',
          r: -1,
          c: '/v1/fill/w_1192,h_670,q_70,strp/<prettyName>-pre.jpg',
          h: 670,
          w: 1192,
        },
        {
          t: 'fullview',
          r: -1,
          h: 1296,
          w: 2304,
          f: 17717,
        },
        {
          t: '92S',
          r: -1,
          c: '/v1/crop/w_92,h_92,x_18,y_0,scl_0.070987654320988,q_70,strp/<prettyName>-92s.jpg',
          h: 92,
          w: 92,
          ss: [
            {
              x: 2,
              c: '/v1/crop/w_184,h_184,x_36,y_0,scl_0.14197530864198,q_70,strp/<prettyName>-92s-2x.jpg',
            },
          ],
        },
        {
          t: 'video',
          r: -1,
          h: 360,
          w: 640,
          q: '360p',
          f: 4904728,
          d: 58,
          b: 'https://wixmp-ed30a86b8c4ca887773594c2.wixmp.com/v/mp4/9c6ef7b6-a310-472a-bd1a-f39b6f630229/deu55dp-f32a0d0d-898e-423e-aa31-d34bf16ce191.VideoQualities.res_360p.5906d55abb0c47a9bae5140c2568baab.mp4',
        },
        {
          t: 'video',
          r: -1,
          h: 480,
          w: 854,
          q: '480p',
          f: 8066782,
          d: 58,
          b: 'https://wixmp-ed30a86b8c4ca887773594c2.wixmp.com/v/mp4/9c6ef7b6-a310-472a-bd1a-f39b6f630229/deu55dp-f32a0d0d-898e-423e-aa31-d34bf16ce191.VideoQualities.res_480p.5906d55abb0c47a9bae5140c2568baab.mp4',
        },
        {
          t: 'video',
          r: -1,
          h: 720,
          w: 1280,
          q: '720p',
          f: 15963980,
          d: 58,
          b: 'https://wixmp-ed30a86b8c4ca887773594c2.wixmp.com/v/mp4/9c6ef7b6-a310-472a-bd1a-f39b6f630229/deu55dp-f32a0d0d-898e-423e-aa31-d34bf16ce191.VideoQualities.res_720p.5906d55abb0c47a9bae5140c2568baab.mp4',
        },
        {
          t: 'video',
          r: -1,
          h: 1080,
          w: 1920,
          q: '1080p',
          f: 34079281,
          d: 58,
          b: 'https://wixmp-ed30a86b8c4ca887773594c2.wixmp.com/v/mp4/9c6ef7b6-a310-472a-bd1a-f39b6f630229/deu55dp-f32a0d0d-898e-423e-aa31-d34bf16ce191.VideoQualities.res_1080p.5906d55abb0c47a9bae5140c2568baab.mp4',
        },
      ],
    },
  },
  {
    deviationId: 894579081,
    type: 'image',
    typeId: 1,
    url: 'https://www.deviantart.com/vladgradobyk/art/Merch-for-IFHP-clothing-Co-894579081',
    title: 'Merch for IFHP clothing Co.',
    isJournal: false,
    isVideo: false,
    isPurchasable: false,
    isFavouritable: true,
    publishedTime: '2021-10-11T12:59:12-0700',
    isTextEditable: false,
    isBackgroundEditable: false,
    legacyTextEditUrl: null,
    isShareable: true,
    isCommentable: true,
    isFavourited: true,
    isDeleted: false,
    isMature: false,
    isNsfg: false,
    isDownloadable: false,
    isAntisocial: false,
    isBlocked: false,
    isPublished: true,
    isDailyDeviation: false,
    hasPrivateComments: false,
    isDreamsofart: false,
    isAiUseDisallowed: true,
    blockReasons: [],
    author: {
      userId: 22037365,
      useridUuid: 'b3509743-53db-4288-8e73-9aa91d76e988',
      username: 'VladGradobyk',
      usericon: 'https://a.deviantart.net/avatars-big/v/l/vladgradobyk.jpg?11',
      type: 'regular',
      isWatching: true,
      isSubscribed: false,
      isNewDeviant: false,
    },
    stats: {
      comments: 1,
      favourites: 24,
      views: 1165,
      downloads: 0,
    },
    media: {
      baseUri:
        'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/b3509743-53db-4288-8e73-9aa91d76e988/deslxmx-2a2b6065-cf1d-48ac-8490-5a48a5b381c1.png',
      prettyName: 'merch_for_ifhp_clothing_co__by_vladgradobyk_deslxmx',
      token: [
        'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7ImhlaWdodCI6Ijw9MTIwMCIsInBhdGgiOiJcL2ZcL2IzNTA5NzQzLTUzZGItNDI4OC04ZTczLTlhYTkxZDc2ZTk4OFwvZGVzbHhteC0yYTJiNjA2NS1jZjFkLTQ4YWMtODQ5MC01YTQ4YTViMzgxYzEucG5nIiwid2lkdGgiOiI8PTkwMCJ9XV0sImF1ZCI6WyJ1cm46c2VydmljZTppbWFnZS5vcGVyYXRpb25zIl19.xFlmgVF-HkBK_8QSaIkpPGzihPAeQt_2Pbdv8XwKcuI',
        'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7InBhdGgiOiJcL2ZcL2IzNTA5NzQzLTUzZGItNDI4OC04ZTczLTlhYTkxZDc2ZTk4OFwvZGVzbHhteC0yYTJiNjA2NS1jZjFkLTQ4YWMtODQ5MC01YTQ4YTViMzgxYzEucG5nIn1dXSwiYXVkIjpbInVybjpzZXJ2aWNlOmZpbGUuZG93bmxvYWQiXX0.dj3vIe3zrNWTKOoZgr5sgmTLRwwKIK67r4uhjBlk1cw',
      ],
      types: [
        {
          t: '150',
          r: 0,
          c: '/v1/fit/w_150,h_150,q_70,strp/<prettyName>-150.jpg',
          h: 150,
          w: 113,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_300,h_300,q_70,strp/<prettyName>-150-2x.jpg',
            },
          ],
        },
        {
          t: '200H',
          r: 0,
          c: '/v1/fill/w_150,h_200,q_70,strp/<prettyName>-200h.jpg',
          h: 200,
          w: 150,
          ss: [
            {
              x: 2,
              c: '/v1/fill/w_300,h_400,q_70,strp/<prettyName>-200h-2x.jpg',
            },
          ],
        },
        {
          t: '300W',
          r: 0,
          c: '/v1/fit/w_300,h_900,q_70,strp/<prettyName>-300w.jpg',
          h: 400,
          w: 300,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_600,h_1200,q_70,strp/<prettyName>-300w-2x.jpg',
            },
          ],
        },
        {
          t: '375W',
          r: 0,
          c: '/v1/fit/w_375,h_500,q_70,strp/<prettyName>-375w.jpg',
          h: 500,
          w: 375,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_750,h_1000,q_70,strp/<prettyName>-375w-2x.jpg',
            },
          ],
        },
        {
          t: '414W',
          r: 0,
          c: '/v1/fit/w_414,h_552,q_70,strp/<prettyName>-414w.jpg',
          h: 552,
          w: 414,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_828,h_1104,q_70,strp/<prettyName>-414w-2x.jpg',
            },
          ],
        },
        {
          t: '250T',
          r: 0,
          c: '/v1/crop/w_188,h_250,x_0,y_0,scl_0.20888888888889,q_70,strp/<prettyName>-250t.jpg',
          h: 250,
          w: 188,
          ss: [
            {
              x: 2,
              c: '/v1/fill/w_375,h_500,q_70,strp/<prettyName>-250t-2x.jpg',
            },
          ],
        },
        {
          t: '350T',
          r: 0,
          c: '/v1/crop/w_263,h_350,x_0,y_0,scl_0.29222222222222,q_70,strp/<prettyName>-350t.jpg',
          h: 350,
          w: 263,
          ss: [
            {
              x: 2,
              c: '/v1/fill/w_525,h_700,q_70,strp/<prettyName>-350t-2x.jpg',
            },
          ],
        },
        {
          t: '400T',
          r: 0,
          c: '/v1/fill/w_300,h_400,q_70,strp/<prettyName>-400t.jpg',
          h: 400,
          w: 300,
          ss: [
            {
              x: 2,
              c: '/v1/fill/w_600,h_800,q_70,strp/<prettyName>-400t-2x.jpg',
            },
          ],
        },
        {
          t: 'preview',
          r: 0,
          c: '/v1/fill/w_774,h_1032,q_70,strp/<prettyName>-pre.jpg',
          h: 1032,
          w: 774,
          f: 1304385,
        },
        {
          t: 'social_preview',
          r: 0,
          c: '/v1/fill/w_774,h_1032,q_70,strp/<prettyName>-pre.jpg',
          h: 1032,
          w: 774,
        },
        {
          t: 'fullview',
          r: 1,
          h: 1200,
          w: 900,
          f: 1304385,
        },
        {
          t: '92S',
          r: 0,
          c: '/v1/crop/w_92,h_92,x_0,y_8,scl_0.10222222222222,q_70,strp/<prettyName>-92s.jpg',
          h: 92,
          w: 92,
          ss: [
            {
              x: 2,
              c: '/v1/crop/w_184,h_184,x_0,y_15,scl_0.20444444444444,q_70,strp/<prettyName>-92s-2x.jpg',
            },
          ],
        },
      ],
    },
  },
  {
    deviationId: 891889699,
    type: 'image',
    typeId: 1,
    url: 'https://www.deviantart.com/stellab/art/Zest-for-Life-891889699',
    title: 'Zest for Life',
    isJournal: false,
    isVideo: false,
    isPurchasable: false,
    isFavouritable: true,
    publishedTime: '2021-09-14T12:39:48-0700',
    isTextEditable: false,
    isBackgroundEditable: false,
    legacyTextEditUrl: null,
    isShareable: true,
    isCommentable: true,
    isFavourited: true,
    isDeleted: false,
    isMature: false,
    isNsfg: false,
    isDownloadable: false,
    isAntisocial: false,
    isBlocked: false,
    isPublished: true,
    isDailyDeviation: false,
    hasPrivateComments: false,
    isDreamsofart: false,
    isAiUseDisallowed: true,
    blockReasons: [],
    author: {
      userId: 6512195,
      useridUuid: 'deb72e19-3a3c-4056-a0da-7ad624a64dc8',
      username: 'StellaB',
      usericon: 'https://a.deviantart.net/avatars-big/s/t/stellab.jpg?14',
      type: 'core_access',
      isWatching: false,
      isSubscribed: false,
      isNewDeviant: false,
    },
    stats: {
      comments: 12,
      favourites: 213,
      views: 5424,
      downloads: 0,
    },
    media: {
      baseUri:
        'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/deb72e19-3a3c-4056-a0da-7ad624a64dc8/der0ahv-e714fcdf-6efb-445f-85e4-cc06832d4305.png',
      prettyName: 'zest_for_life_by_stellab_der0ahv',
      token: [
        'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7ImhlaWdodCI6Ijw9MTYyNCIsInBhdGgiOiJcL2ZcL2RlYjcyZTE5LTNhM2MtNDA1Ni1hMGRhLTdhZDYyNGE2NGRjOFwvZGVyMGFodi1lNzE0ZmNkZi02ZWZiLTQ0NWYtODVlNC1jYzA2ODMyZDQzMDUucG5nIiwid2lkdGgiOiI8PTEyMDAifV1dLCJhdWQiOlsidXJuOnNlcnZpY2U6aW1hZ2Uub3BlcmF0aW9ucyJdfQ.H51tH40QfvIDEKQb6iKznbO78KZYwyrEqSm6ts_5g9U',
        'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7InBhdGgiOiJcL2ZcL2RlYjcyZTE5LTNhM2MtNDA1Ni1hMGRhLTdhZDYyNGE2NGRjOFwvZGVyMGFodi1lNzE0ZmNkZi02ZWZiLTQ0NWYtODVlNC1jYzA2ODMyZDQzMDUucG5nIn1dXSwiYXVkIjpbInVybjpzZXJ2aWNlOmZpbGUuZG93bmxvYWQiXX0.Ee3H_k2gPq-KQUgtOjVhmTk8xQ-FfkhHubtqTIy1KFo',
      ],
      types: [
        {
          t: '150',
          r: 0,
          c: '/v1/fit/w_150,h_150,q_70,strp/<prettyName>-150.jpg',
          h: 150,
          w: 111,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_300,h_300,q_70,strp/<prettyName>-150-2x.jpg',
            },
          ],
        },
        {
          t: '200H',
          r: 0,
          c: '/v1/fill/w_148,h_200,q_70,strp/<prettyName>-200h.jpg',
          h: 200,
          w: 148,
          ss: [
            {
              x: 2,
              c: '/v1/crop/w_296,h_400,x_0,y_0,scl_0.24666666666667,q_70,strp/<prettyName>-200h-2x.jpg',
            },
          ],
        },
        {
          t: '300W',
          r: 0,
          c: '/v1/fit/w_300,h_900,q_70,strp/<prettyName>-300w.jpg',
          h: 406,
          w: 300,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_600,h_1624,q_70,strp/<prettyName>-300w-2x.jpg',
            },
          ],
        },
        {
          t: '375W',
          r: 0,
          c: '/v1/fit/w_375,h_508,q_70,strp/<prettyName>-375w.jpg',
          h: 508,
          w: 375,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_750,h_1016,q_70,strp/<prettyName>-375w-2x.jpg',
            },
          ],
        },
        {
          t: '414W',
          r: 0,
          c: '/v1/fit/w_414,h_560,q_70,strp/<prettyName>-414w.jpg',
          h: 560,
          w: 414,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_828,h_1120,q_70,strp/<prettyName>-414w-2x.jpg',
            },
          ],
        },
        {
          t: '250T',
          r: 0,
          c: '/v1/fill/w_185,h_250,q_70,strp/<prettyName>-250t.jpg',
          h: 250,
          w: 185,
          ss: [
            {
              x: 2,
              c: '/v1/crop/w_369,h_500,x_0,y_0,scl_0.30833333333333,q_70,strp/<prettyName>-250t-2x.jpg',
            },
          ],
        },
        {
          t: '350T',
          r: 0,
          c: '/v1/crop/w_259,h_350,x_0,y_0,scl_0.21583333333333,q_70,strp/<prettyName>-350t.jpg',
          h: 350,
          w: 259,
          ss: [
            {
              x: 2,
              c: '/v1/fill/w_517,h_700,q_70,strp/<prettyName>-350t-2x.jpg',
            },
          ],
        },
        {
          t: '400T',
          r: 0,
          c: '/v1/crop/w_296,h_400,x_0,y_0,scl_0.24666666666667,q_70,strp/<prettyName>-400t.jpg',
          h: 400,
          w: 296,
          ss: [
            {
              x: 2,
              c: '/v1/fill/w_591,h_800,q_70,strp/<prettyName>-400t-2x.jpg',
            },
          ],
        },
        {
          t: 'preview',
          r: 0,
          c: '/v1/fill/w_768,h_1040,q_70,strp/<prettyName>-pre.jpg',
          h: 1040,
          w: 768,
          f: 2825763,
        },
        {
          t: 'social_preview',
          r: 0,
          c: '/v1/fill/w_768,h_1040,q_70,strp/<prettyName>-pre.jpg',
          h: 1040,
          w: 768,
        },
        {
          t: 'fullview',
          r: 1,
          h: 1624,
          w: 1200,
          f: 2825763,
        },
        {
          t: '92S',
          r: 0,
          c: '/v1/crop/w_92,h_92,x_0,y_8,scl_0.076666666666667,q_70,strp/<prettyName>-92s.jpg',
          h: 92,
          w: 92,
          ss: [
            {
              x: 2,
              c: '/v1/crop/w_184,h_184,x_0,y_16,scl_0.15333333333333,q_70,strp/<prettyName>-92s-2x.jpg',
            },
          ],
        },
      ],
    },
  },
  {
    deviationId: 890066630,
    type: 'image',
    typeId: 1,
    url: 'https://www.deviantart.com/krismez/art/Material-Practice-890066630',
    title: 'Material Practice',
    isJournal: false,
    isVideo: false,
    isPurchasable: false,
    isFavouritable: true,
    publishedTime: '2021-08-27T08:33:07-0700',
    isTextEditable: false,
    isBackgroundEditable: false,
    legacyTextEditUrl: null,
    isShareable: true,
    isCommentable: true,
    isFavourited: true,
    isDeleted: false,
    isMature: false,
    isNsfg: false,
    isDownloadable: false,
    isAntisocial: false,
    isBlocked: false,
    isPublished: true,
    isDailyDeviation: false,
    hasPrivateComments: false,
    isDreamsofart: false,
    isAiUseDisallowed: true,
    blockReasons: [],
    author: {
      userId: 61729608,
      useridUuid: '0c64c36f-397e-456e-acd7-547143d97691',
      username: 'KrisMez',
      usericon: 'https://a.deviantart.net/avatars-big/k/r/krismez.jpg?2',
      type: 'regular',
      isWatching: false,
      isSubscribed: false,
      isNewDeviant: false,
    },
    stats: {
      comments: 4,
      favourites: 185,
      views: 10069,
      downloads: 0,
    },
    media: {
      baseUri:
        'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/0c64c36f-397e-456e-acd7-547143d97691/depx7t2-01bfc0ae-61c8-4fd4-be04-c2aa8c51432e.jpg',
      prettyName: 'material_practice_by_krismez_depx7t2',
      token: [
        'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7ImhlaWdodCI6Ijw9ODA2IiwicGF0aCI6IlwvZlwvMGM2NGMzNmYtMzk3ZS00NTZlLWFjZDctNTQ3MTQzZDk3NjkxXC9kZXB4N3QyLTAxYmZjMGFlLTYxYzgtNGZkNC1iZTA0LWMyYWE4YzUxNDMyZS5qcGciLCJ3aWR0aCI6Ijw9MTI4MCJ9XV0sImF1ZCI6WyJ1cm46c2VydmljZTppbWFnZS5vcGVyYXRpb25zIl19.QmTV6W4qpdUiyEZLtQWXASaDCq0V-gfQjE6G-qJKOAE',
      ],
      types: [
        {
          t: '150',
          r: 0,
          c: '/v1/fit/w_150,h_150,q_70,strp/<prettyName>-150.jpg',
          h: 94,
          w: 150,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_300,h_300,q_70,strp/<prettyName>-150-2x.jpg',
            },
          ],
        },
        {
          t: '200H',
          r: 0,
          c: '/v1/fill/w_300,h_189,q_70,strp/<prettyName>-200h.jpg',
          h: 189,
          w: 300,
          ss: [
            {
              x: 2,
              c: '/v1/fill/w_600,h_378,q_70,strp/<prettyName>-200h-2x.jpg',
            },
          ],
        },
        {
          t: '300W',
          r: 0,
          c: '/v1/fit/w_300,h_806,q_70,strp/<prettyName>-300w.jpg',
          h: 189,
          w: 300,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_600,h_806,q_70,strp/<prettyName>-300w-2x.jpg',
            },
          ],
        },
        {
          t: '375W',
          r: 0,
          c: '/v1/fit/w_375,h_236,q_70,strp/<prettyName>-375w.jpg',
          h: 236,
          w: 375,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_750,h_472,q_70,strp/<prettyName>-375w-2x.jpg',
            },
          ],
        },
        {
          t: '414W',
          r: 0,
          c: '/v1/fit/w_414,h_261,q_70,strp/<prettyName>-414w.jpg',
          h: 261,
          w: 414,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_828,h_522,q_70,strp/<prettyName>-414w-2x.jpg',
            },
          ],
        },
        {
          t: '250T',
          r: 0,
          c: '/v1/fill/w_397,h_250,q_70,strp/<prettyName>-250t.jpg',
          h: 250,
          w: 397,
          ss: [
            {
              x: 2,
              c: '/v1/fill/w_795,h_500,q_70,strp/<prettyName>-250t-2x.jpg',
            },
          ],
        },
        {
          t: '350T',
          r: 0,
          c: '/v1/fill/w_556,h_350,q_70,strp/<prettyName>-350t.jpg',
          h: 350,
          w: 556,
          ss: [
            {
              x: 2,
              c: '/v1/fill/w_1113,h_700,q_70,strp/<prettyName>-350t-2x.jpg',
            },
          ],
        },
        {
          t: '400T',
          r: 0,
          c: '/v1/fill/w_636,h_400,q_70,strp/<prettyName>-400t.jpg',
          h: 400,
          w: 635,
          ss: [
            {
              x: 2,
              c: '/v1/fill/w_1272,h_800,q_70,strp/<prettyName>-400t-2x.jpg',
            },
          ],
        },
        {
          t: 'preview',
          r: 0,
          c: '/v1/fill/w_1127,h_709,q_70,strp/<prettyName>-pre.jpg',
          h: 709,
          w: 1127,
          f: 720038,
        },
        {
          t: 'social_preview',
          r: 0,
          c: '/v1/fill/w_1127,h_709,q_70,strp/<prettyName>-pre.jpg',
          h: 709,
          w: 1127,
        },
        {
          t: 'fullview',
          r: 0,
          c: '/v1/fill/w_1280,h_806,q_75,strp/<prettyName>-fullview.jpg',
          h: 806,
          w: 1280,
          f: 720038,
        },
        {
          t: '92S',
          r: 0,
          c: '/v1/crop/w_92,h_92,x_14,y_0,scl_0.076158940397351,q_70,strp/<prettyName>-92s.jpg',
          h: 92,
          w: 92,
          ss: [
            {
              x: 2,
              c: '/v1/crop/w_184,h_184,x_27,y_0,scl_0.1523178807947,q_70,strp/<prettyName>-92s-2x.jpg',
            },
          ],
        },
      ],
    },
  },
  {
    deviationId: 884024510,
    type: 'image',
    typeId: 1,
    url: 'https://www.deviantart.com/ahmetcankahraman/art/No-Way-Out-884024510',
    title: 'No Way Out',
    isJournal: false,
    isVideo: false,
    isPurchasable: true,
    isFavouritable: true,
    publishedTime: '2021-06-28T07:03:08-0700',
    isTextEditable: false,
    isBackgroundEditable: false,
    legacyTextEditUrl: null,
    isShareable: false,
    isCommentable: true,
    isFavourited: true,
    isDeleted: false,
    isMature: false,
    isNsfg: false,
    isDownloadable: false,
    isAntisocial: false,
    isBlocked: false,
    isPublished: true,
    isDailyDeviation: false,
    hasPrivateComments: false,
    isDreamsofart: false,
    isAiUseDisallowed: true,
    blockReasons: [],
    author: {
      userId: 33208145,
      useridUuid: '39c4c4c0-0e3f-4453-96fd-dd06b1fcff31',
      username: 'AhmetCanKahraman',
      usericon: 'https://a.deviantart.net/avatars-big/a/h/ahmetcankahraman.jpg?15',
      type: 'regular',
      isWatching: false,
      isSubscribed: false,
      isNewDeviant: false,
    },
    stats: {
      comments: 3,
      favourites: 176,
      views: 5339,
      downloads: 0,
    },
    media: {
      baseUri:
        'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/39c4c4c0-0e3f-4453-96fd-dd06b1fcff31/dembpoe-eebf1852-16d5-48c0-97c3-5abf7f59d72e.jpg',
      prettyName: 'no_way_out_by_ahmetcankahraman_dembpoe',
      token: [
        'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7ImhlaWdodCI6Ijw9MTM5NSIsInBhdGgiOiJcL2ZcLzM5YzRjNGMwLTBlM2YtNDQ1My05NmZkLWRkMDZiMWZjZmYzMVwvZGVtYnBvZS1lZWJmMTg1Mi0xNmQ1LTQ4YzAtOTdjMy01YWJmN2Y1OWQ3MmUuanBnIiwid2lkdGgiOiI8PTE2MDAifV1dLCJhdWQiOlsidXJuOnNlcnZpY2U6aW1hZ2Uub3BlcmF0aW9ucyJdfQ.mQhgIiLxwthl8dpcxapj1uRI9CRJzsqNC81fdAvg_HA',
      ],
      types: [
        {
          t: '150',
          r: 0,
          c: '/v1/fit/w_150,h_150,q_70,strp/<prettyName>-150.jpg',
          h: 131,
          w: 150,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_300,h_300,q_70,strp/<prettyName>-150-2x.jpg',
            },
          ],
        },
        {
          t: '200H',
          r: 0,
          c: '/v1/fill/w_229,h_200,q_70,strp/<prettyName>-200h.jpg',
          h: 200,
          w: 229,
          ss: [
            {
              x: 2,
              c: '/v1/fill/w_459,h_400,q_70,strp/<prettyName>-200h-2x.jpg',
            },
          ],
        },
        {
          t: '300W',
          r: 0,
          c: '/v1/fit/w_300,h_900,q_70,strp/<prettyName>-300w.jpg',
          h: 262,
          w: 300,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_600,h_1395,q_70,strp/<prettyName>-300w-2x.jpg',
            },
          ],
        },
        {
          t: '375W',
          r: 0,
          c: '/v1/fit/w_375,h_327,q_70,strp/<prettyName>-375w.jpg',
          h: 327,
          w: 375,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_750,h_654,q_70,strp/<prettyName>-375w-2x.jpg',
            },
          ],
        },
        {
          t: '414W',
          r: 0,
          c: '/v1/fit/w_414,h_361,q_70,strp/<prettyName>-414w.jpg',
          h: 361,
          w: 414,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_828,h_722,q_70,strp/<prettyName>-414w-2x.jpg',
            },
          ],
        },
        {
          t: '250T',
          r: 0,
          c: '/v1/fill/w_287,h_250,q_70,strp/<prettyName>-250t.jpg',
          h: 250,
          w: 287,
          ss: [
            {
              x: 2,
              c: '/v1/fill/w_574,h_500,q_70,strp/<prettyName>-250t-2x.jpg',
            },
          ],
        },
        {
          t: '350T',
          r: 0,
          c: '/v1/fill/w_402,h_350,q_70,strp/<prettyName>-350t.jpg',
          h: 350,
          w: 401,
          ss: [
            {
              x: 2,
              c: '/v1/fill/w_803,h_700,q_70,strp/<prettyName>-350t-2x.jpg',
            },
          ],
        },
        {
          t: '400T',
          r: 0,
          c: '/v1/fill/w_459,h_400,q_70,strp/<prettyName>-400t.jpg',
          h: 400,
          w: 459,
          ss: [
            {
              x: 2,
              c: '/v1/fill/w_918,h_800,q_70,strp/<prettyName>-400t-2x.jpg',
            },
          ],
        },
        {
          t: 'preview',
          r: 0,
          c: '/v1/fill/w_957,h_835,q_70,strp/<prettyName>-pre.jpg',
          h: 835,
          w: 957,
          f: 6583020,
        },
        {
          t: 'social_preview',
          r: 0,
          c: '/v1/fill/w_957,h_835,q_70,strp/<prettyName>-pre.jpg',
          h: 835,
          w: 957,
        },
        {
          t: 'fullview',
          r: 0,
          c: '/v1/fill/w_1600,h_1395,q_75,strp/<prettyName>-fullview.jpg',
          h: 1395,
          w: 1600,
          f: 6583020,
        },
        {
          t: '92S',
          r: 0,
          c: '/v1/crop/w_92,h_92,x_3,y_0,scl_0.031081081081081,q_70,strp/<prettyName>-92s.jpg',
          h: 92,
          w: 92,
          ss: [
            {
              x: 2,
              c: '/v1/crop/w_184,h_184,x_7,y_0,scl_0.062162162162162,q_70,strp/<prettyName>-92s-2x.jpg',
            },
          ],
        },
      ],
    },
  },
  {
    deviationId: 881633158,
    type: 'image',
    typeId: 1,
    url: 'https://www.deviantart.com/syntetyc/art/Spirits-of-the-pond-881633158',
    title: 'Spirits of the pond',
    isJournal: false,
    isVideo: false,
    isPurchasable: false,
    isFavouritable: true,
    publishedTime: '2021-06-04T08:02:47-0700',
    isTextEditable: false,
    isBackgroundEditable: false,
    legacyTextEditUrl: null,
    isShareable: true,
    isCommentable: true,
    isFavourited: true,
    isDeleted: false,
    isMature: false,
    isNsfg: false,
    isDownloadable: false,
    isAntisocial: false,
    isBlocked: false,
    isPublished: true,
    isDailyDeviation: false,
    hasPrivateComments: false,
    isDreamsofart: false,
    isAiUseDisallowed: true,
    blockReasons: [],
    author: {
      userId: 2291870,
      useridUuid: 'd97b348d-51a6-4b6d-9a74-a13a0a782583',
      username: 'Syntetyc',
      usericon: 'https://a.deviantart.net/avatars-big/s/y/syntetyc.jpg?6',
      type: 'beta',
      isWatching: false,
      isSubscribed: false,
      isNewDeviant: false,
    },
    stats: {
      comments: 18,
      favourites: 715,
      views: 28370,
      downloads: 0,
    },
    media: {
      baseUri:
        'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/d97b348d-51a6-4b6d-9a74-a13a0a782583/dekwghy-b759db92-dca6-4b65-b668-765b18e765a8.jpg',
      prettyName: 'spirits_of_the_pond_by_syntetyc_dekwghy',
      token: [
        'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7ImhlaWdodCI6Ijw9MTEyNSIsInBhdGgiOiJcL2ZcL2Q5N2IzNDhkLTUxYTYtNGI2ZC05YTc0LWExM2EwYTc4MjU4M1wvZGVrd2doeS1iNzU5ZGI5Mi1kY2E2LTRiNjUtYjY2OC03NjViMThlNzY1YTguanBnIiwid2lkdGgiOiI8PTgwMCJ9XV0sImF1ZCI6WyJ1cm46c2VydmljZTppbWFnZS5vcGVyYXRpb25zIl19.l7D2wY7SRekxFYhp_STFyOQ3wq2-nsNQi7e06QQMxkc',
        'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7InBhdGgiOiJcL2ZcL2Q5N2IzNDhkLTUxYTYtNGI2ZC05YTc0LWExM2EwYTc4MjU4M1wvZGVrd2doeS1iNzU5ZGI5Mi1kY2E2LTRiNjUtYjY2OC03NjViMThlNzY1YTguanBnIn1dXSwiYXVkIjpbInVybjpzZXJ2aWNlOmZpbGUuZG93bmxvYWQiXX0.FtarKA82M22pQL8FJuk_zbUmSj3H7KbUROI5zkUMe0g',
      ],
      types: [
        {
          t: '150',
          r: 0,
          c: '/v1/fit/w_150,h_150,q_70,strp/<prettyName>-150.jpg',
          h: 150,
          w: 107,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_300,h_300,q_70,strp/<prettyName>-150-2x.jpg',
            },
          ],
        },
        {
          t: '200H',
          r: 0,
          c: '/v1/fill/w_142,h_200,q_70,strp/<prettyName>-200h.jpg',
          h: 200,
          w: 142,
          ss: [
            {
              x: 2,
              c: '/v1/crop/w_284,h_400,x_0,y_0,scl_0.35625,q_70,strp/<prettyName>-200h-2x.jpg',
            },
          ],
        },
        {
          t: '300W',
          r: 0,
          c: '/v1/fit/w_300,h_900,q_70,strp/<prettyName>-300w.jpg',
          h: 422,
          w: 300,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_600,h_1125,q_70,strp/<prettyName>-300w-2x.jpg',
            },
          ],
        },
        {
          t: '375W',
          r: 0,
          c: '/v1/fit/w_375,h_527,q_70,strp/<prettyName>-375w.jpg',
          h: 527,
          w: 375,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_750,h_1054,q_70,strp/<prettyName>-375w-2x.jpg',
            },
          ],
        },
        {
          t: '414W',
          r: 0,
          c: '/v1/fit/w_414,h_582,q_70,strp/<prettyName>-414w.jpg',
          h: 582,
          w: 414,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_800,h_1125,q_70,strp/<prettyName>-414w-2x.jpg',
            },
          ],
        },
        {
          t: '250T',
          r: 0,
          c: '/v1/fill/w_178,h_250,q_70,strp/<prettyName>-250t.jpg',
          h: 250,
          w: 178,
          ss: [
            {
              x: 2,
              c: '/v1/crop/w_356,h_500,x_0,y_0,scl_0.445,q_70,strp/<prettyName>-250t-2x.jpg',
            },
          ],
        },
        {
          t: '350T',
          r: 0,
          c: '/v1/fill/w_249,h_350,q_70,strp/<prettyName>-350t.jpg',
          h: 350,
          w: 249,
          ss: [
            {
              x: 2,
              c: '/v1/fill/w_498,h_700,q_70,strp/<prettyName>-350t-2x.jpg',
            },
          ],
        },
        {
          t: '400T',
          r: 0,
          c: '/v1/crop/w_284,h_400,x_0,y_0,scl_0.35625,q_70,strp/<prettyName>-400t.jpg',
          h: 400,
          w: 284,
          ss: [
            {
              x: 2,
              c: '/v1/fill/w_569,h_800,q_70,strp/<prettyName>-400t-2x.jpg',
            },
          ],
        },
        {
          t: 'preview',
          r: 0,
          c: '/v1/fill/w_754,h_1060,q_70,strp/<prettyName>-pre.jpg',
          h: 1060,
          w: 754,
          f: 204348,
        },
        {
          t: 'social_preview',
          r: 0,
          c: '/v1/fill/w_754,h_1060,q_70,strp/<prettyName>-pre.jpg',
          h: 1060,
          w: 754,
        },
        {
          t: 'fullview',
          r: 1,
          h: 1125,
          w: 800,
          f: 204348,
        },
        {
          t: '92S',
          r: 0,
          c: '/v1/crop/w_92,h_92,x_0,y_9,scl_0.115,q_70,strp/<prettyName>-92s.jpg',
          h: 92,
          w: 92,
          ss: [
            {
              x: 2,
              c: '/v1/crop/w_184,h_184,x_0,y_19,scl_0.23,q_70,strp/<prettyName>-92s-2x.jpg',
            },
          ],
        },
      ],
    },
  },
  {
    deviationId: 881513453,
    type: 'image',
    typeId: 1,
    url: 'https://www.deviantart.com/douglasdraco/art/Old-Desert-881513453',
    title: 'Old Desert',
    isJournal: false,
    isVideo: false,
    isPurchasable: true,
    isFavouritable: true,
    publishedTime: '2021-06-03T05:02:43-0700',
    isTextEditable: false,
    isBackgroundEditable: false,
    legacyTextEditUrl: null,
    isShareable: true,
    isCommentable: true,
    isFavourited: true,
    isDeleted: false,
    isMature: false,
    isNsfg: false,
    isDownloadable: false,
    isAntisocial: false,
    isBlocked: false,
    isPublished: true,
    isDailyDeviation: false,
    hasPrivateComments: false,
    isDreamsofart: false,
    isAiUseDisallowed: true,
    blockReasons: [],
    author: {
      userId: 1966431,
      useridUuid: '46f7fe4f-4472-4d20-a5eb-b776e1ec4054',
      username: 'DOUGLASDRACO',
      usericon: 'https://a.deviantart.net/avatars-big/d/o/douglasdraco.jpg?11',
      type: 'regular',
      isWatching: false,
      isSubscribed: false,
      isNewDeviant: false,
    },
    stats: {
      comments: 23,
      favourites: 303,
      views: 15133,
      downloads: 0,
    },
    media: {
      baseUri:
        'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/46f7fe4f-4472-4d20-a5eb-b776e1ec4054/dektw4t-03dda081-aa59-439a-acd0-a3eb704c77ad.jpg',
      prettyName: 'old_desert_by_douglasdraco_dektw4t',
      token: [
        'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7ImhlaWdodCI6Ijw9MTUzNyIsInBhdGgiOiJcL2ZcLzQ2ZjdmZTRmLTQ0NzItNGQyMC1hNWViLWI3NzZlMWVjNDA1NFwvZGVrdHc0dC0wM2RkYTA4MS1hYTU5LTQzOWEtYWNkMC1hM2ViNzA0Yzc3YWQuanBnIiwid2lkdGgiOiI8PTEwMjQifV1dLCJhdWQiOlsidXJuOnNlcnZpY2U6aW1hZ2Uub3BlcmF0aW9ucyJdfQ.3bjC7q_B7-0v1WSaJ-y8GLcfpwheVmaKbedbu7HrG-o',
      ],
      types: [
        {
          t: '150',
          r: 0,
          c: '/v1/fit/w_150,h_150,q_70,strp/<prettyName>-150.jpg',
          h: 150,
          w: 100,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_300,h_300,q_70,strp/<prettyName>-150-2x.jpg',
            },
          ],
        },
        {
          t: '200H',
          r: 0,
          c: '/v1/fill/w_133,h_200,q_70,strp/<prettyName>-200h.jpg',
          h: 200,
          w: 133,
          ss: [
            {
              x: 2,
              c: '/v1/crop/w_267,h_400,x_0,y_0,scl_0.028712764813421,q_70,strp/<prettyName>-200h-2x.jpg',
            },
          ],
        },
        {
          t: '300W',
          r: 0,
          c: '/v1/fit/w_300,h_900,q_70,strp/<prettyName>-300w.jpg',
          h: 450,
          w: 300,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_600,h_1537,q_70,strp/<prettyName>-300w-2x.jpg',
            },
          ],
        },
        {
          t: '375W',
          r: 0,
          c: '/v1/fit/w_375,h_563,q_70,strp/<prettyName>-375w.jpg',
          h: 563,
          w: 375,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_750,h_1126,q_70,strp/<prettyName>-375w-2x.jpg',
            },
          ],
        },
        {
          t: '414W',
          r: 0,
          c: '/v1/fit/w_414,h_621,q_70,strp/<prettyName>-414w.jpg',
          h: 621,
          w: 414,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_828,h_1242,q_70,strp/<prettyName>-414w-2x.jpg',
            },
          ],
        },
        {
          t: '250T',
          r: 0,
          c: '/v1/crop/w_167,h_250,x_0,y_0,scl_0.017958920314012,q_70,strp/<prettyName>-250t.jpg',
          h: 250,
          w: 167,
          ss: [
            {
              x: 2,
              c: '/v1/fill/w_333,h_500,q_70,strp/<prettyName>-250t-2x.jpg',
            },
          ],
        },
        {
          t: '350T',
          r: 0,
          c: '/v1/fill/w_233,h_350,q_70,strp/<prettyName>-350t.jpg',
          h: 350,
          w: 233,
          ss: [
            {
              x: 2,
              c: '/v1/crop/w_467,h_700,x_0,y_0,scl_0.050220453812238,q_70,strp/<prettyName>-350t-2x.jpg',
            },
          ],
        },
        {
          t: '400T',
          r: 0,
          c: '/v1/crop/w_267,h_400,x_0,y_0,scl_0.028712764813421,q_70,strp/<prettyName>-400t.jpg',
          h: 400,
          w: 266,
          ss: [
            {
              x: 2,
              c: '/v1/fill/w_533,h_800,q_70,strp/<prettyName>-400t-2x.jpg',
            },
          ],
        },
        {
          t: 'preview',
          r: 0,
          c: '/v1/fill/w_730,h_1095,q_70,strp/<prettyName>-pre.jpg',
          h: 1095,
          w: 730,
          f: 26319807,
        },
        {
          t: 'social_preview',
          r: 0,
          c: '/v1/fill/w_730,h_1095,q_70,strp/<prettyName>-pre.jpg',
          h: 1095,
          w: 730,
        },
        {
          t: 'fullview',
          r: 0,
          c: '/v1/fill/w_1024,h_1537,q_75,strp/<prettyName>-fullview.jpg',
          h: 1537,
          w: 1024,
          f: 26319807,
        },
        {
          t: '92S',
          r: 0,
          c: '/v1/crop/w_92,h_92,x_0,y_12,scl_0.01,q_70,strp/<prettyName>-92s.jpg',
          h: 92,
          w: 92,
          ss: [
            {
              x: 2,
              c: '/v1/crop/w_184,h_184,x_0,y_23,scl_0.019787073878912,q_70,strp/<prettyName>-92s-2x.jpg',
            },
          ],
        },
      ],
    },
  },
  {
    deviationId: 881216445,
    type: 'image',
    typeId: 1,
    url: 'https://www.deviantart.com/zeinsa/art/Flight-881216445',
    title: 'Flight',
    isJournal: false,
    isVideo: false,
    isPurchasable: false,
    isFavouritable: true,
    publishedTime: '2021-05-31T10:39:43-0700',
    isTextEditable: false,
    isBackgroundEditable: false,
    legacyTextEditUrl: null,
    isShareable: true,
    isCommentable: true,
    isFavourited: true,
    isDeleted: false,
    isMature: false,
    isNsfg: false,
    isDownloadable: true,
    isAntisocial: false,
    isBlocked: false,
    isPublished: true,
    isDailyDeviation: false,
    hasPrivateComments: false,
    isDreamsofart: false,
    isAiUseDisallowed: true,
    blockReasons: [],
    author: {
      userId: 67741867,
      useridUuid: '6c3372e7-cd5c-45c1-9094-19fb9e44d840',
      username: 'zeinsa',
      usericon: 'https://a.deviantart.net/avatars-big/z/e/zeinsa.jpg?2',
      type: 'regular',
      isWatching: false,
      isSubscribed: false,
      isNewDeviant: false,
    },
    stats: {
      comments: 6,
      favourites: 163,
      views: 8481,
      downloads: 6,
    },
    media: {
      baseUri:
        'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/6c3372e7-cd5c-45c1-9094-19fb9e44d840/dekniyl-68b3b8c1-159b-4dc6-ac19-c0860a233be6.jpg',
      prettyName: 'flight_by_zeinsa_dekniyl',
      token: [
        'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7ImhlaWdodCI6Ijw9MTA4MCIsInBhdGgiOiJcL2ZcLzZjMzM3MmU3LWNkNWMtNDVjMS05MDk0LTE5ZmI5ZTQ0ZDg0MFwvZGVrbml5bC02OGIzYjhjMS0xNTliLTRkYzYtYWMxOS1jMDg2MGEyMzNiZTYuanBnIiwid2lkdGgiOiI8PTcyMCJ9XV0sImF1ZCI6WyJ1cm46c2VydmljZTppbWFnZS5vcGVyYXRpb25zIl19.dftsqVBONgmprcZbuu6IwJhIzGmt3luYsQShY4roaN0',
        'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7InBhdGgiOiJcL2ZcLzZjMzM3MmU3LWNkNWMtNDVjMS05MDk0LTE5ZmI5ZTQ0ZDg0MFwvZGVrbml5bC02OGIzYjhjMS0xNTliLTRkYzYtYWMxOS1jMDg2MGEyMzNiZTYuanBnIn1dXSwiYXVkIjpbInVybjpzZXJ2aWNlOmZpbGUuZG93bmxvYWQiXX0.TSw814LVeabIFNyCGJlXepSizpgJVHgmaJgFKfoJ1oA',
      ],
      types: [
        {
          t: '150',
          r: 0,
          c: '/v1/fit/w_150,h_150,q_70,strp/<prettyName>-150.jpg',
          h: 150,
          w: 100,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_300,h_300,q_70,strp/<prettyName>-150-2x.jpg',
            },
          ],
        },
        {
          t: '200H',
          r: 0,
          c: '/v1/fill/w_133,h_200,q_70,strp/<prettyName>-200h.jpg',
          h: 200,
          w: 133,
          ss: [
            {
              x: 2,
              c: '/v1/crop/w_267,h_400,x_0,y_0,scl_0.37083333333333,q_70,strp/<prettyName>-200h-2x.jpg',
            },
          ],
        },
        {
          t: '300W',
          r: 0,
          c: '/v1/fit/w_300,h_900,q_70,strp/<prettyName>-300w.jpg',
          h: 450,
          w: 300,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_600,h_1080,q_70,strp/<prettyName>-300w-2x.jpg',
            },
          ],
        },
        {
          t: '375W',
          r: 0,
          c: '/v1/fit/w_375,h_563,q_70,strp/<prettyName>-375w.jpg',
          h: 563,
          w: 375,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_720,h_1080,q_70,strp/<prettyName>-375w-2x.jpg',
            },
          ],
        },
        {
          t: '414W',
          r: 0,
          c: '/v1/fit/w_414,h_621,q_70,strp/<prettyName>-414w.jpg',
          h: 621,
          w: 414,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_720,h_1080,q_70,strp/<prettyName>-414w-2x.jpg',
            },
          ],
        },
        {
          t: '250T',
          r: 0,
          c: '/v1/crop/w_167,h_250,x_0,y_0,scl_0.23194444444444,q_70,strp/<prettyName>-250t.jpg',
          h: 250,
          w: 167,
          ss: [
            {
              x: 2,
              c: '/v1/fill/w_333,h_500,q_70,strp/<prettyName>-250t-2x.jpg',
            },
          ],
        },
        {
          t: '350T',
          r: 0,
          c: '/v1/fill/w_233,h_350,q_70,strp/<prettyName>-350t.jpg',
          h: 350,
          w: 233,
          ss: [
            {
              x: 2,
              c: '/v1/crop/w_467,h_700,x_0,y_0,scl_0.64861111111111,q_70,strp/<prettyName>-350t-2x.jpg',
            },
          ],
        },
        {
          t: '400T',
          r: 0,
          c: '/v1/crop/w_267,h_400,x_0,y_0,scl_0.37083333333333,q_70,strp/<prettyName>-400t.jpg',
          h: 400,
          w: 267,
          ss: [
            {
              x: 2,
              c: '/v1/fill/w_533,h_800,q_70,strp/<prettyName>-400t-2x.jpg',
            },
          ],
        },
        {
          t: 'preview',
          r: 0,
          c: '/v1/fill/w_720,h_1080,q_75,strp/<prettyName>-fullview.jpg',
          h: 1080,
          w: 720,
          f: 293041,
        },
        {
          t: 'social_preview',
          r: 0,
          c: '/v1/fill/w_720,h_1080,q_75,strp/<prettyName>-fullview.jpg',
          h: 1080,
          w: 720,
        },
        {
          t: 'fullview',
          r: 1,
          h: 1080,
          w: 720,
          f: 293041,
        },
        {
          t: '92S',
          r: 0,
          c: '/v1/crop/w_92,h_92,x_0,y_12,scl_0.12777777777778,q_70,strp/<prettyName>-92s.jpg',
          h: 92,
          w: 92,
          ss: [
            {
              x: 2,
              c: '/v1/crop/w_184,h_184,x_0,y_23,scl_0.25555555555556,q_70,strp/<prettyName>-92s-2x.jpg',
            },
          ],
        },
      ],
    },
  },
  {
    deviationId: 879473925,
    type: 'image',
    typeId: 1,
    url: 'https://www.deviantart.com/charlesejd/art/Cleaning-the-Streets-The-Division-879473925',
    title: 'Cleaning the Streets, The Division',
    isJournal: false,
    isVideo: false,
    isPurchasable: false,
    isFavouritable: true,
    publishedTime: '2021-05-14T03:08:19-0700',
    isTextEditable: false,
    isBackgroundEditable: false,
    legacyTextEditUrl: null,
    isShareable: true,
    isCommentable: true,
    isFavourited: true,
    isDeleted: false,
    isMature: false,
    isNsfg: false,
    isDownloadable: false,
    isAntisocial: false,
    isBlocked: false,
    isPublished: true,
    isDailyDeviation: true,
    hasPrivateComments: false,
    isDreamsofart: false,
    isAiUseDisallowed: true,
    blockReasons: [],
    author: {
      userId: 30866680,
      useridUuid: 'f64fb3b4-ad8e-4704-84e3-8c2c62ddc2ca',
      username: 'CharlesEJD',
      usericon: 'https://a.deviantart.net/avatars-big/c/h/charlesejd.jpg?10',
      type: 'regular',
      isWatching: true,
      isSubscribed: false,
      isNewDeviant: false,
    },
    stats: {
      comments: 39,
      favourites: 913,
      views: 422692,
      downloads: 0,
    },
    media: {
      baseUri:
        'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/f64fb3b4-ad8e-4704-84e3-8c2c62ddc2ca/dejm6f9-6b1a0f52-d18b-456b-8733-0c82861d44c7.jpg',
      prettyName: 'cleaning_the_streets__the_division_by_charlesejd_dejm6f9',
      token: [
        'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7ImhlaWdodCI6Ijw9Njc2IiwicGF0aCI6IlwvZlwvZjY0ZmIzYjQtYWQ4ZS00NzA0LTg0ZTMtOGMyYzYyZGRjMmNhXC9kZWptNmY5LTZiMWEwZjUyLWQxOGItNDU2Yi04NzMzLTBjODI4NjFkNDRjNy5qcGciLCJ3aWR0aCI6Ijw9MTYwMCJ9XV0sImF1ZCI6WyJ1cm46c2VydmljZTppbWFnZS5vcGVyYXRpb25zIl19.bniTDqF2QM8EbqR7IQevwrjoDpvqclSvG6kbUmutiVo',
      ],
      types: [
        {
          t: '150',
          r: 0,
          c: '/v1/fit/w_150,h_150,q_70,strp/<prettyName>-150.jpg',
          h: 63,
          w: 150,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_300,h_300,q_70,strp/<prettyName>-150-2x.jpg',
            },
          ],
        },
        {
          t: '200H',
          r: 0,
          c: '/v1/fill/w_300,h_127,q_70,strp/<prettyName>-200h.jpg',
          h: 127,
          w: 300,
          ss: [
            {
              x: 2,
              c: '/v1/fill/w_600,h_253,q_70,strp/<prettyName>-200h-2x.jpg',
            },
          ],
        },
        {
          t: '300W',
          r: 0,
          c: '/v1/fit/w_300,h_676,q_70,strp/<prettyName>-300w.jpg',
          h: 127,
          w: 300,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_600,h_676,q_70,strp/<prettyName>-300w-2x.jpg',
            },
          ],
        },
        {
          t: '375W',
          r: 0,
          c: '/v1/fit/w_375,h_158,q_70,strp/<prettyName>-375w.jpg',
          h: 158,
          w: 375,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_750,h_316,q_70,strp/<prettyName>-375w-2x.jpg',
            },
          ],
        },
        {
          t: '414W',
          r: 0,
          c: '/v1/fit/w_414,h_175,q_70,strp/<prettyName>-414w.jpg',
          h: 175,
          w: 414,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_828,h_350,q_70,strp/<prettyName>-414w-2x.jpg',
            },
          ],
        },
        {
          t: '250T',
          r: 0,
          c: '/v1/fill/w_500,h_211,q_70,strp/<prettyName>-250t.jpg',
          h: 211,
          w: 500,
          ss: [
            {
              x: 2,
              c: '/v1/fill/w_1000,h_422,q_70,strp/<prettyName>-250t-2x.jpg',
            },
          ],
        },
        {
          t: '350T',
          r: 0,
          c: '/v1/fill/w_700,h_295,q_70,strp/<prettyName>-350t.jpg',
          h: 296,
          w: 700,
          ss: [
            {
              x: 2,
              c: '/v1/fill/w_1400,h_591,q_70,strp/<prettyName>-350t-2x.jpg',
            },
          ],
        },
        {
          t: '400T',
          r: 0,
          c: '/v1/fill/w_800,h_338,q_70,strp/<prettyName>-400t.jpg',
          h: 338,
          w: 800,
          ss: [
            {
              x: 2,
              c: '/v1/fill/w_1600,h_675,q_70,strp/<prettyName>-400t-2x.jpg',
            },
          ],
        },
        {
          t: 'preview',
          r: 0,
          c: '/v1/fill/w_1376,h_581,q_70,strp/<prettyName>-pre.jpg',
          h: 581,
          w: 1376,
          f: 36190665,
        },
        {
          t: 'social_preview',
          r: 0,
          c: '/v1/fill/w_1376,h_581,q_70,strp/<prettyName>-pre.jpg',
          h: 581,
          w: 1376,
        },
        {
          t: 'fullview',
          r: 0,
          c: '/v1/fill/w_1600,h_676,q_75,strp/<prettyName>-fullview.jpg',
          h: 676,
          w: 1600,
          f: 36190665,
        },
        {
          t: '92S',
          r: 0,
          c: '/v1/crop/w_92,h_92,x_32,y_0,scl_0.020966271649954,q_70,strp/<prettyName>-92s.jpg',
          h: 92,
          w: 92,
          ss: [
            {
              x: 2,
              c: '/v1/crop/w_184,h_184,x_63,y_0,scl_0.041932543299909,q_70,strp/<prettyName>-92s-2x.jpg',
            },
          ],
        },
      ],
    },
  },
  {
    deviationId: 874660604,
    type: 'image',
    typeId: 1,
    url: 'https://www.deviantart.com/schadek/art/Samurai-detective-874660604',
    title: 'Samurai detective',
    isJournal: false,
    isVideo: false,
    isPurchasable: false,
    isFavouritable: true,
    publishedTime: '2021-03-28T20:35:37-0700',
    isTextEditable: false,
    isBackgroundEditable: false,
    legacyTextEditUrl: null,
    isShareable: true,
    isCommentable: true,
    isFavourited: true,
    isDeleted: false,
    isMature: false,
    isNsfg: false,
    isDownloadable: true,
    isAntisocial: false,
    isBlocked: false,
    isPublished: true,
    isDailyDeviation: false,
    hasPrivateComments: false,
    isDreamsofart: false,
    isAiUseDisallowed: true,
    blockReasons: [],
    author: {
      userId: 36155523,
      useridUuid: 'ced16fd9-9a5a-43dc-8a4d-30163778f237',
      username: 'Schadek',
      usericon: 'https://a.deviantart.net/avatars-big/s/c/schadek.jpg?7',
      type: 'regular',
      isWatching: true,
      isSubscribed: false,
      isNewDeviant: false,
    },
    stats: {
      comments: 8,
      favourites: 149,
      views: 4641,
      downloads: 1,
    },
    media: {
      baseUri:
        'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/ced16fd9-9a5a-43dc-8a4d-30163778f237/degr0fw-09fec3a4-b327-46bf-a87a-eb55d23140cd.png',
      prettyName: 'samurai_detective_by_schadek_degr0fw',
      token: [
        'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7ImhlaWdodCI6Ijw9NjU5IiwicGF0aCI6IlwvZlwvY2VkMTZmZDktOWE1YS00M2RjLThhNGQtMzAxNjM3NzhmMjM3XC9kZWdyMGZ3LTA5ZmVjM2E0LWIzMjctNDZiZi1hODdhLWViNTVkMjMxNDBjZC5wbmciLCJ3aWR0aCI6Ijw9NTI2In1dXSwiYXVkIjpbInVybjpzZXJ2aWNlOmltYWdlLm9wZXJhdGlvbnMiXX0.LdncggORuIOWmov9Ad4cetTvWnBx8EOp-J_Ntf1q0Q8',
        'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7InBhdGgiOiJcL2ZcL2NlZDE2ZmQ5LTlhNWEtNDNkYy04YTRkLTMwMTYzNzc4ZjIzN1wvZGVncjBmdy0wOWZlYzNhNC1iMzI3LTQ2YmYtYTg3YS1lYjU1ZDIzMTQwY2QucG5nIn1dXSwiYXVkIjpbInVybjpzZXJ2aWNlOmZpbGUuZG93bmxvYWQiXX0.xB7UMuLFcK1MEmMXBYJHjjdLivY28_HkyelQue-vWrc',
      ],
      types: [
        {
          t: '150',
          r: 0,
          c: '/v1/fit/w_150,h_150,q_70,strp/<prettyName>-150.jpg',
          h: 150,
          w: 120,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_300,h_300,q_70,strp/<prettyName>-150-2x.jpg',
            },
          ],
        },
        {
          t: '200H',
          r: 0,
          c: '/v1/fill/w_160,h_200,q_70,strp/<prettyName>-200h.jpg',
          h: 200,
          w: 160,
          ss: [
            {
              x: 2,
              c: '/v1/fill/w_319,h_400,q_70,strp/<prettyName>-200h-2x.jpg',
            },
          ],
        },
        {
          t: '300W',
          r: 0,
          c: '/v1/fit/w_300,h_659,q_70,strp/<prettyName>-300w.jpg',
          h: 376,
          w: 300,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_526,h_659,q_70,strp/<prettyName>-300w-2x.jpg',
            },
          ],
        },
        {
          t: '375W',
          r: 0,
          c: '/v1/fit/w_375,h_470,q_70,strp/<prettyName>-375w.jpg',
          h: 470,
          w: 375,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_526,h_659,q_70,strp/<prettyName>-375w-2x.jpg',
            },
          ],
        },
        {
          t: '414W',
          r: 0,
          c: '/v1/fit/w_414,h_519,q_70,strp/<prettyName>-414w.jpg',
          h: 519,
          w: 414,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_526,h_659,q_70,strp/<prettyName>-414w-2x.jpg',
            },
          ],
        },
        {
          t: '250T',
          r: 0,
          c: '/v1/crop/w_200,h_250,x_0,y_0,scl_0.38022813688213,q_70,strp/<prettyName>-250t.jpg',
          h: 250,
          w: 200,
          ss: [
            {
              x: 2,
              c: '/v1/fill/w_399,h_500,q_70,strp/<prettyName>-250t-2x.jpg',
            },
          ],
        },
        {
          t: '350T',
          r: 0,
          c: '/v1/fill/w_279,h_350,q_70,strp/<prettyName>-350t.jpg',
          h: 350,
          w: 279,
          ss: [
            {
              x: 2,
              c: '/v1/fill/w_526,h_659,q_70,strp/<prettyName>-350t-2x.jpg',
            },
          ],
        },
        {
          t: '400T',
          r: 0,
          c: '/v1/fill/w_319,h_400,q_70,strp/<prettyName>-400t.jpg',
          h: 400,
          w: 319,
          ss: [
            {
              x: 2,
              c: '/v1/fill/w_526,h_659,q_70,strp/<prettyName>-400t-2x.jpg',
            },
          ],
        },
        {
          t: 'preview',
          r: 0,
          c: '/v1/fill/w_526,h_659,q_80,strp/<prettyName>-fullview.jpg',
          h: 659,
          w: 526,
          f: 707706,
        },
        {
          t: 'social_preview',
          r: 0,
          c: '/v1/fill/w_526,h_659,q_80,strp/<prettyName>-fullview.jpg',
          h: 659,
          w: 526,
        },
        {
          t: 'fullview',
          r: 1,
          h: 659,
          w: 526,
          f: 707706,
        },
        {
          t: '92S',
          r: 0,
          c: '/v1/crop/w_92,h_92,x_0,y_6,scl_0.17490494296578,q_70,strp/<prettyName>-92s.jpg',
          h: 92,
          w: 92,
          ss: [
            {
              x: 2,
              c: '/v1/crop/w_184,h_184,x_0,y_12,scl_0.34980988593156,q_70,strp/<prettyName>-92s-2x.jpg',
            },
          ],
        },
      ],
    },
  },
  {
    deviationId: 874311631,
    type: 'image',
    typeId: 1,
    url: 'https://www.deviantart.com/anthonypresley/art/Down-the-Road-874311631',
    title: 'Down the Road',
    isJournal: false,
    isVideo: false,
    isPurchasable: false,
    isFavouritable: true,
    publishedTime: '2021-03-25T08:37:27-0700',
    isTextEditable: false,
    isBackgroundEditable: false,
    legacyTextEditUrl: null,
    isShareable: true,
    isCommentable: true,
    isFavourited: true,
    isDeleted: false,
    isMature: false,
    isNsfg: false,
    isDownloadable: false,
    isAntisocial: false,
    isBlocked: false,
    isPublished: true,
    isDailyDeviation: false,
    hasPrivateComments: false,
    isDreamsofart: false,
    isAiUseDisallowed: true,
    blockReasons: [],
    author: {
      userId: 1336077,
      useridUuid: '287eab66-0f73-4b97-8e74-849c5f06d542',
      username: 'AnthonyPresley',
      usericon: 'https://a.deviantart.net/avatars-big/a/n/anthonypresley.jpg?6',
      type: 'core_pro',
      isWatching: true,
      isSubscribed: false,
      isNewDeviant: false,
    },
    stats: {
      comments: 21,
      favourites: 662,
      views: 96872,
      downloads: 0,
    },
    media: {
      baseUri:
        'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/287eab66-0f73-4b97-8e74-849c5f06d542/degjj67-2f3f0d50-8299-4d2d-9704-90020ccfd643.jpg',
      prettyName: 'down_the_road_by_anthonypresley_degjj67',
      token: [
        'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7ImhlaWdodCI6Ijw9MTUwMCIsInBhdGgiOiJcL2ZcLzI4N2VhYjY2LTBmNzMtNGI5Ny04ZTc0LTg0OWM1ZjA2ZDU0MlwvZGVnamo2Ny0yZjNmMGQ1MC04Mjk5LTRkMmQtOTcwNC05MDAyMGNjZmQ2NDMuanBnIiwid2lkdGgiOiI8PTEwMDAifV1dLCJhdWQiOlsidXJuOnNlcnZpY2U6aW1hZ2Uub3BlcmF0aW9ucyJdfQ.J9PjVWSaXRvchbKD6WExgTY7KNDq84V3ezYnEMzHPQQ',
        'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7InBhdGgiOiJcL2ZcLzI4N2VhYjY2LTBmNzMtNGI5Ny04ZTc0LTg0OWM1ZjA2ZDU0MlwvZGVnamo2Ny0yZjNmMGQ1MC04Mjk5LTRkMmQtOTcwNC05MDAyMGNjZmQ2NDMuanBnIn1dXSwiYXVkIjpbInVybjpzZXJ2aWNlOmZpbGUuZG93bmxvYWQiXX0.LChuGqAl_eJ69qgAnwIX5_GdoRE9hnV1NNnO0vNjp0g',
      ],
      types: [
        {
          t: '150',
          r: 0,
          c: '/v1/fit/w_150,h_150,q_70,strp/<prettyName>-150.jpg',
          h: 150,
          w: 100,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_300,h_300,q_70,strp/<prettyName>-150-2x.jpg',
            },
          ],
        },
        {
          t: '200H',
          r: 0,
          c: '/v1/fill/w_133,h_200,q_70,strp/<prettyName>-200h.jpg',
          h: 200,
          w: 133,
          ss: [
            {
              x: 2,
              c: '/v1/crop/w_267,h_400,x_0,y_0,scl_0.267,q_70,strp/<prettyName>-200h-2x.jpg',
            },
          ],
        },
        {
          t: '300W',
          r: 0,
          c: '/v1/fit/w_300,h_900,q_70,strp/<prettyName>-300w.jpg',
          h: 450,
          w: 300,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_600,h_1500,q_70,strp/<prettyName>-300w-2x.jpg',
            },
          ],
        },
        {
          t: '375W',
          r: 0,
          c: '/v1/fit/w_375,h_563,q_70,strp/<prettyName>-375w.jpg',
          h: 563,
          w: 375,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_750,h_1126,q_70,strp/<prettyName>-375w-2x.jpg',
            },
          ],
        },
        {
          t: '414W',
          r: 0,
          c: '/v1/fit/w_414,h_621,q_70,strp/<prettyName>-414w.jpg',
          h: 621,
          w: 414,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_828,h_1242,q_70,strp/<prettyName>-414w-2x.jpg',
            },
          ],
        },
        {
          t: '250T',
          r: 0,
          c: '/v1/crop/w_167,h_250,x_0,y_0,scl_0.167,q_70,strp/<prettyName>-250t.jpg',
          h: 250,
          w: 167,
          ss: [
            {
              x: 2,
              c: '/v1/fill/w_333,h_500,q_70,strp/<prettyName>-250t-2x.jpg',
            },
          ],
        },
        {
          t: '350T',
          r: 0,
          c: '/v1/fill/w_233,h_350,q_70,strp/<prettyName>-350t.jpg',
          h: 350,
          w: 233,
          ss: [
            {
              x: 2,
              c: '/v1/crop/w_467,h_700,x_0,y_0,scl_0.467,q_70,strp/<prettyName>-350t-2x.jpg',
            },
          ],
        },
        {
          t: '400T',
          r: 0,
          c: '/v1/crop/w_267,h_400,x_0,y_0,scl_0.267,q_70,strp/<prettyName>-400t.jpg',
          h: 400,
          w: 267,
          ss: [
            {
              x: 2,
              c: '/v1/fill/w_533,h_800,q_70,strp/<prettyName>-400t-2x.jpg',
            },
          ],
        },
        {
          t: 'preview',
          r: 0,
          c: '/v1/fill/w_730,h_1095,q_70,strp/<prettyName>-pre.jpg',
          h: 1095,
          w: 730,
          f: 1459487,
        },
        {
          t: 'social_preview',
          r: 0,
          c: '/v1/fill/w_730,h_1095,q_70,strp/<prettyName>-pre.jpg',
          h: 1095,
          w: 730,
        },
        {
          t: 'fullview',
          r: 1,
          h: 1500,
          w: 1000,
          f: 1459487,
        },
        {
          t: '92S',
          r: 0,
          c: '/v1/crop/w_92,h_92,x_0,y_12,scl_0.092,q_70,strp/<prettyName>-92s.jpg',
          h: 92,
          w: 92,
          ss: [
            {
              x: 2,
              c: '/v1/crop/w_184,h_184,x_0,y_23,scl_0.184,q_70,strp/<prettyName>-92s-2x.jpg',
            },
          ],
        },
      ],
    },
  },
  {
    deviationId: 873614248,
    type: 'image',
    typeId: 1,
    url: 'https://www.deviantart.com/anthonypresley/art/Chinatown-873614248',
    title: 'Chinatown',
    isJournal: false,
    isVideo: false,
    isPurchasable: false,
    isFavouritable: true,
    publishedTime: '2021-03-18T08:06:39-0700',
    isTextEditable: false,
    isBackgroundEditable: false,
    legacyTextEditUrl: null,
    isShareable: true,
    isCommentable: true,
    isFavourited: true,
    isDeleted: false,
    isMature: false,
    isNsfg: false,
    isDownloadable: false,
    isAntisocial: false,
    isBlocked: false,
    isPublished: true,
    isDailyDeviation: true,
    hasPrivateComments: false,
    isDreamsofart: false,
    isAiUseDisallowed: true,
    blockReasons: [],
    author: {
      userId: 1336077,
      useridUuid: '287eab66-0f73-4b97-8e74-849c5f06d542',
      username: 'AnthonyPresley',
      usericon: 'https://a.deviantart.net/avatars-big/a/n/anthonypresley.jpg?6',
      type: 'core_pro',
      isWatching: true,
      isSubscribed: false,
      isNewDeviant: false,
    },
    stats: {
      comments: 77,
      favourites: 2369,
      views: 750447,
      downloads: 0,
    },
    media: {
      baseUri:
        'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/287eab66-0f73-4b97-8e74-849c5f06d542/deg4l2g-621368ad-b44b-44eb-ac47-47764083ba4f.jpg',
      prettyName: 'chinatown_by_anthonypresley_deg4l2g',
      token: [
        'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7ImhlaWdodCI6Ijw9MTAwMCIsInBhdGgiOiJcL2ZcLzI4N2VhYjY2LTBmNzMtNGI5Ny04ZTc0LTg0OWM1ZjA2ZDU0MlwvZGVnNGwyZy02MjEzNjhhZC1iNDRiLTQ0ZWItYWM0Ny00Nzc2NDA4M2JhNGYuanBnIiwid2lkdGgiOiI8PTE1MDAifV1dLCJhdWQiOlsidXJuOnNlcnZpY2U6aW1hZ2Uub3BlcmF0aW9ucyJdfQ.8apbLuo_FDnWZ46od0Qh6OA-oFg-QO7trWew1_vbonE',
        'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7InBhdGgiOiJcL2ZcLzI4N2VhYjY2LTBmNzMtNGI5Ny04ZTc0LTg0OWM1ZjA2ZDU0MlwvZGVnNGwyZy02MjEzNjhhZC1iNDRiLTQ0ZWItYWM0Ny00Nzc2NDA4M2JhNGYuanBnIn1dXSwiYXVkIjpbInVybjpzZXJ2aWNlOmZpbGUuZG93bmxvYWQiXX0.PslSOz5dxPP8FKTkKsVZ_cvDGHt3kGMLsNpBQB9Tiis',
      ],
      types: [
        {
          t: '150',
          r: 0,
          c: '/v1/fit/w_150,h_150,q_70,strp/<prettyName>-150.jpg',
          h: 100,
          w: 150,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_300,h_300,q_70,strp/<prettyName>-150-2x.jpg',
            },
          ],
        },
        {
          t: '200H',
          r: 0,
          c: '/v1/fill/w_300,h_200,q_70,strp/<prettyName>-200h.jpg',
          h: 200,
          w: 300,
          ss: [
            {
              x: 2,
              c: '/v1/fill/w_600,h_400,q_70,strp/<prettyName>-200h-2x.jpg',
            },
          ],
        },
        {
          t: '300W',
          r: 0,
          c: '/v1/fit/w_300,h_900,q_70,strp/<prettyName>-300w.jpg',
          h: 200,
          w: 300,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_600,h_1000,q_70,strp/<prettyName>-300w-2x.jpg',
            },
          ],
        },
        {
          t: '375W',
          r: 0,
          c: '/v1/fit/w_375,h_250,q_70,strp/<prettyName>-375w.jpg',
          h: 250,
          w: 375,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_750,h_500,q_70,strp/<prettyName>-375w-2x.jpg',
            },
          ],
        },
        {
          t: '414W',
          r: 0,
          c: '/v1/fit/w_414,h_276,q_70,strp/<prettyName>-414w.jpg',
          h: 276,
          w: 414,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_828,h_552,q_70,strp/<prettyName>-414w-2x.jpg',
            },
          ],
        },
        {
          t: '250T',
          r: 0,
          c: '/v1/fill/w_375,h_250,q_70,strp/<prettyName>-250t.jpg',
          h: 250,
          w: 375,
          ss: [
            {
              x: 2,
              c: '/v1/fill/w_750,h_500,q_70,strp/<prettyName>-250t-2x.jpg',
            },
          ],
        },
        {
          t: '350T',
          r: 0,
          c: '/v1/fill/w_525,h_350,q_70,strp/<prettyName>-350t.jpg',
          h: 350,
          w: 525,
          ss: [
            {
              x: 2,
              c: '/v1/fill/w_1050,h_700,q_70,strp/<prettyName>-350t-2x.jpg',
            },
          ],
        },
        {
          t: '400T',
          r: 0,
          c: '/v1/fill/w_600,h_400,q_70,strp/<prettyName>-400t.jpg',
          h: 400,
          w: 600,
          ss: [
            {
              x: 2,
              c: '/v1/fill/w_1200,h_800,q_70,strp/<prettyName>-400t-2x.jpg',
            },
          ],
        },
        {
          t: 'preview',
          r: 0,
          c: '/v1/fill/w_1095,h_730,q_70,strp/<prettyName>-pre.jpg',
          h: 730,
          w: 1095,
          f: 1758237,
        },
        {
          t: 'social_preview',
          r: 0,
          c: '/v1/fill/w_1095,h_730,q_70,strp/<prettyName>-pre.jpg',
          h: 730,
          w: 1095,
        },
        {
          t: 'fullview',
          r: 1,
          h: 1000,
          w: 1500,
          f: 1758237,
        },
        {
          t: '92S',
          r: 0,
          c: '/v1/crop/w_92,h_92,x_12,y_0,scl_0.092,q_70,strp/<prettyName>-92s.jpg',
          h: 92,
          w: 92,
          ss: [
            {
              x: 2,
              c: '/v1/crop/w_184,h_184,x_23,y_0,scl_0.184,q_70,strp/<prettyName>-92s-2x.jpg',
            },
          ],
        },
      ],
    },
  },
  {
    deviationId: 873001674,
    type: 'image',
    typeId: 1,
    url: 'https://www.deviantart.com/mattdixon/art/Deflated-873001674',
    title: 'Deflated',
    isJournal: false,
    isVideo: false,
    isPurchasable: false,
    isFavouritable: true,
    publishedTime: '2021-03-12T05:45:29-0800',
    isTextEditable: false,
    isBackgroundEditable: false,
    legacyTextEditUrl: null,
    isShareable: true,
    isCommentable: true,
    isFavourited: true,
    isDeleted: false,
    isMature: false,
    isNsfg: false,
    isDownloadable: false,
    isAntisocial: false,
    isBlocked: false,
    isPublished: true,
    isDailyDeviation: false,
    hasPrivateComments: false,
    isDreamsofart: false,
    isAiUseDisallowed: true,
    blockReasons: [],
    author: {
      userId: 613001,
      useridUuid: '989bd361-968e-4c4c-bf51-8583b14a79eb',
      username: 'MattDixon',
      usericon: 'https://a.deviantart.net/avatars-big/m/a/mattdixon.jpg?5',
      type: 'regular',
      isWatching: false,
      isSubscribed: false,
      isNewDeviant: false,
    },
    stats: {
      comments: 5,
      favourites: 244,
      views: 10168,
      downloads: 0,
    },
    media: {
      baseUri:
        'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/989bd361-968e-4c4c-bf51-8583b14a79eb/defrgei-c9c12149-a274-4cde-ad11-d11315930bfe.jpg',
      prettyName: 'deflated_by_mattdixon_defrgei',
      token: [
        'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7ImhlaWdodCI6Ijw9ODAwIiwicGF0aCI6IlwvZlwvOTg5YmQzNjEtOTY4ZS00YzRjLWJmNTEtODU4M2IxNGE3OWViXC9kZWZyZ2VpLWM5YzEyMTQ5LWEyNzQtNGNkZS1hZDExLWQxMTMxNTkzMGJmZS5qcGciLCJ3aWR0aCI6Ijw9NTY2In1dXSwiYXVkIjpbInVybjpzZXJ2aWNlOmltYWdlLm9wZXJhdGlvbnMiXX0.4ezxnO7JM-wawy3rNv9sRwY-Ow0UQzbQgei7fudS-9I',
        'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7InBhdGgiOiJcL2ZcLzk4OWJkMzYxLTk2OGUtNGM0Yy1iZjUxLTg1ODNiMTRhNzllYlwvZGVmcmdlaS1jOWMxMjE0OS1hMjc0LTRjZGUtYWQxMS1kMTEzMTU5MzBiZmUuanBnIn1dXSwiYXVkIjpbInVybjpzZXJ2aWNlOmZpbGUuZG93bmxvYWQiXX0.T-YmV4kktZ9NHNp-WhH9SN8k6bv32gzBvhqNZMPndqk',
      ],
      types: [
        {
          t: '150',
          r: 0,
          c: '/v1/fit/w_150,h_150,q_70,strp/<prettyName>-150.jpg',
          h: 150,
          w: 106,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_300,h_300,q_70,strp/<prettyName>-150-2x.jpg',
            },
          ],
        },
        {
          t: '200H',
          r: 0,
          c: '/v1/crop/w_142,h_200,x_0,y_0,scl_0.25088339222615,q_70,strp/<prettyName>-200h.jpg',
          h: 200,
          w: 142,
          ss: [
            {
              x: 2,
              c: '/v1/fill/w_283,h_400,q_70,strp/<prettyName>-200h-2x.jpg',
            },
          ],
        },
        {
          t: '300W',
          r: 0,
          c: '/v1/fit/w_300,h_800,q_70,strp/<prettyName>-300w.jpg',
          h: 424,
          w: 300,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_566,h_800,q_70,strp/<prettyName>-300w-2x.jpg',
            },
          ],
        },
        {
          t: '375W',
          r: 0,
          c: '/v1/fit/w_375,h_530,q_70,strp/<prettyName>-375w.jpg',
          h: 530,
          w: 375,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_566,h_800,q_70,strp/<prettyName>-375w-2x.jpg',
            },
          ],
        },
        {
          t: '414W',
          r: 0,
          c: '/v1/fit/w_414,h_585,q_70,strp/<prettyName>-414w.jpg',
          h: 585,
          w: 414,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_566,h_800,q_70,strp/<prettyName>-414w-2x.jpg',
            },
          ],
        },
        {
          t: '250T',
          r: 0,
          c: '/v1/fill/w_177,h_250,q_70,strp/<prettyName>-250t.jpg',
          h: 250,
          w: 177,
          ss: [
            {
              x: 2,
              c: '/v1/fill/w_354,h_500,q_70,strp/<prettyName>-250t-2x.jpg',
            },
          ],
        },
        {
          t: '350T',
          r: 0,
          c: '/v1/crop/w_248,h_350,x_0,y_0,scl_0.43816254416961,q_70,strp/<prettyName>-350t.jpg',
          h: 350,
          w: 248,
          ss: [
            {
              x: 2,
              c: '/v1/fill/w_495,h_700,q_70,strp/<prettyName>-350t-2x.jpg',
            },
          ],
        },
        {
          t: '400T',
          r: 0,
          c: '/v1/fill/w_283,h_400,q_70,strp/<prettyName>-400t.jpg',
          h: 400,
          w: 283,
          ss: [
            {
              x: 2,
              c: '/v1/fill/w_566,h_800,q_70,strp/<prettyName>-400t-2x.jpg',
            },
          ],
        },
        {
          t: 'preview',
          r: 0,
          c: '/v1/fill/w_566,h_800,q_75,strp/<prettyName>-fullview.jpg',
          h: 800,
          w: 566,
          f: 77840,
        },
        {
          t: 'social_preview',
          r: 0,
          c: '/v1/fill/w_566,h_800,q_75,strp/<prettyName>-fullview.jpg',
          h: 800,
          w: 566,
        },
        {
          t: 'fullview',
          r: 1,
          h: 800,
          w: 566,
          f: 77840,
        },
        {
          t: '92S',
          r: 0,
          c: '/v1/crop/w_92,h_92,x_0,y_10,scl_0.16254416961131,q_70,strp/<prettyName>-92s.jpg',
          h: 92,
          w: 92,
          ss: [
            {
              x: 2,
              c: '/v1/crop/w_184,h_184,x_0,y_19,scl_0.32508833922261,q_70,strp/<prettyName>-92s-2x.jpg',
            },
          ],
        },
      ],
    },
  },
  {
    deviationId: 872104439,
    type: 'image',
    typeId: 1,
    url: 'https://www.deviantart.com/argaphons/art/Jellyfish-872104439',
    title: 'Jellyfish',
    isJournal: false,
    isVideo: false,
    isPurchasable: true,
    isFavouritable: true,
    publishedTime: '2021-03-03T08:42:01-0800',
    isTextEditable: false,
    isBackgroundEditable: false,
    legacyTextEditUrl: null,
    isShareable: true,
    isCommentable: true,
    isFavourited: true,
    isDeleted: false,
    isMature: false,
    isNsfg: false,
    isDownloadable: true,
    isAntisocial: false,
    isBlocked: false,
    isPublished: true,
    isDailyDeviation: false,
    hasPrivateComments: false,
    isDreamsofart: false,
    isAiUseDisallowed: true,
    blockReasons: [],
    author: {
      userId: 66166139,
      useridUuid: '6ce7782d-8933-4f22-9811-980ab54d88c7',
      username: 'Argaphons',
      usericon: 'https://a.deviantart.net/avatars-big/a/r/argaphons.jpg?4',
      type: 'regular',
      isWatching: true,
      isSubscribed: false,
      isNewDeviant: false,
    },
    stats: {
      comments: 10,
      favourites: 154,
      views: 2741,
      downloads: 3,
    },
    media: {
      baseUri:
        'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/6ce7782d-8933-4f22-9811-980ab54d88c7/def883b-9eb44997-4448-45a2-8f62-9f5370bba695.jpg',
      prettyName: 'jellyfish_by_argaphons_def883b',
      token: [
        'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7ImhlaWdodCI6Ijw9MTYwMCIsInBhdGgiOiJcL2ZcLzZjZTc3ODJkLTg5MzMtNGYyMi05ODExLTk4MGFiNTRkODhjN1wvZGVmODgzYi05ZWI0NDk5Ny00NDQ4LTQ1YTItOGY2Mi05ZjUzNzBiYmE2OTUuanBnIiwid2lkdGgiOiI8PTE2MDAifV1dLCJhdWQiOlsidXJuOnNlcnZpY2U6aW1hZ2Uub3BlcmF0aW9ucyJdfQ.qWskOh6APLzvovbubHJnRkWRwP-KOXjyuiSSBoyyIkE',
      ],
      types: [
        {
          t: '150',
          r: 0,
          c: '/v1/fit/w_150,h_150,q_70,strp/<prettyName>-150.jpg',
          h: 150,
          w: 150,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_300,h_300,q_70,strp/<prettyName>-150-2x.jpg',
            },
          ],
        },
        {
          t: '200H',
          r: 0,
          c: '/v1/fill/w_200,h_200,q_70,strp/<prettyName>-200h.jpg',
          h: 200,
          w: 200,
          ss: [
            {
              x: 2,
              c: '/v1/fill/w_400,h_400,q_70,strp/<prettyName>-200h-2x.jpg',
            },
          ],
        },
        {
          t: '300W',
          r: 0,
          c: '/v1/fit/w_300,h_900,q_70,strp/<prettyName>-300w.jpg',
          h: 300,
          w: 300,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_600,h_1600,q_70,strp/<prettyName>-300w-2x.jpg',
            },
          ],
        },
        {
          t: '375W',
          r: 0,
          c: '/v1/fit/w_375,h_375,q_70,strp/<prettyName>-375w.jpg',
          h: 375,
          w: 375,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_750,h_750,q_70,strp/<prettyName>-375w-2x.jpg',
            },
          ],
        },
        {
          t: '414W',
          r: 0,
          c: '/v1/fit/w_414,h_414,q_70,strp/<prettyName>-414w.jpg',
          h: 414,
          w: 414,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_828,h_828,q_70,strp/<prettyName>-414w-2x.jpg',
            },
          ],
        },
        {
          t: '250T',
          r: 0,
          c: '/v1/fill/w_250,h_250,q_70,strp/<prettyName>-250t.jpg',
          h: 250,
          w: 250,
          ss: [
            {
              x: 2,
              c: '/v1/fill/w_500,h_500,q_70,strp/<prettyName>-250t-2x.jpg',
            },
          ],
        },
        {
          t: '350T',
          r: 0,
          c: '/v1/fill/w_350,h_350,q_70,strp/<prettyName>-350t.jpg',
          h: 350,
          w: 350,
          ss: [
            {
              x: 2,
              c: '/v1/fill/w_700,h_700,q_70,strp/<prettyName>-350t-2x.jpg',
            },
          ],
        },
        {
          t: '400T',
          r: 0,
          c: '/v1/fill/w_400,h_400,q_70,strp/<prettyName>-400t.jpg',
          h: 400,
          w: 400,
          ss: [
            {
              x: 2,
              c: '/v1/fill/w_800,h_800,q_70,strp/<prettyName>-400t-2x.jpg',
            },
          ],
        },
        {
          t: 'preview',
          r: 0,
          c: '/v1/fill/w_894,h_894,q_70,strp/<prettyName>-pre.jpg',
          h: 894,
          w: 894,
          f: 609903,
        },
        {
          t: 'social_preview',
          r: 0,
          c: '/v1/fill/w_894,h_894,q_70,strp/<prettyName>-pre.jpg',
          h: 894,
          w: 894,
        },
        {
          t: 'fullview',
          r: 0,
          c: '/v1/fill/w_1600,h_1600,q_75,strp/<prettyName>-fullview.jpg',
          h: 1600,
          w: 1600,
          f: 609903,
        },
        {
          t: '92S',
          r: 0,
          c: '/v1/crop/w_92,h_92,x_0,y_0,scl_0.047916666666667,q_70,strp/<prettyName>-92s.jpg',
          h: 92,
          w: 92,
          ss: [
            {
              x: 2,
              c: '/v1/crop/w_184,h_184,x_0,y_0,scl_0.095833333333333,q_70,strp/<prettyName>-92s-2x.jpg',
            },
          ],
        },
      ],
    },
  },
  {
    deviationId: 871269987,
    type: 'image',
    typeId: 1,
    url: 'https://www.deviantart.com/marcioabreu7/art/MANDALORIAN-871269987',
    title: 'MANDALORIAN',
    isJournal: false,
    isVideo: false,
    isPurchasable: false,
    isFavouritable: true,
    publishedTime: '2021-02-23T06:06:23-0800',
    isTextEditable: false,
    isBackgroundEditable: false,
    legacyTextEditUrl: null,
    isShareable: true,
    isCommentable: true,
    isFavourited: true,
    isDeleted: false,
    isMature: false,
    isNsfg: false,
    isDownloadable: true,
    isAntisocial: false,
    isBlocked: false,
    isPublished: true,
    isDailyDeviation: false,
    hasPrivateComments: false,
    isDreamsofart: false,
    isAiUseDisallowed: true,
    blockReasons: [],
    author: {
      userId: 8837184,
      useridUuid: '532755f3-e7be-41cb-8280-75aa41b4f2f2',
      username: 'MARCIOABREU7',
      usericon: 'https://a.deviantart.net/avatars-big/m/a/marcioabreu7.jpg?6',
      type: 'regular',
      isWatching: false,
      isSubscribed: false,
      isNewDeviant: false,
    },
    stats: {
      comments: 3,
      favourites: 281,
      views: 12086,
      downloads: 57,
    },
    media: {
      baseUri:
        'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/532755f3-e7be-41cb-8280-75aa41b4f2f2/deeqc83-258ae184-2698-4ef9-a546-a58a45ba5514.jpg',
      prettyName: 'mandalorian_by_marcioabreu7_deeqc83',
      token: [
        'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7ImhlaWdodCI6Ijw9MTI4MCIsInBhdGgiOiJcL2ZcLzUzMjc1NWYzLWU3YmUtNDFjYi04MjgwLTc1YWE0MWI0ZjJmMlwvZGVlcWM4My0yNThhZTE4NC0yNjk4LTRlZjktYTU0Ni1hNThhNDViYTU1MTQuanBnIiwid2lkdGgiOiI8PTkzMSJ9XV0sImF1ZCI6WyJ1cm46c2VydmljZTppbWFnZS5vcGVyYXRpb25zIl19.iIyjN6kFewU7HjAtceZi1ttRUPEEvXGzPZ1QlfZBks0',
        'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7InBhdGgiOiJcL2ZcLzUzMjc1NWYzLWU3YmUtNDFjYi04MjgwLTc1YWE0MWI0ZjJmMlwvZGVlcWM4My0yNThhZTE4NC0yNjk4LTRlZjktYTU0Ni1hNThhNDViYTU1MTQuanBnIn1dXSwiYXVkIjpbInVybjpzZXJ2aWNlOmZpbGUuZG93bmxvYWQiXX0.YUTABR4_jT8wxF1rk8QFbLneXKtt83Cp56rTm9BYRoU',
      ],
      types: [
        {
          t: '150',
          r: 0,
          c: '/v1/fit/w_150,h_150,q_70,strp/<prettyName>-150.jpg',
          h: 150,
          w: 109,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_300,h_300,q_70,strp/<prettyName>-150-2x.jpg',
            },
          ],
        },
        {
          t: '200H',
          r: 0,
          c: '/v1/crop/w_145,h_200,x_0,y_0,scl_0.15682062298604,q_70,strp/<prettyName>-200h.jpg',
          h: 200,
          w: 145,
          ss: [
            {
              x: 2,
              c: '/v1/fill/w_291,h_400,q_70,strp/<prettyName>-200h-2x.jpg',
            },
          ],
        },
        {
          t: '300W',
          r: 0,
          c: '/v1/fit/w_300,h_900,q_70,strp/<prettyName>-300w.jpg',
          h: 412,
          w: 300,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_600,h_1280,q_70,strp/<prettyName>-300w-2x.jpg',
            },
          ],
        },
        {
          t: '375W',
          r: 0,
          c: '/v1/fit/w_375,h_516,q_70,strp/<prettyName>-375w.jpg',
          h: 516,
          w: 375,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_750,h_1032,q_70,strp/<prettyName>-375w-2x.jpg',
            },
          ],
        },
        {
          t: '414W',
          r: 0,
          c: '/v1/fit/w_414,h_569,q_70,strp/<prettyName>-414w.jpg',
          h: 569,
          w: 414,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_828,h_1138,q_70,strp/<prettyName>-414w-2x.jpg',
            },
          ],
        },
        {
          t: '250T',
          r: 0,
          c: '/v1/fill/w_182,h_250,q_70,strp/<prettyName>-250t.jpg',
          h: 250,
          w: 182,
          ss: [
            {
              x: 2,
              c: '/v1/fill/w_364,h_500,q_70,strp/<prettyName>-250t-2x.jpg',
            },
          ],
        },
        {
          t: '350T',
          r: 0,
          c: '/v1/crop/w_255,h_350,x_0,y_0,scl_0.27389903329753,q_70,strp/<prettyName>-350t.jpg',
          h: 350,
          w: 255,
          ss: [
            {
              x: 2,
              c: '/v1/fill/w_509,h_700,q_70,strp/<prettyName>-350t-2x.jpg',
            },
          ],
        },
        {
          t: '400T',
          r: 0,
          c: '/v1/fill/w_291,h_400,q_70,strp/<prettyName>-400t.jpg',
          h: 400,
          w: 291,
          ss: [
            {
              x: 2,
              c: '/v1/fill/w_582,h_800,q_70,strp/<prettyName>-400t-2x.jpg',
            },
          ],
        },
        {
          t: 'preview',
          r: 0,
          c: '/v1/fill/w_762,h_1048,q_70,strp/<prettyName>-pre.jpg',
          h: 1048,
          w: 762,
          f: 321052,
        },
        {
          t: 'social_preview',
          r: 0,
          c: '/v1/fill/w_762,h_1048,q_70,strp/<prettyName>-pre.jpg',
          h: 1048,
          w: 762,
        },
        {
          t: 'fullview',
          r: 1,
          h: 1280,
          w: 931,
          f: 321052,
        },
        {
          t: '92S',
          r: 0,
          c: '/v1/crop/w_92,h_92,x_0,y_9,scl_0.098818474758324,q_70,strp/<prettyName>-92s.jpg',
          h: 92,
          w: 92,
          ss: [
            {
              x: 2,
              c: '/v1/crop/w_184,h_184,x_0,y_17,scl_0.19763694951665,q_70,strp/<prettyName>-92s-2x.jpg',
            },
          ],
        },
      ],
    },
  },
  {
    deviationId: 870662595,
    type: 'image',
    typeId: 1,
    url: 'https://www.deviantart.com/kori-z/art/At-Sea-870662595',
    title: 'At Sea',
    isJournal: false,
    isVideo: false,
    isPurchasable: false,
    isFavouritable: true,
    publishedTime: '2021-02-17T08:28:27-0800',
    isTextEditable: false,
    isBackgroundEditable: false,
    legacyTextEditUrl: null,
    isShareable: true,
    isCommentable: true,
    isFavourited: true,
    isDeleted: false,
    isMature: false,
    isNsfg: false,
    isDownloadable: false,
    isAntisocial: false,
    isBlocked: false,
    isPublished: true,
    isDailyDeviation: false,
    hasPrivateComments: false,
    isDreamsofart: false,
    isAiUseDisallowed: true,
    blockReasons: [],
    author: {
      userId: 55478162,
      useridUuid: 'f9da2d67-777f-4a81-b460-fd314ba1ecb8',
      username: 'Kori-Z',
      usericon: 'https://a.deviantart.net/avatars-big/k/o/kori-z.jpg?3',
      type: 'regular',
      isWatching: true,
      isSubscribed: false,
      isNewDeviant: false,
    },
    stats: {
      comments: 16,
      favourites: 192,
      views: 3733,
      downloads: 0,
    },
    media: {
      baseUri:
        'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/f9da2d67-777f-4a81-b460-fd314ba1ecb8/deedbk3-02dc90a2-91da-42e3-bb1f-9607a9a42c13.png',
      prettyName: 'at_sea_by_kori_z_deedbk3',
      token: [
        'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7ImhlaWdodCI6Ijw9MTIwNCIsInBhdGgiOiJcL2ZcL2Y5ZGEyZDY3LTc3N2YtNGE4MS1iNDYwLWZkMzE0YmExZWNiOFwvZGVlZGJrMy0wMmRjOTBhMi05MWRhLTQyZTMtYmIxZi05NjA3YTlhNDJjMTMucG5nIiwid2lkdGgiOiI8PTEwMjQifV1dLCJhdWQiOlsidXJuOnNlcnZpY2U6aW1hZ2Uub3BlcmF0aW9ucyJdfQ.yhV5p_MYDs-5dhTinvFFaEKBQY6IBADNaZykLCWQw3w',
      ],
      types: [
        {
          t: '150',
          r: 0,
          c: '/v1/fit/w_150,h_150,q_70,strp/<prettyName>-150.jpg',
          h: 150,
          w: 128,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_300,h_300,q_70,strp/<prettyName>-150-2x.jpg',
            },
          ],
        },
        {
          t: '200H',
          r: 0,
          c: '/v1/fill/w_170,h_200,q_70,strp/<prettyName>-200h.jpg',
          h: 200,
          w: 170,
          ss: [
            {
              x: 2,
              c: '/v1/fill/w_340,h_400,q_70,strp/<prettyName>-200h-2x.jpg',
            },
          ],
        },
        {
          t: '300W',
          r: 0,
          c: '/v1/fit/w_300,h_900,q_70,strp/<prettyName>-300w.jpg',
          h: 353,
          w: 300,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_600,h_1204,q_70,strp/<prettyName>-300w-2x.jpg',
            },
          ],
        },
        {
          t: '375W',
          r: 0,
          c: '/v1/fit/w_375,h_441,q_70,strp/<prettyName>-375w.jpg',
          h: 441,
          w: 375,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_750,h_882,q_70,strp/<prettyName>-375w-2x.jpg',
            },
          ],
        },
        {
          t: '414W',
          r: 0,
          c: '/v1/fit/w_414,h_487,q_70,strp/<prettyName>-414w.jpg',
          h: 487,
          w: 414,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_828,h_974,q_70,strp/<prettyName>-414w-2x.jpg',
            },
          ],
        },
        {
          t: '250T',
          r: 0,
          c: '/v1/fill/w_213,h_250,q_70,strp/<prettyName>-250t.jpg',
          h: 250,
          w: 213,
          ss: [
            {
              x: 2,
              c: '/v1/fill/w_425,h_500,q_70,strp/<prettyName>-250t-2x.jpg',
            },
          ],
        },
        {
          t: '350T',
          r: 0,
          c: '/v1/fill/w_298,h_350,q_70,strp/<prettyName>-350t.jpg',
          h: 350,
          w: 298,
          ss: [
            {
              x: 2,
              c: '/v1/crop/w_595,h_700,x_0,y_0,scl_0.46708463949843,q_70,strp/<prettyName>-350t-2x.jpg',
            },
          ],
        },
        {
          t: '400T',
          r: 0,
          c: '/v1/fill/w_340,h_400,q_70,strp/<prettyName>-400t.jpg',
          h: 400,
          w: 340,
          ss: [
            {
              x: 2,
              c: '/v1/crop/w_681,h_800,x_0,y_0,scl_0.53369905956113,q_70,strp/<prettyName>-400t-2x.jpg',
            },
          ],
        },
        {
          t: 'preview',
          r: 0,
          c: '/v1/fill/w_824,h_969,q_70,strp/<prettyName>-pre.jpg',
          h: 969,
          w: 824,
          f: 2359058,
        },
        {
          t: 'social_preview',
          r: 0,
          c: '/v1/fill/w_824,h_969,q_70,strp/<prettyName>-pre.jpg',
          h: 969,
          w: 824,
        },
        {
          t: 'fullview',
          r: 0,
          c: '/v1/fill/w_1024,h_1204,q_80,strp/<prettyName>-fullview.jpg',
          h: 1204,
          w: 1024,
          f: 2359058,
        },
        {
          t: '92S',
          r: 0,
          c: '/v1/crop/w_92,h_92,x_0,y_4,scl_0.072100313479624,q_70,strp/<prettyName>-92s.jpg',
          h: 92,
          w: 92,
          ss: [
            {
              x: 2,
              c: '/v1/crop/w_184,h_184,x_0,y_8,scl_0.14420062695925,q_70,strp/<prettyName>-92s-2x.jpg',
            },
          ],
        },
      ],
    },
  },
  {
    deviationId: 870369463,
    type: 'image',
    typeId: 1,
    url: 'https://www.deviantart.com/bettykwong/art/The-Minish-870369463',
    title: 'The Minish',
    isJournal: false,
    isVideo: false,
    isPurchasable: false,
    isFavouritable: true,
    publishedTime: '2021-02-14T15:42:32-0800',
    isTextEditable: false,
    isBackgroundEditable: false,
    legacyTextEditUrl: null,
    isShareable: true,
    isCommentable: true,
    isFavourited: true,
    isDeleted: false,
    isMature: false,
    isNsfg: false,
    isDownloadable: false,
    isAntisocial: false,
    isBlocked: false,
    isPublished: true,
    isDailyDeviation: false,
    hasPrivateComments: false,
    isDreamsofart: false,
    isAiUseDisallowed: true,
    blockReasons: [],
    author: {
      userId: 485254,
      useridUuid: '8fed6458-f2bd-4588-a2b0-517cc9936a4f',
      username: 'BettyKwong',
      usericon: 'https://a.deviantart.net/avatars-big/b/e/bettykwong.jpg?1',
      type: 'core_access',
      isWatching: true,
      isSubscribed: false,
      isNewDeviant: false,
    },
    stats: {
      comments: 15,
      favourites: 588,
      views: 19808,
      downloads: 0,
    },
    media: {
      baseUri:
        'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/8fed6458-f2bd-4588-a2b0-517cc9936a4f/dee71dj-bac440b7-c0c9-4a1e-a608-70762d64da4d.jpg',
      prettyName: 'the_minish_by_bettykwong_dee71dj',
      token: [
        'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7ImhlaWdodCI6Ijw9NTY5IiwicGF0aCI6IlwvZlwvOGZlZDY0NTgtZjJiZC00NTg4LWEyYjAtNTE3Y2M5OTM2YTRmXC9kZWU3MWRqLWJhYzQ0MGI3LWMwYzktNGExZS1hNjA4LTcwNzYyZDY0ZGE0ZC5qcGciLCJ3aWR0aCI6Ijw9MTA0MSJ9XV0sImF1ZCI6WyJ1cm46c2VydmljZTppbWFnZS5vcGVyYXRpb25zIl19.jVeMeaezqyuzo1ZZvGxYdcbbkLrd2LTFEOWcwyXyMLI',
        'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7InBhdGgiOiJcL2ZcLzhmZWQ2NDU4LWYyYmQtNDU4OC1hMmIwLTUxN2NjOTkzNmE0ZlwvZGVlNzFkai1iYWM0NDBiNy1jMGM5LTRhMWUtYTYwOC03MDc2MmQ2NGRhNGQuanBnIn1dXSwiYXVkIjpbInVybjpzZXJ2aWNlOmZpbGUuZG93bmxvYWQiXX0.pop56ZPHuIFSQ-8WodFhj5wsw22NzvwvBQv7uZ-LTLI',
      ],
      types: [
        {
          t: '150',
          r: 0,
          c: '/v1/fit/w_150,h_150,q_70,strp/<prettyName>-150.jpg',
          h: 82,
          w: 150,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_300,h_300,q_70,strp/<prettyName>-150-2x.jpg',
            },
          ],
        },
        {
          t: '200H',
          r: 0,
          c: '/v1/fill/w_300,h_164,q_70,strp/<prettyName>-200h.jpg',
          h: 164,
          w: 300,
          ss: [
            {
              x: 2,
              c: '/v1/fill/w_600,h_328,q_70,strp/<prettyName>-200h-2x.jpg',
            },
          ],
        },
        {
          t: '300W',
          r: 0,
          c: '/v1/fit/w_300,h_569,q_70,strp/<prettyName>-300w.jpg',
          h: 164,
          w: 300,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_600,h_569,q_70,strp/<prettyName>-300w-2x.jpg',
            },
          ],
        },
        {
          t: '375W',
          r: 0,
          c: '/v1/fit/w_375,h_205,q_70,strp/<prettyName>-375w.jpg',
          h: 205,
          w: 375,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_750,h_410,q_70,strp/<prettyName>-375w-2x.jpg',
            },
          ],
        },
        {
          t: '414W',
          r: 0,
          c: '/v1/fit/w_414,h_226,q_70,strp/<prettyName>-414w.jpg',
          h: 226,
          w: 414,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_828,h_452,q_70,strp/<prettyName>-414w-2x.jpg',
            },
          ],
        },
        {
          t: '250T',
          r: 0,
          c: '/v1/fill/w_457,h_250,q_70,strp/<prettyName>-250t.jpg',
          h: 250,
          w: 457,
          ss: [
            {
              x: 2,
              c: '/v1/fill/w_915,h_500,q_70,strp/<prettyName>-250t-2x.jpg',
            },
          ],
        },
        {
          t: '350T',
          r: 0,
          c: '/v1/fill/w_640,h_350,q_70,strp/<prettyName>-350t.jpg',
          h: 350,
          w: 640,
          ss: [
            {
              x: 2,
              c: '/v1/fill/w_1041,h_569,q_70,strp/<prettyName>-350t-2x.jpg',
            },
          ],
        },
        {
          t: '400T',
          r: 0,
          c: '/v1/fill/w_732,h_400,q_70,strp/<prettyName>-400t.jpg',
          h: 400,
          w: 732,
          ss: [
            {
              x: 2,
              c: '/v1/fill/w_1041,h_569,q_70,strp/<prettyName>-400t-2x.jpg',
            },
          ],
        },
        {
          t: 'preview',
          r: 0,
          c: '/v1/fill/w_1041,h_569,q_75,strp/<prettyName>-fullview.jpg',
          h: 569,
          w: 1041,
          f: 513110,
        },
        {
          t: 'social_preview',
          r: 0,
          c: '/v1/fill/w_1041,h_569,q_75,strp/<prettyName>-fullview.jpg',
          h: 569,
          w: 1041,
        },
        {
          t: 'fullview',
          r: 1,
          h: 569,
          w: 1041,
          f: 513110,
        },
        {
          t: '92S',
          r: 0,
          c: '/v1/crop/w_92,h_92,x_19,y_0,scl_0.16168717047452,q_70,strp/<prettyName>-92s.jpg',
          h: 92,
          w: 92,
          ss: [
            {
              x: 2,
              c: '/v1/crop/w_184,h_184,x_38,y_0,scl_0.32337434094903,q_70,strp/<prettyName>-92s-2x.jpg',
            },
          ],
        },
      ],
    },
  },
  {
    deviationId: 866930140,
    type: 'image',
    typeId: 1,
    url: 'https://www.deviantart.com/rgpc/art/Kings-of-Convenience-866930140',
    title: 'Kings of Convenience',
    isJournal: false,
    isVideo: false,
    isPurchasable: false,
    isFavouritable: true,
    publishedTime: '2021-01-12T15:03:11-0800',
    isTextEditable: false,
    isBackgroundEditable: false,
    legacyTextEditUrl: null,
    isShareable: true,
    isCommentable: true,
    isFavourited: true,
    isDeleted: false,
    isMature: false,
    isNsfg: false,
    isDownloadable: false,
    isAntisocial: false,
    isBlocked: false,
    isPublished: true,
    isDailyDeviation: false,
    hasPrivateComments: false,
    isDreamsofart: false,
    isAiUseDisallowed: true,
    blockReasons: [],
    author: {
      userId: 44678339,
      useridUuid: 'deb9b22d-e03e-4dd4-b706-969efca8fec4',
      username: 'RGPC',
      usericon: 'https://a.deviantart.net/avatars-big/r/g/rgpc.jpg?4',
      type: 'regular',
      isWatching: true,
      isSubscribed: false,
      isNewDeviant: false,
    },
    stats: {
      comments: 2,
      favourites: 55,
      views: 1969,
      downloads: 0,
    },
    media: {
      baseUri:
        'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/deb9b22d-e03e-4dd4-b706-969efca8fec4/dec5bks-d1b9ac6f-59fa-4baa-9c3f-bf3a92c3dc96.jpg',
      prettyName: 'kings_of_convenience_by_rgpc_dec5bks',
      token: [
        'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7InBhdGgiOiJcL2ZcL2RlYjliMjJkLWUwM2UtNGRkNC1iNzA2LTk2OWVmY2E4ZmVjNFwvZGVjNWJrcy1kMWI5YWM2Zi01OWZhLTRiYWEtOWMzZi1iZjNhOTJjM2RjOTYuanBnIiwiaGVpZ2h0IjoiPD0xNDQ5Iiwid2lkdGgiOiI8PTEwMjQifV1dLCJhdWQiOlsidXJuOnNlcnZpY2U6aW1hZ2Uud2F0ZXJtYXJrIl0sIndtayI6eyJwYXRoIjoiXC93bVwvZGViOWIyMmQtZTAzZS00ZGQ0LWI3MDYtOTY5ZWZjYThmZWM0XC9yZ3BjLTQucG5nIiwib3BhY2l0eSI6OTUsInByb3BvcnRpb25zIjowLjQ1LCJncmF2aXR5IjoiY2VudGVyIn19.2ofhs_dEh7VE8zkKYP-VceVaEvKtgbZj68j19wh00jI',
      ],
      types: [
        {
          t: '150',
          r: 0,
          c: '/v1/fit/w_150,h_150,q_70,strp/<prettyName>-150.jpg',
          h: 150,
          w: 106,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_300,h_300,q_70,strp/<prettyName>-150-2x.jpg',
            },
          ],
        },
        {
          t: '200H',
          r: 0,
          c: '/v1/crop/w_141,h_200,x_0,y_0,scl_0.078453038674033,q_70,strp/<prettyName>-200h.jpg',
          h: 200,
          w: 141,
          ss: [
            {
              x: 2,
              c: '/v1/fill/w_283,h_400,q_70,strp/<prettyName>-200h-2x.jpg',
            },
          ],
        },
        {
          t: '300W',
          r: 0,
          c: '/v1/fit/w_300,h_900,q_70,strp/<prettyName>-300w.jpg',
          h: 425,
          w: 300,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_600,h_1449,q_70,strp/<prettyName>-300w-2x.jpg',
            },
          ],
        },
        {
          t: '375W',
          r: 0,
          c: '/v1/fit/w_375,h_531,q_70,strp/<prettyName>-375w.jpg',
          h: 531,
          w: 375,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_750,h_1062,q_70,strp/<prettyName>-375w-2x.jpg',
            },
          ],
        },
        {
          t: '414W',
          r: 0,
          c: '/v1/fit/w_414,h_586,q_70,strp/<prettyName>-414w.jpg',
          h: 586,
          w: 414,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_828,h_1172,q_70,strp/<prettyName>-414w-2x.jpg',
            },
          ],
        },
        {
          t: '250T',
          r: 0,
          c: '/v1/fill/w_177,h_250,q_70,strp/<prettyName>-250t.jpg',
          h: 250,
          w: 177,
          ss: [
            {
              x: 2,
              c: '/v1/crop/w_354,h_500,x_0,y_0,scl_0.19558011049724,q_70,strp/<prettyName>-250t-2x.jpg',
            },
          ],
        },
        {
          t: '350T',
          r: 0,
          c: '/v1/crop/w_247,h_350,x_0,y_0,scl_0.13701657458564,q_70,strp/<prettyName>-350t.jpg',
          h: 350,
          w: 247,
          ss: [
            {
              x: 2,
              c: '/v1/fill/w_495,h_700,q_70,strp/<prettyName>-350t-2x.jpg',
            },
          ],
        },
        {
          t: '400T',
          r: 0,
          c: '/v1/fill/w_283,h_400,q_70,strp/<prettyName>-400t.jpg',
          h: 400,
          w: 283,
          ss: [
            {
              x: 2,
              c: '/v1/crop/w_566,h_800,x_0,y_0,scl_0.31270718232044,q_70,strp/<prettyName>-400t-2x.jpg',
            },
          ],
        },
        {
          t: 'preview',
          r: 0,
          c: '/v1/fill/w_751,h_1063,q_70,strp/<prettyName>-pre.jpg',
          h: 1063,
          w: 751,
          f: 3105966,
        },
        {
          t: 'social_preview',
          r: 0,
          c: '/v1/fill/w_751,h_1063,q_70,strp/<prettyName>-pre.jpg',
          h: 1063,
          w: 751,
        },
        {
          t: 'fullview',
          r: 0,
          c: '/v1/fill/w_1024,h_1449,q_75,strp/<prettyName>-fullview.jpg',
          h: 1449,
          w: 1024,
          f: 3105966,
        },
        {
          t: '92S',
          r: 0,
          c: '/v1/crop/w_92,h_92,x_0,y_10,scl_0.050828729281768,q_70,strp/<prettyName>-92s.jpg',
          h: 92,
          w: 92,
          ss: [
            {
              x: 2,
              c: '/v1/crop/w_184,h_184,x_0,y_19,scl_0.10165745856354,q_70,strp/<prettyName>-92s-2x.jpg',
            },
          ],
        },
      ],
    },
  },
  {
    deviationId: 866445779,
    type: 'image',
    typeId: 1,
    url: 'https://www.deviantart.com/zxs1103/art/ELEVEN-866445779',
    title: 'ELEVEN',
    isJournal: false,
    isVideo: false,
    isPurchasable: false,
    isFavouritable: true,
    publishedTime: '2021-01-07T23:47:57-0800',
    isTextEditable: false,
    isBackgroundEditable: false,
    legacyTextEditUrl: null,
    isShareable: true,
    isCommentable: true,
    isFavourited: true,
    isDeleted: false,
    isMature: false,
    isNsfg: false,
    isDownloadable: false,
    isAntisocial: false,
    isBlocked: false,
    isPublished: true,
    isDailyDeviation: true,
    hasPrivateComments: false,
    isDreamsofart: false,
    isAiUseDisallowed: true,
    blockReasons: [],
    author: {
      userId: 19786793,
      useridUuid: 'ed57201c-cd7a-4877-bbaf-17b139419196',
      username: 'zxs1103',
      usericon: 'https://a.deviantart.net/avatars-big/z/x/zxs1103.jpg?11',
      type: 'regular',
      isWatching: false,
      isSubscribed: false,
      isNewDeviant: false,
    },
    stats: {
      comments: 12,
      favourites: 453,
      views: 326007,
      downloads: 0,
    },
    media: {
      baseUri:
        'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/ed57201c-cd7a-4877-bbaf-17b139419196/debuxub-717a0e5b-361e-4843-95eb-463c9e010892.png',
      prettyName: 'eleven_by_zxs1103_debuxub',
      token: [
        'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7ImhlaWdodCI6Ijw9MTUwMCIsInBhdGgiOiJcL2ZcL2VkNTcyMDFjLWNkN2EtNDg3Ny1iYmFmLTE3YjEzOTQxOTE5NlwvZGVidXh1Yi03MTdhMGU1Yi0zNjFlLTQ4NDMtOTVlYi00NjNjOWUwMTA4OTIucG5nIiwid2lkdGgiOiI8PTEwNjEifV1dLCJhdWQiOlsidXJuOnNlcnZpY2U6aW1hZ2Uub3BlcmF0aW9ucyJdfQ.rjrHPYZjWyxQi68wtsg3jLil6e7ILTeltV8qv-Z_uy4',
        'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7InBhdGgiOiJcL2ZcL2VkNTcyMDFjLWNkN2EtNDg3Ny1iYmFmLTE3YjEzOTQxOTE5NlwvZGVidXh1Yi03MTdhMGU1Yi0zNjFlLTQ4NDMtOTVlYi00NjNjOWUwMTA4OTIucG5nIn1dXSwiYXVkIjpbInVybjpzZXJ2aWNlOmZpbGUuZG93bmxvYWQiXX0.cRoz600A9vXpU5p3JFF2NroVUHTbmAjZfBEaK-CKzHw',
      ],
      types: [
        {
          t: '150',
          r: 0,
          c: '/v1/fit/w_150,h_150,q_70,strp/<prettyName>-150.jpg',
          h: 150,
          w: 106,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_300,h_300,q_70,strp/<prettyName>-150-2x.jpg',
            },
          ],
        },
        {
          t: '200H',
          r: 0,
          c: '/v1/crop/w_141,h_200,x_0,y_0,scl_0.13383600377003,q_70,strp/<prettyName>-200h.jpg',
          h: 200,
          w: 141,
          ss: [
            {
              x: 2,
              c: '/v1/fill/w_283,h_400,q_70,strp/<prettyName>-200h-2x.jpg',
            },
          ],
        },
        {
          t: '300W',
          r: 0,
          c: '/v1/fit/w_300,h_900,q_70,strp/<prettyName>-300w.jpg',
          h: 424,
          w: 300,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_600,h_1500,q_70,strp/<prettyName>-300w-2x.jpg',
            },
          ],
        },
        {
          t: '375W',
          r: 0,
          c: '/v1/fit/w_375,h_530,q_70,strp/<prettyName>-375w.jpg',
          h: 530,
          w: 375,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_750,h_1060,q_70,strp/<prettyName>-375w-2x.jpg',
            },
          ],
        },
        {
          t: '414W',
          r: 0,
          c: '/v1/fit/w_414,h_585,q_70,strp/<prettyName>-414w.jpg',
          h: 585,
          w: 414,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_828,h_1170,q_70,strp/<prettyName>-414w-2x.jpg',
            },
          ],
        },
        {
          t: '250T',
          r: 0,
          c: '/v1/fill/w_177,h_250,q_70,strp/<prettyName>-250t.jpg',
          h: 250,
          w: 177,
          ss: [
            {
              x: 2,
              c: '/v1/fill/w_354,h_500,q_70,strp/<prettyName>-250t-2x.jpg',
            },
          ],
        },
        {
          t: '350T',
          r: 0,
          c: '/v1/crop/w_248,h_350,x_0,y_0,scl_0.23374175306315,q_70,strp/<prettyName>-350t.jpg',
          h: 350,
          w: 248,
          ss: [
            {
              x: 2,
              c: '/v1/fill/w_495,h_700,q_70,strp/<prettyName>-350t-2x.jpg',
            },
          ],
        },
        {
          t: '400T',
          r: 0,
          c: '/v1/fill/w_283,h_400,q_70,strp/<prettyName>-400t.jpg',
          h: 400,
          w: 283,
          ss: [
            {
              x: 2,
              c: '/v1/fill/w_566,h_800,q_70,strp/<prettyName>-400t-2x.jpg',
            },
          ],
        },
        {
          t: 'preview',
          r: 0,
          c: '/v1/fill/w_752,h_1063,q_70,strp/<prettyName>-pre.jpg',
          h: 1063,
          w: 752,
          f: 2449334,
        },
        {
          t: 'social_preview',
          r: 0,
          c: '/v1/fill/w_752,h_1063,q_70,strp/<prettyName>-pre.jpg',
          h: 1063,
          w: 752,
        },
        {
          t: 'fullview',
          r: 1,
          h: 1500,
          w: 1061,
          f: 2449334,
        },
        {
          t: '92S',
          r: 0,
          c: '/v1/crop/w_92,h_92,x_0,y_10,scl_0.086710650329877,q_70,strp/<prettyName>-92s.jpg',
          h: 92,
          w: 92,
          ss: [
            {
              x: 2,
              c: '/v1/crop/w_184,h_184,x_0,y_19,scl_0.17342130065975,q_70,strp/<prettyName>-92s-2x.jpg',
            },
          ],
        },
      ],
    },
  },
  {
    deviationId: 866469382,
    type: 'image',
    typeId: 1,
    url: 'https://www.deviantart.com/arthurhenri/art/Northern-Lights-866469382',
    title: 'Northern Lights',
    isJournal: false,
    isVideo: false,
    isPurchasable: false,
    isFavouritable: true,
    publishedTime: '2021-01-08T06:57:59-0800',
    isTextEditable: false,
    isBackgroundEditable: false,
    legacyTextEditUrl: null,
    isShareable: true,
    isCommentable: true,
    isFavourited: true,
    isDeleted: false,
    isMature: false,
    isNsfg: false,
    isDownloadable: false,
    isAntisocial: false,
    isBlocked: false,
    isPublished: true,
    isDailyDeviation: false,
    hasPrivateComments: false,
    isDreamsofart: false,
    isAiUseDisallowed: true,
    blockReasons: [],
    author: {
      userId: 31318401,
      useridUuid: '5ce79a6a-19ed-4c4f-946a-ca8ab3f77e37',
      username: 'ArthurHenri',
      usericon: 'https://a.deviantart.net/avatars-big/a/r/arthurhenri.jpg',
      type: 'regular',
      isWatching: true,
      isSubscribed: false,
      isNewDeviant: false,
    },
    stats: {
      comments: 11,
      favourites: 367,
      views: 25730,
      downloads: 0,
    },
    media: {
      baseUri:
        'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/5ce79a6a-19ed-4c4f-946a-ca8ab3f77e37/debvg1y-43cd645f-e53f-4641-a45f-54dde7bb81d6.jpg',
      prettyName: 'northern_lights_by_arthurhenri_debvg1y',
      token: [
        'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7ImhlaWdodCI6Ijw9MTEyNSIsInBhdGgiOiJcL2ZcLzVjZTc5YTZhLTE5ZWQtNGM0Zi05NDZhLWNhOGFiM2Y3N2UzN1wvZGVidmcxeS00M2NkNjQ1Zi1lNTNmLTQ2NDEtYTQ1Zi01NGRkZTdiYjgxZDYuanBnIiwid2lkdGgiOiI8PTkwMCJ9XV0sImF1ZCI6WyJ1cm46c2VydmljZTppbWFnZS5vcGVyYXRpb25zIl19.1lVtk3h7vHiEkFlyxmv9gec4grgBfe0iFWo8CPrERuA',
      ],
      types: [
        {
          t: '150',
          r: 0,
          c: '/v1/fit/w_150,h_150,q_70,strp/<prettyName>-150.jpg',
          h: 150,
          w: 120,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_300,h_300,q_70,strp/<prettyName>-150-2x.jpg',
            },
          ],
        },
        {
          t: '200H',
          r: 0,
          c: '/v1/fill/w_160,h_200,q_70,strp/<prettyName>-200h.jpg',
          h: 200,
          w: 160,
          ss: [
            {
              x: 2,
              c: '/v1/fill/w_320,h_400,q_70,strp/<prettyName>-200h-2x.jpg',
            },
          ],
        },
        {
          t: '300W',
          r: 0,
          c: '/v1/fit/w_300,h_900,q_70,strp/<prettyName>-300w.jpg',
          h: 375,
          w: 300,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_600,h_1125,q_70,strp/<prettyName>-300w-2x.jpg',
            },
          ],
        },
        {
          t: '375W',
          r: 0,
          c: '/v1/fit/w_375,h_469,q_70,strp/<prettyName>-375w.jpg',
          h: 469,
          w: 375,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_750,h_938,q_70,strp/<prettyName>-375w-2x.jpg',
            },
          ],
        },
        {
          t: '414W',
          r: 0,
          c: '/v1/fit/w_414,h_518,q_70,strp/<prettyName>-414w.jpg',
          h: 518,
          w: 414,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_828,h_1036,q_70,strp/<prettyName>-414w-2x.jpg',
            },
          ],
        },
        {
          t: '250T',
          r: 0,
          c: '/v1/fill/w_200,h_250,q_70,strp/<prettyName>-250t.jpg',
          h: 250,
          w: 200,
          ss: [
            {
              x: 2,
              c: '/v1/fill/w_400,h_500,q_70,strp/<prettyName>-250t-2x.jpg',
            },
          ],
        },
        {
          t: '350T',
          r: 0,
          c: '/v1/fill/w_280,h_350,q_70,strp/<prettyName>-350t.jpg',
          h: 350,
          w: 280,
          ss: [
            {
              x: 2,
              c: '/v1/fill/w_560,h_700,q_70,strp/<prettyName>-350t-2x.jpg',
            },
          ],
        },
        {
          t: '400T',
          r: 0,
          c: '/v1/fill/w_320,h_400,q_70,strp/<prettyName>-400t.jpg',
          h: 400,
          w: 320,
          ss: [
            {
              x: 2,
              c: '/v1/fill/w_640,h_800,q_70,strp/<prettyName>-400t-2x.jpg',
            },
          ],
        },
        {
          t: 'preview',
          r: 0,
          c: '/v1/fill/w_800,h_1000,q_70,strp/<prettyName>-pre.jpg',
          h: 1000,
          w: 800,
          f: 1103506,
        },
        {
          t: 'social_preview',
          r: 0,
          c: '/v1/fill/w_800,h_1000,q_70,strp/<prettyName>-pre.jpg',
          h: 1000,
          w: 800,
        },
        {
          t: 'fullview',
          r: 0,
          c: '/v1/fill/w_900,h_1125,q_75,strp/<prettyName>-fullview.jpg',
          h: 1125,
          w: 900,
          f: 1103506,
        },
        {
          t: '92S',
          r: 0,
          c: '/v1/crop/w_92,h_92,x_0,y_6,scl_0.085185185185185,q_70,strp/<prettyName>-92s.jpg',
          h: 92,
          w: 92,
          ss: [
            {
              x: 2,
              c: '/v1/crop/w_184,h_184,x_0,y_12,scl_0.17037037037037,q_70,strp/<prettyName>-92s-2x.jpg',
            },
          ],
        },
      ],
    },
  },
  {
    deviationId: 865559038,
    type: 'image',
    typeId: 1,
    url: 'https://www.deviantart.com/grahamtg/art/Shoals-865559038',
    title: 'Shoals',
    isJournal: false,
    isVideo: false,
    isPurchasable: false,
    isFavouritable: true,
    publishedTime: '2020-12-30T07:51:00-0800',
    isTextEditable: false,
    isBackgroundEditable: false,
    legacyTextEditUrl: null,
    isShareable: true,
    isCommentable: true,
    isFavourited: true,
    isDeleted: false,
    isMature: false,
    isNsfg: false,
    isDownloadable: true,
    isAntisocial: false,
    isBlocked: false,
    isPublished: true,
    isDailyDeviation: false,
    hasPrivateComments: false,
    isDreamsofart: false,
    isAiUseDisallowed: true,
    blockReasons: [],
    author: {
      userId: 10531290,
      useridUuid: 'd1b51f5e-5c08-4dee-ba8f-3e5b0930796f',
      username: 'GrahamTG',
      usericon: 'https://a.deviantart.net/avatars-big/g/r/grahamtg.png?5',
      type: 'regular',
      isWatching: false,
      isSubscribed: false,
      isNewDeviant: false,
    },
    stats: {
      comments: 21,
      favourites: 306,
      views: 5378,
      downloads: 71,
    },
    media: {
      baseUri:
        'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/d1b51f5e-5c08-4dee-ba8f-3e5b0930796f/debbxmm-cb8ed161-3523-477d-99ef-69a02ce25004.jpg',
      prettyName: 'shoals_by_grahamtg_debbxmm',
      token: [
        'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7ImhlaWdodCI6Ijw9MzUwOCIsInBhdGgiOiJcL2ZcL2QxYjUxZjVlLTVjMDgtNGRlZS1iYThmLTNlNWIwOTMwNzk2ZlwvZGViYnhtbS1jYjhlZDE2MS0zNTIzLTQ3N2QtOTllZi02OWEwMmNlMjUwMDQuanBnIiwid2lkdGgiOiI8PTI0ODAifV1dLCJhdWQiOlsidXJuOnNlcnZpY2U6aW1hZ2Uub3BlcmF0aW9ucyJdfQ.AjPc14-Bpig9Td5jzSppv1CeOfC-SNmwcW-ItIWOSpA',
        'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7InBhdGgiOiJcL2ZcL2QxYjUxZjVlLTVjMDgtNGRlZS1iYThmLTNlNWIwOTMwNzk2ZlwvZGViYnhtbS1jYjhlZDE2MS0zNTIzLTQ3N2QtOTllZi02OWEwMmNlMjUwMDQuanBnIn1dXSwiYXVkIjpbInVybjpzZXJ2aWNlOmZpbGUuZG93bmxvYWQiXX0.aD-VAT6ME0ZpGRMM09npKrVeTFJm1jEaUvTWPiQlTuQ',
      ],
      types: [
        {
          t: '150',
          r: 0,
          c: '/v1/fit/w_150,h_150,q_70,strp/<prettyName>-150.jpg',
          h: 150,
          w: 106,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_300,h_300,q_70,strp/<prettyName>-150-2x.jpg',
            },
          ],
        },
        {
          t: '200H',
          r: 0,
          c: '/v1/crop/w_141,h_200,x_0,y_0,scl_0.057258064516129,q_70,strp/<prettyName>-200h.jpg',
          h: 200,
          w: 141,
          ss: [
            {
              x: 2,
              c: '/v1/fill/w_283,h_400,q_70,strp/<prettyName>-200h-2x.jpg',
            },
          ],
        },
        {
          t: '300W',
          r: 0,
          c: '/v1/fit/w_300,h_900,q_70,strp/<prettyName>-300w.jpg',
          h: 424,
          w: 300,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_600,h_1800,q_70,strp/<prettyName>-300w-2x.jpg',
            },
          ],
        },
        {
          t: '375W',
          r: 0,
          c: '/v1/fit/w_375,h_530,q_70,strp/<prettyName>-375w.jpg',
          h: 530,
          w: 375,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_750,h_1060,q_70,strp/<prettyName>-375w-2x.jpg',
            },
          ],
        },
        {
          t: '414W',
          r: 0,
          c: '/v1/fit/w_414,h_586,q_70,strp/<prettyName>-414w.jpg',
          h: 586,
          w: 414,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_828,h_1172,q_70,strp/<prettyName>-414w-2x.jpg',
            },
          ],
        },
        {
          t: '250T',
          r: 0,
          c: '/v1/fill/w_177,h_250,q_70,strp/<prettyName>-250t.jpg',
          h: 250,
          w: 177,
          ss: [
            {
              x: 2,
              c: '/v1/crop/w_353,h_500,x_0,y_0,scl_0.14274193548387,q_70,strp/<prettyName>-250t-2x.jpg',
            },
          ],
        },
        {
          t: '350T',
          r: 0,
          c: '/v1/crop/w_247,h_350,x_0,y_0,scl_0.1,q_70,strp/<prettyName>-350t.jpg',
          h: 350,
          w: 247,
          ss: [
            {
              x: 2,
              c: '/v1/fill/w_495,h_700,q_70,strp/<prettyName>-350t-2x.jpg',
            },
          ],
        },
        {
          t: '400T',
          r: 0,
          c: '/v1/fill/w_283,h_400,q_70,strp/<prettyName>-400t.jpg',
          h: 400,
          w: 283,
          ss: [
            {
              x: 2,
              c: '/v1/crop/w_566,h_800,x_0,y_0,scl_0.22822580645161,q_70,strp/<prettyName>-400t-2x.jpg',
            },
          ],
        },
        {
          t: 'preview',
          r: 0,
          c: '/v1/fill/w_752,h_1063,q_70,strp/<prettyName>-pre.jpg',
          h: 1063,
          w: 752,
          f: 7933234,
        },
        {
          t: 'social_preview',
          r: 0,
          c: '/v1/fill/w_752,h_1063,q_70,strp/<prettyName>-pre.jpg',
          h: 1063,
          w: 752,
        },
        {
          t: 'fullview',
          r: 1,
          h: 3508,
          w: 2480,
          f: 7933234,
        },
        {
          t: '92S',
          r: 0,
          c: '/v1/crop/w_92,h_92,x_0,y_10,scl_0.037096774193548,q_70,strp/<prettyName>-92s.jpg',
          h: 92,
          w: 92,
          ss: [
            {
              x: 2,
              c: '/v1/crop/w_184,h_184,x_0,y_19,scl_0.074193548387097,q_70,strp/<prettyName>-92s-2x.jpg',
            },
          ],
        },
      ],
    },
  },
  {
    deviationId: 864738392,
    type: 'image',
    typeId: 1,
    url: 'https://www.deviantart.com/schwartz-design/art/Happy-Holidays-864738392',
    title: 'Happy Holidays',
    isJournal: false,
    isVideo: false,
    isPurchasable: false,
    isFavouritable: true,
    publishedTime: '2020-12-21T13:35:55-0800',
    isTextEditable: false,
    isBackgroundEditable: false,
    legacyTextEditUrl: null,
    isShareable: true,
    isCommentable: true,
    isFavourited: true,
    isDeleted: false,
    isMature: false,
    isNsfg: false,
    isDownloadable: false,
    isAntisocial: false,
    isBlocked: false,
    isPublished: true,
    isDailyDeviation: false,
    hasPrivateComments: false,
    isDreamsofart: false,
    isAiUseDisallowed: true,
    blockReasons: [],
    author: {
      userId: 58825047,
      useridUuid: '75c52da7-cad1-4f99-a964-53930f65c1e6',
      username: 'Schwartz-Design',
      usericon: 'https://a.deviantart.net/avatars-big/s/c/schwartz-design.png?2',
      type: 'regular',
      isWatching: false,
      isSubscribed: false,
      isNewDeviant: false,
    },
    stats: {
      comments: 6,
      favourites: 164,
      views: 2985,
      downloads: 0,
    },
    media: {
      baseUri:
        'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/75c52da7-cad1-4f99-a964-53930f65c1e6/deaucew-fd2c056e-81ee-46d4-9969-afcc4323c6c5.jpg',
      prettyName: 'happy_holidays_by_schwartz_design_deaucew',
      token: [
        'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7ImhlaWdodCI6Ijw9MTIzNCIsInBhdGgiOiJcL2ZcLzc1YzUyZGE3LWNhZDEtNGY5OS1hOTY0LTUzOTMwZjY1YzFlNlwvZGVhdWNldy1mZDJjMDU2ZS04MWVlLTQ2ZDQtOTk2OS1hZmNjNDMyM2M2YzUuanBnIiwid2lkdGgiOiI8PTgyNyJ9XV0sImF1ZCI6WyJ1cm46c2VydmljZTppbWFnZS5vcGVyYXRpb25zIl19.B13tB3R27x6xbZtPdBl-09rsdiGbXeP18Nj4sJacV84',
        'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7InBhdGgiOiJcL2ZcLzc1YzUyZGE3LWNhZDEtNGY5OS1hOTY0LTUzOTMwZjY1YzFlNlwvZGVhdWNldy1mZDJjMDU2ZS04MWVlLTQ2ZDQtOTk2OS1hZmNjNDMyM2M2YzUuanBnIn1dXSwiYXVkIjpbInVybjpzZXJ2aWNlOmZpbGUuZG93bmxvYWQiXX0.xFR_M4I0Mz-Nlw3dg5bZV6mcxNR-uD8iFPPFsCuhUK0',
      ],
      types: [
        {
          t: '150',
          r: 0,
          c: '/v1/fit/w_150,h_150,q_70,strp/<prettyName>-150.jpg',
          h: 150,
          w: 101,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_300,h_300,q_70,strp/<prettyName>-150-2x.jpg',
            },
          ],
        },
        {
          t: '200H',
          r: 0,
          c: '/v1/fill/w_134,h_200,q_70,strp/<prettyName>-200h.jpg',
          h: 200,
          w: 134,
          ss: [
            {
              x: 2,
              c: '/v1/fill/w_268,h_400,q_70,strp/<prettyName>-200h-2x.jpg',
            },
          ],
        },
        {
          t: '300W',
          r: 0,
          c: '/v1/fit/w_300,h_900,q_70,strp/<prettyName>-300w.jpg',
          h: 448,
          w: 300,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_600,h_1234,q_70,strp/<prettyName>-300w-2x.jpg',
            },
          ],
        },
        {
          t: '375W',
          r: 0,
          c: '/v1/fit/w_375,h_560,q_70,strp/<prettyName>-375w.jpg',
          h: 560,
          w: 375,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_750,h_1120,q_70,strp/<prettyName>-375w-2x.jpg',
            },
          ],
        },
        {
          t: '414W',
          r: 0,
          c: '/v1/fit/w_414,h_618,q_70,strp/<prettyName>-414w.jpg',
          h: 618,
          w: 414,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_827,h_1234,q_70,strp/<prettyName>-414w-2x.jpg',
            },
          ],
        },
        {
          t: '250T',
          r: 0,
          c: '/v1/crop/w_168,h_250,x_0,y_0,scl_0.20314389359129,q_70,strp/<prettyName>-250t.jpg',
          h: 250,
          w: 168,
          ss: [
            {
              x: 2,
              c: '/v1/fill/w_335,h_500,q_70,strp/<prettyName>-250t-2x.jpg',
            },
          ],
        },
        {
          t: '350T',
          r: 0,
          c: '/v1/crop/w_235,h_350,x_0,y_0,scl_0.28415961305925,q_70,strp/<prettyName>-350t.jpg',
          h: 350,
          w: 235,
          ss: [
            {
              x: 2,
              c: '/v1/fill/w_469,h_700,q_70,strp/<prettyName>-350t-2x.jpg',
            },
          ],
        },
        {
          t: '400T',
          r: 0,
          c: '/v1/fill/w_268,h_400,q_70,strp/<prettyName>-400t.jpg',
          h: 400,
          w: 268,
          ss: [
            {
              x: 2,
              c: '/v1/fill/w_536,h_800,q_70,strp/<prettyName>-400t-2x.jpg',
            },
          ],
        },
        {
          t: 'preview',
          r: 0,
          c: '/v1/fill/w_732,h_1092,q_70,strp/<prettyName>-pre.jpg',
          h: 1092,
          w: 732,
          f: 786393,
        },
        {
          t: 'social_preview',
          r: 0,
          c: '/v1/fill/w_732,h_1092,q_70,strp/<prettyName>-pre.jpg',
          h: 1092,
          w: 732,
        },
        {
          t: 'fullview',
          r: 1,
          h: 1234,
          w: 827,
          f: 786393,
        },
        {
          t: '92S',
          r: 0,
          c: '/v1/crop/w_92,h_92,x_0,y_11,scl_0.11124546553809,q_70,strp/<prettyName>-92s.jpg',
          h: 92,
          w: 92,
          ss: [
            {
              x: 2,
              c: '/v1/crop/w_184,h_184,x_0,y_23,scl_0.22249093107618,q_70,strp/<prettyName>-92s-2x.jpg',
            },
          ],
        },
      ],
    },
  },
  {
    deviationId: 864355160,
    type: 'image',
    typeId: 1,
    url: 'https://www.deviantart.com/moussee/art/Yearning-864355160',
    title: 'Yearning',
    isJournal: false,
    isVideo: false,
    isPurchasable: false,
    isFavouritable: true,
    publishedTime: '2020-12-17T12:31:45-0800',
    isTextEditable: false,
    isBackgroundEditable: false,
    legacyTextEditUrl: null,
    isShareable: true,
    isCommentable: true,
    isFavourited: true,
    isDeleted: false,
    isMature: false,
    isNsfg: false,
    isDownloadable: false,
    isAntisocial: false,
    isBlocked: false,
    isPublished: true,
    isDailyDeviation: false,
    hasPrivateComments: false,
    isDreamsofart: false,
    isAiUseDisallowed: true,
    blockReasons: [],
    author: {
      userId: 8386333,
      useridUuid: '2d435f80-afd5-4469-b274-15674539c176',
      username: 'moussee',
      usericon: 'https://a.deviantart.net/avatars-big/m/o/moussee.jpg',
      type: 'core_access',
      isWatching: true,
      isSubscribed: false,
      isNewDeviant: false,
    },
    stats: {
      comments: 13,
      favourites: 112,
      views: 1477,
      downloads: 0,
    },
    media: {
      baseUri:
        'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/2d435f80-afd5-4469-b274-15674539c176/deam4pk-5aa3f1ad-2f70-4b92-b8d6-0fa26e0a7f60.jpg',
      prettyName: 'yearning_by_moussee_deam4pk',
      token: [
        'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7ImhlaWdodCI6Ijw9NjAwIiwicGF0aCI6IlwvZlwvMmQ0MzVmODAtYWZkNS00NDY5LWIyNzQtMTU2NzQ1MzljMTc2XC9kZWFtNHBrLTVhYTNmMWFkLTJmNzAtNGI5Mi1iOGQ2LTBmYTI2ZTBhN2Y2MC5qcGciLCJ3aWR0aCI6Ijw9NDMyIn1dXSwiYXVkIjpbInVybjpzZXJ2aWNlOmltYWdlLm9wZXJhdGlvbnMiXX0.ziYJs5MqF0WBZJ129tlUrprS_6SZCaxJFwyrx1CiZ58',
        'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7InBhdGgiOiJcL2ZcLzJkNDM1ZjgwLWFmZDUtNDQ2OS1iMjc0LTE1Njc0NTM5YzE3NlwvZGVhbTRway01YWEzZjFhZC0yZjcwLTRiOTItYjhkNi0wZmEyNmUwYTdmNjAuanBnIn1dXSwiYXVkIjpbInVybjpzZXJ2aWNlOmZpbGUuZG93bmxvYWQiXX0.54ecZXYyiwfSghNShoqCo_GB0ew7q7ASUYGDQBTiOYM',
      ],
      types: [
        {
          t: '150',
          r: 0,
          c: '/v1/fit/w_150,h_150,q_70,strp/<prettyName>-150.jpg',
          h: 150,
          w: 108,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_300,h_300,q_70,strp/<prettyName>-150-2x.jpg',
            },
          ],
        },
        {
          t: '200H',
          r: 0,
          c: '/v1/fill/w_144,h_200,q_70,strp/<prettyName>-200h.jpg',
          h: 200,
          w: 144,
          ss: [
            {
              x: 2,
              c: '/v1/fill/w_288,h_400,q_70,strp/<prettyName>-200h-2x.jpg',
            },
          ],
        },
        {
          t: '300W',
          r: 0,
          c: '/v1/fit/w_300,h_600,q_70,strp/<prettyName>-300w.jpg',
          h: 417,
          w: 300,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_432,h_600,q_70,strp/<prettyName>-300w-2x.jpg',
            },
          ],
        },
        {
          t: '375W',
          r: 0,
          c: '/v1/fit/w_375,h_521,q_70,strp/<prettyName>-375w.jpg',
          h: 521,
          w: 375,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_432,h_600,q_70,strp/<prettyName>-375w-2x.jpg',
            },
          ],
        },
        {
          t: '414W',
          r: 0,
          c: '/v1/fit/w_414,h_575,q_70,strp/<prettyName>-414w.jpg',
          h: 575,
          w: 414,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_432,h_600,q_70,strp/<prettyName>-414w-2x.jpg',
            },
          ],
        },
        {
          t: '250T',
          r: 0,
          c: '/v1/fill/w_180,h_250,q_70,strp/<prettyName>-250t.jpg',
          h: 250,
          w: 180,
          ss: [
            {
              x: 2,
              c: '/v1/fill/w_360,h_500,q_70,strp/<prettyName>-250t-2x.jpg',
            },
          ],
        },
        {
          t: '350T',
          r: 0,
          c: '/v1/fill/w_252,h_350,q_70,strp/<prettyName>-350t.jpg',
          h: 350,
          w: 252,
          ss: [
            {
              x: 2,
              c: '/v1/fill/w_432,h_600,q_70,strp/<prettyName>-350t-2x.jpg',
            },
          ],
        },
        {
          t: '400T',
          r: 0,
          c: '/v1/fill/w_288,h_400,q_70,strp/<prettyName>-400t.jpg',
          h: 400,
          w: 288,
          ss: [
            {
              x: 2,
              c: '/v1/fill/w_432,h_600,q_70,strp/<prettyName>-400t-2x.jpg',
            },
          ],
        },
        {
          t: 'preview',
          r: 0,
          c: '/v1/fill/w_432,h_600,q_75,strp/<prettyName>-fullview.jpg',
          h: 600,
          w: 432,
          f: 141674,
        },
        {
          t: 'social_preview',
          r: 0,
          c: '/v1/fill/w_432,h_600,q_75,strp/<prettyName>-fullview.jpg',
          h: 600,
          w: 432,
        },
        {
          t: 'fullview',
          r: 1,
          h: 600,
          w: 432,
          f: 141674,
        },
        {
          t: '92S',
          r: 0,
          c: '/v1/crop/w_92,h_92,x_0,y_9,scl_0.21296296296296,q_70,strp/<prettyName>-92s.jpg',
          h: 92,
          w: 92,
          ss: [
            {
              x: 2,
              c: '/v1/crop/w_184,h_184,x_0,y_18,scl_0.42592592592593,q_70,strp/<prettyName>-92s-2x.jpg',
            },
          ],
        },
      ],
    },
  },
  {
    deviationId: 29379001,
    type: 'image',
    typeId: 1,
    url: 'https://www.deviantart.com/zilla774/art/Stamp-Template-29379001',
    title: 'Stamp Template',
    isJournal: false,
    isVideo: false,
    isPurchasable: false,
    isFavouritable: true,
    publishedTime: '2006-02-21T02:44:27-0800',
    isTextEditable: false,
    isBackgroundEditable: false,
    legacyTextEditUrl: null,
    isShareable: false,
    isCommentable: true,
    isFavourited: true,
    isDeleted: false,
    isMature: false,
    isNsfg: false,
    isDownloadable: true,
    isAntisocial: false,
    isBlocked: false,
    isPublished: true,
    isDailyDeviation: false,
    hasPrivateComments: false,
    isAiUseDisallowed: true,
    blockReasons: [],
    author: {
      userId: 407544,
      useridUuid: '6f2db594-1a76-45ca-8d5b-4bba71021c9b',
      username: 'zilla774',
      usericon: 'https://a.deviantart.net/avatars-big/z/i/zilla774.png?6',
      type: 'admin',
      isWatching: false,
      isSubscribed: false,
      isNewDeviant: false,
    },
    stats: {
      comments: 2648,
      favourites: 11426,
      views: 469122,
      downloads: 109175,
    },
    media: {
      baseUri:
        'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/i/6f2db594-1a76-45ca-8d5b-4bba71021c9b/dhhozd-2ca0bbd4-0603-49f8-a24a-c15fb0ffe479.gif',
      types: [
        {
          t: '150',
          r: -1,
          h: 56,
          w: 99,
          o: true,
        },
        {
          t: '200H',
          r: -1,
          h: 56,
          w: 99,
          o: true,
        },
        {
          t: '300W',
          r: -1,
          h: 56,
          w: 99,
          o: true,
        },
        {
          t: '375W',
          r: -1,
          h: 56,
          w: 99,
          o: true,
        },
        {
          t: '414W',
          r: -1,
          h: 56,
          w: 99,
          o: true,
        },
        {
          t: '250T',
          r: -1,
          h: 56,
          w: 99,
          o: true,
        },
        {
          t: '350T',
          r: -1,
          h: 56,
          w: 99,
          o: true,
        },
        {
          t: '400T',
          r: -1,
          h: 56,
          w: 99,
          o: true,
        },
        {
          t: 'preview',
          r: -1,
          h: 56,
          w: 99,
          o: true,
          f: 3997,
        },
        {
          t: 'social_preview',
          r: -1,
          h: 56,
          w: 99,
          o: true,
        },
        {
          t: 'fullview',
          r: -1,
          h: 56,
          w: 99,
          o: true,
          f: 3997,
        },
      ],
    },
  },
  {
    deviationId: 863942558,
    type: 'image',
    typeId: 1,
    url: 'https://www.deviantart.com/rgpc/art/Sevastopol-863942558',
    title: 'Sevastopol',
    isJournal: false,
    isVideo: false,
    isPurchasable: false,
    isFavouritable: true,
    publishedTime: '2020-12-13T05:04:12-0800',
    isTextEditable: false,
    isBackgroundEditable: false,
    legacyTextEditUrl: null,
    isShareable: true,
    isCommentable: true,
    isFavourited: true,
    isDeleted: false,
    isMature: false,
    isNsfg: false,
    isDownloadable: false,
    isAntisocial: false,
    isBlocked: false,
    isPublished: true,
    isDailyDeviation: false,
    hasPrivateComments: false,
    isDreamsofart: false,
    isAiUseDisallowed: true,
    blockReasons: [],
    author: {
      userId: 44678339,
      useridUuid: 'deb9b22d-e03e-4dd4-b706-969efca8fec4',
      username: 'RGPC',
      usericon: 'https://a.deviantart.net/avatars-big/r/g/rgpc.jpg?4',
      type: 'regular',
      isWatching: true,
      isSubscribed: false,
      isNewDeviant: false,
    },
    stats: {
      comments: 2,
      favourites: 75,
      views: 2142,
      downloads: 0,
    },
    media: {
      baseUri:
        'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/deb9b22d-e03e-4dd4-b706-969efca8fec4/deadace-290f41ed-7d6a-4214-8d3b-ea9591b3e268.jpg',
      prettyName: 'sevastopol_by_rgpc_deadace',
      token: [
        'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7InBhdGgiOiJcL2ZcL2RlYjliMjJkLWUwM2UtNGRkNC1iNzA2LTk2OWVmY2E4ZmVjNFwvZGVhZGFjZS0yOTBmNDFlZC03ZDZhLTQyMTQtOGQzYi1lYTk1OTFiM2UyNjguanBnIiwiaGVpZ2h0IjoiPD0xNDQ5Iiwid2lkdGgiOiI8PTEwMjQifV1dLCJhdWQiOlsidXJuOnNlcnZpY2U6aW1hZ2Uud2F0ZXJtYXJrIl0sIndtayI6eyJwYXRoIjoiXC93bVwvZGViOWIyMmQtZTAzZS00ZGQ0LWI3MDYtOTY5ZWZjYThmZWM0XC9yZ3BjLTQucG5nIiwib3BhY2l0eSI6OTUsInByb3BvcnRpb25zIjowLjQ1LCJncmF2aXR5IjoiY2VudGVyIn19.mnE8tJyQjr3z2J2WnO6KAEwDVbh6JM5U-FZeZIuD8vQ',
      ],
      types: [
        {
          t: '150',
          r: 0,
          c: '/v1/fit/w_150,h_150,q_70,strp/<prettyName>-150.jpg',
          h: 150,
          w: 106,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_300,h_300,q_70,strp/<prettyName>-150-2x.jpg',
            },
          ],
        },
        {
          t: '200H',
          r: 0,
          c: '/v1/crop/w_141,h_200,x_0,y_0,scl_0.078453038674033,q_70,strp/<prettyName>-200h.jpg',
          h: 200,
          w: 141,
          ss: [
            {
              x: 2,
              c: '/v1/fill/w_283,h_400,q_70,strp/<prettyName>-200h-2x.jpg',
            },
          ],
        },
        {
          t: '300W',
          r: 0,
          c: '/v1/fit/w_300,h_900,q_70,strp/<prettyName>-300w.jpg',
          h: 425,
          w: 300,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_600,h_1449,q_70,strp/<prettyName>-300w-2x.jpg',
            },
          ],
        },
        {
          t: '375W',
          r: 0,
          c: '/v1/fit/w_375,h_531,q_70,strp/<prettyName>-375w.jpg',
          h: 531,
          w: 375,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_750,h_1062,q_70,strp/<prettyName>-375w-2x.jpg',
            },
          ],
        },
        {
          t: '414W',
          r: 0,
          c: '/v1/fit/w_414,h_586,q_70,strp/<prettyName>-414w.jpg',
          h: 586,
          w: 414,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_828,h_1172,q_70,strp/<prettyName>-414w-2x.jpg',
            },
          ],
        },
        {
          t: '250T',
          r: 0,
          c: '/v1/fill/w_177,h_250,q_70,strp/<prettyName>-250t.jpg',
          h: 250,
          w: 177,
          ss: [
            {
              x: 2,
              c: '/v1/crop/w_354,h_500,x_0,y_0,scl_0.19558011049724,q_70,strp/<prettyName>-250t-2x.jpg',
            },
          ],
        },
        {
          t: '350T',
          r: 0,
          c: '/v1/crop/w_247,h_350,x_0,y_0,scl_0.13701657458564,q_70,strp/<prettyName>-350t.jpg',
          h: 350,
          w: 247,
          ss: [
            {
              x: 2,
              c: '/v1/fill/w_495,h_700,q_70,strp/<prettyName>-350t-2x.jpg',
            },
          ],
        },
        {
          t: '400T',
          r: 0,
          c: '/v1/fill/w_283,h_400,q_70,strp/<prettyName>-400t.jpg',
          h: 400,
          w: 283,
          ss: [
            {
              x: 2,
              c: '/v1/crop/w_566,h_800,x_0,y_0,scl_0.31270718232044,q_70,strp/<prettyName>-400t-2x.jpg',
            },
          ],
        },
        {
          t: 'preview',
          r: 0,
          c: '/v1/fill/w_751,h_1063,q_70,strp/<prettyName>-pre.jpg',
          h: 1063,
          w: 751,
          f: 2610133,
        },
        {
          t: 'social_preview',
          r: 0,
          c: '/v1/fill/w_751,h_1063,q_70,strp/<prettyName>-pre.jpg',
          h: 1063,
          w: 751,
        },
        {
          t: 'fullview',
          r: 0,
          c: '/v1/fill/w_1024,h_1449,q_75,strp/<prettyName>-fullview.jpg',
          h: 1449,
          w: 1024,
          f: 2610133,
        },
        {
          t: '92S',
          r: 0,
          c: '/v1/crop/w_92,h_92,x_0,y_10,scl_0.050828729281768,q_70,strp/<prettyName>-92s.jpg',
          h: 92,
          w: 92,
          ss: [
            {
              x: 2,
              c: '/v1/crop/w_184,h_184,x_0,y_19,scl_0.10165745856354,q_70,strp/<prettyName>-92s-2x.jpg',
            },
          ],
        },
      ],
    },
  },
  {
    deviationId: 863023908,
    type: 'image',
    typeId: 1,
    url: 'https://www.deviantart.com/patvit/art/Arisa-s-Tale-Environment-Process-863023908',
    title: "Arisa's Tale Environment Process",
    isJournal: false,
    isVideo: false,
    isGif: true,
    isPurchasable: false,
    isFavouritable: true,
    publishedTime: '2020-12-03T12:08:18-0800',
    isTextEditable: false,
    isBackgroundEditable: false,
    legacyTextEditUrl: null,
    isShareable: true,
    isCommentable: true,
    isFavourited: true,
    isDeleted: false,
    isMature: false,
    isNsfg: false,
    isDownloadable: true,
    isAntisocial: false,
    isBlocked: false,
    isPublished: true,
    isDailyDeviation: false,
    hasPrivateComments: false,
    isDreamsofart: false,
    isAiUseDisallowed: true,
    blockReasons: [],
    author: {
      userId: 14072475,
      useridUuid: '0a0d2127-67f5-4425-b9f3-a8a6dea6ee3f',
      username: 'PATVIT',
      usericon: 'https://a.deviantart.net/avatars-big/p/a/patvit.jpg?1',
      type: 'regular',
      isWatching: true,
      isSubscribed: false,
      isNewDeviant: false,
    },
    stats: {
      comments: 6,
      favourites: 216,
      views: 6672,
      downloads: 18,
    },
    media: {
      baseUri:
        'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/0a0d2127-67f5-4425-b9f3-a8a6dea6ee3f/de9tlic-cc757a89-2b99-4680-a3aa-5d03570b81f1.gif',
      prettyName: 'arisa_s_tale_environment_process_by_patvit_de9tlic',
      token: [
        'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7ImhlaWdodCI6Ijw9MTA4MCIsInBhdGgiOiJcL2ZcLzBhMGQyMTI3LTY3ZjUtNDQyNS1iOWYzLWE4YTZkZWE2ZWUzZlwvZGU5dGxpYy1jYzc1N2E4OS0yYjk5LTQ2ODAtYTNhYS01ZDAzNTcwYjgxZjEuZ2lmIiwid2lkdGgiOiI8PTE5MjAifV1dLCJhdWQiOlsidXJuOnNlcnZpY2U6aW1hZ2Uub3BlcmF0aW9ucyJdfQ.QDRoWyzz8pmxSN8QoGLspPsZsjJotvV7eQ0DuQejQD4',
        'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7InBhdGgiOiJcL2ZcLzBhMGQyMTI3LTY3ZjUtNDQyNS1iOWYzLWE4YTZkZWE2ZWUzZlwvZGU5dGxpYy1jYzc1N2E4OS0yYjk5LTQ2ODAtYTNhYS01ZDAzNTcwYjgxZjEuZ2lmIn1dXSwiYXVkIjpbInVybjpzZXJ2aWNlOmZpbGUuZG93bmxvYWQiXX0.ohRleO4HKvPWXd3Co_eF-yv77bI93mTKEP7w_HwjU34',
      ],
      types: [
        {
          t: '150',
          r: 0,
          c: '/v1/fit/w_150,h_150,q_85,strp/<prettyName>-150.jpg',
          h: 84,
          w: 150,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_300,h_300,q_85,strp/<prettyName>-150-2x.jpg',
            },
          ],
        },
        {
          t: '200H',
          r: 0,
          c: '/v1/fill/w_300,h_169,q_85,strp/<prettyName>-200h.jpg',
          h: 169,
          w: 300,
          ss: [
            {
              x: 2,
              c: '/v1/fill/w_600,h_338,q_85,strp/<prettyName>-200h-2x.jpg',
            },
          ],
        },
        {
          t: '300W',
          r: 0,
          c: '/v1/fit/w_300,h_900,q_85,strp/<prettyName>-300w.jpg',
          h: 169,
          w: 300,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_600,h_1080,q_85,strp/<prettyName>-300w-2x.jpg',
            },
          ],
        },
        {
          t: '375W',
          r: 0,
          c: '/v1/fit/w_375,h_211,q_85,strp/<prettyName>-375w.jpg',
          h: 211,
          w: 375,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_750,h_422,q_85,strp/<prettyName>-375w-2x.jpg',
            },
          ],
        },
        {
          t: '414W',
          r: 0,
          c: '/v1/fit/w_414,h_233,q_85,strp/<prettyName>-414w.jpg',
          h: 233,
          w: 414,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_828,h_466,q_85,strp/<prettyName>-414w-2x.jpg',
            },
          ],
        },
        {
          t: '250T',
          r: 0,
          c: '/v1/fill/w_444,h_250,q_85,strp/<prettyName>-250t.jpg',
          h: 250,
          w: 444,
          ss: [
            {
              x: 2,
              c: '/v1/fill/w_889,h_500,q_85,strp/<prettyName>-250t-2x.jpg',
            },
          ],
        },
        {
          t: '350T',
          r: 0,
          c: '/v1/fill/w_622,h_350,q_85,strp/<prettyName>-350t.jpg',
          h: 350,
          w: 622,
          ss: [
            {
              x: 2,
              c: '/v1/fill/w_1244,h_700,q_85,strp/<prettyName>-350t-2x.jpg',
            },
          ],
        },
        {
          t: '400T',
          r: 0,
          c: '/v1/fill/w_711,h_400,q_85,strp/<prettyName>-400t.jpg',
          h: 400,
          w: 711,
          ss: [
            {
              x: 2,
              c: '/v1/fill/w_1422,h_800,q_85,strp/<prettyName>-400t-2x.jpg',
            },
          ],
        },
        {
          t: 'preview',
          r: 0,
          c: '/v1/fill/w_1192,h_670,q_85,strp/<prettyName>-pre.jpg',
          h: 670,
          w: 1192,
          f: 4876609,
        },
        {
          t: 'social_preview',
          r: 0,
          c: '/v1/fill/w_1192,h_670,q_85,strp/<prettyName>-pre.jpg',
          h: 670,
          w: 1192,
        },
        {
          t: 'fullview',
          r: 1,
          h: 1080,
          w: 1920,
          f: 4876609,
        },
        {
          t: '92S',
          r: 0,
          c: '/v1/crop/w_92,h_92,x_18,y_0,scl_0.085185185185185,q_85,strp/<prettyName>-92s.jpg',
          h: 92,
          w: 92,
          ss: [
            {
              x: 2,
              c: '/v1/crop/w_184,h_184,x_36,y_0,scl_0.17037037037037,q_85,strp/<prettyName>-92s-2x.jpg',
            },
          ],
        },
      ],
    },
  },
  {
    deviationId: 859790980,
    type: 'image',
    typeId: 1,
    url: 'https://www.deviantart.com/peterhoff3/art/Water-and-Shadow-the-prints-of-Kawase-Hasui-123-859790980',
    title: 'Water and Shadow: the prints of Kawase Hasui 123',
    isJournal: false,
    isVideo: false,
    isPurchasable: false,
    isFavouritable: true,
    publishedTime: '2020-11-29T14:33:06-0800',
    isTextEditable: false,
    isBackgroundEditable: false,
    legacyTextEditUrl: null,
    isShareable: true,
    isCommentable: true,
    isFavourited: true,
    isDeleted: false,
    isMature: false,
    isNsfg: false,
    isDownloadable: true,
    isAntisocial: false,
    isBlocked: false,
    isPublished: true,
    isDailyDeviation: false,
    hasPrivateComments: false,
    isDreamsofart: false,
    isAiUseDisallowed: true,
    blockReasons: [],
    author: {
      userId: 15127446,
      useridUuid: 'd5e0df5b-07a6-4fff-9b78-367a7334e184',
      username: 'Peterhoff3',
      usericon: 'https://a.deviantart.net/avatars-big/p/e/peterhoff3.jpg?4',
      type: 'core_access',
      isWatching: true,
      isSubscribed: false,
      isNewDeviant: false,
    },
    stats: {
      comments: 1,
      favourites: 113,
      views: 1003,
      downloads: 19,
    },
    media: {
      baseUri:
        'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/d5e0df5b-07a6-4fff-9b78-367a7334e184/de7ways-9bc33393-f951-4410-ac83-1736c680d9bf.jpg',
      prettyName: 'water_and_shadow__the_prints_of_kawase_hasui_123_by_peterhoff3_de7ways',
      token: [
        'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7ImhlaWdodCI6Ijw9OTI3IiwicGF0aCI6IlwvZlwvZDVlMGRmNWItMDdhNi00ZmZmLTliNzgtMzY3YTczMzRlMTg0XC9kZTd3YXlzLTliYzMzMzkzLWY5NTEtNDQxMC1hYzgzLTE3MzZjNjgwZDliZi5qcGciLCJ3aWR0aCI6Ijw9MTI4MCJ9XV0sImF1ZCI6WyJ1cm46c2VydmljZTppbWFnZS5vcGVyYXRpb25zIl19.wsL68DyOtz_rMpjW_fK983x1KgXeIDokYdautlKcLhA',
      ],
      types: [
        {
          t: '150',
          r: 0,
          c: '/v1/fit/w_150,h_150,q_70,strp/<prettyName>-150.jpg',
          h: 109,
          w: 150,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_300,h_300,q_70,strp/<prettyName>-150-2x.jpg',
            },
          ],
        },
        {
          t: '200H',
          r: 0,
          c: '/v1/fill/w_276,h_200,q_70,strp/<prettyName>-200h.jpg',
          h: 200,
          w: 276,
          ss: [
            {
              x: 2,
              c: '/v1/fill/w_552,h_400,q_70,strp/<prettyName>-200h-2x.jpg',
            },
          ],
        },
        {
          t: '300W',
          r: 0,
          c: '/v1/fit/w_300,h_900,q_70,strp/<prettyName>-300w.jpg',
          h: 217,
          w: 300,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_600,h_927,q_70,strp/<prettyName>-300w-2x.jpg',
            },
          ],
        },
        {
          t: '375W',
          r: 0,
          c: '/v1/fit/w_375,h_272,q_70,strp/<prettyName>-375w.jpg',
          h: 272,
          w: 375,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_750,h_544,q_70,strp/<prettyName>-375w-2x.jpg',
            },
          ],
        },
        {
          t: '414W',
          r: 0,
          c: '/v1/fit/w_414,h_300,q_70,strp/<prettyName>-414w.jpg',
          h: 300,
          w: 414,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_828,h_600,q_70,strp/<prettyName>-414w-2x.jpg',
            },
          ],
        },
        {
          t: '250T',
          r: 0,
          c: '/v1/fill/w_345,h_250,q_70,strp/<prettyName>-250t.jpg',
          h: 250,
          w: 345,
          ss: [
            {
              x: 2,
              c: '/v1/fill/w_691,h_500,q_70,strp/<prettyName>-250t-2x.jpg',
            },
          ],
        },
        {
          t: '350T',
          r: 0,
          c: '/v1/fill/w_483,h_350,q_70,strp/<prettyName>-350t.jpg',
          h: 350,
          w: 483,
          ss: [
            {
              x: 2,
              c: '/v1/fill/w_967,h_700,q_70,strp/<prettyName>-350t-2x.jpg',
            },
          ],
        },
        {
          t: '400T',
          r: 0,
          c: '/v1/fill/w_552,h_400,q_70,strp/<prettyName>-400t.jpg',
          h: 400,
          w: 552,
          ss: [
            {
              x: 2,
              c: '/v1/fill/w_1105,h_800,q_70,strp/<prettyName>-400t-2x.jpg',
            },
          ],
        },
        {
          t: 'preview',
          r: 0,
          c: '/v1/fill/w_1051,h_761,q_70,strp/<prettyName>-pre.jpg',
          h: 761,
          w: 1051,
          f: 467980,
        },
        {
          t: 'social_preview',
          r: 0,
          c: '/v1/fill/w_1051,h_761,q_70,strp/<prettyName>-pre.jpg',
          h: 761,
          w: 1051,
        },
        {
          t: 'fullview',
          r: 0,
          c: '/v1/fill/w_1280,h_927,q_75,strp/<prettyName>-fullview.jpg',
          h: 927,
          w: 1280,
          f: 467980,
        },
        {
          t: '92S',
          r: 0,
          c: '/v1/crop/w_92,h_92,x_9,y_0,scl_0.090819348469891,q_70,strp/<prettyName>-92s.jpg',
          h: 92,
          w: 92,
          ss: [
            {
              x: 2,
              c: '/v1/crop/w_184,h_184,x_18,y_0,scl_0.18163869693978,q_70,strp/<prettyName>-92s-2x.jpg',
            },
          ],
        },
      ],
    },
  },
  {
    deviationId: 862589151,
    type: 'image',
    typeId: 1,
    url: 'https://www.deviantart.com/gudzart/art/Bouquet-on-a-blue-background-862589151',
    title: 'Bouquet on a blue background',
    isJournal: false,
    isVideo: false,
    isPurchasable: false,
    isFavouritable: true,
    publishedTime: '2020-11-29T03:13:37-0800',
    isTextEditable: false,
    isBackgroundEditable: false,
    legacyTextEditUrl: null,
    isShareable: true,
    isCommentable: true,
    isFavourited: true,
    isDeleted: false,
    isMature: false,
    isNsfg: false,
    isDownloadable: true,
    isAntisocial: false,
    isBlocked: false,
    isPublished: true,
    isDailyDeviation: false,
    hasPrivateComments: false,
    isDreamsofart: false,
    isAiUseDisallowed: true,
    blockReasons: [],
    author: {
      userId: 45047560,
      useridUuid: '57b38de6-1b18-4abf-804e-3bab24014e65',
      username: 'Gudzart',
      usericon: 'https://a.deviantart.net/avatars-big/g/u/gudzart.jpg?6',
      type: 'core_access',
      isWatching: false,
      isSubscribed: false,
      isNewDeviant: false,
    },
    stats: {
      comments: 15,
      favourites: 177,
      views: 1227,
      downloads: 13,
    },
    media: {
      baseUri:
        'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/57b38de6-1b18-4abf-804e-3bab24014e65/de9ka1r-ca0b04b7-e8ec-4900-9fd5-19d0ba5fa960.jpg',
      prettyName: 'bouquet_on_a_blue_background_by_gudzart_de9ka1r',
      token: [
        'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7ImhlaWdodCI6Ijw9MzU1OSIsInBhdGgiOiJcL2ZcLzU3YjM4ZGU2LTFiMTgtNGFiZi04MDRlLTNiYWIyNDAxNGU2NVwvZGU5a2Exci1jYTBiMDRiNy1lOGVjLTQ5MDAtOWZkNS0xOWQwYmE1ZmE5NjAuanBnIiwid2lkdGgiOiI8PTI1NTEifV1dLCJhdWQiOlsidXJuOnNlcnZpY2U6aW1hZ2Uub3BlcmF0aW9ucyJdfQ.a220a7kv38d8MbB12VGe-hWbZrHt67-TJP6-3VPIn3g',
        'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7InBhdGgiOiJcL2ZcLzU3YjM4ZGU2LTFiMTgtNGFiZi04MDRlLTNiYWIyNDAxNGU2NVwvZGU5a2Exci1jYTBiMDRiNy1lOGVjLTQ5MDAtOWZkNS0xOWQwYmE1ZmE5NjAuanBnIn1dXSwiYXVkIjpbInVybjpzZXJ2aWNlOmZpbGUuZG93bmxvYWQiXX0.mTzNOjIxOkjQYI2_BJE6i92FmijTVgyDoIEgTTuTB7c',
      ],
      types: [
        {
          t: '150',
          r: 0,
          c: '/v1/fit/w_150,h_150,q_70,strp/<prettyName>-150.jpg',
          h: 150,
          w: 108,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_300,h_300,q_70,strp/<prettyName>-150-2x.jpg',
            },
          ],
        },
        {
          t: '200H',
          r: 0,
          c: '/v1/fill/w_143,h_200,q_70,strp/<prettyName>-200h.jpg',
          h: 200,
          w: 143,
          ss: [
            {
              x: 2,
              c: '/v1/fill/w_287,h_400,q_70,strp/<prettyName>-200h-2x.jpg',
            },
          ],
        },
        {
          t: '300W',
          r: 0,
          c: '/v1/fit/w_300,h_900,q_70,strp/<prettyName>-300w.jpg',
          h: 419,
          w: 300,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_600,h_1800,q_70,strp/<prettyName>-300w-2x.jpg',
            },
          ],
        },
        {
          t: '375W',
          r: 0,
          c: '/v1/fit/w_375,h_523,q_70,strp/<prettyName>-375w.jpg',
          h: 523,
          w: 375,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_750,h_1046,q_70,strp/<prettyName>-375w-2x.jpg',
            },
          ],
        },
        {
          t: '414W',
          r: 0,
          c: '/v1/fit/w_414,h_578,q_70,strp/<prettyName>-414w.jpg',
          h: 578,
          w: 414,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_828,h_1156,q_70,strp/<prettyName>-414w-2x.jpg',
            },
          ],
        },
        {
          t: '250T',
          r: 0,
          c: '/v1/fill/w_179,h_250,q_70,strp/<prettyName>-250t.jpg',
          h: 250,
          w: 179,
          ss: [
            {
              x: 2,
              c: '/v1/crop/w_358,h_500,x_0,y_0,scl_0.14072912583301,q_70,strp/<prettyName>-250t-2x.jpg',
            },
          ],
        },
        {
          t: '350T',
          r: 0,
          c: '/v1/fill/w_251,h_350,q_70,strp/<prettyName>-350t.jpg',
          h: 350,
          w: 251,
          ss: [
            {
              x: 2,
              c: '/v1/fill/w_502,h_700,q_70,strp/<prettyName>-350t-2x.jpg',
            },
          ],
        },
        {
          t: '400T',
          r: 0,
          c: '/v1/fill/w_287,h_400,q_70,strp/<prettyName>-400t.jpg',
          h: 400,
          w: 287,
          ss: [
            {
              x: 2,
              c: '/v1/crop/w_573,h_800,x_0,y_0,scl_0.2250098000784,q_70,strp/<prettyName>-400t-2x.jpg',
            },
          ],
        },
        {
          t: 'preview',
          r: 0,
          c: '/v1/fill/w_757,h_1056,q_70,strp/<prettyName>-pre.jpg',
          h: 1056,
          w: 757,
          f: 8437580,
        },
        {
          t: 'social_preview',
          r: 0,
          c: '/v1/fill/w_757,h_1056,q_70,strp/<prettyName>-pre.jpg',
          h: 1056,
          w: 757,
        },
        {
          t: 'fullview',
          r: 1,
          h: 3559,
          w: 2551,
          f: 8437580,
        },
        {
          t: '92S',
          r: 0,
          c: '/v1/crop/w_92,h_92,x_0,y_9,scl_0.036064288514308,q_70,strp/<prettyName>-92s.jpg',
          h: 92,
          w: 92,
          ss: [
            {
              x: 2,
              c: '/v1/crop/w_184,h_184,x_0,y_18,scl_0.072128577028616,q_70,strp/<prettyName>-92s-2x.jpg',
            },
          ],
        },
      ],
    },
  },
  {
    deviationId: 862590251,
    type: 'image',
    typeId: 1,
    url: 'https://www.deviantart.com/ratinrage/art/Hide-and-seek-862590251',
    title: 'Hide and seek',
    isJournal: false,
    isVideo: false,
    isPurchasable: false,
    isFavouritable: true,
    publishedTime: '2020-11-29T03:37:36-0800',
    isTextEditable: false,
    isBackgroundEditable: false,
    legacyTextEditUrl: null,
    isShareable: false,
    isCommentable: false,
    isFavourited: true,
    isDeleted: false,
    isMature: false,
    isNsfg: false,
    isDownloadable: false,
    isAntisocial: true,
    isBlocked: false,
    isPublished: true,
    isDailyDeviation: false,
    hasPrivateComments: false,
    isDreamsofart: false,
    isAiUseDisallowed: true,
    blockReasons: [],
    author: {
      userId: 17548213,
      useridUuid: 'e831fd02-da60-4f1c-a9ac-13132558dbca',
      username: 'ratinrage',
      usericon: 'https://a.deviantart.net/avatars-big/r/a/ratinrage.jpg?4',
      type: 'core_access',
      isWatching: false,
      isSubscribed: false,
      isNewDeviant: false,
    },
    stats: {
      comments: 62,
      favourites: 357,
      views: 2402,
      downloads: 0,
    },
    media: {
      baseUri:
        'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/e831fd02-da60-4f1c-a9ac-13132558dbca/de9kawb-e7c57bde-a9d8-4e39-8657-60f50bfde0bd.jpg',
      prettyName: 'hide_and_seek_by_ratinrage_de9kawb',
      token: [
        'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7ImhlaWdodCI6Ijw9Njc4IiwicGF0aCI6IlwvZlwvZTgzMWZkMDItZGE2MC00ZjFjLWE5YWMtMTMxMzI1NThkYmNhXC9kZTlrYXdiLWU3YzU3YmRlLWE5ZDgtNGUzOS04NjU3LTYwZjUwYmZkZTBiZC5qcGciLCJ3aWR0aCI6Ijw9OTAwIn1dXSwiYXVkIjpbInVybjpzZXJ2aWNlOmltYWdlLm9wZXJhdGlvbnMiXX0.MiAtd7KfhKoAbF7GN0QILHwxL79hXhCcd-Bj-RcL_BQ',
      ],
      types: [
        {
          t: '150',
          r: 0,
          c: '/v1/fit/w_150,h_150,q_70,strp/<prettyName>-150.jpg',
          h: 113,
          w: 150,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_300,h_300,q_70,strp/<prettyName>-150-2x.jpg',
            },
          ],
        },
        {
          t: '200H',
          r: 0,
          c: '/v1/fill/w_266,h_200,q_70,strp/<prettyName>-200h.jpg',
          h: 200,
          w: 265,
          ss: [
            {
              x: 2,
              c: '/v1/fill/w_532,h_400,q_70,strp/<prettyName>-200h-2x.jpg',
            },
          ],
        },
        {
          t: '300W',
          r: 0,
          c: '/v1/fit/w_300,h_678,q_70,strp/<prettyName>-300w.jpg',
          h: 226,
          w: 300,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_600,h_678,q_70,strp/<prettyName>-300w-2x.jpg',
            },
          ],
        },
        {
          t: '375W',
          r: 0,
          c: '/v1/fit/w_375,h_283,q_70,strp/<prettyName>-375w.jpg',
          h: 283,
          w: 375,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_750,h_566,q_70,strp/<prettyName>-375w-2x.jpg',
            },
          ],
        },
        {
          t: '414W',
          r: 0,
          c: '/v1/fit/w_414,h_312,q_70,strp/<prettyName>-414w.jpg',
          h: 312,
          w: 414,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_828,h_624,q_70,strp/<prettyName>-414w-2x.jpg',
            },
          ],
        },
        {
          t: '250T',
          r: 0,
          c: '/v1/fill/w_332,h_250,q_70,strp/<prettyName>-250t.jpg',
          h: 250,
          w: 332,
          ss: [
            {
              x: 2,
              c: '/v1/fill/w_664,h_500,q_70,strp/<prettyName>-250t-2x.jpg',
            },
          ],
        },
        {
          t: '350T',
          r: 0,
          c: '/v1/fill/w_465,h_350,q_70,strp/<prettyName>-350t.jpg',
          h: 350,
          w: 465,
        },
        {
          t: '400T',
          r: 0,
          c: '/v1/fill/w_532,h_400,q_70,strp/<prettyName>-400t.jpg',
          h: 400,
          w: 531,
        },
        {
          t: 'preview',
          r: 0,
          c: '/v1/fill/w_900,h_678,q_75,strp/<prettyName>-fullview.jpg',
          h: 678,
          w: 900,
          f: 1142521,
        },
        {
          t: 'social_preview',
          r: 0,
          c: '/v1/fill/w_900,h_678,q_75,strp/<prettyName>-fullview.jpg',
          h: 678,
          w: 900,
        },
        {
          t: 'fullview',
          r: 0,
          c: '/v1/fill/w_900,h_678,q_75,strp/<prettyName>-fullview.jpg',
          h: 678,
          w: 900,
          f: 1142521,
        },
        {
          t: '92S',
          r: 0,
          c: '/v1/crop/w_92,h_92,x_8,y_0,scl_0.061129568106312,q_70,strp/<prettyName>-92s.jpg',
          h: 92,
          w: 92,
          ss: [
            {
              x: 2,
              c: '/v1/crop/w_184,h_184,x_15,y_0,scl_0.12225913621262,q_70,strp/<prettyName>-92s-2x.jpg',
            },
          ],
        },
      ],
    },
  },
  {
    deviationId: 861643747,
    type: 'image',
    typeId: 1,
    url: 'https://www.deviantart.com/ratinrage/art/Warm-autumn-861643747',
    title: 'Warm autumn',
    isJournal: false,
    isVideo: false,
    isPurchasable: false,
    isFavouritable: true,
    publishedTime: '2020-11-19T03:57:28-0800',
    isTextEditable: false,
    isBackgroundEditable: false,
    legacyTextEditUrl: null,
    isShareable: false,
    isCommentable: false,
    isFavourited: true,
    isDeleted: false,
    isMature: false,
    isNsfg: false,
    isDownloadable: false,
    isAntisocial: true,
    isBlocked: false,
    isPublished: true,
    isDailyDeviation: false,
    hasPrivateComments: false,
    isDreamsofart: false,
    isAiUseDisallowed: true,
    blockReasons: [],
    author: {
      userId: 17548213,
      useridUuid: 'e831fd02-da60-4f1c-a9ac-13132558dbca',
      username: 'ratinrage',
      usericon: 'https://a.deviantart.net/avatars-big/r/a/ratinrage.jpg?4',
      type: 'core_access',
      isWatching: false,
      isSubscribed: false,
      isNewDeviant: false,
    },
    stats: {
      comments: 0,
      favourites: 304,
      views: 654,
      downloads: 0,
    },
    media: {
      baseUri:
        'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/e831fd02-da60-4f1c-a9ac-13132558dbca/de900kj-67142e40-3c5e-4a71-8813-930b26efd3bc.jpg',
      prettyName: 'warm_autumn_by_ratinrage_de900kj',
      token: [
        'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7ImhlaWdodCI6Ijw9NzUwIiwicGF0aCI6IlwvZlwvZTgzMWZkMDItZGE2MC00ZjFjLWE5YWMtMTMxMzI1NThkYmNhXC9kZTkwMGtqLTY3MTQyZTQwLTNjNWUtNGE3MS04ODEzLTkzMGIyNmVmZDNiYy5qcGciLCJ3aWR0aCI6Ijw9MTAyNCJ9XV0sImF1ZCI6WyJ1cm46c2VydmljZTppbWFnZS5vcGVyYXRpb25zIl19.eDBY0aBw1UiaJGcEAAxnBHKCyq7d-krM1I_ExcJBAS4',
      ],
      types: [
        {
          t: '150',
          r: 0,
          c: '/v1/fit/w_150,h_150,q_70,strp/<prettyName>-150.jpg',
          h: 110,
          w: 150,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_300,h_300,q_70,strp/<prettyName>-150-2x.jpg',
            },
          ],
        },
        {
          t: '200H',
          r: 0,
          c: '/v1/fill/w_273,h_200,q_70,strp/<prettyName>-200h.jpg',
          h: 200,
          w: 273,
          ss: [
            {
              x: 2,
              c: '/v1/fill/w_547,h_400,q_70,strp/<prettyName>-200h-2x.jpg',
            },
          ],
        },
        {
          t: '300W',
          r: 0,
          c: '/v1/fit/w_300,h_750,q_70,strp/<prettyName>-300w.jpg',
          h: 220,
          w: 300,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_600,h_750,q_70,strp/<prettyName>-300w-2x.jpg',
            },
          ],
        },
        {
          t: '375W',
          r: 0,
          c: '/v1/fit/w_375,h_275,q_70,strp/<prettyName>-375w.jpg',
          h: 275,
          w: 375,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_750,h_550,q_70,strp/<prettyName>-375w-2x.jpg',
            },
          ],
        },
        {
          t: '414W',
          r: 0,
          c: '/v1/fit/w_414,h_303,q_70,strp/<prettyName>-414w.jpg',
          h: 303,
          w: 414,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_828,h_606,q_70,strp/<prettyName>-414w-2x.jpg',
            },
          ],
        },
        {
          t: '250T',
          r: 0,
          c: '/v1/fill/w_342,h_250,q_70,strp/<prettyName>-250t.jpg',
          h: 250,
          w: 341,
          ss: [
            {
              x: 2,
              c: '/v1/fill/w_684,h_500,q_70,strp/<prettyName>-250t-2x.jpg',
            },
          ],
        },
        {
          t: '350T',
          r: 0,
          c: '/v1/fill/w_478,h_350,q_70,strp/<prettyName>-350t.jpg',
          h: 350,
          w: 478,
          ss: [
            {
              x: 2,
              c: '/v1/fill/w_957,h_700,q_70,strp/<prettyName>-350t-2x.jpg',
            },
          ],
        },
        {
          t: '400T',
          r: 0,
          c: '/v1/fill/w_547,h_400,q_70,strp/<prettyName>-400t.jpg',
          h: 400,
          w: 546,
        },
        {
          t: 'preview',
          r: 0,
          c: '/v1/fill/w_1024,h_750,q_75,strp/<prettyName>-fullview.jpg',
          h: 750,
          w: 1024,
          f: 1205470,
        },
        {
          t: 'social_preview',
          r: 0,
          c: '/v1/fill/w_1024,h_750,q_75,strp/<prettyName>-fullview.jpg',
          h: 750,
          w: 1024,
        },
        {
          t: 'fullview',
          r: 0,
          c: '/v1/fill/w_1024,h_750,q_75,strp/<prettyName>-fullview.jpg',
          h: 750,
          w: 1024,
          f: 1205470,
        },
        {
          t: '92S',
          r: 0,
          c: '/v1/crop/w_92,h_92,x_8,y_0,scl_0.062884483937116,q_70,strp/<prettyName>-92s.jpg',
          h: 92,
          w: 92,
          ss: [
            {
              x: 2,
              c: '/v1/crop/w_184,h_184,x_17,y_0,scl_0.12576896787423,q_70,strp/<prettyName>-92s-2x.jpg',
            },
          ],
        },
      ],
    },
  },
  {
    deviationId: 861539231,
    type: 'image',
    typeId: 1,
    url: 'https://www.deviantart.com/yanadhyana/art/The-Pig-Girl-of-Blackapple-861539231',
    title: 'The Pig Girl of Blackapple',
    isJournal: false,
    isVideo: false,
    isPurchasable: false,
    isFavouritable: true,
    publishedTime: '2020-11-18T01:29:58-0800',
    isTextEditable: false,
    isBackgroundEditable: false,
    legacyTextEditUrl: null,
    isShareable: true,
    isCommentable: true,
    isFavourited: true,
    isDeleted: false,
    isMature: false,
    isNsfg: false,
    isDownloadable: false,
    isAntisocial: false,
    isBlocked: false,
    isPublished: true,
    isDailyDeviation: false,
    hasPrivateComments: false,
    isDreamsofart: false,
    isAiUseDisallowed: true,
    blockReasons: [],
    author: {
      userId: 20423868,
      useridUuid: '49073434-8f60-49d6-bf9f-e8800cd083e2',
      username: 'yanadhyana',
      usericon: 'https://a.deviantart.net/avatars-big/y/a/yanadhyana.jpg?9',
      type: 'core_plus',
      isWatching: true,
      isSubscribed: false,
      isNewDeviant: false,
    },
    stats: {
      comments: 28,
      favourites: 345,
      views: 2795,
      downloads: 9,
    },
    media: {
      baseUri:
        'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/49073434-8f60-49d6-bf9f-e8800cd083e2/de8xrxb-a3ec3baa-fae7-40e4-979c-a4b1a1800af3.png',
      prettyName: 'the_pig_girl_of_blackapple_by_yanadhyana_de8xrxb',
      token: [
        'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7ImhlaWdodCI6Ijw9ODAwIiwicGF0aCI6IlwvZlwvNDkwNzM0MzQtOGY2MC00OWQ2LWJmOWYtZTg4MDBjZDA4M2UyXC9kZTh4cnhiLWEzZWMzYmFhLWZhZTctNDBlNC05NzljLWE0YjFhMTgwMGFmMy5wbmciLCJ3aWR0aCI6Ijw9MTA5NCJ9XV0sImF1ZCI6WyJ1cm46c2VydmljZTppbWFnZS5vcGVyYXRpb25zIl19.Gm5ZzXdfkMxpGcNUx3NbtP71U6PmyzNO-aBbI4GG5tw',
        'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7InBhdGgiOiJcL2ZcLzQ5MDczNDM0LThmNjAtNDlkNi1iZjlmLWU4ODAwY2QwODNlMlwvZGU4eHJ4Yi1hM2VjM2JhYS1mYWU3LTQwZTQtOTc5Yy1hNGIxYTE4MDBhZjMucG5nIn1dXSwiYXVkIjpbInVybjpzZXJ2aWNlOmZpbGUuZG93bmxvYWQiXX0.GMzfOWZDTASJD_N6R1vF_YnNh4UqnCqMSInKwHhl6WI',
      ],
      types: [
        {
          t: '150',
          r: 0,
          c: '/v1/fit/w_150,h_150,q_70,strp/<prettyName>-150.jpg',
          h: 110,
          w: 150,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_300,h_300,q_70,strp/<prettyName>-150-2x.jpg',
            },
          ],
        },
        {
          t: '200H',
          r: 0,
          c: '/v1/fill/w_274,h_200,q_70,strp/<prettyName>-200h.jpg',
          h: 200,
          w: 274,
          ss: [
            {
              x: 2,
              c: '/v1/fill/w_547,h_400,q_70,strp/<prettyName>-200h-2x.jpg',
            },
          ],
        },
        {
          t: '300W',
          r: 0,
          c: '/v1/fit/w_300,h_800,q_70,strp/<prettyName>-300w.jpg',
          h: 219,
          w: 300,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_600,h_800,q_70,strp/<prettyName>-300w-2x.jpg',
            },
          ],
        },
        {
          t: '375W',
          r: 0,
          c: '/v1/fit/w_375,h_274,q_70,strp/<prettyName>-375w.jpg',
          h: 274,
          w: 375,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_750,h_548,q_70,strp/<prettyName>-375w-2x.jpg',
            },
          ],
        },
        {
          t: '414W',
          r: 0,
          c: '/v1/fit/w_414,h_303,q_70,strp/<prettyName>-414w.jpg',
          h: 303,
          w: 414,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_828,h_606,q_70,strp/<prettyName>-414w-2x.jpg',
            },
          ],
        },
        {
          t: '250T',
          r: 0,
          c: '/v1/fill/w_342,h_250,q_70,strp/<prettyName>-250t.jpg',
          h: 250,
          w: 342,
          ss: [
            {
              x: 2,
              c: '/v1/fill/w_684,h_500,q_70,strp/<prettyName>-250t-2x.jpg',
            },
          ],
        },
        {
          t: '350T',
          r: 0,
          c: '/v1/fill/w_479,h_350,q_70,strp/<prettyName>-350t.jpg',
          h: 350,
          w: 479,
          ss: [
            {
              x: 2,
              c: '/v1/fill/w_957,h_700,q_70,strp/<prettyName>-350t-2x.jpg',
            },
          ],
        },
        {
          t: '400T',
          r: 0,
          c: '/v1/fill/w_547,h_400,q_70,strp/<prettyName>-400t.jpg',
          h: 400,
          w: 547,
          ss: [
            {
              x: 2,
              c: '/v1/fill/w_1094,h_800,q_70,strp/<prettyName>-400t-2x.jpg',
            },
          ],
        },
        {
          t: 'preview',
          r: 0,
          c: '/v1/fill/w_1045,h_764,q_70,strp/<prettyName>-pre.jpg',
          h: 764,
          w: 1045,
          f: 1922385,
        },
        {
          t: 'social_preview',
          r: 0,
          c: '/v1/fill/w_1045,h_764,q_70,strp/<prettyName>-pre.jpg',
          h: 764,
          w: 1045,
        },
        {
          t: 'fullview',
          r: 1,
          h: 800,
          w: 1094,
          f: 1922385,
        },
        {
          t: '92S',
          r: 0,
          c: '/v1/crop/w_92,h_92,x_8,y_0,scl_0.115,q_70,strp/<prettyName>-92s.jpg',
          h: 92,
          w: 92,
          ss: [
            {
              x: 2,
              c: '/v1/crop/w_184,h_184,x_17,y_0,scl_0.23,q_70,strp/<prettyName>-92s-2x.jpg',
            },
          ],
        },
      ],
    },
  },
  {
    deviationId: 861141108,
    type: 'image',
    typeId: 1,
    url: 'https://www.deviantart.com/mizuriau/art/Keanu-Reeves-as-John-Constantine-861141108',
    title: 'Keanu Reeves as John Constantine',
    isJournal: false,
    isVideo: false,
    isPurchasable: false,
    isFavouritable: true,
    publishedTime: '2020-11-13T20:21:32-0800',
    isTextEditable: false,
    isBackgroundEditable: false,
    legacyTextEditUrl: null,
    isShareable: true,
    isCommentable: true,
    isFavourited: true,
    isDeleted: false,
    isMature: false,
    isNsfg: false,
    isDownloadable: false,
    isAntisocial: false,
    isBlocked: false,
    isPublished: true,
    isDailyDeviation: false,
    hasPrivateComments: false,
    isDreamsofart: false,
    isAiUseDisallowed: true,
    blockReasons: [],
    author: {
      userId: 44419253,
      useridUuid: '5aa16421-e20b-4a8d-9428-fe192c4f41d2',
      username: 'MizuriAU',
      usericon: 'https://a.deviantart.net/avatars-big/m/i/mizuriau.png?8',
      type: 'regular',
      isWatching: false,
      isSubscribed: false,
      isNewDeviant: false,
    },
    stats: {
      comments: 5,
      favourites: 116,
      views: 4529,
      downloads: 0,
    },
    media: {
      baseUri:
        'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/5aa16421-e20b-4a8d-9428-fe192c4f41d2/de8p8qc-9243d1c0-3bf9-4f11-9946-94ccd4451304.png',
      prettyName: 'keanu_reeves_as_john_constantine_by_mizuriau_de8p8qc',
      token: [
        'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7ImhlaWdodCI6Ijw9MjI4NiIsInBhdGgiOiJcL2ZcLzVhYTE2NDIxLWUyMGItNGE4ZC05NDI4LWZlMTkyYzRmNDFkMlwvZGU4cDhxYy05MjQzZDFjMC0zYmY5LTRmMTEtOTk0Ni05NGNjZDQ0NTEzMDQucG5nIiwid2lkdGgiOiI8PTE2MDAifV1dLCJhdWQiOlsidXJuOnNlcnZpY2U6aW1hZ2Uub3BlcmF0aW9ucyJdfQ.SkIpgmRcjPaZPXNdFKFImuAN-2qpuuDBncLGfmEEfrI',
      ],
      types: [
        {
          t: '150',
          r: 0,
          c: '/v1/fit/w_150,h_150,q_70,strp/<prettyName>-150.jpg',
          h: 150,
          w: 105,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_300,h_300,q_70,strp/<prettyName>-150-2x.jpg',
            },
          ],
        },
        {
          t: '200H',
          r: 0,
          c: '/v1/fill/w_140,h_200,q_70,strp/<prettyName>-200h.jpg',
          h: 200,
          w: 140,
          ss: [
            {
              x: 2,
              c: '/v1/fill/w_280,h_400,q_70,strp/<prettyName>-200h-2x.jpg',
            },
          ],
        },
        {
          t: '300W',
          r: 0,
          c: '/v1/fit/w_300,h_900,q_70,strp/<prettyName>-300w.jpg',
          h: 429,
          w: 300,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_600,h_1800,q_70,strp/<prettyName>-300w-2x.jpg',
            },
          ],
        },
        {
          t: '375W',
          r: 0,
          c: '/v1/fit/w_375,h_536,q_70,strp/<prettyName>-375w.jpg',
          h: 536,
          w: 375,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_750,h_1072,q_70,strp/<prettyName>-375w-2x.jpg',
            },
          ],
        },
        {
          t: '414W',
          r: 0,
          c: '/v1/fit/w_414,h_592,q_70,strp/<prettyName>-414w.jpg',
          h: 592,
          w: 414,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_828,h_1184,q_70,strp/<prettyName>-414w-2x.jpg',
            },
          ],
        },
        {
          t: '250T',
          r: 0,
          c: '/v1/fill/w_175,h_250,q_70,strp/<prettyName>-250t.jpg',
          h: 250,
          w: 175,
          ss: [
            {
              x: 2,
              c: '/v1/fill/w_350,h_500,q_70,strp/<prettyName>-250t-2x.jpg',
            },
          ],
        },
        {
          t: '350T',
          r: 0,
          c: '/v1/fill/w_245,h_350,q_70,strp/<prettyName>-350t.jpg',
          h: 350,
          w: 245,
          ss: [
            {
              x: 2,
              c: '/v1/fill/w_490,h_700,q_70,strp/<prettyName>-350t-2x.jpg',
            },
          ],
        },
        {
          t: '400T',
          r: 0,
          c: '/v1/fill/w_280,h_400,q_70,strp/<prettyName>-400t.jpg',
          h: 400,
          w: 280,
          ss: [
            {
              x: 2,
              c: '/v1/fill/w_560,h_800,q_70,strp/<prettyName>-400t-2x.jpg',
            },
          ],
        },
        {
          t: 'preview',
          r: 0,
          c: '/v1/fill/w_748,h_1069,q_70,strp/<prettyName>-pre.jpg',
          h: 1069,
          w: 748,
          f: 12852604,
        },
        {
          t: 'social_preview',
          r: 0,
          c: '/v1/fill/w_748,h_1069,q_70,strp/<prettyName>-pre.jpg',
          h: 1069,
          w: 748,
        },
        {
          t: 'fullview',
          r: 0,
          c: '/v1/fill/w_1600,h_2286,q_80,strp/<prettyName>-fullview.jpg',
          h: 2286,
          w: 1600,
          f: 12852604,
        },
        {
          t: '92S',
          r: 0,
          c: '/v1/crop/w_92,h_92,x_0,y_10,scl_0.026285714285714,q_70,strp/<prettyName>-92s.jpg',
          h: 92,
          w: 92,
          ss: [
            {
              x: 2,
              c: '/v1/crop/w_184,h_184,x_0,y_20,scl_0.052571428571429,q_70,strp/<prettyName>-92s-2x.jpg',
            },
          ],
        },
      ],
    },
  },
  {
    deviationId: 861023487,
    type: 'image',
    typeId: 1,
    url: 'https://www.deviantart.com/frnkschmdt/art/sketchbook-12112020-861023487',
    title: 'sketchbook 12112020',
    isJournal: false,
    isVideo: false,
    isPurchasable: false,
    isFavouritable: true,
    publishedTime: '2020-11-12T15:04:00-0800',
    isTextEditable: false,
    isBackgroundEditable: false,
    legacyTextEditUrl: null,
    isShareable: true,
    isCommentable: true,
    isFavourited: true,
    isDeleted: false,
    isMature: false,
    isNsfg: false,
    isDownloadable: true,
    isAntisocial: false,
    isBlocked: false,
    isPublished: true,
    isDailyDeviation: false,
    hasPrivateComments: false,
    isDreamsofart: false,
    isAiUseDisallowed: true,
    blockReasons: [],
    author: {
      userId: 41725994,
      useridUuid: 'cac0e2af-599f-47ae-a6c2-08c579829481',
      username: 'FrnkSchmdt',
      usericon: 'https://a.deviantart.net/avatars-big/f/r/frnkschmdt.jpg?11',
      type: 'regular',
      isWatching: false,
      isSubscribed: false,
      isNewDeviant: false,
    },
    stats: {
      comments: 13,
      favourites: 131,
      views: 292,
      downloads: 3,
    },
    media: {
      baseUri:
        'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/cac0e2af-599f-47ae-a6c2-08c579829481/de8mpz3-10b51b9f-d0ad-4fe8-97b9-8af5c1e7b739.jpg',
      prettyName: 'sketchbook_12112020_by_frnkschmdt_de8mpz3',
      token: [
        'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7ImhlaWdodCI6Ijw9ODUwIiwicGF0aCI6IlwvZlwvY2FjMGUyYWYtNTk5Zi00N2FlLWE2YzItMDhjNTc5ODI5NDgxXC9kZThtcHozLTEwYjUxYjlmLWQwYWQtNGZlOC05N2I5LThhZjVjMWU3YjczOS5qcGciLCJ3aWR0aCI6Ijw9MTUzMyJ9XV0sImF1ZCI6WyJ1cm46c2VydmljZTppbWFnZS5vcGVyYXRpb25zIl19.eegAzYE3fPMQYeJ4V-JIcO5mlihf3NGtf58BUHn3NqI',
        'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7InBhdGgiOiJcL2ZcL2NhYzBlMmFmLTU5OWYtNDdhZS1hNmMyLTA4YzU3OTgyOTQ4MVwvZGU4bXB6My0xMGI1MWI5Zi1kMGFkLTRmZTgtOTdiOS04YWY1YzFlN2I3MzkuanBnIn1dXSwiYXVkIjpbInVybjpzZXJ2aWNlOmZpbGUuZG93bmxvYWQiXX0.YPCzZ0cWnwSV49Y_cX9jx6-vqchE5G1JhzjQhlEyHCw',
      ],
      types: [
        {
          t: '150',
          r: 0,
          c: '/v1/fit/w_150,h_150,q_70,strp/<prettyName>-150.jpg',
          h: 83,
          w: 150,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_300,h_300,q_70,strp/<prettyName>-150-2x.jpg',
            },
          ],
        },
        {
          t: '200H',
          r: 0,
          c: '/v1/fill/w_300,h_166,q_70,strp/<prettyName>-200h.jpg',
          h: 166,
          w: 300,
          ss: [
            {
              x: 2,
              c: '/v1/fill/w_600,h_333,q_70,strp/<prettyName>-200h-2x.jpg',
            },
          ],
        },
        {
          t: '300W',
          r: 0,
          c: '/v1/fit/w_300,h_850,q_70,strp/<prettyName>-300w.jpg',
          h: 166,
          w: 300,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_600,h_850,q_70,strp/<prettyName>-300w-2x.jpg',
            },
          ],
        },
        {
          t: '375W',
          r: 0,
          c: '/v1/fit/w_375,h_208,q_70,strp/<prettyName>-375w.jpg',
          h: 208,
          w: 375,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_750,h_416,q_70,strp/<prettyName>-375w-2x.jpg',
            },
          ],
        },
        {
          t: '414W',
          r: 0,
          c: '/v1/fit/w_414,h_230,q_70,strp/<prettyName>-414w.jpg',
          h: 230,
          w: 414,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_828,h_460,q_70,strp/<prettyName>-414w-2x.jpg',
            },
          ],
        },
        {
          t: '250T',
          r: 0,
          c: '/v1/fill/w_451,h_250,q_70,strp/<prettyName>-250t.jpg',
          h: 250,
          w: 451,
          ss: [
            {
              x: 2,
              c: '/v1/fill/w_902,h_500,q_70,strp/<prettyName>-250t-2x.jpg',
            },
          ],
        },
        {
          t: '350T',
          r: 0,
          c: '/v1/fill/w_631,h_350,q_70,strp/<prettyName>-350t.jpg',
          h: 350,
          w: 631,
          ss: [
            {
              x: 2,
              c: '/v1/fill/w_1262,h_700,q_70,strp/<prettyName>-350t-2x.jpg',
            },
          ],
        },
        {
          t: '400T',
          r: 0,
          c: '/v1/fill/w_721,h_400,q_70,strp/<prettyName>-400t.jpg',
          h: 400,
          w: 721,
          ss: [
            {
              x: 2,
              c: '/v1/fill/w_1443,h_800,q_70,strp/<prettyName>-400t-2x.jpg',
            },
          ],
        },
        {
          t: 'preview',
          r: 0,
          c: '/v1/fill/w_1201,h_666,q_70,strp/<prettyName>-pre.jpg',
          h: 666,
          w: 1201,
          f: 309633,
        },
        {
          t: 'social_preview',
          r: 0,
          c: '/v1/fill/w_1201,h_666,q_70,strp/<prettyName>-pre.jpg',
          h: 666,
          w: 1201,
        },
        {
          t: 'fullview',
          r: 1,
          h: 850,
          w: 1533,
          f: 309633,
        },
        {
          t: '92S',
          r: 0,
          c: '/v1/crop/w_92,h_92,x_18,y_0,scl_0.10823529411765,q_70,strp/<prettyName>-92s.jpg',
          h: 92,
          w: 92,
          ss: [
            {
              x: 2,
              c: '/v1/crop/w_184,h_184,x_37,y_0,scl_0.21647058823529,q_70,strp/<prettyName>-92s-2x.jpg',
            },
          ],
        },
      ],
    },
  },
  {
    deviationId: 860678606,
    type: 'image',
    typeId: 1,
    url: 'https://www.deviantart.com/neo-innov/art/VESTAL-portrait-860678606',
    title: 'VESTAL portrait',
    isJournal: false,
    isVideo: false,
    isPurchasable: false,
    isFavouritable: true,
    publishedTime: '2020-11-09T03:38:53-0800',
    isTextEditable: false,
    isBackgroundEditable: false,
    legacyTextEditUrl: null,
    isShareable: true,
    isCommentable: true,
    isFavourited: true,
    isDeleted: false,
    isMature: false,
    isNsfg: false,
    isDownloadable: true,
    isAntisocial: false,
    isBlocked: false,
    isPublished: true,
    isDailyDeviation: false,
    hasPrivateComments: false,
    isDreamsofart: false,
    isAiUseDisallowed: true,
    blockReasons: [],
    author: {
      userId: 8635768,
      useridUuid: '4ac6faea-77eb-4c40-9885-9abb06d077c9',
      username: 'neo-innov',
      usericon: 'https://a.deviantart.net/avatars-big/n/e/neo-innov.jpg?13',
      type: 'regular',
      isWatching: false,
      isSubscribed: false,
      isNewDeviant: false,
    },
    stats: {
      comments: 13,
      favourites: 203,
      views: 6294,
      downloads: 16,
    },
    media: {
      baseUri:
        'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/4ac6faea-77eb-4c40-9885-9abb06d077c9/de8fbv2-587af57e-3d26-4960-b01d-9908acb1e0e8.jpg',
      prettyName: 'vestal_portrait_by_neo_innov_de8fbv2',
      token: [
        'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7ImhlaWdodCI6Ijw9ODUwIiwicGF0aCI6IlwvZlwvNGFjNmZhZWEtNzdlYi00YzQwLTk4ODUtOWFiYjA2ZDA3N2M5XC9kZThmYnYyLTU4N2FmNTdlLTNkMjYtNDk2MC1iMDFkLTk5MDhhY2IxZTBlOC5qcGciLCJ3aWR0aCI6Ijw9NjAxIn1dXSwiYXVkIjpbInVybjpzZXJ2aWNlOmltYWdlLm9wZXJhdGlvbnMiXX0._X0NkKq_c2ScQ7Wb-GjVnnzcif5pKOvOs5tvII78sNs',
        'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7InBhdGgiOiJcL2ZcLzRhYzZmYWVhLTc3ZWItNGM0MC05ODg1LTlhYmIwNmQwNzdjOVwvZGU4ZmJ2Mi01ODdhZjU3ZS0zZDI2LTQ5NjAtYjAxZC05OTA4YWNiMWUwZTguanBnIn1dXSwiYXVkIjpbInVybjpzZXJ2aWNlOmZpbGUuZG93bmxvYWQiXX0.wZxV-pkAJgWM4YHzEeJjToamf3Pfi-99Pt37WyboV4s',
      ],
      types: [
        {
          t: '150',
          r: 0,
          c: '/v1/fit/w_150,h_150,q_70,strp/<prettyName>-150.jpg',
          h: 150,
          w: 106,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_300,h_300,q_70,strp/<prettyName>-150-2x.jpg',
            },
          ],
        },
        {
          t: '200H',
          r: 0,
          c: '/v1/crop/w_141,h_200,x_0,y_0,scl_0.23627287853577,q_70,strp/<prettyName>-200h.jpg',
          h: 200,
          w: 141,
          ss: [
            {
              x: 2,
              c: '/v1/fill/w_283,h_400,q_70,strp/<prettyName>-200h-2x.jpg',
            },
          ],
        },
        {
          t: '300W',
          r: 0,
          c: '/v1/fit/w_300,h_850,q_70,strp/<prettyName>-300w.jpg',
          h: 424,
          w: 300,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_600,h_850,q_70,strp/<prettyName>-300w-2x.jpg',
            },
          ],
        },
        {
          t: '375W',
          r: 0,
          c: '/v1/fit/w_375,h_530,q_70,strp/<prettyName>-375w.jpg',
          h: 530,
          w: 375,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_601,h_850,q_70,strp/<prettyName>-375w-2x.jpg',
            },
          ],
        },
        {
          t: '414W',
          r: 0,
          c: '/v1/fit/w_414,h_586,q_70,strp/<prettyName>-414w.jpg',
          h: 586,
          w: 414,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_601,h_850,q_70,strp/<prettyName>-414w-2x.jpg',
            },
          ],
        },
        {
          t: '250T',
          r: 0,
          c: '/v1/fill/w_177,h_250,q_70,strp/<prettyName>-250t.jpg',
          h: 250,
          w: 177,
          ss: [
            {
              x: 2,
              c: '/v1/crop/w_354,h_500,x_0,y_0,scl_0.58901830282862,q_70,strp/<prettyName>-250t-2x.jpg',
            },
          ],
        },
        {
          t: '350T',
          r: 0,
          c: '/v1/crop/w_247,h_350,x_0,y_0,scl_0.4126455906822,q_70,strp/<prettyName>-350t.jpg',
          h: 350,
          w: 247,
          ss: [
            {
              x: 2,
              c: '/v1/fill/w_495,h_700,q_70,strp/<prettyName>-350t-2x.jpg',
            },
          ],
        },
        {
          t: '400T',
          r: 0,
          c: '/v1/fill/w_283,h_400,q_70,strp/<prettyName>-400t.jpg',
          h: 400,
          w: 283,
          ss: [
            {
              x: 2,
              c: '/v1/fill/w_566,h_800,q_70,strp/<prettyName>-400t-2x.jpg',
            },
          ],
        },
        {
          t: 'preview',
          r: 0,
          c: '/v1/fill/w_601,h_850,q_75,strp/<prettyName>-fullview.jpg',
          h: 850,
          w: 601,
          f: 158415,
        },
        {
          t: 'social_preview',
          r: 0,
          c: '/v1/fill/w_601,h_850,q_75,strp/<prettyName>-fullview.jpg',
          h: 850,
          w: 601,
        },
        {
          t: 'fullview',
          r: 1,
          h: 850,
          w: 601,
          f: 158415,
        },
        {
          t: '92S',
          r: 0,
          c: '/v1/crop/w_92,h_92,x_0,y_10,scl_0.15307820299501,q_70,strp/<prettyName>-92s.jpg',
          h: 92,
          w: 92,
          ss: [
            {
              x: 2,
              c: '/v1/crop/w_184,h_184,x_0,y_19,scl_0.30615640599002,q_70,strp/<prettyName>-92s-2x.jpg',
            },
          ],
        },
      ],
    },
  },
  {
    deviationId: 860609528,
    type: 'image',
    typeId: 1,
    url: 'https://www.deviantart.com/abueloretrowave/art/HOTEL-ROOM-3-860609528',
    title: 'HOTEL ROOM 3',
    isJournal: false,
    isVideo: false,
    isPurchasable: false,
    isFavouritable: true,
    publishedTime: '2020-11-08T10:34:54-0800',
    isTextEditable: false,
    isBackgroundEditable: false,
    legacyTextEditUrl: null,
    isShareable: true,
    isCommentable: true,
    isFavourited: true,
    isDeleted: false,
    isMature: false,
    isNsfg: false,
    isDownloadable: false,
    isAntisocial: false,
    isBlocked: false,
    isPublished: true,
    isDailyDeviation: false,
    hasPrivateComments: false,
    isDreamsofart: false,
    isAiUseDisallowed: true,
    blockReasons: [],
    author: {
      userId: 43102213,
      useridUuid: '5ae216c6-d3a5-4c81-ae92-d0d9295e0ebc',
      username: 'AbueloRetroWave',
      usericon: 'https://a.deviantart.net/avatars-big/a/b/abueloretrowave.jpg',
      type: 'regular',
      isWatching: true,
      isSubscribed: false,
      isNewDeviant: false,
    },
    stats: {
      comments: 7,
      favourites: 196,
      views: 5557,
      downloads: 0,
    },
    media: {
      baseUri:
        'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/5ae216c6-d3a5-4c81-ae92-d0d9295e0ebc/de8duk8-94e00990-f814-4f1c-8d9b-a5e834d6b7d5.png',
      prettyName: 'hotel_room_3_by_abueloretrowave_de8duk8',
      token: [
        'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7ImhlaWdodCI6Ijw9MTIwMCIsInBhdGgiOiJcL2ZcLzVhZTIxNmM2LWQzYTUtNGM4MS1hZTkyLWQwZDkyOTVlMGViY1wvZGU4ZHVrOC05NGUwMDk5MC1mODE0LTRmMWMtOGQ5Yi1hNWU4MzRkNmI3ZDUucG5nIiwid2lkdGgiOiI8PTEyMDAifV1dLCJhdWQiOlsidXJuOnNlcnZpY2U6aW1hZ2Uub3BlcmF0aW9ucyJdfQ.4HAnhYND5ptKMWDzY4uinn5_O7qJtODAODIgDD9BApQ',
        'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7InBhdGgiOiJcL2ZcLzVhZTIxNmM2LWQzYTUtNGM4MS1hZTkyLWQwZDkyOTVlMGViY1wvZGU4ZHVrOC05NGUwMDk5MC1mODE0LTRmMWMtOGQ5Yi1hNWU4MzRkNmI3ZDUucG5nIn1dXSwiYXVkIjpbInVybjpzZXJ2aWNlOmZpbGUuZG93bmxvYWQiXX0.4iVs_3mn8jqtNSanjATFjqMGAhM1uFVFMAi8sCntjq4',
      ],
      types: [
        {
          t: '150',
          r: 0,
          c: '/v1/fit/w_150,h_150,q_70,strp/<prettyName>-150.jpg',
          h: 150,
          w: 150,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_300,h_300,q_70,strp/<prettyName>-150-2x.jpg',
            },
          ],
        },
        {
          t: '200H',
          r: 0,
          c: '/v1/fill/w_200,h_200,q_70,strp/<prettyName>-200h.jpg',
          h: 200,
          w: 200,
          ss: [
            {
              x: 2,
              c: '/v1/fill/w_400,h_400,q_70,strp/<prettyName>-200h-2x.jpg',
            },
          ],
        },
        {
          t: '300W',
          r: 0,
          c: '/v1/fit/w_300,h_900,q_70,strp/<prettyName>-300w.jpg',
          h: 300,
          w: 300,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_600,h_1200,q_70,strp/<prettyName>-300w-2x.jpg',
            },
          ],
        },
        {
          t: '375W',
          r: 0,
          c: '/v1/fit/w_375,h_375,q_70,strp/<prettyName>-375w.jpg',
          h: 375,
          w: 375,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_750,h_750,q_70,strp/<prettyName>-375w-2x.jpg',
            },
          ],
        },
        {
          t: '414W',
          r: 0,
          c: '/v1/fit/w_414,h_414,q_70,strp/<prettyName>-414w.jpg',
          h: 414,
          w: 414,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_828,h_828,q_70,strp/<prettyName>-414w-2x.jpg',
            },
          ],
        },
        {
          t: '250T',
          r: 0,
          c: '/v1/fill/w_250,h_250,q_70,strp/<prettyName>-250t.jpg',
          h: 250,
          w: 250,
          ss: [
            {
              x: 2,
              c: '/v1/fill/w_500,h_500,q_70,strp/<prettyName>-250t-2x.jpg',
            },
          ],
        },
        {
          t: '350T',
          r: 0,
          c: '/v1/fill/w_350,h_350,q_70,strp/<prettyName>-350t.jpg',
          h: 350,
          w: 350,
          ss: [
            {
              x: 2,
              c: '/v1/fill/w_700,h_700,q_70,strp/<prettyName>-350t-2x.jpg',
            },
          ],
        },
        {
          t: '400T',
          r: 0,
          c: '/v1/fill/w_400,h_400,q_70,strp/<prettyName>-400t.jpg',
          h: 400,
          w: 400,
          ss: [
            {
              x: 2,
              c: '/v1/fill/w_800,h_800,q_70,strp/<prettyName>-400t-2x.jpg',
            },
          ],
        },
        {
          t: 'preview',
          r: 0,
          c: '/v1/fill/w_894,h_894,q_70,strp/<prettyName>-pre.jpg',
          h: 894,
          w: 894,
          f: 38858,
        },
        {
          t: 'social_preview',
          r: 0,
          c: '/v1/fill/w_894,h_894,q_70,strp/<prettyName>-pre.jpg',
          h: 894,
          w: 894,
        },
        {
          t: 'fullview',
          r: 1,
          h: 1200,
          w: 1200,
          f: 38858,
        },
        {
          t: '92S',
          r: 0,
          c: '/v1/crop/w_92,h_92,x_0,y_0,scl_0.076666666666667,q_70,strp/<prettyName>-92s.jpg',
          h: 92,
          w: 92,
          ss: [
            {
              x: 2,
              c: '/v1/crop/w_184,h_184,x_0,y_0,scl_0.15333333333333,q_70,strp/<prettyName>-92s-2x.jpg',
            },
          ],
        },
      ],
    },
  },
  {
    deviationId: 860608395,
    type: 'image',
    typeId: 1,
    url: 'https://www.deviantart.com/mirrutatep/art/Neon-Nirvana-860608395',
    title: 'Neon Nirvana',
    isJournal: false,
    isVideo: false,
    isPurchasable: false,
    isFavouritable: true,
    publishedTime: '2020-11-08T10:20:48-0800',
    isTextEditable: false,
    isBackgroundEditable: false,
    legacyTextEditUrl: null,
    isShareable: true,
    isCommentable: true,
    isFavourited: true,
    isDeleted: false,
    isMature: false,
    isNsfg: false,
    isDownloadable: true,
    isAntisocial: false,
    isBlocked: false,
    isPublished: true,
    isDailyDeviation: false,
    hasPrivateComments: false,
    isDreamsofart: false,
    isAiUseDisallowed: true,
    blockReasons: [],
    author: {
      userId: 46382880,
      useridUuid: 'e4e058b5-3787-459a-ae71-91efb253bce2',
      username: 'MirruTatep',
      usericon: 'https://a.deviantart.net/avatars-big/m/i/mirrutatep.jpg?2',
      type: 'regular',
      isWatching: false,
      isSubscribed: false,
      isNewDeviant: false,
    },
    stats: {
      comments: 12,
      favourites: 248,
      views: 6882,
      downloads: 79,
    },
    media: {
      baseUri:
        'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/e4e058b5-3787-459a-ae71-91efb253bce2/de8dtor-5aa8cd00-d9b0-4927-8f7d-357ac341434c.png',
      prettyName: 'neon_nirvana_by_mirrutatep_de8dtor',
      token: [
        'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7ImhlaWdodCI6Ijw9Mzc4IiwicGF0aCI6IlwvZlwvZTRlMDU4YjUtMzc4Ny00NTlhLWFlNzEtOTFlZmIyNTNiY2UyXC9kZThkdG9yLTVhYThjZDAwLWQ5YjAtNDkyNy04ZjdkLTM1N2FjMzQxNDM0Yy5wbmciLCJ3aWR0aCI6Ijw9NjcyIn1dXSwiYXVkIjpbInVybjpzZXJ2aWNlOmltYWdlLm9wZXJhdGlvbnMiXX0.rks3_xLhwVVLLjTrSBZlVOrsWr2sKBJKryxJ0hUYelE',
        'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7InBhdGgiOiJcL2ZcL2U0ZTA1OGI1LTM3ODctNDU5YS1hZTcxLTkxZWZiMjUzYmNlMlwvZGU4ZHRvci01YWE4Y2QwMC1kOWIwLTQ5MjctOGY3ZC0zNTdhYzM0MTQzNGMucG5nIn1dXSwiYXVkIjpbInVybjpzZXJ2aWNlOmZpbGUuZG93bmxvYWQiXX0.apTaNyqnmKU-TRYEhAf7xImV92tP485hwq39P4dHwAM',
      ],
      types: [
        {
          t: '150',
          r: 0,
          c: '/v1/fit/w_150,h_150,q_70,strp/<prettyName>-150.jpg',
          h: 84,
          w: 150,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_300,h_300,q_70,strp/<prettyName>-150-2x.jpg',
            },
          ],
        },
        {
          t: '200H',
          r: 0,
          c: '/v1/fill/w_300,h_169,q_70,strp/<prettyName>-200h.jpg',
          h: 169,
          w: 300,
          ss: [
            {
              x: 2,
              c: '/v1/fill/w_600,h_338,q_70,strp/<prettyName>-200h-2x.jpg',
            },
          ],
        },
        {
          t: '300W',
          r: 0,
          c: '/v1/fit/w_300,h_378,q_70,strp/<prettyName>-300w.jpg',
          h: 169,
          w: 300,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_600,h_378,q_70,strp/<prettyName>-300w-2x.jpg',
            },
          ],
        },
        {
          t: '375W',
          r: 0,
          c: '/v1/fit/w_375,h_211,q_70,strp/<prettyName>-375w.jpg',
          h: 211,
          w: 375,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_672,h_378,q_70,strp/<prettyName>-375w-2x.jpg',
            },
          ],
        },
        {
          t: '414W',
          r: 0,
          c: '/v1/fit/w_414,h_233,q_70,strp/<prettyName>-414w.jpg',
          h: 233,
          w: 414,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_672,h_378,q_70,strp/<prettyName>-414w-2x.jpg',
            },
          ],
        },
        {
          t: '250T',
          r: 0,
          c: '/v1/fill/w_444,h_250,q_70,strp/<prettyName>-250t.jpg',
          h: 250,
          w: 444,
          ss: [
            {
              x: 2,
              c: '/v1/fill/w_672,h_378,q_70,strp/<prettyName>-250t-2x.jpg',
            },
          ],
        },
        {
          t: '350T',
          r: 0,
          c: '/v1/fill/w_622,h_350,q_70,strp/<prettyName>-350t.jpg',
          h: 350,
          w: 622,
          ss: [
            {
              x: 2,
              c: '/v1/fill/w_672,h_378,q_70,strp/<prettyName>-350t-2x.jpg',
            },
          ],
        },
        {
          t: '400T',
          r: 0,
          c: '/v1/fill/w_672,h_378,q_80,strp/<prettyName>-fullview.jpg',
          h: 378,
          w: 672,
        },
        {
          t: 'preview',
          r: 0,
          c: '/v1/fill/w_672,h_378,q_80,strp/<prettyName>-fullview.jpg',
          h: 378,
          w: 672,
          f: 8159,
        },
        {
          t: 'social_preview',
          r: 0,
          c: '/v1/fill/w_672,h_378,q_80,strp/<prettyName>-fullview.jpg',
          h: 378,
          w: 672,
        },
        {
          t: 'fullview',
          r: 1,
          h: 378,
          w: 672,
          f: 8159,
        },
        {
          t: '92S',
          r: 0,
          c: '/v1/crop/w_92,h_92,x_18,y_0,scl_0.24338624338624,q_70,strp/<prettyName>-92s.jpg',
          h: 92,
          w: 92,
          ss: [
            {
              x: 2,
              c: '/v1/crop/w_184,h_184,x_36,y_0,scl_0.48677248677249,q_70,strp/<prettyName>-92s-2x.jpg',
            },
          ],
        },
      ],
    },
  },
  {
    deviationId: 860110270,
    type: 'image',
    typeId: 1,
    url: 'https://www.deviantart.com/dimary/art/Sea-Witch-860110270',
    title: 'Sea Witch',
    isJournal: false,
    isVideo: false,
    isPurchasable: false,
    isFavouritable: true,
    publishedTime: '2020-11-03T07:40:18-0800',
    isTextEditable: false,
    isBackgroundEditable: false,
    legacyTextEditUrl: null,
    isShareable: true,
    isCommentable: true,
    isFavourited: true,
    isDeleted: false,
    isMature: false,
    isNsfg: false,
    isDownloadable: false,
    isAntisocial: false,
    isBlocked: false,
    isPublished: true,
    isDailyDeviation: false,
    hasPrivateComments: false,
    isDreamsofart: false,
    isAiUseDisallowed: true,
    blockReasons: [],
    author: {
      userId: 11118414,
      useridUuid: 'bb39d633-c2e1-407d-a815-dfb3ccedb455',
      username: 'dimary',
      usericon: 'https://a.deviantart.net/avatars-big/d/i/dimary.jpg?4',
      type: 'core_access',
      isWatching: true,
      isSubscribed: false,
      isNewDeviant: false,
    },
    stats: {
      comments: 6,
      favourites: 322,
      views: 5175,
      downloads: 0,
    },
    media: {
      baseUri:
        'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/bb39d633-c2e1-407d-a815-dfb3ccedb455/de835by-a768887c-8463-4d0d-8410-f0276f43da5c.jpg',
      prettyName: 'sea_witch_by_dimary_de835by',
      token: [
        'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7ImhlaWdodCI6Ijw9NjAwIiwicGF0aCI6IlwvZlwvYmIzOWQ2MzMtYzJlMS00MDdkLWE4MTUtZGZiM2NjZWRiNDU1XC9kZTgzNWJ5LWE3Njg4ODdjLTg0NjMtNGQwZC04NDEwLWYwMjc2ZjQzZGE1Yy5qcGciLCJ3aWR0aCI6Ijw9NjAwIn1dXSwiYXVkIjpbInVybjpzZXJ2aWNlOmltYWdlLm9wZXJhdGlvbnMiXX0.Jm2WuWyTegxc-EiSO3nspFWnhUUI6-d8mFvXZNoFZ0M',
        'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7InBhdGgiOiJcL2ZcL2JiMzlkNjMzLWMyZTEtNDA3ZC1hODE1LWRmYjNjY2VkYjQ1NVwvZGU4MzVieS1hNzY4ODg3Yy04NDYzLTRkMGQtODQxMC1mMDI3NmY0M2RhNWMuanBnIn1dXSwiYXVkIjpbInVybjpzZXJ2aWNlOmZpbGUuZG93bmxvYWQiXX0.Rp28vFALQixgXj4jZA4tRlMdWfkzwi_dpP1_YiS5Gc4',
      ],
      types: [
        {
          t: '150',
          r: 0,
          c: '/v1/fit/w_150,h_150,q_70,strp/<prettyName>-150.jpg',
          h: 150,
          w: 150,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_300,h_300,q_70,strp/<prettyName>-150-2x.jpg',
            },
          ],
        },
        {
          t: '200H',
          r: 0,
          c: '/v1/fill/w_200,h_200,q_70,strp/<prettyName>-200h.jpg',
          h: 200,
          w: 200,
          ss: [
            {
              x: 2,
              c: '/v1/fill/w_400,h_400,q_70,strp/<prettyName>-200h-2x.jpg',
            },
          ],
        },
        {
          t: '300W',
          r: 0,
          c: '/v1/fit/w_300,h_600,q_70,strp/<prettyName>-300w.jpg',
          h: 300,
          w: 300,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_600,h_600,q_70,strp/<prettyName>-300w-2x.jpg',
            },
          ],
        },
        {
          t: '375W',
          r: 0,
          c: '/v1/fit/w_375,h_375,q_70,strp/<prettyName>-375w.jpg',
          h: 375,
          w: 375,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_600,h_600,q_70,strp/<prettyName>-375w-2x.jpg',
            },
          ],
        },
        {
          t: '414W',
          r: 0,
          c: '/v1/fit/w_414,h_414,q_70,strp/<prettyName>-414w.jpg',
          h: 414,
          w: 414,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_600,h_600,q_70,strp/<prettyName>-414w-2x.jpg',
            },
          ],
        },
        {
          t: '250T',
          r: 0,
          c: '/v1/fill/w_250,h_250,q_70,strp/<prettyName>-250t.jpg',
          h: 250,
          w: 250,
          ss: [
            {
              x: 2,
              c: '/v1/fill/w_500,h_500,q_70,strp/<prettyName>-250t-2x.jpg',
            },
          ],
        },
        {
          t: '350T',
          r: 0,
          c: '/v1/fill/w_350,h_350,q_70,strp/<prettyName>-350t.jpg',
          h: 350,
          w: 350,
          ss: [
            {
              x: 2,
              c: '/v1/fill/w_600,h_600,q_70,strp/<prettyName>-350t-2x.jpg',
            },
          ],
        },
        {
          t: '400T',
          r: 0,
          c: '/v1/fill/w_400,h_400,q_70,strp/<prettyName>-400t.jpg',
          h: 400,
          w: 400,
          ss: [
            {
              x: 2,
              c: '/v1/fill/w_600,h_600,q_70,strp/<prettyName>-400t-2x.jpg',
            },
          ],
        },
        {
          t: 'preview',
          r: 0,
          c: '/v1/fill/w_600,h_600,q_75,strp/<prettyName>-fullview.jpg',
          h: 600,
          w: 600,
          f: 101142,
        },
        {
          t: 'social_preview',
          r: 0,
          c: '/v1/fill/w_600,h_600,q_75,strp/<prettyName>-fullview.jpg',
          h: 600,
          w: 600,
        },
        {
          t: 'fullview',
          r: 1,
          h: 600,
          w: 600,
          f: 101142,
        },
        {
          t: '92S',
          r: 0,
          c: '/v1/crop/w_92,h_92,x_0,y_0,scl_0.15333333333333,q_70,strp/<prettyName>-92s.jpg',
          h: 92,
          w: 92,
          ss: [
            {
              x: 2,
              c: '/v1/crop/w_184,h_184,x_0,y_0,scl_0.30666666666667,q_70,strp/<prettyName>-92s-2x.jpg',
            },
          ],
        },
      ],
    },
  },
  {
    deviationId: 860012395,
    type: 'image',
    typeId: 1,
    url: 'https://www.deviantart.com/arthurhenri/art/Cachos-860012395',
    title: 'Cachos',
    isJournal: false,
    isVideo: false,
    isPurchasable: false,
    isFavouritable: true,
    publishedTime: '2020-11-02T08:28:39-0800',
    isTextEditable: false,
    isBackgroundEditable: false,
    legacyTextEditUrl: null,
    isShareable: true,
    isCommentable: true,
    isFavourited: true,
    isDeleted: false,
    isMature: false,
    isNsfg: false,
    isDownloadable: false,
    isAntisocial: false,
    isBlocked: false,
    isPublished: true,
    isDailyDeviation: false,
    hasPrivateComments: false,
    isDreamsofart: false,
    isAiUseDisallowed: true,
    blockReasons: [],
    author: {
      userId: 31318401,
      useridUuid: '5ce79a6a-19ed-4c4f-946a-ca8ab3f77e37',
      username: 'ArthurHenri',
      usericon: 'https://a.deviantart.net/avatars-big/a/r/arthurhenri.jpg',
      type: 'regular',
      isWatching: true,
      isSubscribed: false,
      isNewDeviant: false,
    },
    stats: {
      comments: 16,
      favourites: 395,
      views: 5575,
      downloads: 0,
    },
    media: {
      baseUri:
        'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/5ce79a6a-19ed-4c4f-946a-ca8ab3f77e37/de811t7-38843ad4-a512-4b60-8956-a18aceb9bfa0.jpg',
      prettyName: 'cachos_by_arthurhenri_de811t7',
      token: [
        'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7ImhlaWdodCI6Ijw9OTAwIiwicGF0aCI6IlwvZlwvNWNlNzlhNmEtMTllZC00YzRmLTk0NmEtY2E4YWIzZjc3ZTM3XC9kZTgxMXQ3LTM4ODQzYWQ0LWE1MTItNGI2MC04OTU2LWExOGFjZWI5YmZhMC5qcGciLCJ3aWR0aCI6Ijw9OTAwIn1dXSwiYXVkIjpbInVybjpzZXJ2aWNlOmltYWdlLm9wZXJhdGlvbnMiXX0.t9dgHAXkAPmfmTbryy9DbXwDdH1Pc18h5nn9dyHsHkQ',
      ],
      types: [
        {
          t: '150',
          r: 0,
          c: '/v1/fit/w_150,h_150,q_70,strp/<prettyName>-150.jpg',
          h: 150,
          w: 150,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_300,h_300,q_70,strp/<prettyName>-150-2x.jpg',
            },
          ],
        },
        {
          t: '200H',
          r: 0,
          c: '/v1/fill/w_200,h_200,q_70,strp/<prettyName>-200h.jpg',
          h: 200,
          w: 200,
          ss: [
            {
              x: 2,
              c: '/v1/fill/w_400,h_400,q_70,strp/<prettyName>-200h-2x.jpg',
            },
          ],
        },
        {
          t: '300W',
          r: 0,
          c: '/v1/fit/w_300,h_900,q_70,strp/<prettyName>-300w.jpg',
          h: 300,
          w: 300,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_600,h_900,q_70,strp/<prettyName>-300w-2x.jpg',
            },
          ],
        },
        {
          t: '375W',
          r: 0,
          c: '/v1/fit/w_375,h_375,q_70,strp/<prettyName>-375w.jpg',
          h: 375,
          w: 375,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_750,h_750,q_70,strp/<prettyName>-375w-2x.jpg',
            },
          ],
        },
        {
          t: '414W',
          r: 0,
          c: '/v1/fit/w_414,h_414,q_70,strp/<prettyName>-414w.jpg',
          h: 414,
          w: 414,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_828,h_828,q_70,strp/<prettyName>-414w-2x.jpg',
            },
          ],
        },
        {
          t: '250T',
          r: 0,
          c: '/v1/fill/w_250,h_250,q_70,strp/<prettyName>-250t.jpg',
          h: 250,
          w: 250,
          ss: [
            {
              x: 2,
              c: '/v1/fill/w_500,h_500,q_70,strp/<prettyName>-250t-2x.jpg',
            },
          ],
        },
        {
          t: '350T',
          r: 0,
          c: '/v1/fill/w_350,h_350,q_70,strp/<prettyName>-350t.jpg',
          h: 350,
          w: 350,
          ss: [
            {
              x: 2,
              c: '/v1/fill/w_700,h_700,q_70,strp/<prettyName>-350t-2x.jpg',
            },
          ],
        },
        {
          t: '400T',
          r: 0,
          c: '/v1/fill/w_400,h_400,q_70,strp/<prettyName>-400t.jpg',
          h: 400,
          w: 400,
          ss: [
            {
              x: 2,
              c: '/v1/fill/w_800,h_800,q_70,strp/<prettyName>-400t-2x.jpg',
            },
          ],
        },
        {
          t: 'preview',
          r: 0,
          c: '/v1/fill/w_894,h_894,q_70,strp/<prettyName>-pre.jpg',
          h: 894,
          w: 894,
          f: 1612381,
        },
        {
          t: 'social_preview',
          r: 0,
          c: '/v1/fill/w_894,h_894,q_70,strp/<prettyName>-pre.jpg',
          h: 894,
          w: 894,
        },
        {
          t: 'fullview',
          r: 0,
          c: '/v1/fill/w_900,h_900,q_75,strp/<prettyName>-fullview.jpg',
          h: 900,
          w: 900,
          f: 1612381,
        },
        {
          t: '92S',
          r: 0,
          c: '/v1/crop/w_92,h_92,x_0,y_0,scl_0.068148148148148,q_70,strp/<prettyName>-92s.jpg',
          h: 92,
          w: 92,
          ss: [
            {
              x: 2,
              c: '/v1/crop/w_184,h_184,x_0,y_0,scl_0.1362962962963,q_70,strp/<prettyName>-92s-2x.jpg',
            },
          ],
        },
      ],
    },
  },
  {
    deviationId: 1199849126,
    type: 'image',
    typeId: 1,
    url: 'https://www.deviantart.com/rin-the-gay-reindeer/art/Art-trade-Simon-Read-desc-1199849126',
    shortUrl: 'http://fav.me/djucxie',
    title: '(Art trade) Simon (Read desc)',
    isJournal: false,
    isVideo: false,
    isPurchasable: false,
    isAdoptable: false,
    isFavouritable: true,
    publishedTime: '2025-05-28T02:09:01-0700',
    isTextEditable: false,
    isBackgroundEditable: false,
    legacyTextEditUrl: null,
    isShareable: true,
    isCommentable: true,
    isFavourited: false,
    isDeleted: false,
    isMature: false,
    isNsfg: false,
    isDownloadable: true,
    isAntisocial: false,
    isBlocked: false,
    isPublished: true,
    isDailyDeviation: false,
    hasPrivateComments: false,
    isDreamsofart: false,
    isUpscaled: false,
    isAiUseDisallowed: true,
    isAiGenerated: false,
    canUpdateAiClaim: true,
    isMultiImage: false,
    canBeMultiImage: true,
    isDefaultImage: false,
    license: 'none',
    blockReasons: [],
    author: {
      userId: 97799161,
      useridUuid: '56dae98d-789d-49da-bd13-14dddff5dc91',
      username: 'Rin-The-Gay-Reindeer',
      usericon: 'https://a.deviantart.net/avatars-big/r/i/rin-the-gay-reindeer.jpg?10',
      type: 'core_plus',
      isGroup: false,
      isWatching: false,
      isSubscribed: false,
      isNewDeviant: false,
    },
    stats: {
      comments: 1,
      favourites: 5,
      views: 2306,
      downloads: 0,
      privatelyCollected: 0,
    },
    media: {
      baseUri:
        'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/56dae98d-789d-49da-bd13-14dddff5dc91/djucxie-88f1597d-fc52-4a13-b50a-7f6f10d12a51.png',
      prettyName: '_art_trade__simon__read_desc__by_rin_the_gay_reindeer_djucxie',
      token: [
        'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7ImhlaWdodCI6Ijw9MTAwOCIsInBhdGgiOiJcL2ZcLzU2ZGFlOThkLTc4OWQtNDlkYS1iZDEzLTE0ZGRkZmY1ZGM5MVwvZGp1Y3hpZS04OGYxNTk3ZC1mYzUyLTRhMTMtYjUwYS03ZjZmMTBkMTJhNTEucG5nIiwid2lkdGgiOiI8PTQwOSJ9XV0sImF1ZCI6WyJ1cm46c2VydmljZTppbWFnZS5vcGVyYXRpb25zIl19.PE2DVOg3gxN8dZG5YzfsFPQH7LtiU1diHYefc-jKH_I',
        'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7InBhdGgiOiJcL2ZcLzU2ZGFlOThkLTc4OWQtNDlkYS1iZDEzLTE0ZGRkZmY1ZGM5MVwvZGp1Y3hpZS04OGYxNTk3ZC1mYzUyLTRhMTMtYjUwYS03ZjZmMTBkMTJhNTEucG5nIn1dXSwiYXVkIjpbInVybjpzZXJ2aWNlOmZpbGUuZG93bmxvYWQiXX0.iS3zE8Z_Nknea_IXZ8v5t6Xc9wyrgRDrYHYz7vZf4pw',
      ],
      types: [
        {
          t: '150',
          r: 0,
          c: '/v1/fit/w_150,h_150,q_70,strp/<prettyName>-150.jpg',
          h: 150,
          w: 61,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_300,h_300,q_70,strp/<prettyName>-150-2x.jpg',
              w: 300,
              h: 300,
            },
          ],
        },
        {
          t: '200H',
          r: 0,
          c: '/v1/crop/w_100,h_201,x_0,y_0,scl_0.24449877750611,q_70,strp/<prettyName>-200h.jpg',
          h: 201,
          w: 100,
          ss: [
            {
              x: 2,
              c: '/v1/crop/w_162,h_400,x_0,y_0,scl_0.39853300733496,q_70,strp/<prettyName>-200h-2x.jpg',
              w: 162,
              h: 400,
            },
          ],
        },
        {
          t: '300W',
          r: 0,
          c: '/v1/fit/w_300,h_900,q_70,strp/<prettyName>-300w.jpg',
          h: 739,
          w: 300,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_409,h_1008,q_70,strp/<prettyName>-300w-2x.jpg',
              w: 409,
              h: 1008,
            },
          ],
        },
        {
          t: '375W',
          r: 0,
          c: '/v1/fit/w_365,h_900,q_70,strp/<prettyName>-375w.jpg',
          h: 900,
          w: 365,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_409,h_1008,q_70,strp/<prettyName>-375w-2x.jpg',
              w: 409,
              h: 1008,
            },
          ],
        },
        {
          t: '414W',
          r: 0,
          c: '/v1/fill/w_409,h_1008,q_80,strp/<prettyName>-fullview.jpg',
          h: 1008,
          w: 409,
        },
        {
          t: '250T',
          r: 0,
          c: '/v1/crop/w_101,h_250,x_0,y_0,scl_0.24938875305623,q_70,strp/<prettyName>-250t.jpg',
          h: 250,
          w: 101,
          ss: [
            {
              x: 2,
              c: '/v1/fill/w_203,h_500,q_70,strp/<prettyName>-250t-2x.jpg',
              w: 203,
              h: 500,
            },
          ],
        },
        {
          t: '350T',
          r: 0,
          c: '/v1/fill/w_142,h_350,q_70,strp/<prettyName>-350t.jpg',
          h: 350,
          w: 142,
          ss: [
            {
              x: 2,
              c: '/v1/fill/w_284,h_700,q_70,strp/<prettyName>-350t-2x.jpg',
              w: 284,
              h: 700,
            },
          ],
        },
        {
          t: '400T',
          r: 0,
          c: '/v1/crop/w_162,h_400,x_0,y_0,scl_0.39853300733496,q_70,strp/<prettyName>-400t.jpg',
          h: 400,
          w: 162,
          ss: [
            {
              x: 2,
              c: '/v1/crop/w_325,h_800,x_0,y_0,scl_0.79462102689487,q_70,strp/<prettyName>-400t-2x.jpg',
              w: 325,
              h: 800,
            },
          ],
        },
        {
          t: 'preview',
          r: 0,
          c: '/v1/fill/w_409,h_1008,q_80,strp/<prettyName>-fullview.jpg',
          h: 1008,
          w: 409,
          f: 115526,
        },
        {
          t: 'social_preview',
          r: 0,
          c: '/v1/fill/w_409,h_1008,q_80,strp/<prettyName>-fullview.jpg',
          h: 1008,
          w: 409,
        },
        {
          t: 'fullview',
          r: 1,
          h: 1008,
          w: 409,
          f: 115526,
        },
        {
          t: '92S',
          r: 0,
          c: '/v1/crop/w_92,h_92,x_0,y_34,scl_0.22493887530562,q_70,strp/<prettyName>-92s.jpg',
          h: 92,
          w: 92,
          ss: [
            {
              x: 2,
              c: '/v1/crop/w_184,h_184,x_0,y_67,scl_0.44987775061125,q_70,strp/<prettyName>-92s-2x.jpg',
              w: 184,
              h: 184,
            },
          ],
        },
        {
          t: '125S',
          r: 0,
          c: '/v1/crop/w_125,h_125,x_0,y_46,scl_0.30562347188264,q_70,strp/<prettyName>-125s.jpg',
          h: 125,
          w: 125,
          ss: [
            {
              x: 2,
              c: '/v1/crop/w_250,h_250,x_0,y_92,scl_0.61124694376528,q_70,strp/<prettyName>-125s-2x.jpg',
              w: 250,
              h: 250,
            },
          ],
        },
      ],
    },
    extended: {
      deviationUuid: '6941852D-02A8-6C35-2AD0-D4F81AAD5EBB',
      canUserAddToGroup: true,
      isDaProtected: true,
      groupListUrl: 'https://www.deviantart.com/deviation/1199849126/groups',
      originalFile: {
        type: 'png',
        width: 409,
        height: 1008,
        filesize: 115526,
      },
      tags: [
        {
          name: 'arttrade',
          url: 'https://www.deviantart.com/tag/arttrade',
        },
        {
          name: 'idkwhatelsetotaglol',
          url: 'https://www.deviantart.com/tag/idkwhatelsetotaglol',
        },
      ],
      download: {
        url: 'https://www.deviantart.com/download/1199849126/djucxie-88f1597d-fc52-4a13-b50a-7f6f10d12a51.png?token=43d0b25c1ef0381d30e120acde2a1804fa3c890b&ts=1748541950',
        type: 'png',
        width: 409,
        height: 1008,
        filesize: 115526,
      },
      stats: {
        views: 2306,
        today: 1,
        shares: 0,
        downloads: 0,
        groups: 0,
      },
      relatedContent: [
        {
          contentType: 'monetization_promotion_pcp_firstparty',
          layout: 0,
          deviations: [
            {
              deviationId: 1105358166,
              type: 'image',
              typeId: 1,
              url: 'https://www.deviantart.com/iridyscenzia/art/The-dunes-of-time-1105358166',
              shortUrl: 'http://fav.me/dia3nti',
              title: 'The dunes of time',
              isJournal: false,
              isVideo: false,
              isPurchasable: true,
              isAdoptable: false,
              isFavouritable: true,
              publishedTime: '2024-10-02T06:40:32-0700',
              isTextEditable: false,
              isBackgroundEditable: false,
              legacyTextEditUrl: null,
              isShareable: true,
              isCommentable: true,
              isFavourited: false,
              isDeleted: false,
              isMature: false,
              isNsfg: false,
              isDownloadable: false,
              isAntisocial: false,
              isBlocked: false,
              isPublished: true,
              isDailyDeviation: true,
              hasPrivateComments: false,
              isDreamsofart: false,
              isUpscaled: false,
              isAiUseDisallowed: true,
              isAiGenerated: false,
              canUpdateAiClaim: true,
              isMultiImage: false,
              canBeMultiImage: true,
              isDefaultImage: false,
              license: 'none',
              blockReasons: [],
              author: {
                userId: 44003946,
                useridUuid: 'f71e3555-d9ac-4e91-9598-ad07f0980ac2',
                username: 'IRIDYSCENZIA',
                usericon: 'https://a.deviantart.net/avatars-big/i/r/iridyscenzia.gif?10',
                type: 'senior',
                isGroup: false,
                isWatching: false,
                isSubscribed: false,
                isNewDeviant: false,
              },
              stats: {
                comments: 70,
                favourites: 317,
                views: 450692,
                downloads: 0,
                privatelyCollected: 0,
              },
              media: {
                baseUri:
                  'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/f71e3555-d9ac-4e91-9598-ad07f0980ac2/dia3nti-8f4c22a1-cda9-484c-9006-db890d9fa15f.png',
                prettyName: 'the_dunes_of_time_by_iridyscenzia_dia3nti',
                token: [
                  'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7ImhlaWdodCI6Ijw9OTAwIiwicGF0aCI6Ii9mL2Y3MWUzNTU1LWQ5YWMtNGU5MS05NTk4LWFkMDdmMDk4MGFjMi9kaWEzbnRpLThmNGMyMmExLWNkYTktNDg0Yy05MDA2LWRiODkwZDlmYTE1Zi5wbmciLCJ3aWR0aCI6Ijw9MTYwMCJ9XV0sImF1ZCI6WyJ1cm46c2VydmljZTppbWFnZS5vcGVyYXRpb25zIl19.IgxzIKkG9MFxFB_vaKDo_AIqSMgAJE79LdNio_7ogqc',
                  'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7InBhdGgiOiIvZi9mNzFlMzU1NS1kOWFjLTRlOTEtOTU5OC1hZDA3ZjA5ODBhYzIvZGlhM250aS04ZjRjMjJhMS1jZGE5LTQ4NGMtOTAwNi1kYjg5MGQ5ZmExNWYucG5nIn1dXSwiYXVkIjpbInVybjpzZXJ2aWNlOmZpbGUuZG93bmxvYWQiXX0.22qDInMWKb5RHAwfhF5VeL13maHi6Rw9ubBg1CKquxk',
                ],
                types: [
                  {
                    t: '150',
                    r: 0,
                    c: '/v1/fit/w_150,h_150,q_70,strp/<prettyName>-150.jpg',
                    h: 84,
                    w: 150,
                    ss: [
                      {
                        x: 2,
                        c: '/v1/fit/w_300,h_300,q_70,strp/<prettyName>-150-2x.jpg',
                        w: 300,
                        h: 300,
                      },
                    ],
                  },
                  {
                    t: '200H',
                    r: 0,
                    c: '/v1/fill/w_300,h_169,q_70,strp/<prettyName>-200h.jpg',
                    h: 169,
                    w: 300,
                    ss: [
                      {
                        x: 2,
                        c: '/v1/fill/w_600,h_338,q_70,strp/<prettyName>-200h-2x.jpg',
                        w: 600,
                        h: 338,
                      },
                    ],
                  },
                  {
                    t: '300W',
                    r: 0,
                    c: '/v1/fit/w_300,h_900,q_70,strp/<prettyName>-300w.jpg',
                    h: 169,
                    w: 300,
                    ss: [
                      {
                        x: 2,
                        c: '/v1/fit/w_600,h_900,q_70,strp/<prettyName>-300w-2x.jpg',
                        w: 600,
                        h: 900,
                      },
                    ],
                  },
                  {
                    t: '375W',
                    r: 0,
                    c: '/v1/fit/w_375,h_211,q_70,strp/<prettyName>-375w.jpg',
                    h: 211,
                    w: 375,
                    ss: [
                      {
                        x: 2,
                        c: '/v1/fit/w_750,h_422,q_70,strp/<prettyName>-375w-2x.jpg',
                        w: 750,
                        h: 422,
                      },
                    ],
                  },
                  {
                    t: '414W',
                    r: 0,
                    c: '/v1/fit/w_414,h_233,q_70,strp/<prettyName>-414w.jpg',
                    h: 233,
                    w: 414,
                    ss: [
                      {
                        x: 2,
                        c: '/v1/fit/w_828,h_466,q_70,strp/<prettyName>-414w-2x.jpg',
                        w: 828,
                        h: 466,
                      },
                    ],
                  },
                  {
                    t: '250T',
                    r: 0,
                    c: '/v1/fill/w_444,h_250,q_70,strp/<prettyName>-250t.jpg',
                    h: 250,
                    w: 444,
                    ss: [
                      {
                        x: 2,
                        c: '/v1/fill/w_889,h_500,q_70,strp/<prettyName>-250t-2x.jpg',
                        w: 889,
                        h: 500,
                      },
                    ],
                  },
                  {
                    t: '350T',
                    r: 0,
                    c: '/v1/fill/w_622,h_350,q_70,strp/<prettyName>-350t.jpg',
                    h: 350,
                    w: 622,
                    ss: [
                      {
                        x: 2,
                        c: '/v1/fill/w_1244,h_700,q_70,strp/<prettyName>-350t-2x.jpg',
                        w: 1244,
                        h: 700,
                      },
                    ],
                  },
                  {
                    t: '400T',
                    r: 0,
                    c: '/v1/fill/w_711,h_400,q_70,strp/<prettyName>-400t.jpg',
                    h: 400,
                    w: 711,
                    ss: [
                      {
                        x: 2,
                        c: '/v1/fill/w_1422,h_800,q_70,strp/<prettyName>-400t-2x.jpg',
                        w: 1422,
                        h: 800,
                      },
                    ],
                  },
                  {
                    t: 'preview',
                    r: 0,
                    c: '/v1/fill/w_1192,h_670,q_70,strp/<prettyName>-pre.jpg',
                    h: 670,
                    w: 1192,
                    f: 856919,
                    ss: [
                      {
                        x: 2,
                        c: '/v1/fill/w_1192,h_670,q_70,strp/<prettyName>-pre-2x.jpg',
                        w: 1192,
                        h: 670,
                      },
                    ],
                  },
                  {
                    t: 'social_preview',
                    r: 0,
                    c: '/v1/fill/w_1192,h_670,q_70,strp/<prettyName>-pre.jpg',
                    h: 670,
                    w: 1192,
                    ss: [
                      {
                        x: 2,
                        c: '/v1/fill/w_1192,h_670,q_70,strp/<prettyName>-pre-2x.jpg',
                        w: 1192,
                        h: 670,
                      },
                    ],
                  },
                  {
                    t: 'fullview',
                    r: 1,
                    h: 900,
                    w: 1600,
                    f: 856919,
                  },
                  {
                    t: '92S',
                    r: 0,
                    c: '/v1/crop/w_92,h_92,x_18,y_0,scl_0.10222222222222,q_70,strp/<prettyName>-92s.jpg',
                    h: 92,
                    w: 92,
                    ss: [
                      {
                        x: 2,
                        c: '/v1/crop/w_184,h_184,x_36,y_0,scl_0.20444444444444,q_70,strp/<prettyName>-92s-2x.jpg',
                        w: 184,
                        h: 184,
                      },
                    ],
                  },
                  {
                    t: '125S',
                    r: 0,
                    c: '/v1/crop/w_125,h_125,x_24,y_0,scl_0.13888888888889,q_70,strp/<prettyName>-125s.jpg',
                    h: 125,
                    w: 125,
                    ss: [
                      {
                        x: 2,
                        c: '/v1/crop/w_250,h_250,x_49,y_0,scl_0.27777777777778,q_70,strp/<prettyName>-125s-2x.jpg',
                        w: 250,
                        h: 250,
                      },
                    ],
                  },
                ],
              },
              pcp: {
                downloadPrice: 240,
                downloadDollarPrice: 3,
                salesCount: 4,
                subproductId: 572628032,
              },
              onSaleAs: ['pcp'],
              filetype: 'png',
            },
            {
              deviationId: 1038618934,
              type: 'image',
              typeId: 1,
              url: 'https://www.deviantart.com/iridyscenzia/art/Abstract-art-1038618934',
              shortUrl: 'http://fav.me/dh6d7hy',
              title: 'Abstract art',
              isJournal: false,
              isVideo: false,
              isPurchasable: true,
              isAdoptable: false,
              isFavouritable: true,
              publishedTime: '2024-04-04T08:34:59-0700',
              isTextEditable: false,
              isBackgroundEditable: false,
              legacyTextEditUrl: null,
              isShareable: true,
              isCommentable: true,
              isFavourited: false,
              isDeleted: false,
              isMature: false,
              isNsfg: false,
              isDownloadable: false,
              isAntisocial: false,
              isBlocked: false,
              isPublished: true,
              isDailyDeviation: false,
              hasPrivateComments: false,
              isDreamsofart: false,
              isUpscaled: false,
              isAiUseDisallowed: true,
              isAiGenerated: false,
              canUpdateAiClaim: true,
              isMultiImage: false,
              canBeMultiImage: true,
              isDefaultImage: false,
              license: 'by-nc-nd',
              blockReasons: [],
              author: {
                userId: 44003946,
                useridUuid: 'f71e3555-d9ac-4e91-9598-ad07f0980ac2',
                username: 'IRIDYSCENZIA',
                usericon: 'https://a.deviantart.net/avatars-big/i/r/iridyscenzia.gif?10',
                type: 'senior',
                isGroup: false,
                isWatching: false,
                isSubscribed: false,
                isNewDeviant: false,
              },
              stats: {
                comments: 10,
                favourites: 65,
                views: 6951,
                downloads: 0,
                privatelyCollected: 0,
              },
              media: {
                baseUri:
                  'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/f71e3555-d9ac-4e91-9598-ad07f0980ac2/dh6d7hy-3d1b4089-c29c-434e-b206-41456c017b49.png',
                prettyName: 'abstract_art_by_iridyscenzia_dh6d7hy',
                token: [
                  'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7ImhlaWdodCI6Ijw9NzIwIiwicGF0aCI6Ii9mL2Y3MWUzNTU1LWQ5YWMtNGU5MS05NTk4LWFkMDdmMDk4MGFjMi9kaDZkN2h5LTNkMWI0MDg5LWMyOWMtNDM0ZS1iMjA2LTQxNDU2YzAxN2I0OS5wbmciLCJ3aWR0aCI6Ijw9NzIwIn1dXSwiYXVkIjpbInVybjpzZXJ2aWNlOmltYWdlLm9wZXJhdGlvbnMiXX0.1UPWp57S6kOb55fzvezYD3dU2Q5oQr0JrGyzikMPLrs',
                  'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7InBhdGgiOiIvZi9mNzFlMzU1NS1kOWFjLTRlOTEtOTU5OC1hZDA3ZjA5ODBhYzIvZGg2ZDdoeS0zZDFiNDA4OS1jMjljLTQzNGUtYjIwNi00MTQ1NmMwMTdiNDkucG5nIn1dXSwiYXVkIjpbInVybjpzZXJ2aWNlOmZpbGUuZG93bmxvYWQiXX0.MVV1iH-xdmFSbw8WRco0b_7_vhfqQAOf1pryu5ioehs',
                ],
                types: [
                  {
                    t: '150',
                    r: 0,
                    c: '/v1/fit/w_150,h_150,q_70,strp/<prettyName>-150.jpg',
                    h: 150,
                    w: 150,
                    ss: [
                      {
                        x: 2,
                        c: '/v1/fit/w_300,h_300,q_70,strp/<prettyName>-150-2x.jpg',
                        w: 300,
                        h: 300,
                      },
                    ],
                  },
                  {
                    t: '200H',
                    r: 0,
                    c: '/v1/fill/w_200,h_200,q_70,strp/<prettyName>-200h.jpg',
                    h: 200,
                    w: 200,
                    ss: [
                      {
                        x: 2,
                        c: '/v1/fill/w_400,h_400,q_70,strp/<prettyName>-200h-2x.jpg',
                        w: 400,
                        h: 400,
                      },
                    ],
                  },
                  {
                    t: '300W',
                    r: 0,
                    c: '/v1/fit/w_300,h_720,q_70,strp/<prettyName>-300w.jpg',
                    h: 300,
                    w: 300,
                    ss: [
                      {
                        x: 2,
                        c: '/v1/fit/w_600,h_720,q_70,strp/<prettyName>-300w-2x.jpg',
                        w: 600,
                        h: 720,
                      },
                    ],
                  },
                  {
                    t: '375W',
                    r: 0,
                    c: '/v1/fit/w_375,h_375,q_70,strp/<prettyName>-375w.jpg',
                    h: 375,
                    w: 375,
                    ss: [
                      {
                        x: 2,
                        c: '/v1/fit/w_720,h_720,q_70,strp/<prettyName>-375w-2x.jpg',
                        w: 720,
                        h: 720,
                      },
                    ],
                  },
                  {
                    t: '414W',
                    r: 0,
                    c: '/v1/fit/w_414,h_414,q_70,strp/<prettyName>-414w.jpg',
                    h: 414,
                    w: 414,
                    ss: [
                      {
                        x: 2,
                        c: '/v1/fit/w_720,h_720,q_70,strp/<prettyName>-414w-2x.jpg',
                        w: 720,
                        h: 720,
                      },
                    ],
                  },
                  {
                    t: '250T',
                    r: 0,
                    c: '/v1/fill/w_250,h_250,q_70,strp/<prettyName>-250t.jpg',
                    h: 250,
                    w: 250,
                    ss: [
                      {
                        x: 2,
                        c: '/v1/fill/w_500,h_500,q_70,strp/<prettyName>-250t-2x.jpg',
                        w: 500,
                        h: 500,
                      },
                    ],
                  },
                  {
                    t: '350T',
                    r: 0,
                    c: '/v1/fill/w_350,h_350,q_70,strp/<prettyName>-350t.jpg',
                    h: 350,
                    w: 350,
                    ss: [
                      {
                        x: 2,
                        c: '/v1/fill/w_700,h_700,q_70,strp/<prettyName>-350t-2x.jpg',
                        w: 700,
                        h: 700,
                      },
                    ],
                  },
                  {
                    t: '400T',
                    r: 0,
                    c: '/v1/fill/w_400,h_400,q_70,strp/<prettyName>-400t.jpg',
                    h: 400,
                    w: 400,
                    ss: [
                      {
                        x: 2,
                        c: '/v1/fill/w_720,h_720,q_70,strp/<prettyName>-400t-2x.jpg',
                        w: 720,
                        h: 720,
                      },
                    ],
                  },
                  {
                    t: 'preview',
                    r: 0,
                    c: '/v1/fill/w_720,h_720,q_80,strp/<prettyName>-fullview.jpg',
                    h: 720,
                    w: 720,
                    f: 328035,
                  },
                  {
                    t: 'social_preview',
                    r: 0,
                    c: '/v1/fill/w_720,h_720,q_80,strp/<prettyName>-fullview.jpg',
                    h: 720,
                    w: 720,
                  },
                  {
                    t: 'fullview',
                    r: 1,
                    h: 720,
                    w: 720,
                    f: 328035,
                  },
                  {
                    t: '92S',
                    r: 0,
                    c: '/v1/crop/w_92,h_92,x_0,y_0,scl_0.12777777777778,q_70,strp/<prettyName>-92s.jpg',
                    h: 92,
                    w: 92,
                    ss: [
                      {
                        x: 2,
                        c: '/v1/crop/w_184,h_184,x_0,y_0,scl_0.25555555555556,q_70,strp/<prettyName>-92s-2x.jpg',
                        w: 184,
                        h: 184,
                      },
                    ],
                  },
                  {
                    t: '125S',
                    r: 0,
                    c: '/v1/crop/w_125,h_125,x_0,y_0,scl_0.17361111111111,q_70,strp/<prettyName>-125s.jpg',
                    h: 125,
                    w: 125,
                    ss: [
                      {
                        x: 2,
                        c: '/v1/crop/w_250,h_250,x_0,y_0,scl_0.34722222222222,q_70,strp/<prettyName>-125s-2x.jpg',
                        w: 250,
                        h: 250,
                      },
                    ],
                  },
                ],
              },
              pcp: {
                downloadPrice: 240,
                downloadDollarPrice: 3,
                salesCount: 0,
                subproductId: 569067330,
              },
              onSaleAs: ['pcp'],
              filetype: 'png',
            },
          ],
        },
      ],
      showStageMonetizationPromo: 'generic',
      descriptionText: {
        excerpt:
          "Art trade for @ZetiGamer64 \n\nI got very lazy, so I leave it white, the pentagram on the left of the shirt gets on my nerves even tho I'm a Catholic, also it is your late birthday gift tbh. Plus I hope you like it! ^^",
        html: {
          type: 'tiptap',
          markup:
            '{"version":"1","document":{"type":"doc","content":[{"type":"paragraph","attrs":{"indentType":null,"indentation":null,"textAlign":"left"},"content":[{"type":"text","text":"Art trade for "},{"type":"da-mention","attrs":{"user":{"icon":"https://a.deviantart.net/avatars-big/z/e/zetigamer64.jpg?10","username":"ZetiGamer64","userId":79110430,"type":"regular"}}},{"type":"text","text":" "}]},{"type":"paragraph","attrs":{"indentType":null,"indentation":null,"textAlign":"left"}},{"type":"paragraph","attrs":{"indentType":null,"indentation":null,"textAlign":"left"},"content":[{"type":"text","text":"I got very lazy, so I leave it white, the pentagram on the left of the shirt gets on my nerves even tho I\'m a Catholic, also it is your late birthday gift tbh. Plus I hope you like it! ^^"}]}]},"features":[]}',
          features:
            '[{"type":"TIPTAP_FEATURE","data":{"tiptap":true,"version":1}},{"type":"WORD_COUNT_FEATURE","data":{"words":44,"chars":203}},{"type":"MEDIA_COUNT_FEATURE","data":{"emoji":0,"emotes":0,"images":0,"mentions":1,"video":0,"galleries":0,"gifs":0,"ids":[]}},{"type":"IS_EMPTY_FEATURE","data":{"isEmpty":false}}]',
        },
      },
    },
  },
];
